
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("l0lnS", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== 'undefined' ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 3);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var RushaCore = __webpack_require__(5);
            var _require = __webpack_require__(1), toHex = _require.toHex, ceilHeapSize = _require.ceilHeapSize;
            var conv = __webpack_require__(6);
            // Calculate the length of buffer that the sha1 routine uses
            // including the padding.
            var padlen = function(len) {
                for(len += 9; len % 64 > 0; len += 1);
                return len;
            };
            var padZeroes = function(bin, len) {
                var h8 = new Uint8Array(bin.buffer);
                var om = len % 4, align = len - om;
                switch(om){
                    case 0:
                        h8[align + 3] = 0;
                    case 1:
                        h8[align + 2] = 0;
                    case 2:
                        h8[align + 1] = 0;
                    case 3:
                        h8[align + 0] = 0;
                }
                for(var i = (len >> 2) + 1; i < bin.length; i++)bin[i] = 0;
            };
            var padData = function(bin, chunkLen, msgLen) {
                bin[chunkLen >> 2] |= 0x80 << 24 - (chunkLen % 4 << 3);
                // To support msgLen >= 2 GiB, use a float division when computing the
                // high 32-bits of the big-endian message length in bits.
                bin[((chunkLen >> 2) + 2 & -16) + 14] = msgLen / 536870912 | 0;
                bin[((chunkLen >> 2) + 2 & -16) + 15] = msgLen << 3;
            };
            var getRawDigest = function(heap, padMaxChunkLen) {
                var io = new Int32Array(heap, padMaxChunkLen + 320, 5);
                var out = new Int32Array(5);
                var arr = new DataView(out.buffer);
                arr.setInt32(0, io[0], false);
                arr.setInt32(4, io[1], false);
                arr.setInt32(8, io[2], false);
                arr.setInt32(12, io[3], false);
                arr.setInt32(16, io[4], false);
                return out;
            };
            var Rusha = function() {
                function Rusha(chunkSize) {
                    _classCallCheck(this, Rusha);
                    chunkSize = chunkSize || 65536;
                    if (chunkSize % 64 > 0) throw new Error('Chunk size must be a multiple of 128 bit');
                    this._offset = 0;
                    this._maxChunkLen = chunkSize;
                    this._padMaxChunkLen = padlen(chunkSize);
                    // The size of the heap is the sum of:
                    // 1. The padded input message size
                    // 2. The extended space the algorithm needs (320 byte)
                    // 3. The 160 bit state the algoritm uses
                    this._heap = new ArrayBuffer(ceilHeapSize(this._padMaxChunkLen + 320 + 20));
                    this._h32 = new Int32Array(this._heap);
                    this._h8 = new Int8Array(this._heap);
                    this._core = new RushaCore({
                        Int32Array: Int32Array
                    }, {}, this._heap);
                }
                Rusha.prototype._initState = function _initState(heap, padMsgLen) {
                    this._offset = 0;
                    var io = new Int32Array(heap, padMsgLen + 320, 5);
                    io[0] = 1732584193;
                    io[1] = -271733879;
                    io[2] = -1732584194;
                    io[3] = 271733878;
                    io[4] = -1009589776;
                };
                Rusha.prototype._padChunk = function _padChunk(chunkLen, msgLen) {
                    var padChunkLen = padlen(chunkLen);
                    var view = new Int32Array(this._heap, 0, padChunkLen >> 2);
                    padZeroes(view, chunkLen);
                    padData(view, chunkLen, msgLen);
                    return padChunkLen;
                };
                Rusha.prototype._write = function _write(data, chunkOffset, chunkLen, off) {
                    conv(data, this._h8, this._h32, chunkOffset, chunkLen, off || 0);
                };
                Rusha.prototype._coreCall = function _coreCall(data, chunkOffset, chunkLen, msgLen, finalize) {
                    var padChunkLen = chunkLen;
                    this._write(data, chunkOffset, chunkLen);
                    if (finalize) padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                };
                Rusha.prototype.rawDigest = function rawDigest(str) {
                    var msgLen = str.byteLength || str.length || str.size || 0;
                    this._initState(this._heap, this._padMaxChunkLen);
                    var chunkOffset = 0, chunkLen = this._maxChunkLen;
                    for(chunkOffset = 0; msgLen > chunkOffset + chunkLen; chunkOffset += chunkLen)this._coreCall(str, chunkOffset, chunkLen, msgLen, false);
                    this._coreCall(str, chunkOffset, msgLen - chunkOffset, msgLen, true);
                    return getRawDigest(this._heap, this._padMaxChunkLen);
                };
                Rusha.prototype.digest = function digest(str) {
                    return toHex(this.rawDigest(str).buffer);
                };
                Rusha.prototype.digestFromString = function digestFromString(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromBuffer = function digestFromBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromArrayBuffer = function digestFromArrayBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.resetState = function resetState() {
                    this._initState(this._heap, this._padMaxChunkLen);
                    return this;
                };
                Rusha.prototype.append = function append(chunk) {
                    var chunkOffset = 0;
                    var chunkLen = chunk.byteLength || chunk.length || chunk.size || 0;
                    var turnOffset = this._offset % this._maxChunkLen;
                    var inputLen = void 0;
                    this._offset += chunkLen;
                    while(chunkOffset < chunkLen){
                        inputLen = Math.min(chunkLen - chunkOffset, this._maxChunkLen - turnOffset);
                        this._write(chunk, chunkOffset, inputLen, turnOffset);
                        turnOffset += inputLen;
                        chunkOffset += inputLen;
                        if (turnOffset === this._maxChunkLen) {
                            this._core.hash(this._maxChunkLen, this._padMaxChunkLen);
                            turnOffset = 0;
                        }
                    }
                    return this;
                };
                Rusha.prototype.getState = function getState() {
                    var turnOffset = this._offset % this._maxChunkLen;
                    var heap = void 0;
                    if (!turnOffset) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        heap = io.buffer.slice(io.byteOffset, io.byteOffset + io.byteLength);
                    } else heap = this._heap.slice(0);
                    return {
                        offset: this._offset,
                        heap: heap
                    };
                };
                Rusha.prototype.setState = function setState(state) {
                    this._offset = state.offset;
                    if (state.heap.byteLength === 20) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        io.set(new Int32Array(state.heap));
                    } else this._h32.set(new Int32Array(state.heap));
                    return this;
                };
                Rusha.prototype.rawEnd = function rawEnd() {
                    var msgLen = this._offset;
                    var chunkLen = msgLen % this._maxChunkLen;
                    var padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                    var result = getRawDigest(this._heap, this._padMaxChunkLen);
                    this._initState(this._heap, this._padMaxChunkLen);
                    return result;
                };
                Rusha.prototype.end = function end() {
                    return toHex(this.rawEnd().buffer);
                };
                return Rusha;
            }();
            module1.exports = Rusha;
            module1.exports._core = RushaCore;
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /* eslint-env commonjs, browser */ //
            // toHex
            //
            var precomputedHex = new Array(256);
            for(var i = 0; i < 256; i++)precomputedHex[i] = (i < 0x10 ? '0' : '') + i.toString(16);
            module1.exports.toHex = function(arrayBuffer) {
                var binarray = new Uint8Array(arrayBuffer);
                var res = new Array(arrayBuffer.byteLength);
                for(var _i = 0; _i < res.length; _i++)res[_i] = precomputedHex[binarray[_i]];
                return res.join('');
            };
            //
            // ceilHeapSize
            //
            module1.exports.ceilHeapSize = function(v) {
                // The asm.js spec says:
                // The heap object's byteLength must be either
                // 2^n for n in [12, 24) or 2^24 * n for n ≥ 1.
                // Also, byteLengths smaller than 2^16 are deprecated.
                var p = 0;
                // If v is smaller than 2^16, the smallest possible solution
                // is 2^16.
                if (v <= 65536) return 65536;
                // If v < 2^24, we round up to 2^n,
                // otherwise we round up to 2^24 * n.
                if (v < 16777216) {
                    for(p = 1; p < v; p = p << 1);
                } else {
                    for(p = 16777216; p < v; p += 16777216);
                }
                return p;
            };
            //
            // isDedicatedWorkerScope
            //
            module1.exports.isDedicatedWorkerScope = function(self1) {
                var isRunningInWorker = 'WorkerGlobalScope' in self1 && self1 instanceof self1.WorkerGlobalScope;
                var isRunningInSharedWorker = 'SharedWorkerGlobalScope' in self1 && self1 instanceof self1.SharedWorkerGlobalScope;
                var isRunningInServiceWorker = 'ServiceWorkerGlobalScope' in self1 && self1 instanceof self1.ServiceWorkerGlobalScope;
                // Detects whether we run inside a dedicated worker or not.
                //
                // We can't just check for `DedicatedWorkerGlobalScope`, since IE11
                // has a bug where it only supports `WorkerGlobalScope`.
                //
                // Therefore, we consider us as running inside a dedicated worker
                // when we are running inside a worker, but not in a shared or service worker.
                //
                // When new types of workers are introduced, we will need to adjust this code.
                return isRunningInWorker && !isRunningInSharedWorker && !isRunningInServiceWorker;
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, worker */ module1.exports = function() {
                var Rusha = __webpack_require__(0);
                var hashData = function(hasher, data, cb) {
                    try {
                        return cb(null, hasher.digest(data));
                    } catch (e) {
                        return cb(e);
                    }
                };
                var hashFile = function(hasher, readTotal, blockSize, file, cb) {
                    var reader = new self.FileReader();
                    reader.onloadend = function onloadend() {
                        if (reader.error) return cb(reader.error);
                        var buffer = reader.result;
                        readTotal += reader.result.byteLength;
                        try {
                            hasher.append(buffer);
                        } catch (e) {
                            cb(e);
                            return;
                        }
                        if (readTotal < file.size) hashFile(hasher, readTotal, blockSize, file, cb);
                        else cb(null, hasher.end());
                    };
                    reader.readAsArrayBuffer(file.slice(readTotal, readTotal + blockSize));
                };
                var workerBehaviourEnabled = true;
                self.onmessage = function(event) {
                    if (!workerBehaviourEnabled) return;
                    var data = event.data.data, file = event.data.file, id = event.data.id;
                    if (typeof id === 'undefined') return;
                    if (!file && !data) return;
                    var blockSize = event.data.blockSize || 4194304;
                    var hasher = new Rusha(blockSize);
                    hasher.resetState();
                    var done = function(err, hash) {
                        if (!err) self.postMessage({
                            id: id,
                            hash: hash
                        });
                        else self.postMessage({
                            id: id,
                            error: err.name
                        });
                    };
                    if (data) hashData(hasher, data, done);
                    if (file) hashFile(hasher, 0, blockSize, file, done);
                };
                return function() {
                    workerBehaviourEnabled = false;
                };
            };
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, browser */ var work = __webpack_require__(4);
            var Rusha = __webpack_require__(0);
            var createHash = __webpack_require__(7);
            var runWorker = __webpack_require__(2);
            var _require = __webpack_require__(1), isDedicatedWorkerScope = _require.isDedicatedWorkerScope;
            var isRunningInDedicatedWorker = typeof self !== 'undefined' && isDedicatedWorkerScope(self);
            Rusha.disableWorkerBehaviour = isRunningInDedicatedWorker ? runWorker() : function() {};
            Rusha.createWorker = function() {
                var worker = work(/*require.resolve*/ 2);
                var terminate = worker.terminate;
                worker.terminate = function() {
                    URL.revokeObjectURL(worker.objectURL);
                    terminate.call(worker);
                };
                return worker;
            };
            Rusha.createHash = createHash;
            module1.exports = Rusha;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            function webpackBootstrapFunc(modules) {
                /******/ // The module cache
                /******/ var installedModules = {};
                /******/ // The require function
                /******/ function __webpack_require__(moduleId) {
                    /******/ // Check if module is in cache
                    /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                    /******/ // Create a new module (and put it into the cache)
                    /******/ var module1 = installedModules[moduleId] = {
                        /******/ i: moduleId,
                        /******/ l: false,
                        /******/ exports: {}
                    };
                    /******/ // Execute the module function
                    /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                    /******/ // Flag the module as loaded
                    /******/ module1.l = true;
                    /******/ // Return the exports of the module
                    /******/ return module1.exports;
                /******/ }
                /******/ // expose the modules object (__webpack_modules__)
                /******/ __webpack_require__.m = modules;
                /******/ // expose the module cache
                /******/ __webpack_require__.c = installedModules;
                /******/ // identity function for calling harmony imports with the correct context
                /******/ __webpack_require__.i = function(value) {
                    return value;
                };
                /******/ // define getter function for harmony exports
                /******/ __webpack_require__.d = function(exports, name, getter) {
                    /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                        /******/ configurable: false,
                        /******/ enumerable: true,
                        /******/ get: getter
                    });
                /******/ };
                /******/ // define __esModule on exports
                /******/ __webpack_require__.r = function(exports) {
                    /******/ Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                /******/ };
                /******/ // getDefaultExport function for compatibility with non-harmony modules
                /******/ __webpack_require__.n = function(module1) {
                    /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                        return module1['default'];
                    } : /******/ function getModuleExports() {
                        return module1;
                    };
                    /******/ __webpack_require__.d(getter, 'a', getter);
                    /******/ return getter;
                /******/ };
                /******/ // Object.prototype.hasOwnProperty.call
                /******/ __webpack_require__.o = function(object, property) {
                    return Object.prototype.hasOwnProperty.call(object, property);
                };
                /******/ // __webpack_public_path__
                /******/ __webpack_require__.p = "/";
                /******/ // on error function for async loading
                /******/ __webpack_require__.oe = function(err) {
                    console.error(err);
                    throw err;
                };
                var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE);
                return f.default || f // try to call default if defined to also support babel esmodule exports
                ;
            }
            var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+';
            var dependencyRegExp = '\\((\/\\*.*?\\*\/)?\s?.*?(' + moduleNameReqExp + ').*?\\)' // additional chars when output.pathinfo is true
            ;
            // http://stackoverflow.com/a/2593661/130442
            function quoteRegExp(str) {
                return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
            }
            function getModuleDependencies(sources, module1, queueName) {
                var retval = {};
                retval[queueName] = [];
                var fnString = module1.toString();
                var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);
                if (!wrapperSignature) return retval;
                var webpackRequireName = wrapperSignature[1];
                // main bundle deps
                var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g');
                var match;
                while(match = re.exec(fnString)){
                    if (match[3] === 'dll-reference') continue;
                    retval[queueName].push(match[3]);
                }
                // dll deps
                re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g');
                while(match = re.exec(fnString)){
                    if (!sources[match[2]]) {
                        retval[queueName].push(match[1]);
                        sources[match[2]] = __webpack_require__(match[1]).m;
                    }
                    retval[match[2]] = retval[match[2]] || [];
                    retval[match[2]].push(match[4]);
                }
                return retval;
            }
            function hasValuesInQueues(queues) {
                var keys = Object.keys(queues);
                return keys.reduce(function(hasValues, key) {
                    return hasValues || queues[key].length > 0;
                }, false);
            }
            function getRequiredModules(sources, moduleId) {
                var modulesQueue = {
                    main: [
                        moduleId
                    ]
                };
                var requiredModules = {
                    main: []
                };
                var seenModules = {
                    main: {}
                };
                while(hasValuesInQueues(modulesQueue)){
                    var queues = Object.keys(modulesQueue);
                    for(var i = 0; i < queues.length; i++){
                        var queueName = queues[i];
                        var queue = modulesQueue[queueName];
                        var moduleToCheck = queue.pop();
                        seenModules[queueName] = seenModules[queueName] || {};
                        if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue;
                        seenModules[queueName][moduleToCheck] = true;
                        requiredModules[queueName] = requiredModules[queueName] || [];
                        requiredModules[queueName].push(moduleToCheck);
                        var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName);
                        var newModulesKeys = Object.keys(newModules);
                        for(var j = 0; j < newModulesKeys.length; j++){
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || [];
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]]);
                        }
                    }
                }
                return requiredModules;
            }
            module1.exports = function(moduleId, options) {
                options = options || {};
                var sources = {
                    main: __webpack_require__.m
                };
                var requiredModules = options.all ? {
                    main: Object.keys(sources)
                } : getRequiredModules(sources, moduleId);
                var src = '';
                Object.keys(requiredModules).filter(function(m) {
                    return m !== 'main';
                }).forEach(function(module1) {
                    var entryModule = 0;
                    while(requiredModules[module1][entryModule])entryModule++;
                    requiredModules[module1].push(entryModule);
                    sources[module1][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })';
                    src = src + 'var ' + module1 + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module1].map(function(id) {
                        return '' + JSON.stringify(id) + ': ' + sources[module1][id].toString();
                    }).join(',') + '});\n';
                });
                src = src + '(' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function(id) {
                    return '' + JSON.stringify(id) + ': ' + sources.main[id].toString();
                }).join(',') + '})(self);';
                var blob = new window.Blob([
                    src
                ], {
                    type: 'text/javascript'
                });
                if (options.bare) return blob;
                var URL1 = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var workerUrl = URL1.createObjectURL(blob);
                var worker = new window.Worker(workerUrl);
                worker.objectURL = workerUrl;
                return worker;
            };
        /***/ },
        /* 5 */ /***/ function(module1, exports) {
            // The low-level RushCore module provides the heart of Rusha,
            // a high-speed sha1 implementation working on an Int32Array heap.
            // At first glance, the implementation seems complicated, however
            // with the SHA1 spec at hand, it is obvious this almost a textbook
            // implementation that has a few functions hand-inlined and a few loops
            // hand-unrolled.
            module1.exports = function RushaCore(stdlib$840, foreign$841, heap$842) {
                'use asm';
                var H$843 = new stdlib$840.Int32Array(heap$842);
                function hash$844(k$845, x$846) {
                    // k in bytes
                    k$845 = k$845 | 0;
                    x$846 = x$846 | 0;
                    var i$847 = 0, j$848 = 0, y0$849 = 0, z0$850 = 0, y1$851 = 0, z1$852 = 0, y2$853 = 0, z2$854 = 0, y3$855 = 0, z3$856 = 0, y4$857 = 0, z4$858 = 0, t0$859 = 0, t1$860 = 0;
                    y0$849 = H$843[x$846 + 320 >> 2] | 0;
                    y1$851 = H$843[x$846 + 324 >> 2] | 0;
                    y2$853 = H$843[x$846 + 328 >> 2] | 0;
                    y3$855 = H$843[x$846 + 332 >> 2] | 0;
                    y4$857 = H$843[x$846 + 336 >> 2] | 0;
                    for(i$847 = 0; (i$847 | 0) < (k$845 | 0); i$847 = i$847 + 64 | 0){
                        z0$850 = y0$849;
                        z1$852 = y1$851;
                        z2$854 = y2$853;
                        z3$856 = y3$855;
                        z4$858 = y4$857;
                        for(j$848 = 0; (j$848 | 0) < 64; j$848 = j$848 + 4 | 0){
                            t1$860 = H$843[i$847 + j$848 >> 2] | 0;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 & y2$853 | ~y1$851 & y3$855) | 0) + ((t1$860 + y4$857 | 0) + 1518500249 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[k$845 + j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 64 | 0; (j$848 | 0) < (k$845 + 80 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 & y2$853 | ~y1$851 & y3$855) | 0) + ((t1$860 + y4$857 | 0) + 1518500249 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 80 | 0; (j$848 | 0) < (k$845 + 160 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 ^ y2$853 ^ y3$855) | 0) + ((t1$860 + y4$857 | 0) + 1859775393 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 160 | 0; (j$848 | 0) < (k$845 + 240 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 & y2$853 | y1$851 & y3$855 | y2$853 & y3$855) | 0) + ((t1$860 + y4$857 | 0) - 1894007588 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 240 | 0; (j$848 | 0) < (k$845 + 320 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 ^ y2$853 ^ y3$855) | 0) + ((t1$860 + y4$857 | 0) - 899497514 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        y0$849 = y0$849 + z0$850 | 0;
                        y1$851 = y1$851 + z1$852 | 0;
                        y2$853 = y2$853 + z2$854 | 0;
                        y3$855 = y3$855 + z3$856 | 0;
                        y4$857 = y4$857 + z4$858 | 0;
                    }
                    H$843[x$846 + 320 >> 2] = y0$849;
                    H$843[x$846 + 324 >> 2] = y1$851;
                    H$843[x$846 + 328 >> 2] = y2$853;
                    H$843[x$846 + 332 >> 2] = y3$855;
                    H$843[x$846 + 336 >> 2] = y4$857;
                }
                return {
                    hash: hash$844
                };
            };
        /***/ },
        /* 6 */ /***/ function(module1, exports) {
            var _this = this;
            /* eslint-env commonjs, browser */ var reader = void 0;
            if (typeof self !== 'undefined' && typeof self.FileReaderSync !== 'undefined') reader = new self.FileReaderSync();
            // Convert a binary string and write it to the heap.
            // A binary string is expected to only contain char codes < 256.
            var convStr = function(str, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = str.charCodeAt(start + 3);
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = str.charCodeAt(start + 2);
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = str.charCodeAt(start + 1);
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = str.charCodeAt(start);
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2] = str.charCodeAt(start + i) << 24 | str.charCodeAt(start + i + 1) << 16 | str.charCodeAt(start + i + 2) << 8 | str.charCodeAt(start + i + 3);
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = str.charCodeAt(start + j + 2);
                    case 2:
                        H8[off + j + 2 | 0] = str.charCodeAt(start + j + 1);
                    case 1:
                        H8[off + j + 3 | 0] = str.charCodeAt(start + j);
                }
            };
            // Convert a buffer or array and write it to the heap.
            // The buffer or array is expected to only contain elements < 256.
            var convBuf = function(buf, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = buf[start + 3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[start + 2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[start + 1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[start];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[start + i] << 24 | buf[start + i + 1] << 16 | buf[start + i + 2] << 8 | buf[start + i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[start + j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[start + j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[start + j];
                }
            };
            var convBlob = function(blob, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                var buf = new Uint8Array(reader.readAsArrayBuffer(blob.slice(start, start + len)));
                switch(om){
                    case 0:
                        H8[off] = buf[3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[0];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[i] << 24 | buf[i + 1] << 16 | buf[i + 2] << 8 | buf[i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[j];
                }
            };
            module1.exports = function(data, H8, H32, start, len, off) {
                if (typeof data === 'string') return convStr(data, H8, H32, start, len, off);
                if (data instanceof Array) return convBuf(data, H8, H32, start, len, off);
                // Safely doing a Buffer check using "this" to avoid Buffer polyfill to be included in the dist
                if (_this && _this.Buffer && _this.Buffer.isBuffer(data)) return convBuf(data, H8, H32, start, len, off);
                if (data instanceof ArrayBuffer) return convBuf(new Uint8Array(data), H8, H32, start, len, off);
                if (data.buffer instanceof ArrayBuffer) return convBuf(new Uint8Array(data.buffer, data.byteOffset, data.byteLength), H8, H32, start, len, off);
                if (data instanceof Blob) return convBlob(data, H8, H32, start, len, off);
                throw new Error('Unsupported data type.');
            };
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var Rusha = __webpack_require__(0);
            var _require = __webpack_require__(1), toHex = _require.toHex;
            var Hash = function() {
                function Hash() {
                    _classCallCheck(this, Hash);
                    this._rusha = new Rusha();
                    this._rusha.resetState();
                }
                Hash.prototype.update = function update(data) {
                    this._rusha.append(data);
                    return this;
                };
                Hash.prototype.digest = function digest(encoding) {
                    var digest = this._rusha.rawEnd().buffer;
                    if (!encoding) return digest;
                    if (encoding === 'hex') return toHex(digest);
                    throw new Error('unsupported digest encoding');
                };
                _createClass(Hash, [
                    {
                        key: 'state',
                        get: function() {
                            return this._rusha.getState();
                        },
                        set: function(state) {
                            this._rusha.setState(state);
                        }
                    }
                ]);
                return Hash;
            }();
            module1.exports = function() {
                return new Hash();
            };
        /***/ }
    ]);
});

});

parcelRegister("lPJNC", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3e2d250be541ee83$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    help: {
        id: "fabric.editor.elementBrowser.help",
        defaultMessage: "Help"
    },
    insert: {
        id: "fabric.editor.elementbrowser.modal.insert",
        defaultMessage: "Insert"
    },
    close: {
        id: "fabric.editor.elementbrowser.modal.close",
        defaultMessage: "Close"
    },
    all: {
        id: "fabric.editor.elementbrowser.categorylist.category-all",
        defaultMessage: "All"
    },
    formatting: {
        id: "fabric.editor.elementbrowser.categorylist.category-formatting",
        defaultMessage: "Formatting"
    },
    'confluence-content': {
        id: "fabric.editor.elementbrowser.categorylist.category-confluence-content",
        defaultMessage: "Confluence content"
    },
    media: {
        id: "fabric.editor.elementbrowser.categorylist.category-media",
        defaultMessage: "Media"
    },
    visuals: {
        id: "fabric.editor.elementbrowser.categorylist.category-visuals",
        defaultMessage: "Visuals & images"
    },
    navigation: {
        id: "fabric.editor.elementbrowser.categorylist.category-navigation",
        defaultMessage: "Navigation"
    },
    'external-content': {
        id: "fabric.editor.elementbrowser.categorylist.category-external-content",
        defaultMessage: "External content"
    },
    communication: {
        id: "fabric.editor.elementbrowser.categorylist.category-communication",
        defaultMessage: "Communication"
    },
    reporting: {
        id: "fabric.editor.elementbrowser.categorylist.category-reporting",
        defaultMessage: "Reporting"
    },
    admin: {
        id: "fabric.editor.elementbrowser.categorylist.category-admin",
        defaultMessage: "Administration"
    },
    development: {
        id: "fabric.editor.elementbrowser.categorylist.category-development",
        defaultMessage: "Development"
    },
    AI: {
        id: "fabric.editor.elementbrowser.categorylist.category-ai",
        defaultMessage: "Rovo"
    },
    featuredWhiteboardDescription: {
        id: "fabric.editor.elementbrowser.featured.whiteboard.description",
        defaultMessage: "Use a whiteboard to add visuals to your page"
    },
    browse: {
        id: "fabric.editor.elementbrowser.sidebar.heading",
        defaultMessage: "Browse"
    },
    categoryRecommended: {
        id: "editor-common.quick-insert.categoryRecommended",
        defaultMessage: "Recommended"
    },
    categoryStructure: {
        id: "editor-common.quick-insert.categoryStructure",
        defaultMessage: "Structure"
    },
    categoryMedia: {
        id: "editor-common.quick-insert.categoryMedia",
        defaultMessage: "Media"
    },
    categoryCreate: {
        id: "editor-common.quick-insert.categoryCreate",
        defaultMessage: "Create"
    },
    categoryEmbed: {
        id: "editor-common.quick-insert.categoryEmbed",
        defaultMessage: "Embed"
    },
    categoryTextFormatting: {
        id: "editor-common.quick-insert.categoryTextFormatting",
        defaultMessage: "Text formatting"
    },
    categoryRovo: {
        id: "editor-common.quick-insert.categoryRovo",
        defaultMessage: "Rovo"
    },
    categoryDataAndCharts: {
        id: "editor-common.quick-insert.categoryDataAndCharts",
        defaultMessage: "Data and charts"
    },
    categoryBlockTemplates: {
        id: "editor-common.quick-insert.categoryBlockTemplates",
        defaultMessage: "Block templates"
    },
    categoryOther: {
        id: "editor-common.quick-insert.categoryOther",
        defaultMessage: "Other elements"
    },
    searchResults: {
        id: "editor-common.quick-insert.searchResults",
        defaultMessage: "Search results"
    },
    previewAttributionBy: {
        id: "editor-common.quick-insert.previewAttributionBy",
        defaultMessage: "By {name}"
    },
    previewAttributionAtlassian: {
        id: "editor-common.quick-insert.previewAttributionAtlassian.ai-non-final",
        defaultMessage: "Atlassian"
    },
    previewAttributionAssets: {
        id: "editor-common.quick-insert.previewAttributionAssets.ai-non-final",
        defaultMessage: "Assets"
    },
    previewAttributionConfluence: {
        id: "editor-common.quick-insert.previewAttributionConfluence.ai-non-final",
        defaultMessage: "Confluence"
    },
    previewAttributionJira: {
        id: "editor-common.quick-insert.previewAttributionJira.ai-non-final",
        defaultMessage: "Jira"
    },
    previewAttributionJiraServiceManagement: {
        id: "editor-common.quick-insert.previewAttributionJiraServiceManagement.ai-non-final",
        defaultMessage: "Jira Service Management"
    },
    previewAttributionMicrosoft: {
        id: "editor-common.quick-insert.previewAttributionMicrosoft.ai-non-final",
        defaultMessage: "Microsoft"
    }
});
module.exports["messages"] = $3e2d250be541ee83$export$defe85febe8b728c;

});

parcelRegister("6OpMl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $d8DK7 = parcelRequire("d8DK7");


var $e4Q12 = parcelRequire("e4Q12");


var $l4yrE = parcelRequire("l4yrE");

/* ResourcedEmojiComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");





var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");


var $gxxZD = parcelRequire("gxxZD");


var $9tfSW = parcelRequire("9tfSW");


var $1GEKi = parcelRequire("1GEKi");








var $4xiow = parcelRequire("4xiow");


var $2p7KE = parcelRequire("2p7KE");


var $72OmS = parcelRequire("72OmS");


var $1Vdnd = parcelRequire("1Vdnd");


var $1FzXO = parcelRequire("1FzXO");


var $iKpb2 = parcelRequire("iKpb2");

const $af933464a9c9fdc1$var$ignoreWrapperStyles = null;
var $af933464a9c9fdc1$var$ResourcedEmojiComponentRenderStatesEnum = /*#__PURE__*/ function(ResourcedEmojiComponentRenderStatesEnum) {
    ResourcedEmojiComponentRenderStatesEnum["INITIAL"] = "INITIAL";
    ResourcedEmojiComponentRenderStatesEnum["FALLBACK"] = "FALLBACK";
    ResourcedEmojiComponentRenderStatesEnum["EMOJI"] = "EMOJI";
    return ResourcedEmojiComponentRenderStatesEnum;
}($af933464a9c9fdc1$var$ResourcedEmojiComponentRenderStatesEnum || {});
const $af933464a9c9fdc1$export$7bfde52eceb3e2f6 = ({ emojiProvider: emojiProvider, emojiId: emojiId, emojiProviderLookupOrder: emojiProviderLookupOrder, showTooltip: showTooltip = false, customFallback: customFallback, fitToHeight: fitToHeight = (0, $l4yrE.defaultEmojiHeight), ignoreWrapper: ignoreWrapper = false, optimistic: optimistic = false, optimisticImageURL: optimisticImageURL, editorEmoji: editorEmoji, renderUnicodeEmojiAsImage: renderUnicodeEmojiAsImage = true, pageTitleEmoji: pageTitleEmoji = false, placeholderXcss: placeholderXcss, onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    const { shortName: shortName, id: id, fallback: fallback } = emojiId;
    const [emoji, setEmoji] = (0, $cozmU.useState)();
    const [loaded, setLoaded] = (0, $cozmU.useState)(false);
    const [imageLoadError, setImageLoadError] = (0, $cozmU.useState)(false);
    const [resolvedEmojiProvider, setResolvedEmojiProvider] = (0, $cozmU.useState)();
    const fetchOrGetEmoji = (0, $cozmU.useCallback)(async (_emojiProvider, emojiId, optimisticFetch = false)=>{
        if (!_emojiProvider.fetchByEmojiId) {
            setEmoji(undefined);
            const reason = 'missing fetchByEmojiId interface';
            onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
            (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).failure({
                metadata: {
                    reason: reason,
                    source: 'ResourcedEmojiComponent'
                }
            });
        }
        const useUnicodeEmojis = (0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true);
        const normalizedEmojiId = useUnicodeEmojis ? {
            ...emojiId,
            id: emojiId.id || undefined
        } : emojiId; // A shortName-only optimistic request can resolve without an emoji before the catalogue loads.
        // Use the non-optimistic path so it waits for the catalogue and tokenizes custom emoji media.
        const shouldFetchOptimistically = useUnicodeEmojis ? optimisticFetch && Boolean(emojiId.id) : optimisticFetch;
        const foundEmoji = _emojiProvider.fetchByEmojiId(normalizedEmojiId, shouldFetchOptimistically, (0, $iDrrr.fg)('platform_bitbucket_fix_shortname_and_ordering') ? emojiProviderLookupOrder : undefined);
        (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).mark((0, $9tfSW.UfoEmojiTimings).METADATA_START);
        if ((0, $1Vdnd.isPromise)(foundEmoji)) {
            setLoaded(false);
            foundEmoji.then((emoji)=>{
                setEmoji(emoji);
                if (!emoji) {
                    const reason = 'failed to find';
                    onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason); // emoji is undefined
                    (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).failure({
                        metadata: {
                            reason: reason,
                            source: 'ResourcedEmojiComponent',
                            data: {
                                emoji: {
                                    id: emojiId.id,
                                    shortName: emojiId.shortName
                                }
                            }
                        }
                    });
                }
            }).catch(()=>{
                setEmoji(undefined);
                const reason = 'failed to load';
                onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).failure({
                    metadata: {
                        reason: reason,
                        source: 'ResourcedEmojiComponent',
                        data: {
                            emoji: {
                                id: emojiId.id,
                                shortName: emojiId.shortName
                            }
                        }
                    }
                });
            }).finally(()=>{
                setLoaded(true);
                (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).mark((0, $9tfSW.UfoEmojiTimings).METADATA_END);
            });
        } else {
            setEmoji(foundEmoji);
            setLoaded(true);
            (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).mark((0, $9tfSW.UfoEmojiTimings).METADATA_END);
        }
    }, [
        emojiProviderLookupOrder,
        onEmojiLoadFail
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!emojiId) return;
        if (!(0, $1GEKi.hasUfoMarked)((0, $d8DK7.sampledUfoRenderedEmoji)(emojiId), (0, $9tfSW.UfoEmojiTimings).FMP_END)) (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).markFMP();
    }, [
        emojiId
    ]); // Fetching during render means a render React later discards (for example a pass that suspends)
    // still creates a promise whose callbacks set state and schedule yet another render. This layout
    // effect only runs for committed renders, and being pre-paint it keeps the synchronous cache-hit
    // path from flashing the placeholder.
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!resolvedEmojiProvider || !emojiId) return;
        fetchOrGetEmoji(resolvedEmojiProvider, emojiId, optimistic);
    }, [
        resolvedEmojiProvider,
        emojiId,
        optimistic,
        fetchOrGetEmoji
    ]); /**
                                                                      * Setting resolved emoji provider for optimistic rendering
                                                                      */ 
    (0, $cozmU.useEffect)(()=>{
        Promise.resolve(emojiProvider).then((emojiProvider)=>{
            setResolvedEmojiProvider(emojiProvider);
        });
    }, [
        emojiProvider
    ]);
    const emojiRenderState = (0, $cozmU.useMemo)(()=>{
        if (!emoji && !loaded && !optimisticImageURL || optimisticImageURL && !emoji && !id && (0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) return "INITIAL";
        else if (!emoji && loaded || imageLoadError) return "FALLBACK";
        return "EMOJI";
    }, [
        emoji,
        loaded,
        optimisticImageURL,
        imageLoadError,
        id
    ]);
    const optimisticEmojiDescription = (0, $cozmU.useMemo)(()=>{
        // For STANDARD emojis, use native unicode character instead of optimistic image.
        if ((0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
            const resolvedId = id || emoji?.id;
            if (!resolvedId) return undefined;
            const unicodeEmoji = (0, $4xiow.emojiIdToEmoji)(resolvedId);
            if (unicodeEmoji) return {
                ...emoji ?? {
                    id: id,
                    shortName: shortName,
                    fallback: fallback,
                    type: 'STANDARD',
                    category: '',
                    searchable: true
                },
                representation: {
                    unicodeEmoji: unicodeEmoji
                }
            };
        } // reduce blast radius by targeting page title
        if (pageTitleEmoji && optimisticImageURL && (0, $iDrrr.fg)('platform_emoji_prevent_img_src_changing')) return {
            id: id,
            shortName: shortName,
            fallback: fallback,
            type: '',
            category: '',
            searchable: true,
            representation: {
                height: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
                width: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
                imagePath: optimisticImageURL
            }
        };
         // extend prevention to all surfaces
        if (optimisticImageURL && (0, $iDrrr.fg)('platform_emoji_prevent_img_src_changing_all')) return {
            id: id,
            shortName: shortName,
            fallback: fallback,
            type: '',
            category: '',
            searchable: true,
            representation: {
                height: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
                width: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
                imagePath: optimisticImageURL
            }
        };
        if (optimisticImageURL) {
            if (emoji && ((0, $2p7KE.isImageRepresentation)(emoji.representation) || (0, $72OmS.isMediaRepresentation)(emoji?.representation))) {
                const { width: width, height: height } = emoji.representation;
                return {
                    ...emoji,
                    representation: {
                        width: width,
                        height: height,
                        imagePath: optimisticImageURL
                    }
                };
            } else return {
                id: id,
                shortName: shortName,
                fallback: fallback,
                type: '',
                category: '',
                representation: {
                    height: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
                    width: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true
            };
        }
        return emoji;
    }, [
        emoji,
        optimisticImageURL,
        fallback,
        fitToHeight,
        id,
        shortName,
        pageTitleEmoji
    ]);
    const handleOnLoadError = (0, $cozmU.useCallback)((emojiId)=>{
        setImageLoadError(true);
        const reason = 'load error';
        onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
        (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).failure({
            metadata: {
                reason: reason,
                source: 'ResourcedEmojiComponent',
                emojiId: emojiId.id
            }
        });
    }, [
        onEmojiLoadFail
    ]);
    const handleOnLoadSuccess = (0, $cozmU.useCallback)((emojiId)=>{
        onEmojiLoadSuccess && onEmojiLoadSuccess(emojiId.id);
    }, [
        onEmojiLoadSuccess
    ]); // use width: auto when fitToHeight is defined
    const autoWidth = !!fitToHeight;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gxxZD.EmojiCommonProvider), {
        emojiProvider: resolvedEmojiProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-emoji-id": id,
        "data-emoji-short-name": shortName,
        "data-emoji-text": fallback || shortName,
        "data-ssr-placeholder": `emoji-${id ?? shortName}`,
        "data-ssr-placeholder-replace": `emoji-${id ?? shortName}`,
        className: (0, $hekY6.default)([
            ignoreWrapper && "_3iDTPbcK7c"
        ])
    }, emojiRenderState === "INITIAL" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), {
        shortName: shortName,
        showTooltip: showTooltip,
        size: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
        loading: true,
        xcss: placeholderXcss
    }), emojiRenderState === "FALLBACK" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, customFallback || fallback || shortName), emojiRenderState === "EMOJI" && optimisticEmojiDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1FzXO.default), {
        emoji: optimisticEmojiDescription,
        onLoadError: handleOnLoadError,
        onLoadSuccess: handleOnLoadSuccess,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        autoWidth: autoWidth,
        editorEmoji: editorEmoji,
        renderUnicodeEmojiAsImage: renderUnicodeEmojiAsImage
    })));
};
var $af933464a9c9fdc1$export$2e2bcd8739ae039 = $af933464a9c9fdc1$export$7bfde52eceb3e2f6;



var $9Jo6P = parcelRequire("9Jo6P");

const $8996823a89ed3e69$var$ResourcedEmoji = (props)=>{
    const { emojiId: emojiId, optimisticImageURL: optimisticImageURL } = props;
    (0, $cozmU.useEffect)(()=>{
        if (!emojiId) return;
        (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).start({
            samplingRate: (0, $l4yrE.SAMPLING_RATE_EMOJI_RENDERED_EXP)
        });
        (0, $e4Q12.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName).addMetadata({
            source: 'ResourcedEmoji',
            emojiId: emojiId.id,
            isOptimisticImageURL: !!optimisticImageURL
        });
        return ()=>{
            (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).abort({
                metadata: {
                    source: 'ResourcedEmoji',
                    reason: 'unmount'
                }
            });
        };
    }, [
        emojiId,
        optimisticImageURL
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Jo6P.UfoErrorBoundary), {
        experiences: [
            (0, $e4Q12.ufoExperiences)['emoji-rendered'].getInstance(props.emojiId.id || props.emojiId.shortName)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af933464a9c9fdc1$export$7bfde52eceb3e2f6), props));
};
var $8996823a89ed3e69$export$2e2bcd8739ae039 = $8996823a89ed3e69$var$ResourcedEmoji;
module.exports["default"] = $8996823a89ed3e69$export$2e2bcd8739ae039;

});

parcelRegister("d8DK7", function(module, exports) {

var $e4Q12 = parcelRequire("e4Q12");


var $53TEx = parcelRequire("53TEx");

const $37720bf73e14576a$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $53TEx.withSampling)((0, $e4Q12.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
module.exports["sampledUfoRenderedEmoji"] = $37720bf73e14576a$export$71c8cba6f1251ea9;

});

parcelRegister("gxxZD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cr9f7 = parcelRequire("cr9f7");

const $d0b501ffb123d2f7$export$1120e666998e21b5 = (props)=>{
    const emojiContextValue = (0, $cozmU.useMemo)(()=>props.emojiProvider ? {
            emoji: {
                emojiProvider: props.emojiProvider
            }
        } : undefined, [
        props.emojiProvider
    ]);
    if (!!emojiContextValue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cr9f7.EmojiContextProvider), {
        emojiContextValue: emojiContextValue
    }, props.children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
};
module.exports["EmojiCommonProvider"] = $d0b501ffb123d2f7$export$1120e666998e21b5;

});

parcelRegister("cr9f7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $l3Ofr = parcelRequire("l3Ofr");


var $aGLvf = parcelRequire("aGLvf");

const $47b6237c4d0cf4ed$export$f4a09143833145ed = ({ children: children, emojiContextValue: emojiContextValue })=>{
    const memoizedEmojiContextValue = (0, $cozmU.useMemo)(()=>emojiContextValue, [
        emojiContextValue
    ]);
    (0, $cozmU.useEffect)(()=>{
        // trigger emoji fetching
        async function fetchEmojiProvider() {
            try {
                await memoizedEmojiContextValue?.emoji.emojiProvider.fetchEmojiProvider();
            } catch (error) {
                (0, $l3Ofr.default)('fetchEmojiProvider error catched from outside', error);
            }
        }
        if (memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand) {
            const isFetchingOnDemand = memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand();
            if (!isFetchingOnDemand) fetchEmojiProvider();
        } else fetchEmojiProvider();
    }, [
        memoizedEmojiContextValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aGLvf.EmojiContext).Provider, {
        value: memoizedEmojiContextValue
    }, children);
};
module.exports["EmojiContextProvider"] = $47b6237c4d0cf4ed$export$f4a09143833145ed;

});

parcelRegister("1GEKi", function(module, exports) {
const $ac4f45f8bd90a0fe$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
module.exports["hasUfoMarked"] = $ac4f45f8bd90a0fe$export$a9be054d2a5cedc0;

});

parcelRegister("1FzXO", function(module, exports) {
/* Emoji.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $9tfSW = parcelRequire("9tfSW");


var $1GEKi = parcelRequire("1GEKi");


var $d8DK7 = parcelRequire("d8DK7");


var $e4Q12 = parcelRequire("e4Q12");


var $7gsaD = parcelRequire("7gsaD");


var $l4yrE = parcelRequire("l4yrE");

const $74d8240b08e598d0$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);


const $208e74a60833564a$export$607f0d89b8881fb4 = (rep)=>!!(rep && rep.unicodeEmoji);



var $bvr9K = parcelRequire("bvr9K");


var $ldPoq = parcelRequire("ldPoq");


var $1kRhf = parcelRequire("1kRhf");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 


const $05233230a42f662c$export$471c4c6c1d1a0512 = (props, event)=>{
    const { emoji: emoji, onDelete: onDelete } = props;
    if (onDelete) onDelete((0, $ldPoq.toEmojiId)(emoji), emoji, event);
};


/* ImageEmoji.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $1hQ0e = parcelRequire("1hQ0e");








var $d96oP = parcelRequire("d96oP");

const $c6cbfe5640e3365a$var$getHeight = (fitToHeight)=>(0, $d96oP.getPixelRatio)() > 1 ? fitToHeight * 2 : fitToHeight;
const $c6cbfe5640e3365a$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && emoji.representation && 'height' in emoji.representation && $c6cbfe5640e3365a$var$getHeight(fitToHeight) > emoji.representation.height);



var $5sUij = parcelRequire("5sUij");

const $ce7a17dc9ab6d41e$var$result = {
    mac: false,
    supportsIntersectionObserver: false
};
if (typeof navigator !== 'undefined') {
    $ce7a17dc9ab6d41e$var$result.mac = /Mac/.test(navigator.platform);
    $ce7a17dc9ab6d41e$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}
var $ce7a17dc9ab6d41e$export$2e2bcd8739ae039 = $ce7a17dc9ab6d41e$var$result;


const $195e4aff720550fa$export$2f62ee6831462844 = (options)=>{
    const hookResult = (0, $5sUij.useInView)(options);
    if (!(0, $ce7a17dc9ab6d41e$export$2e2bcd8739ae039).supportsIntersectionObserver) // Unsupported, return no `ref` and default `inView` true value
    return [
        undefined,
        true
    ];
    return hookResult;
};













var $2p7KE = parcelRequire("2p7KE");


var $72OmS = parcelRequire("72OmS");










/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ /**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ /**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ function $53c540ad50774e92$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace(/Mod/i, 'Ctrl'),
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}


function $f45a08709afce394$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace(/Mod/i, 'Ctrl');
    const mac = common.replace(/Mod/i, 'Cmd');
    return (0, $53c540ad50774e92$export$d8a7f422d8d42038)(description, windows, mac, common);
}


const $05c9bdca5f91550e$export$1ea584ca7009bcc1 = (0, $f45a08709afce394$export$7e6b588cc98b34f1)('Backspace', 'Backspace');
const $05c9bdca5f91550e$export$8d734690d3a46118 = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};





/* ToolTipContentWithKeymap.tsx generated by @compiled/babel-plugin v3.0.2 */ 





/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 

function $eaa3cf1c1fac6b0b$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $ce7a17dc9ab6d41e$export$2e2bcd8739ae039).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
    else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = (0, $05c9bdca5f91550e$export$8d734690d3a46118)[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $ce7a17dc9ab6d41e$export$2e2bcd8739ae039).mac ? '' : '+');
}


const $99794ca75c05544d$var$tooltipShortcutStyle = null;
const $99794ca75c05544d$export$c7308f5f9ed494ac = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && (0, $eaa3cf1c1fac6b0b$export$384a290f8c265cc5)(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, description, shortcut && description && '\u00A0', shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _0KLXruB4sa _0Of8r2dnbC _1wydGWdnbC _2Zuz6QFQfX _1ZnuxbFQfX _1iKH5nD0un"
        ])
    }, shortcut)) : null;
});


const $62e6710b6e922942$export$4727956877b6f612 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99794ca75c05544d$export$c7308f5f9ed494ac), {
        description: formatMessage((0, $1kRhf.messages).deleteEmojiTooltip),
        keymap: (0, $05c9bdca5f91550e$export$1ea584ca7009bcc1)
    });
};









var $9GVkD = parcelRequire("9GVkD");




const $1d251284bd364c50$export$d151e4941072147c = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        id: `screenreader-emoji-${emoji.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $1kRhf.messages).deleteEmojiTooltipForScreenreader,
        values: {
            shortName: emoji.shortName
        }
    }));
};


/* DeleteButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $7ZB0A = parcelRequire("7ZB0A");


var $5avUB = parcelRequire("5avUB");


var $iMnC5 = parcelRequire("iMnC5");





var $7gAFi = parcelRequire("7gAFi");


var $a5rDX = parcelRequire("a5rDX");

const $beda65cbb4bf246c$var$styles = {
    boxWrapperStyle: "_39xV0270UD _0jFU0V70UD"
};
const $beda65cbb4bf246c$var$deleteButton = null;
const $beda65cbb4bf246c$var$refreshedDeleteButton = null; /**
                                     * Test id for wrapper Emoji delete button
                                     */ 
const $beda65cbb4bf246c$export$28fc7374cf1206d4 = 'render-emoji-delete-button';
const $beda65cbb4bf246c$var$DeleteButton = (props)=>{
    const isRefreshEnabled = (0, $7gAFi.isRefreshEmojiPickerEnabled)();
    return /*#__PURE__*/ $cozmU.createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_0fKRyPnQyn _3iDTPbQ4SZ _1mT5xdWVPG _2IhTon4F84 _4ApkO24F84 _42Yu6B7dHp _2CTNV7dnbC",
            isRefreshEnabled && "_2IhTon5UaJ _4ApkO25UaJ",
            (0, $a5rDX.emojiDeleteButton)
        ]),
        "data-testid": $beda65cbb4bf246c$export$28fc7374cf1206d4
    }, /*#__PURE__*/ $cozmU.createElement((0, $7ZB0A.default), {
        iconBefore: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $beda65cbb4bf246c$var$styles.boxWrapperStyle
        }, isRefreshEnabled ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
            label: (0, $l4yrE.deleteEmojiLabel),
            color: "var(--ds-icon, #292A2E)",
            size: "medium"
        }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
            label: (0, $l4yrE.deleteEmojiLabel),
            color: "var(--ds-text-subtle, #505258)",
            size: "small"
        })),
        onClick: props.onClick,
        appearance: "subtle-link",
        spacing: "none",
        testId: "emoji-delete-button",
        tabIndex: -1
    }));
};
var $beda65cbb4bf246c$export$2e2bcd8739ae039 = $beda65cbb4bf246c$var$DeleteButton;



var $1FzXO = parcelRequire("1FzXO");





const $7cbdfa334838272a$var$handleImageError = (props, event)=>{
    const { emoji: emoji, onLoadError: onLoadError } = props; // Hide error state (but keep space for it)
    if (event.target) {
        const target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) onLoadError((0, $ldPoq.toEmojiId)(emoji), emoji, event);
};
const $7cbdfa334838272a$export$99dfeb9d71c11788 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showDelete: showDelete, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, isDecorative: isDecorative } = props;
    const [ref, inView] = (0, $195e4aff720550fa$export$2f62ee6831462844)({
        triggerOnce: true
    });
    const ufoExp = (0, $cozmU.useMemo)(()=>(0, $d8DK7.sampledUfoRenderedEmoji)(emoji), [
        emoji
    ]);
    const classes = `${(0, $a5rDX.emojiMainStyle)} ${(0, $a5rDX.emojiNodeStyles)} ${selected ? (0, $a5rDX.commonSelectedStyles) : ''} ${selectOnHover ? (0, $a5rDX.selectOnHoverStyles) : ''} ${(0, $a5rDX.emojiImage)} ${className ? className : ''} ${showDelete ? (0, $a5rDX.deletableEmoji) : ''}`;
    let width;
    let height;
    let src;
    const representation = (0, $c6cbfe5640e3365a$export$b7e9058f156d8d19)(emoji, fitToHeight) ? emoji.altRepresentation : emoji.representation;
    if ((0, $2p7KE.isImageRepresentation)(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    } else if ((0, $72OmS.isMediaRepresentation)(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    let sizing = {};
    if (fitToHeight && width && height) {
        const sizingWidth = autoWidth ? 'auto' : fitToHeight / height * width; // Presize image, to prevent reflow due to size changes after loading
        sizing = {
            width: sizingWidth,
            height: fitToHeight
        };
    }
    const onError = (0, $cozmU.useCallback)((event)=>{
        $7cbdfa334838272a$var$handleImageError({
            emoji: props.emoji,
            onLoadError: props.onLoadError
        }, event);
    }, [
        props.emoji,
        props.onLoadError
    ]);
    const onLoad = (0, $cozmU.useCallback)(()=>{
        const mountedMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $9tfSW.UfoEmojiTimings).MOUNTED_END); // onload could trigger before onBeforeLoad when emojis in viewport at start, so we need to mark onload start manually.
        if (!(0, $1GEKi.hasUfoMarked)(ufoExp, (0, $9tfSW.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $9tfSW.UfoEmojiTimings).ONLOAD_START, mountedMark?.time);
        const loadedStartMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $9tfSW.UfoEmojiTimings).ONLOAD_START);
        if (mountedMark && loadedStartMark) ufoExp.addMetadata({
            lazyLoad: loadedStartMark.time > mountedMark.time
        });
         // onload_start
        if (!(0, $1GEKi.hasUfoMarked)(ufoExp, (0, $9tfSW.UfoEmojiTimings).ONLOAD_END)) ufoExp.mark((0, $9tfSW.UfoEmojiTimings).ONLOAD_END);
        ufoExp.success({
            metadata: {
                IBSupported: (0, $ce7a17dc9ab6d41e$export$2e2bcd8739ae039).supportsIntersectionObserver
            }
        });
        if (onLoadSuccess) onLoadSuccess(emoji);
    }, [
        emoji,
        onLoadSuccess,
        ufoExp
    ]);
    const onBeforeLoad = (0, $cozmU.useCallback)(()=>{
        if (!(0, $1GEKi.hasUfoMarked)(ufoExp, (0, $9tfSW.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $9tfSW.UfoEmojiTimings).ONLOAD_START);
    }, [
        ufoExp
    ]);
    const onMouseOver = (0, $cozmU.useCallback)((e)=>{
        // only disable tooltip when not on focus
        if (!(0, $1hQ0e.getDocument)()?.activeElement?.contains(e.target)) e.stopPropagation();
    }, []); // because of the lack of browser support of on before load natively, used IntersectionObserver helper hook to mimic the before load time mark for UFO.
    (0, $cozmU.useEffect)(()=>{
        if (inView) onBeforeLoad();
    }, [
        inView,
        onBeforeLoad
    ]);
    const imgAlt = isDecorative && (0, $iDrrr.fg)('emoji_decorative_label') ? '' : emoji.name || emoji.shortName || '';
    const emojiNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        loading: disableLazyLoad ? 'eager' : 'lazy',
        src: src,
        key: src,
        alt: imgAlt,
        "data-emoji-short-name": emoji.shortName,
        "data-emoji-id": emoji.id,
        "data-emoji-text": emoji.fallback || emoji.shortName,
        className: "emoji",
        style: {
            visibility: 'visible'
        },
        onError: onError,
        onLoad: onLoad,
        ...sizing,
        "data-vc": "emoji"
    }); // show a tooltip for deletable emoji only on focus
    if (showDelete) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $62e6710b6e922942$export$4727956877b6f612), null),
        position: "right-start",
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1FzXO.EmojiNodeWrapper), {
        ...props,
        "aria-labelledby": `screenreader-emoji-${emoji.id}`,
        type: "image",
        className: classes,
        ref: ref,
        showTooltip: false,
        onMouseOver: onMouseOver
    }, emojiNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $beda65cbb4bf246c$export$2e2bcd8739ae039), {
        onClick: (event)=>(0, $05233230a42f662c$export$471c4c6c1d1a0512)(props, event)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1d251284bd364c50$export$d151e4941072147c), {
        emoji: emoji
    })));
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1FzXO.EmojiNodeWrapper), {
        ...props,
        type: "image",
        className: classes,
        ref: ref
    }, emojiNode));
};


/* SpriteEmoji.tsx generated by @compiled/babel-plugin v3.0.2 */ 











const $1c04ac8f330413af$export$ef49ddbb198ce334 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const representation = emoji.representation;
    const sprite = representation.sprite;
    const classes = `${(0, $a5rDX.emojiNodeStyles)} ${selected ? (0, $a5rDX.commonSelectedStyles) : ''} ${selectOnHover ? (0, $a5rDX.selectOnHoverStyles) : ''} ${className ? className : ''}`;
    let sizing = {};
    if (fitToHeight) {
        if ((0, $ieeJu.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true)) sizing = {
            minHeight: `${fitToHeight}px`,
            minWidth: `${fitToHeight}px`
        };
        else sizing = {
            width: `${fitToHeight}px`,
            height: `${fitToHeight}px`,
            minHeight: `${fitToHeight}px`,
            minWidth: `${fitToHeight}px`
        };
    }
    const xPositionInPercent = 100 / (sprite.column - 1) * (representation.xIndex - 0);
    const yPositionInPercent = 100 / (sprite.row - 1) * (representation.yIndex - 0);
    const style = {
        backgroundImage: `url(${sprite.url})`,
        backgroundPosition: `${xPositionInPercent}% ${yPositionInPercent}%`,
        backgroundSize: `${sprite.column * 100}% ${sprite.row * 100}%`,
        ...sizing
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ $cozmU.createElement((0, $1FzXO.EmojiNodeWrapper), {
        ...props,
        type: "sprite",
        className: classes
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $a5rDX.emojiSprite),
        style: style
    })));
};


/* UnicodeEmoji.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $bqYnI = parcelRequire("bqYnI");


var $9QhNT = parcelRequire("9QhNT");





var $iKpb2 = parcelRequire("iKpb2");





const $7b3879a4508dca75$var$useUnicodeEmojiImage = (unicodeEmoji)=>{
    const [state, setState] = (0, $cozmU.useState)({
        status: 'loading'
    });
    (0, $cozmU.useEffect)(()=>{
        let cancelled = false;
        let imagePathToRevoke;
        setState({
            status: 'loading',
            unicodeEmoji: unicodeEmoji
        });
        (0, $9QhNT.renderUnicodeEmojiToImagePath)(unicodeEmoji).then((imagePath)=>{
            if (cancelled) {
                if (imagePath) URL.revokeObjectURL(imagePath);
                return;
            }
            imagePathToRevoke = imagePath;
            setState(imagePath ? {
                status: 'ready',
                unicodeEmoji: unicodeEmoji,
                imagePath: imagePath
            } : {
                status: 'failed',
                unicodeEmoji: unicodeEmoji
            });
        }).catch(()=>{
            if (!cancelled) setState({
                status: 'failed',
                unicodeEmoji: unicodeEmoji
            });
        });
        return ()=>{
            cancelled = true;
            if (imagePathToRevoke) URL.revokeObjectURL(imagePathToRevoke);
        };
    }, [
        unicodeEmoji
    ]);
    return state;
};
const $7b3879a4508dca75$var$UnicodeEmojiImage = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, showTooltip: showTooltip } = props;
    const emojiText = emoji.representation.unicodeEmoji;
    const unicodeEmojiImage = $7b3879a4508dca75$var$useUnicodeEmojiImage(emojiText);
    const hasCurrentEmojiImage = unicodeEmojiImage.unicodeEmoji === emojiText;
    if ((0, $bqYnI.isSSR)() || !hasCurrentEmojiImage || unicodeEmojiImage.status === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), {
        shortName: emoji.shortName,
        showTooltip: showTooltip,
        size: fitToHeight,
        loading: true
    });
    if (unicodeEmojiImage.status === 'ready') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7cbdfa334838272a$export$99dfeb9d71c11788), {
        ...props,
        emoji: {
            ...emoji,
            altRepresentation: undefined,
            representation: {
                imagePath: unicodeEmojiImage.imagePath,
                width: (0, $1FzXO.unicodeEmojiCanvasSize),
                height: (0, $1FzXO.unicodeEmojiCanvasSize)
            }
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), {
        shortName: emoji.shortName,
        showTooltip: showTooltip,
        size: fitToHeight
    });
};
const $7b3879a4508dca75$export$a6bb8d12872402fb = (props)=>{
    const { emoji: emoji, selected: selected, selectOnHover: selectOnHover, className: className, fitToHeight: fitToHeight, renderUnicodeEmojiAsImage: renderUnicodeEmojiAsImage = true } = props;
    if (renderUnicodeEmojiAsImage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b3879a4508dca75$var$UnicodeEmojiImage, props);
    const classes = `${(0, $a5rDX.emojiNodeStyles)} ${selected ? (0, $a5rDX.commonSelectedStyles) : ''} ${selectOnHover ? (0, $a5rDX.selectOnHoverStyles) : ''} ${className ? className : ''}`;
    const emojiText = emoji.representation.unicodeEmoji;
    const defaultSize = `${fitToHeight ?? (0, $l4yrE.defaultEmojiHeight)}px`;
    const emojiSize = `var(--emoji-common-unicode-size, ${defaultSize})`;
    const style = {
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: emojiSize,
        alignItems: 'center',
        aspectRatio: '1/1'
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1FzXO.EmojiNodeWrapper), {
        ...props,
        type: "unicode",
        className: classes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: style
    }, emojiText)));
};


const $9b741b87d47c6c28$var$emojiSpriteContainer = null;
const $9b741b87d47c6c28$var$emojiImageContainer = null; // Unicode emojis render as text inside a <span>, not an <img>, so they do not need
// borderRadius (which would clip a background on hover) or the img { display: block } rule.
const $9b741b87d47c6c28$var$emojiUnicodeContainer = null;
const $9b741b87d47c6c28$export$6130a4ff6b3c066e = 128;
const $9b741b87d47c6c28$var$handleMouseDown = (props, event)=>{
    // Clicked emoji delete button
    if (event.target instanceof Element && event.target.getAttribute('aria-label') === (0, $l4yrE.deleteEmojiLabel)) return;
    const { emoji: emoji, onSelected: onSelected } = props;
    if (onSelected && (0, $bvr9K.leftClick)(event)) {
        if (props.preventFocusOnMouseDown) event.preventDefault();
        onSelected((0, $ldPoq.toEmojiId)(emoji), emoji, event);
    }
};
const $9b741b87d47c6c28$var$handleKeyDown = (props, event)=>{
    if (!(0, $l4yrE.EMOJI_KEYBOARD_KEYS_SUPPORTED).includes(event.key)) return;
    event.preventDefault();
    event.stopPropagation();
    const { emoji: emoji, onSelected: onSelected, showDelete: showDelete } = props;
    if (onSelected && (event.key === (0, $l4yrE.KeyboardKeys).Enter || event.key === (0, $l4yrE.KeyboardKeys).Space)) onSelected((0, $ldPoq.toEmojiId)(emoji), emoji, event);
    if (showDelete && event.key === (0, $l4yrE.KeyboardKeys).Backspace) (0, $05233230a42f662c$export$471c4c6c1d1a0512)(props, event);
};
const $9b741b87d47c6c28$var$handleMouseMove = (props, event)=>{
    const { emoji: emoji, onMouseMove: onMouseMove } = props;
    if (onMouseMove) onMouseMove((0, $ldPoq.toEmojiId)(emoji), emoji, event);
};
const $9b741b87d47c6c28$var$handleFocus = (props, event)=>{
    const { emoji: emoji, onFocus: onFocus } = props;
    if (onFocus) onFocus((0, $ldPoq.toEmojiId)(emoji), emoji, event);
};
const $9b741b87d47c6c28$export$ce5eef59d8e46687 = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showTooltip: showTooltip, showDelete: showDelete, shouldBeInteractive: shouldBeInteractive = false, tabIndex: tabIndex, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, onDelete: onDelete, onLoadError: onLoadError, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, children: children, type: type, editorEmoji: editorEmoji, renderUnicodeEmojiAsImage: renderUnicodeEmojiAsImage, isDecorative: isDecorative, ...other } = props;
    const intl = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    const isAriaLabelEmpty = editorEmoji || isDecorative && (0, $iDrrr.fg)('emoji_decorative_label');
    let ariaLabel;
    if (isAriaLabelEmpty) ariaLabel = undefined;
    else if (intl) ariaLabel = intl.formatMessage((0, $1kRhf.messages).changeEmojiShortnameButtonLabel, {
        shortName: emoji.name ?? emoji.shortName
    });
    else ariaLabel = emoji.shortName;
    const tooltipContent = showTooltip && (0, $ieeJu.expValEquals)('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true) ? emoji.shortName || emoji.name || undefined : undefined;
    const emojiSpan = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        role: editorEmoji ? undefined : shouldBeInteractive ? 'button' : ariaLabel ? 'img' : 'presentation',
        "aria-label": ariaLabel,
        ref: ref,
        "data-testid": `${type}-emoji-${emoji.shortName}`,
        "data-emoji-type": type,
        tabIndex: shouldBeInteractive ? tabIndex || 0 : undefined,
        className: (0, $hekY6.default)([
            type === 'sprite' ? "_313842A17z _0adFHsdnbC _1DCdHiA17z _2XsHFMdnbC _3iDTPbvbI6 _1iPKDrNZfY _2hB4kovbI6 _1GBPVvSPN1 _3woHNtSPN1 _2oqNm2t2nV _1XjlOoo126 _0eVgdoo126 _1zr6Dc98eZ _0htemXYbGa _067LceT6kp _0ui43C1O6y _0hot5EBMeg" : type === 'unicode' ? "_313842A17z _0adFHsdnbC _1DCdHiA17z _2XsHFMdnbC _0KLXrujOvk _3iDTPbvbI6 _1RrJLit2nV _1XjlOoo126 _0eVgdoo126 _2LVIB7YvD1 _4jXNFKYvD1 _3JWaHCRAKS _1MkY46YvD1 _1zr6Dc98eZ _0htemXYbGa _067LceT6kp _0ui43C1O6y _0hot5EBMeg" : "_0bjKvDzXzM _313842A17z _0adFHsdnbC _1DCdHiA17z _2XsHFMdnbC _0KLXrujOvk _3iDTPbvbI6 _1RrJLit2nV _23odCivLZJ _1XjlOoo126 _0eVgdoo126 _2LVIB7YvD1 _4jXNFKYvD1 _3JWaHCRAKS _1MkY46YvD1 _1zr6Dc98eZ _0htemXYbGa _067LceT6kp _0ui43C1O6y _0hot5EBMeg",
            className
        ]),
        onKeyDown: (event)=>$9b741b87d47c6c28$var$handleKeyDown(props, event),
        onMouseDown: (event)=>{
            $9b741b87d47c6c28$var$handleMouseDown(props, event);
        },
        onMouseEnter: (event)=>{
            $9b741b87d47c6c28$var$handleMouseMove(props, event);
        },
        onFocus: (event)=>{
            $9b741b87d47c6c28$var$handleFocus(props, event);
        },
        title: showTooltip && !(0, $ieeJu.expValEquals)('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true) ? emoji.shortName : undefined,
        ...other
    }, children);
    if (tooltipContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: tooltipContent,
        isScreenReaderAnnouncementDisabled: true,
        position: "top",
        tag: "span"
    }, emojiSpan);
    return emojiSpan;
});
const $9b741b87d47c6c28$export$56cc48506ff790a = (props)=>{
    const { emoji: emoji } = props; // start emoji rendered experience, it may have already started earlier in ResourcedEmoji or CachingEmoji
    (0, $7gsaD.useSampledUFOComponentExperience)((0, $e4Q12.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $l4yrE.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'Emoji',
        emojiId: emoji.id
    });
    (0, $cozmU.useEffect)(()=>{
        const ufoExp = (0, $d8DK7.sampledUfoRenderedEmoji)(emoji);
        if (!(0, $1GEKi.hasUfoMarked)(ufoExp, 'fmp')) ufoExp.markFMP();
        if (!(0, $1GEKi.hasUfoMarked)(ufoExp, (0, $9tfSW.UfoEmojiTimings).MOUNTED_END)) ufoExp.mark((0, $9tfSW.UfoEmojiTimings).MOUNTED_END);
        if (emoji.type === (0, $9tfSW.ProviderTypes).STANDARD || (0, $208e74a60833564a$export$607f0d89b8881fb4)(emoji.representation)) (0, $ieeJu.expValEquals)('platform_use_unicode_emojis', 'isEnabled', true);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $208e74a60833564a$export$607f0d89b8881fb4)(emoji.representation)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7b3879a4508dca75$export$a6bb8d12872402fb), props);
     // TODO: We always prefer render as image as having accessibility issues with sprite representation
    if ((0, $74d8240b08e598d0$export$a194199d673d75de)(emoji.representation)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1c04ac8f330413af$export$ef49ddbb198ce334), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7cbdfa334838272a$export$99dfeb9d71c11788), props);
};
var $9b741b87d47c6c28$export$2e2bcd8739ae039 = $9b741b87d47c6c28$export$56cc48506ff790a;
module.exports["unicodeEmojiCanvasSize"] = $9b741b87d47c6c28$export$6130a4ff6b3c066e;
module.exports["EmojiNodeWrapper"] = $9b741b87d47c6c28$export$ce5eef59d8e46687;
module.exports["default"] = $9b741b87d47c6c28$export$2e2bcd8739ae039;

});

parcelRegister("bvr9K", function(module, exports) {
function $72087d0c7cb66425$export$34ebdaf2c517ae75(reactEvent) {
    return reactEvent.button === 0 && !reactEvent.altKey && !reactEvent.ctrlKey && !reactEvent.metaKey && !reactEvent.shiftKey;
}
module.exports["leftClick"] = $72087d0c7cb66425$export$34ebdaf2c517ae75;

});

parcelRegister("1kRhf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $68215d7718b9da32$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    deleteEmojiTooltip: {
        id: "fabric.emoji.delete.tooltip",
        defaultMessage: "Delete"
    },
    deleteEmojiTooltipForScreenreader: {
        id: "fabric.emoji.delete.screenreader.tooltip",
        defaultMessage: "To delete {shortName} emoji, press Backspace"
    },
    deleteEmojiTitle: {
        id: "fabric.emoji.delete.title",
        defaultMessage: "Remove emoji"
    },
    deleteEmojiDescription: {
        id: "fabric.emoji.delete.description",
        defaultMessage: "All existing instances of this emoji will be replaced with {emojiShortName}"
    },
    deleteEmojiLabel: {
        id: "fabric.emoji.delete.label",
        defaultMessage: "Remove"
    },
    addCustomEmojiLabel: {
        id: "fabric.emoji.add.custom.emoji.label",
        defaultMessage: "Add your own emoji"
    },
    emojiPlaceholder: {
        id: "fabric.emoji.placeholder",
        defaultMessage: "e.g. hello"
    },
    emojiNameAriaLabel: {
        id: "fabric.emoji.name.ariaLabel",
        defaultMessage: "Enter a name for the new emoji"
    },
    emojiNameLabel: {
        id: "fabric.emoji.name.label",
        defaultMessage: "Emoji name"
    },
    emojiChooseFileTitle: {
        id: "fabric.emoji.choose.file.title",
        defaultMessage: "Choose file"
    },
    emojiChooseFileDndTitle: {
        id: "fabric.emoji.choose.file.dnd.title",
        defaultMessage: "Select or drop an image"
    },
    emojiChooseFileScreenReaderDescription: {
        id: "fabric.emoji.choose.file.screenReaderDescription",
        defaultMessage: "Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB"
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: "fabric.emoji.select.skin.tone.ariaLabel",
        defaultMessage: "Choose your skin tone, {selectedTone} selected"
    },
    emojiSelectColorButtonAriaLabelText: {
        id: "fabric.emoji.select.color.ariaLabel",
        defaultMessage: "Productivity emoji color selector"
    },
    emojiSelectColorListAriaLabelText: {
        id: "fabric.emoji.select.color.list.ariaLabel",
        defaultMessage: "Productivity emoji colour selector"
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: "fabric.emoji.select.skin.list.ariaLabel",
        defaultMessage: "Skin tone selector"
    },
    emojiImageRequirements: {
        id: "fabric.emoji.image.requirements",
        defaultMessage: "JPG, PNG or GIF. Max size 1 MB."
    },
    emojiPreviewTitle: {
        id: "fabric.emoji.preview.title",
        defaultMessage: "Preview"
    },
    emojiPreview: {
        id: "fabric.emoji.preview",
        defaultMessage: "Your new emoji {emoji} looks great"
    },
    addEmojiLabel: {
        id: "fabric.emoji.add.label",
        defaultMessage: "Add emoji"
    },
    createEmojiWithRovoTitle: {
        id: "fabric.emoji.ai.create.title",
        defaultMessage: "Create an emoji with Rovo"
    },
    createEmojiWithRovoPromptPlaceholder: {
        id: "fabric.emoji.ai.prompt.placeholder",
        defaultMessage: "Describe your emoji..."
    },
    createEmojiWithRovoPromptAriaLabel: {
        id: "fabric.emoji.ai.prompt.ariaLabel",
        defaultMessage: "Describe the emoji you want to generate"
    },
    createEmojiWithRovoGenerateLabel: {
        id: "fabric.emoji.ai.generate.label",
        defaultMessage: "Generate"
    },
    createEmojiWithRovoError: {
        id: "fabric.emoji.ai.error",
        defaultMessage: "Something went wrong. Try a different description."
    },
    retryLabel: {
        id: "fabric.emoji.retry.label",
        defaultMessage: "Retry"
    },
    cancelLabel: {
        id: "fabric.emoji.cancel.label",
        defaultMessage: "Cancel"
    },
    searchPlaceholder: {
        id: "fabric.emoji.search.placeholder",
        defaultMessage: "Search"
    },
    searchLabel: {
        id: "fabric.emoji.search.label",
        defaultMessage: "Emoji name"
    },
    searchResultsStatus: {
        id: "fabric.emoji.search.status.count",
        defaultMessage: "Found {count} emojis"
    },
    searchResultsStatusSeeAll: {
        id: "fabric.emoji.search.status",
        defaultMessage: "Seeing all emojis"
    },
    categoriesSelectorLabel: {
        id: "fabric.emoji.categories.label",
        defaultMessage: "Choose an emoji category"
    },
    categoriesSearchResults: {
        id: "fabric.emoji.categories.search.results",
        defaultMessage: "Search results"
    },
    frequentCategory: {
        id: "fabric.emoji.category.frequent",
        defaultMessage: "Frequent"
    },
    peopleCategory: {
        id: "fabric.emoji.category.people",
        defaultMessage: "People"
    },
    natureCategory: {
        id: "fabric.emoji.category.nature",
        defaultMessage: "Nature"
    },
    foodsCategory: {
        id: "fabric.emoji.category.foods",
        defaultMessage: "Food & Drink"
    },
    activityCategory: {
        id: "fabric.emoji.category.activity",
        defaultMessage: "Activity"
    },
    placesCategory: {
        id: "fabric.emoji.category.places",
        defaultMessage: "Travel & Places"
    },
    objectsCategory: {
        id: "fabric.emoji.category.objects",
        defaultMessage: "Objects"
    },
    symbolsCategory: {
        id: "fabric.emoji.category.symbols",
        defaultMessage: "Symbols"
    },
    flagsCategory: {
        id: "fabric.emoji.category.flags",
        defaultMessage: "Flags"
    },
    productivityCategory: {
        id: "fabric.emoji.category.productivity",
        defaultMessage: "Atlassian & productivity"
    },
    userUploadsCustomCategory: {
        id: "fabric.emoji.category.user.uploads",
        defaultMessage: "Your uploads"
    },
    allUploadsCustomCategory: {
        id: "fabric.emoji.category.all.uploads",
        defaultMessage: "All uploads"
    },
    deleteEmojiFailed: {
        id: "fabric.emoji.error.delete.failed",
        defaultMessage: "Remove failed"
    },
    emojiInvalidImage: {
        id: "fabric.emoji.error.invalid.image",
        defaultMessage: "Selected image is invalid"
    },
    emojiUploadFailed: {
        id: "fabric.emoji.error.upload.failed",
        defaultMessage: "Upload failed"
    },
    emojiUploadTimeout: {
        id: "fabric.emoji.error.upload.timeout",
        defaultMessage: "Upload timed out"
    },
    emojiImageTooBig: {
        id: "fabric.emoji.error.image.too.big",
        defaultMessage: "Selected image is more than 1 MB"
    },
    emojiUnsupportedFileType: {
        id: "fabric.emoji.error.unsupported.file.type",
        defaultMessage: "This file type isn't supported. Select a PNG, JPEG, or GIF to create your emoji."
    },
    emojiDuplicateName: {
        id: "fabric.emoji.error.duplicate.name",
        defaultMessage: "An emoji with this name exists already"
    },
    emojiPickerNoResults: {
        id: "fabric.emoji.picker.no.results",
        defaultMessage: "No results"
    },
    emojiPickerAddCustomEmoji: {
        id: "fabric.emoji.picker.add.custom.emoji",
        defaultMessage: "Add custom emoji"
    },
    emojiPickerTitle: {
        id: "fabric.emoji.picker",
        defaultMessage: "Emoji picker"
    },
    emojiPickerListPanel: {
        id: "fabric.emoji.pickerlist.tabpanel",
        defaultMessage: "Emojis actions and list panel"
    },
    emojiPickerGrid: {
        id: "fabric.emoji.pickerlist.grid",
        defaultMessage: "{showSearchResults, select, true{Search results} other{Emojis}}"
    },
    emojiButtonRoleDescription: {
        id: "fabric.emoji.emojipicker.emoi.roledescription",
        defaultMessage: "emoji button"
    },
    changeEmojiShortnameButtonLabel: {
        id: "fabric.emoji.change.shortname.button.label",
        defaultMessage: "Change emoji, currently {shortName}"
    },
    error: {
        id: "fabric.emoji.emojipicker.error",
        defaultMessage: "Error!"
    }
});
module.exports["messages"] = $68215d7718b9da32$export$defe85febe8b728c;

});

parcelRegister("5sUij", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

"use client";
var $3fab3c301f36e350$var$__defProp = Object.defineProperty;
var $3fab3c301f36e350$var$__defNormalProp = (obj, key, value)=>key in obj ? $3fab3c301f36e350$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3fab3c301f36e350$var$__publicField = (obj, key, value)=>$3fab3c301f36e350$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/observe.ts
var $3fab3c301f36e350$var$observerMap = /* @__PURE__ */ new Map();
var $3fab3c301f36e350$var$RootIds = /* @__PURE__ */ new WeakMap();
var $3fab3c301f36e350$var$rootId = 0;
var $3fab3c301f36e350$var$unsupportedValue = void 0;
function $3fab3c301f36e350$export$2ef3a60ee1f37bec(inView) {
    $3fab3c301f36e350$var$unsupportedValue = inView;
}
function $3fab3c301f36e350$var$getRootId(root) {
    if (!root) return "0";
    if ($3fab3c301f36e350$var$RootIds.has(root)) return $3fab3c301f36e350$var$RootIds.get(root);
    $3fab3c301f36e350$var$rootId += 1;
    $3fab3c301f36e350$var$RootIds.set(root, $3fab3c301f36e350$var$rootId.toString());
    return $3fab3c301f36e350$var$RootIds.get(root);
}
function $3fab3c301f36e350$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? $3fab3c301f36e350$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $3fab3c301f36e350$var$createObserver(options) {
    const id = $3fab3c301f36e350$var$optionsToId(options);
    let instance = $3fab3c301f36e350$var$observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $3fab3c301f36e350$var$observerMap.set(id, instance);
    }
    return instance;
}
function $3fab3c301f36e350$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $3fab3c301f36e350$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id: id, observer: observer, elements: elements } = $3fab3c301f36e350$var$createObserver(options);
    const callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $3fab3c301f36e350$var$observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function $3fab3c301f36e350$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $3fab3c301f36e350$export$a62107ca74432f44 = class extends $cozmU.Component {
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $3fab3c301f36e350$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children: children } = this.props;
        if (typeof children === "function") {
            const { inView: inView, entry: entry } = this.state;
            return children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const { as: as, triggerOnce: triggerOnce, threshold: threshold, root: root, rootMargin: rootMargin, onChange: onChange, skip: skip, trackVisibility: trackVisibility, delay: delay, initialInView: initialInView, fallbackInView: fallbackInView, ...props } = this.props;
        return $cozmU.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
    constructor(props){
        super(props);
        $3fab3c301f36e350$var$__publicField(this, "node", null);
        $3fab3c301f36e350$var$__publicField(this, "_unobserveCb", null);
        $3fab3c301f36e350$var$__publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        $3fab3c301f36e350$var$__publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!$3fab3c301f36e350$var$isPlainChildren(this.props)) this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
};
function $3fab3c301f36e350$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = $cozmU.useState(null);
    const callback = $cozmU.useRef(onChange);
    const [state, setState] = $cozmU.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    $cozmU.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = $3fab3c301f36e350$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = $cozmU.useRef(void 0);
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}
 //# sourceMappingURL=index.mjs.map
module.exports["useInView"] = $3fab3c301f36e350$export$2f62ee6831462844;

});

parcelRegister("7gAFi", function(module, exports) {

var $fhEsv = parcelRequire("fhEsv");

const $5261e6b835b6a009$export$6e2c41f8d3a0d428 = ()=>{
    return (0, $fhEsv.isTeamoji26RefreshEmojiPickerEnabled)();
};
module.exports["isRefreshEmojiPickerEnabled"] = $5261e6b835b6a009$export$6e2c41f8d3a0d428;

});

parcelRegister("9QhNT", function(module, exports) {

var $bqYnI = parcelRequire("bqYnI");

const $666a52e02f54064a$var$unicodeEmojiCanvasSize = 128;
const $666a52e02f54064a$var$unicodeEmojiCanvasFontSize = 124;
const $666a52e02f54064a$var$unicodeEmojiCanvasTopPadding = 8;
const $666a52e02f54064a$export$3692f6e5ef5bb18a = async (unicodeEmoji)=>{
    const OffscreenCanvasCtor = globalThis['OffscreenCanvas'];
    if ((0, $bqYnI.isSSR)() || !OffscreenCanvasCtor || typeof URL === 'undefined') return undefined;
    const canvas = new OffscreenCanvasCtor($666a52e02f54064a$var$unicodeEmojiCanvasSize, $666a52e02f54064a$var$unicodeEmojiCanvasSize);
    const context = canvas.getContext('2d');
    if (!context) return undefined;
    context.clearRect(0, 0, $666a52e02f54064a$var$unicodeEmojiCanvasSize, $666a52e02f54064a$var$unicodeEmojiCanvasSize);
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.font = `${$666a52e02f54064a$var$unicodeEmojiCanvasFontSize}px sans-serif`;
    context.fillText(unicodeEmoji, $666a52e02f54064a$var$unicodeEmojiCanvasSize / 2, $666a52e02f54064a$var$unicodeEmojiCanvasSize / 2 + $666a52e02f54064a$var$unicodeEmojiCanvasTopPadding);
    const blob = await canvas.convertToBlob({
        type: 'image/png'
    });
    return URL.createObjectURL(blob);
};
module.exports["renderUnicodeEmojiToImagePath"] = $666a52e02f54064a$export$3692f6e5ef5bb18a;

});

parcelRegister("iKpb2", function(module, exports) {
/* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $ieeJu = parcelRequire("ieeJu");


var $l4yrE = parcelRequire("l4yrE");


var $dprMh = parcelRequire("dprMh");


var $a5rDX = parcelRequire("a5rDX");

const $60c089d6c9d8e0bd$var$placeholderContainer = null;
const $60c089d6c9d8e0bd$var$EmojiPlaceholder = (props)=>{
    const { shortName: shortName, size: size = (0, $l4yrE.defaultEmojiHeight), showTooltip: showTooltip, representation: representation, loading: loading = false, xcss: xcss } = props;
    let scaledWidth;
    let scaledHeight;
    if (representation && size) {
        const width = representation.width;
        const height = representation.height;
        if (width && height) {
            scaledWidth = size / height * width;
            scaledHeight = size;
        }
    }
    const width = scaledWidth || size;
    const height = scaledHeight || size;
    const style = (0, $ieeJu.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? {
        fill: 'f7f7f7',
        minWidth: `${0, $l4yrE.defaultDenseEmojiHeight}px`,
        minHeight: `${0, $l4yrE.defaultDenseEmojiHeight}px`
    } : {
        fill: 'f7f7f7',
        minWidth: `${width}px`,
        width: `${width}px`,
        height: `${height}px`
    };
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": (0, $dprMh.emojiPlaceholderTestId)(shortName),
        "aria-busy": loading,
        role: "status",
        "aria-label": shortName,
        className: (0, $hekY6.default)([
            "_313842A17z _0adFHsdnbC _1DCdHiA17z _2XsHFMdnbC _0bjKvDzXzM _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _3iDTPbvbI6 _0KLXru9r67 _1RrJLit2nV _1ANEUSLRg7 _2fwxA5DIqT",
            [
                (0, $a5rDX.placeholder),
                xcss
            ].join(' ')
        ]),
        style: style,
        title: showTooltip ? shortName : ''
    });
};
var $60c089d6c9d8e0bd$export$2e2bcd8739ae039 /**
                                  * @deprecated Use `import { emojiPlaceholderTestId } from '@atlaskit/emoji/emoji-placeholder'` instead.
                                  */  = $60c089d6c9d8e0bd$var$EmojiPlaceholder;
module.exports["default"] = $60c089d6c9d8e0bd$export$2e2bcd8739ae039;

});

parcelRegister("af2XZ", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lzgC6 = parcelRequire("lzgC6");


var $79zKY = parcelRequire("79zKY");




const $b70bbde68fb4f7cf$export$6335145236247192 = (0, $lzgC6.default)()((0, $79zKY.EmojiPickerInternal));
var $b70bbde68fb4f7cf$export$2e2bcd8739ae039 = $b70bbde68fb4f7cf$export$6335145236247192;
module.exports["EmojiPicker"] = $b70bbde68fb4f7cf$export$6335145236247192;
module.exports["default"] = $b70bbde68fb4f7cf$export$2e2bcd8739ae039;

});

parcelRegister("79zKY", function(module, exports) {
/* EmojiPickerInternal.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $gxxZD = parcelRequire("gxxZD");


var $e4Q12 = parcelRequire("e4Q12");


var $l4yrE = parcelRequire("l4yrE");


var $fhEsv = parcelRequire("fhEsv");




class $17feadf27fee0317$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    componentDidMount() {
        // check for the module has not yet been loaded
        // state.asyncLoadedComponent should be initialised
        // with static field to prevent unnecessary rerender
        if (!this.state.asyncLoadedComponent) this.asyncLoadComponent();
    }
    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) this.loadEmojiProvider(this.props.emojiProvider);
    }
    componentWillUnmount() {
        this.isUnmounted = true;
    }
    loadEmojiProvider(futureEmojiProvider) {
        futureEmojiProvider.then((loadedEmojiProvider)=>{
            if (!this.isUnmounted) this.setState({
                loadedEmojiProvider: loadedEmojiProvider
            });
        }).catch(()=>{
            if (!this.isUnmounted) this.setState({
                loadedEmojiProvider: undefined
            });
        });
    }
    setAsyncState(asyncLoadedComponent) {
        if (!this.isUnmounted) this.setState({
            asyncLoadedComponent: asyncLoadedComponent
        });
    }
    renderLoading() {
        return null;
    }
    render() {
        if (this.loaded(this.state)) {
            const { loadedEmojiProvider: loadedEmojiProvider, asyncLoadedComponent: asyncLoadedComponent } = this.state;
            return this.renderLoaded(loadedEmojiProvider, asyncLoadedComponent);
        }
        return this.renderLoading();
    }
    constructor(props, _state){
        super(props);
        this.isUnmounted = false;
        this.loaded = (state)=>!!state.asyncLoadedComponent && !!state.loadedEmojiProvider;
        this.state = _state;
        // initializing here instead of componentDidMount to avoid needless
        // rerendering if emojiProvider resolves immediately.
        this.loadEmojiProvider(this.props.emojiProvider);
    }
}



var $9Jo6P = parcelRequire("9Jo6P");


var $25dyz = parcelRequire("25dyz");


var $jurYe = parcelRequire("jurYe");

function $bcad700cee40b752$var$_defineProperty(e, r, t) {
    return (r = $bcad700cee40b752$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $bcad700cee40b752$var$_toPropertyKey(t) {
    var i = $bcad700cee40b752$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $bcad700cee40b752$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $bcad700cee40b752$var$isRefreshEmojiPickerEnabled = ()=>{
    return (0, $fhEsv.isTeamoji26RefreshEmojiPickerEnabled)();
};
const $bcad700cee40b752$var$emojiPicker = null;
const $bcad700cee40b752$var$emojiPickerNew = null;
class $bcad700cee40b752$export$bcf219a275f21b24 extends (0, $17feadf27fee0317$export$2e2bcd8739ae039) {
    asyncLoadComponent() {
        (0, $25dyz.emojiPickerLoader)().then((component)=>{
            $bcad700cee40b752$export$bcf219a275f21b24.AsyncLoadedComponent = component;
            this.setAsyncState(component);
        });
    }
    renderLoading() {
        const item = new (0, $jurYe.LoadingItem)();
        const handlePickerRef = (ref)=>{
            if (this.props.onPickerRef) this.props.onPickerRef(ref);
        };
        (0, $e4Q12.ufoExperiences)['emoji-picker-opened'].markFMP();
        return $bcad700cee40b752$var$isRefreshEmojiPickerEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: handlePickerRef,
            className: (0, $hekY6.default)([
                "_30huDKVtRi _0bjKvD8fU6 _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuI7V3 _0KLXruoI2d _2OUyjtGk8v _0jFU0VtezV _39xV02aQBb _4ouGXIaQBb _4kiQYAe9dk _0NUa3reThk"
            ])
        }, item.renderItem()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: handlePickerRef,
            className: (0, $hekY6.default)([
                "_30huDKVtRi _0bjKvDzXzM _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuI7V3 _0KLXruoI2d _2OUyjtGk8v _0jFU0VtezV _39xV02aQBb _4ouGXIaQBb _4kiQYAe9dk _0NUa3reThk"
            ])
        }, item.renderItem());
    }
    renderLoaded(loadedEmojiProvider, EmojiPickerComponent) {
        const { emojiProvider: emojiProvider, ...otherProps } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Jo6P.UfoErrorBoundary), {
            experiences: [
                (0, $e4Q12.ufoExperiences)['emoji-picker-opened']
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gxxZD.EmojiCommonProvider), {
            emojiProvider: loadedEmojiProvider
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(EmojiPickerComponent, otherProps)));
    }
    constructor(props){
        super(props, {});
        $bcad700cee40b752$var$_defineProperty(this, "state", {
            asyncLoadedComponent: $bcad700cee40b752$export$bcf219a275f21b24.AsyncLoadedComponent
        });
        (0, $e4Q12.ufoExperiences)['emoji-picker-opened'].start();
    }
}
// state initialised with static component to prevent
// rerender when the module has already been loaded
$bcad700cee40b752$var$_defineProperty($bcad700cee40b752$export$bcf219a275f21b24, "AsyncLoadedComponent", void 0);
$bcad700cee40b752$var$_defineProperty($bcad700cee40b752$export$bcf219a275f21b24, "defaultProps", {
    size: (0, $l4yrE.defaultEmojiPickerSize)
});
module.exports["EmojiPickerInternal"] = $bcad700cee40b752$export$bcf219a275f21b24;

});

parcelRegister("25dyz", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $39tfn = parcelRequire("39tfn");

const $ddf4ab4ee9cf001f$export$6b1deaa9ff7c5a6c = ()=>(0, $39tfn.emojiPickerModuleLoader)().then((module)=>module.default);
module.exports["emojiPickerLoader"] = $ddf4ab4ee9cf001f$export$6b1deaa9ff7c5a6c;

});

parcelRegister("2eLSi", function(module, exports) {

let $1a120685a1000ab9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1a120685a1000ab9$var$load("icYyL"),
    $1a120685a1000ab9$var$load("5RJ9W"),
    $1a120685a1000ab9$var$load("6wr18"),
    $1a120685a1000ab9$var$load("74UIr"),
    $1a120685a1000ab9$var$load("hhss7"),
    $1a120685a1000ab9$var$load("34Vvm"),
    $1a120685a1000ab9$var$load("1rRsB"),
    $1a120685a1000ab9$var$load("cjTEF"),
    $1a120685a1000ab9$var$load("bOOzQ"),
    $1a120685a1000ab9$var$load("iNbHV"),
    $1a120685a1000ab9$var$load("ffEVr"),
    $1a120685a1000ab9$var$load("Wowvf"),
    $1a120685a1000ab9$var$load("4g6rd"),
    $1a120685a1000ab9$var$load("fsHUe")
]).then(()=>parcelRequire('dCRrZ'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("jurYe", function(module, exports) {
/* LoadingItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");


var $gbON5 = parcelRequire("gbON5");


var $h3gyY = parcelRequire("h3gyY");

function $fab03db4d4deddbf$var$_defineProperty(e, r, t) {
    return (r = $fab03db4d4deddbf$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fab03db4d4deddbf$var$_toPropertyKey(t) {
    var i = $fab03db4d4deddbf$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fab03db4d4deddbf$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fab03db4d4deddbf$var$emojiPickerSpinner = null;
class $fab03db4d4deddbf$export$a16bfd7fb92e211d extends (0, $gbON5.AbstractItem) {
    constructor(){
        super({}, (0, $h3gyY.sizes).loadingRowHeight);
        $fab03db4d4deddbf$var$_defineProperty(this, "renderItem", ()=>/*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _39xV02N91d _0jFU0Vb1xp _37wbyuDIqT _0hPCNLDIqT _1z0ZYFdnbC _1UPrH0dnbC _4ims5nIZbP"
                ])
            }, /*#__PURE__*/ $cozmU.createElement("div", null, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
                size: "medium"
            }))));
    }
}
module.exports["LoadingItem"] = $fab03db4d4deddbf$export$a16bfd7fb92e211d;

});

parcelRegister("gbON5", function(module, exports) {
class $4e24ee2dbeb465cc$export$8faa7b3aa4960e00 {
    constructor(props, height){
        this.height = void 0;
        this.props = void 0;
        this.renderItem = void 0;
        this.props = props;
        this.height = height;
    }
}
module.exports["AbstractItem"] = $4e24ee2dbeb465cc$export$8faa7b3aa4960e00;

});

parcelRegister("h3gyY", function(module, exports) {

var $l4yrE = parcelRequire("l4yrE");

const $efc5787e82f2c9b7$export$c647cb0ee6e282fe = {
    listHeight: (0, $l4yrE.emojiPickerListHeight),
    listHeightNew: (0, $l4yrE.emojiPickerListHeightNew),
    listWidth: (0, $l4yrE.emojiPickerWidth),
    searchHeight: 52,
    categoryHeadingHeight: 30,
    emojiRowHeight: 40,
    addEmojiHeight: 32,
    loadingRowHeight: 150,
    noResultsHeight: 300,
    uploadActionHeight: 40,
    emojiPerRow: 8
};
module.exports["sizes"] = $efc5787e82f2c9b7$export$c647cb0ee6e282fe;

});

parcelRegister("gOVqR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aGLvf = parcelRequire("aGLvf");

const $58edf92bb5fbac7d$var$supportsUploadFeature = (emojiProvider)=>{
    const emojiUploadProvider = emojiProvider;
    return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
};
const $58edf92bb5fbac7d$export$482903c4ce3f5633 = ()=>{
    const context = (0, $cozmU.useContext)((0, $aGLvf.EmojiContext));
    // Hooks API
    const [isUploadSupported, setIsUploadSupported] = (0, $cozmU.useState)(false);
    if (!context) throw new Error('useEmoji must be used within EmojiContext');
    const { emojiProvider: emojiProvider } = context.emoji;
    (0, $cozmU.useEffect)(()=>{
        if ($58edf92bb5fbac7d$var$supportsUploadFeature(emojiProvider)) {
            const checkIfUploadIsSupported = async ()=>{
                try {
                    const supported = await emojiProvider.isUploadSupported();
                    setIsUploadSupported(supported);
                    return true;
                } catch (error) {
                    return false;
                }
            };
            checkIfUploadIsSupported();
        }
    }, [
        emojiProvider
    ]);
    return {
        emojiProvider: emojiProvider,
        isUploadSupported: isUploadSupported
    };
};
module.exports["useEmoji"] = $58edf92bb5fbac7d$export$482903c4ce3f5633;

});

parcelRegister("6vxzB", function(module, exports) {
const $70a5b093cb3b548a$export$c30017717ce2168e = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes
        }
    });
module.exports["createEvent"] = $70a5b093cb3b548a$export$c30017717ce2168e;

});

parcelRegister("8tMWQ", function(module, exports) {
/**
 * Used for store failure metadata for analytics
 * @param error The error could be a service error with {code, reason} or an Error
 * @returns any
 */ const $2cfa8eb58ac7a222$export$74aaf4784c2edb2c = (error)=>{
    if (error instanceof Error) return {
        name: error.name,
        message: error.message
    };
    return error;
};
module.exports["extractErrorInfo"] = $2cfa8eb58ac7a222$export$74aaf4784c2edb2c;

});

parcelRegister("asQaT", function(module, exports) {

var $6vxzB = parcelRequire("6vxzB");

const $002167777178fde4$export$ccd0c8bcbda28b7a = (emoji)=>(source)=>{
        return (0, $6vxzB.createEvent)('operational', 'failed', 'recordEmojiSelection', undefined, {
            source: source,
            emojiId: emoji?.id,
            emojiType: emoji?.type,
            emojiCategory: emoji?.category
        });
    };
module.exports["recordFailedEmoji"] = $002167777178fde4$export$ccd0c8bcbda28b7a;

});

parcelRegister("25bJi", function(module, exports) {

var $6vxzB = parcelRequire("6vxzB");

const $7aea967cf124fb1b$export$3125c3f60f61a0a9 = (emoji)=>(source)=>{
        return (0, $6vxzB.createEvent)('operational', 'succeeded', 'recordEmojiSelection', undefined, {
            source: source,
            emojiId: emoji?.id,
            emojiType: emoji?.type,
            emojiCategory: emoji?.category
        });
    };
module.exports["recordSucceededEmoji"] = $7aea967cf124fb1b$export$3125c3f60f61a0a9;

});

parcelRegister("jLKkm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1GEKi = parcelRequire("1GEKi");


var $d8DK7 = parcelRequire("d8DK7");


var $e4Q12 = parcelRequire("e4Q12");


var $7gsaD = parcelRequire("7gsaD");


var $l4yrE = parcelRequire("l4yrE");


var $fZ1dq = parcelRequire("fZ1dq");





var $gOVqR = parcelRequire("gOVqR");


var $9tfSW = parcelRequire("9tfSW");


var $8tMWQ = parcelRequire("8tMWQ");





var $l3Ofr = parcelRequire("l3Ofr");


var $1FzXO = parcelRequire("1FzXO");


var $iKpb2 = parcelRequire("iKpb2");

const $99e2ad1a227dfe6b$export$aa961da7639f7a98 = (props)=>{
    const { emoji: emoji, placeholderSize: placeholderSize, showTooltip: showTooltip, fitToHeight: fitToHeight, children: children, ...restProps } = props;
    const { shortName: shortName, representation: representation } = emoji;
    const [cachedEmoji, setCachedEmoji] = (0, $cozmU.useState)();
    const [inValidImage, setInvalidImage] = (0, $cozmU.useState)(false);
    const { emojiProvider: emojiProvider } = (0, $gOVqR.useEmoji)();
    const loadEmoji = (0, $cozmU.useCallback)((emojiProvider)=>{
        (0, $l3Ofr.default)('Loading image via media cache', emoji.shortName);
        (0, $d8DK7.sampledUfoRenderedEmoji)(emoji).mark((0, $9tfSW.UfoEmojiTimings).MEDIA_START);
        emojiProvider.getMediaEmojiDescriptionURLWithInlineToken(emoji).then((cachedEmoji)=>{
            setCachedEmoji(cachedEmoji);
            setInvalidImage(false);
            (0, $d8DK7.sampledUfoRenderedEmoji)(emoji).mark((0, $9tfSW.UfoEmojiTimings).MEDIA_END);
        }).catch((error)=>{
            setCachedEmoji(undefined);
            setInvalidImage(true);
            (0, $d8DK7.sampledUfoRenderedEmoji)(emoji).failure({
                metadata: {
                    error: (0, $8tMWQ.extractErrorInfo)(error),
                    reason: 'failed to load media emoji',
                    source: 'CachingMediaEmoji',
                    emojiId: emoji.id
                }
            });
        });
    }, [
        emoji
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (emojiProvider) loadEmoji(emojiProvider);
    }, [
        emojiProvider,
        loadEmoji
    ]);
    const handleLoadError = (_emojiId)=>{
        (0, $d8DK7.sampledUfoRenderedEmoji)(_emojiId).failure({
            metadata: {
                reason: 'load error',
                source: 'CachingMediaEmoji',
                emojiId: _emojiId.id
            }
        });
        setInvalidImage(true);
    };
    if (cachedEmoji && !inValidImage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1FzXO.default), {
        ...restProps,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        emoji: cachedEmoji,
        onLoadError: handleLoadError
    });
    const imageRepresentation = representation && 'height' in representation ? representation : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), {
        size: fitToHeight || placeholderSize,
        shortName: shortName,
        showTooltip: showTooltip,
        representation: imageRepresentation
    });
};





/* EmojiFallback.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");








var $a5rDX = parcelRequire("a5rDX");

const $ff7054dcfd0496ff$var$emojiFallbackStyles = null;
const $ff7054dcfd0496ff$export$e3a226c1c0d61870 = (props)=>{
    const { emoji: emoji, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const { fallback: fallback, shortName: shortName } = emoji;
    const classes = `${(0, $a5rDX.emojiNodeStyles)} ${selected ? (0, $a5rDX.commonSelectedStyles) : ''} ${selectOnHover ? (0, $a5rDX.selectOnHoverStyles) : ''} ${className ? className : ''}`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1FzXO.EmojiNodeWrapper), {
        type: "image",
        ...props,
        className: classes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d _37wbyuDIqT _0hPCNLDIqT"
        ])
    }, fallback || shortName)));
};
var $ff7054dcfd0496ff$export$2e2bcd8739ae039 = $ff7054dcfd0496ff$export$e3a226c1c0d61870;



var $9Jo6P = parcelRequire("9Jo6P");

const $1bfa3672d7898975$export$e81207f376d36133 = (props)=>{
    // Optimisation to only render CachingMediaEmoji if necessary
    // slight performance hit, which accumulates for a large number of emoji.
    const { emoji: emoji, placeholderSize: placeholderSize, ...restProps } = props;
    // start emoji rendered experience, it may have already started earlier in `ResourcedEmoji`.
    (0, $7gsaD.useSampledUFOComponentExperience)((0, $e4Q12.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $l4yrE.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'CachingEmoji',
        emojiId: emoji.id
    });
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $1GEKi.hasUfoMarked)((0, $d8DK7.sampledUfoRenderedEmoji)(emoji), 'fmp')) (0, $d8DK7.sampledUfoRenderedEmoji)(emoji).markFMP();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const emojiNode = ()=>{
        if ((0, $fZ1dq.isMediaEmoji)(emoji)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99e2ad1a227dfe6b$export$aa961da7639f7a98), {
            emoji: emoji,
            placeholderSize: placeholderSize,
            ...restProps
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1bfa3672d7898975$var$StandardEmoji, {
            emoji: emoji,
            ...restProps
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Jo6P.UfoErrorBoundary), {
        experiences: [
            (0, $e4Q12.ufoExperiences)['emoji-rendered'].getInstance(props.emoji.id || props.emoji.shortName)
        ]
    }, emojiNode());
};
const $1bfa3672d7898975$var$StandardEmoji = (props)=>{
    const { emoji: emoji, ...restProps } = props;
    const [imageLoadError, setImageLoadError] = (0, $cozmU.useState)(false);
    const handleLoadError = (_emojiId)=>{
        setImageLoadError(true);
    };
    if (imageLoadError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ff7054dcfd0496ff$export$2e2bcd8739ae039), {
        emoji: emoji,
        ...restProps
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1FzXO.default), {
        emoji: emoji,
        onLoadError: handleLoadError,
        ...restProps
    });
};
const $1bfa3672d7898975$var$_default_1 = /*#__PURE__*/ (0, $cozmU.memo)($1bfa3672d7898975$export$e81207f376d36133);
var $1bfa3672d7898975$export$2e2bcd8739ae039 = $1bfa3672d7898975$var$_default_1;
module.exports["default"] = $1bfa3672d7898975$export$2e2bcd8739ae039;

});

parcelRegister("lBoXQ", function(module, exports) {
/* EmojiPreviewComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $anBbz = parcelRequire("anBbz");


var $jLKkm = parcelRequire("jLKkm");

const $5103a64cbf38c21b$var$emojiName = null;
const $5103a64cbf38c21b$var$emojiShortName = null;
const $5103a64cbf38c21b$var$preview = null;
const $5103a64cbf38c21b$var$previewImg = null;
const $5103a64cbf38c21b$var$previewText = null;
const $5103a64cbf38c21b$export$222c91bd2db2d158 = ({ emoji: emoji })=>{
    const fitToHeight = (0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true) ? 32 : undefined;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_0Of8r2uFDC _1ZnuxbuFDC _1wydGWuFDC _2Zuz6QuFDC _3iDTPbQ4SZ _0aFT5v1qpb _3TGfC9LRg7 _0jFU0VUofl _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _39xV02Uofl _2yHzK9dnbC _3j6ezTdnbC _3i7n2adnbC _26yOTxdnbC _3skfARdnbC _3natBxdnbC _1FPnnJdnbC _1vJRcjdnbC _0mzAWiUofl _0LOdDvUofl _430i96Uofl _03qA4iUofl _27LRgcOLYo _4tayJvOLYo _3LOhKmdnbC _3M4DpidnbC _2smhYldnbC _42LJStdnbC _43vhjeRAKS _4snuQ5715P _3vDJ5g715P _0ywjPhx5FZ _40IPznUofl _3jqVQ5Uofl _0vcmbtvLZJ"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $jLKkm.default), {
        key: emoji.id || emoji.shortName,
        emoji: emoji,
        fitToHeight: fitToHeight
    })), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _4xdlr0DIqT _313842Ll21 _2XsHFMuFDC _1EqgXlyt6F _39xV02yt6F _2O5Vij7dHp _3YEZNO7dHp"
        ])
    }, emoji.name && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _1UtDYzy7kJ _39HuIbz8Lp _1ANEUSLRg7 _09eJsYAv7U"
        ])
    }, emoji.name), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _1UtDYzZpcK _26BoRw7dHp _1DCdHiLl21 _1wydGWFQfX _39HuIbz8Lp _1ANEUSLRg7 _2plNSKmnOE _1GZd6Uy7kJ"
        ])
    }, emoji.shortName)));
};
module.exports["EmojiPreviewComponent"] = $5103a64cbf38c21b$export$222c91bd2db2d158;

});

parcelRegister("go7uG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $8f99a430e8355353$export$74e304339778e94d = (0, $kSwu1.defineMessages)({
    copyCodeToClipboard: {
        id: "fabric.editor.codeBlockCopyButton.copyToClipboard",
        defaultMessage: "Copy as text"
    },
    copyCodeSnippetToClipboard: {
        id: "editor-common.messages.codeBlockButton.copyCodeSnippetToClipboard",
        defaultMessage: "Copy code text"
    },
    copiedCodeToClipboard: {
        id: "fabric.editor.codeBlockCopyButton.copiedToClipboard",
        defaultMessage: "Copied!"
    },
    // Remove wrapCode/unwrapCode and use wrapCodeLabel/unwrapCodeLabel
    // when cleaning up platform_editor_code_block_q4_lovability.
    wrapCode: {
        id: "fabric.editor.codeBlockWrapButton.wrapCodeBlock",
        defaultMessage: "Turn on wrap"
    },
    unwrapCode: {
        id: "fabric.editor.codeBlockWrapButton.unwrapCodeBlock",
        defaultMessage: "Turn off wrap"
    },
    wrapCodeLabel: {
        id: "fabric.editor.codeBlockWrapButton.wrapCode",
        defaultMessage: "Wrap code"
    },
    unwrapCodeLabel: {
        id: "fabric.editor.codeBlockWrapButton.unwrapCode",
        defaultMessage: "Unwrap code"
    },
    showLineNumbersLabel: {
        id: "fabric.editor.codeBlockLineNumbersButton.showLineNumbers",
        defaultMessage: "Show line numbers"
    },
    hideLineNumbersLabel: {
        id: "fabric.editor.codeBlockLineNumbersButton.hideLineNumbers",
        defaultMessage: "Hide line numbers"
    },
    formatCode: {
        id: "fabric.editor.codeBlockFormatButton.formatCode",
        defaultMessage: "Format code"
    },
    formatCodeUnavailable: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeUnavailable",
        defaultMessage: "Formatting not available for this language"
    },
    formatCodeFailed: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailed",
        defaultMessage: "Code formatting failed"
    },
    formatCodeFailedDescription: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailedDescription",
        defaultMessage: "Review the content or change the selected language."
    },
    formatCodeFailedAutoDetectedDescription: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailedAutoDetectedDescription",
        defaultMessage: "Review the content or select a specific language."
    },
    selectLanguage: {
        id: "fabric.editor.selectLanguage",
        defaultMessage: "Select language"
    },
    detectLanguage: {
        id: "fabric.editor.codeBlock.detectLanguage",
        defaultMessage: "Detect language"
    },
    detectedLanguage: {
        id: "fabric.editor.codeBlock.detectedLanguage",
        defaultMessage: "{language} (detected)"
    },
    noneDetected: {
        id: "fabric.editor.codeBlock.noneDetected",
        defaultMessage: "(None detected)"
    },
    recentlyUsed: {
        id: "fabric.editor.codeBlock.recentlyUsed",
        defaultMessage: "Recently used"
    },
    all: {
        id: "fabric.editor.codeBlock.all",
        defaultMessage: "All"
    },
    downloadCodeBlock: {
        id: "fabric.editor.codeBlockDownloadButton.downloadCodeBlock",
        defaultMessage: "Download"
    }
});
module.exports["codeBlockButtonMessages"] = $8f99a430e8355353$export$74e304339778e94d;

});

parcelRegister("8Xus6", function(module, exports) {
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages
const $cfd109792a890cba$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];
module.exports["SUPPORTED_LANGUAGES"] = $cfd109792a890cba$export$7c77c3a9bb93870d;

});

parcelRegister("efgwK", function(module, exports) {

var $1Ujre = parcelRequire("1Ujre");


var $mr7nI = parcelRequire("mr7nI");

var $c57af174cd21b1e3$var$FORMATS = /*#__PURE__*/ function(FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
    return FORMATS;
}($c57af174cd21b1e3$var$FORMATS || {});
const $c57af174cd21b1e3$export$56c3660a4ee2196a = (timestamp)=>{
    const date = new Date(Number(timestamp));
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return {
        day: day,
        month: month,
        year: year
    };
};
const $c57af174cd21b1e3$export$6297728405c48562 = (timeZone)=>{
    const today = new Date(Date.now());
    if (timeZone) {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        }).formatToParts(today);
        const year = Number(parts.find((p)=>p.type === 'year')?.value);
        const month = Number(parts.find((p)=>p.type === 'month')?.value) - 1;
        const day = Number(parts.find((p)=>p.type === 'day')?.value);
        return Date.UTC(year, month, day).toString();
    }
    const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
const $c57af174cd21b1e3$var$addLeadingZero = (val)=>{
    if (val < 10) return `0${val}`;
    return val;
};
const $c57af174cd21b1e3$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $c57af174cd21b1e3$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
    if (!intl || pattern === "YYYY-MM-DD") return $c57af174cd21b1e3$export$70a1b7b6fffe4dd1(timestamp);
    const date = new Date(Number(timestamp));
    return intl.formatDate(date, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        formatMatcher: 'best fit'
    });
};
const $c57af174cd21b1e3$export$70a1b7b6fffe4dd1 = (timestamp)=>{
    const date = new Date(Number(timestamp));
    return `${date.getUTCFullYear()}-${$c57af174cd21b1e3$var$addLeadingZero(date.getUTCMonth() + 1)}-${$c57af174cd21b1e3$var$addLeadingZero(date.getUTCDate())}`;
};
const $c57af174cd21b1e3$export$e6cc7bfc6e0e363e = (timestamp, timeZone)=>{
    return (0, $mr7nI.default)(new Date(Number(timestamp)), new Date(Number($c57af174cd21b1e3$export$6297728405c48562(timeZone))));
};
const $c57af174cd21b1e3$export$fbc04a9e57b04a80 = (timestamp, intl, timeZone)=>{
    const curDate = new Date(Number($c57af174cd21b1e3$export$6297728405c48562(timeZone)));
    const givenDate = new Date(Number(timestamp));
    const distance = (0, $1Ujre.default)(givenDate, curDate);
    if (intl && [
        -1,
        0,
        1
    ].indexOf(distance) > -1) return $c57af174cd21b1e3$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
        numeric: 'auto'
    }));
    return $c57af174cd21b1e3$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
};
module.exports["timestampToUTCDate"] = $c57af174cd21b1e3$export$56c3660a4ee2196a;
module.exports["todayTimestampInUTC"] = $c57af174cd21b1e3$export$6297728405c48562;
module.exports["timestampToString"] = $c57af174cd21b1e3$export$48755a044ef883a0;
module.exports["timestampToIsoFormat"] = $c57af174cd21b1e3$export$70a1b7b6fffe4dd1;
module.exports["isPastDate"] = $c57af174cd21b1e3$export$e6cc7bfc6e0e363e;
module.exports["timestampToTaskContext"] = $c57af174cd21b1e3$export$fbc04a9e57b04a80;

});

parcelRegister("45O09", function(module, exports) {

var $jVdlG = parcelRequire("jVdlG");


var $lqPdm = parcelRequire("lqPdm");

const $dca98429b91f0137$var$lightPanelColors = {
    info: '#DEEBFF',
    note: '#EAE6FF',
    tip: '#E3FCEF',
    success: '#E3FCEF',
    warning: '#FFFAE6',
    error: '#FFEBE6'
};
const $dca98429b91f0137$var$prefix = 'ak-editor-panel';
const $dca98429b91f0137$export$6dd740b6c888e050 = {
    prefix: $dca98429b91f0137$var$prefix,
    content: `${$dca98429b91f0137$var$prefix}__content`,
    icon: `${$dca98429b91f0137$var$prefix}__icon`,
    noIcon: `${$dca98429b91f0137$var$prefix}__no-icon`
};
const $dca98429b91f0137$export$b0ee08fae091706a = {
    infoPanel: `.${$dca98429b91f0137$var$prefix}[data-panel-type=${(0, $jVdlG.PanelType).INFO}]`,
    notePanel: `.${$dca98429b91f0137$var$prefix}[data-panel-type=${(0, $jVdlG.PanelType).NOTE}]`,
    warningPanel: `.${$dca98429b91f0137$var$prefix}[data-panel-type=${(0, $jVdlG.PanelType).WARNING}]`,
    errorPanel: `.${$dca98429b91f0137$var$prefix}[data-panel-type=${(0, $jVdlG.PanelType).ERROR}]`,
    successPanel: `.${$dca98429b91f0137$var$prefix}[data-panel-type=${(0, $jVdlG.PanelType).SUCCESS}]`,
    noteButton: `button[aria-label="Note"]`,
    warningButton: `button[aria-label="Warning"]`,
    removeButton: `button[aria-label="Remove"]`,
    colorPalette: `[aria-label="Background color"]`,
    selectedColor: `[aria-label="Light green"]`,
    removeEmojiIcon: `[aria-label="Remove emoji"]`,
    emojiIcon: `[aria-label="editor-add-emoji"]`,
    selectedEmoji: `[aria-label=":grinning:"]`,
    addYourOwnEmoji: `#add-custom-emoji`,
    emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
    title: `#editor-title`,
    emojiPopup: `[data-testid="popup-wrapper"]`,
    searchEmoji: `[aria-label="Emoji name"]`,
    orangeWarningIcon: `[aria-label=":warning:"]`,
    yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
    copyButton: `button[aria-label="Copy"]`
};
const $dca98429b91f0137$export$8099afddf1b1be78 = (panelType)=>$dca98429b91f0137$var$lightPanelColors[panelType] || 'none';
const $dca98429b91f0137$export$dd3f0fd482ae7ccc = (panelType)=>(0, $lqPdm.hexToEditorBackgroundPaletteColor)($dca98429b91f0137$var$lightPanelColors[panelType]) || 'none';
module.exports["PanelSharedCssClassName"] = $dca98429b91f0137$export$6dd740b6c888e050;
module.exports["getPanelTypeBackgroundNoTokens"] = $dca98429b91f0137$export$8099afddf1b1be78;
module.exports["getPanelTypeBackground"] = $dca98429b91f0137$export$dd3f0fd482ae7ccc;

});

parcelRegister("5X6fy", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("4G6PK", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $4e6f18d969fc9276$export$5937600f4cc784f0 = 24;
const $4e6f18d969fc9276$export$71d660e8ca5b8f73 = 320;
const $4e6f18d969fc9276$export$cd11d7d46412c89b = 3;
const $4e6f18d969fc9276$export$71482734bb54ac3 = 10;
const $4e6f18d969fc9276$export$fd2b09475ada41cc = 12;
const $4e6f18d969fc9276$export$8c5ac0b0c62a3d21 = 8;
const $4e6f18d969fc9276$export$68d0abe4f03863fb = $4e6f18d969fc9276$export$fd2b09475ada41cc * 2;
const $4e6f18d969fc9276$export$d722b7527b1834a8 = 250;
const $4e6f18d969fc9276$export$da894f7669b4e67c = 200;
const $4e6f18d969fc9276$export$e13825c38da2ce1 = 100;
var $4e6f18d969fc9276$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
    return Layout;
}({});
const $4e6f18d969fc9276$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $4e6f18d969fc9276$export$4d41d008e9cd4f34 = 0.5;
const $4e6f18d969fc9276$export$b4b560efd3c61856 = 'caption-placeholder';
module.exports["MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH"] = $4e6f18d969fc9276$export$5937600f4cc784f0;
module.exports["MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH"] = $4e6f18d969fc9276$export$71d660e8ca5b8f73;
module.exports["MEDIA_SINGLE_SNAP_GAP"] = $4e6f18d969fc9276$export$cd11d7d46412c89b;
module.exports["MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN"] = $4e6f18d969fc9276$export$8c5ac0b0c62a3d21;
module.exports["MEDIA_SINGLE_GUTTER_SIZE"] = $4e6f18d969fc9276$export$68d0abe4f03863fb;
module.exports["DEFAULT_IMAGE_WIDTH"] = $4e6f18d969fc9276$export$d722b7527b1834a8;
module.exports["DEFAULT_IMAGE_HEIGHT"] = $4e6f18d969fc9276$export$da894f7669b4e67c;
module.exports["MEDIA_SINGLE_RESIZE_THROTTLE_TIME"] = $4e6f18d969fc9276$export$e13825c38da2ce1;
module.exports["wrappedLayouts"] = $4e6f18d969fc9276$export$405baca3d8bc263d;
module.exports["DEFAULT_ROUNDING_INTERVAL"] = $4e6f18d969fc9276$export$4d41d008e9cd4f34;
module.exports["CAPTION_PLACEHOLDER_ID"] = $4e6f18d969fc9276$export$b4b560efd3c61856;

});

parcelRegister("ihn0W", function(module, exports) {

var $34CLe = parcelRequire("34CLe");

const $24a1030e8452f7d6$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $34CLe.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
module.exports["shouldAddDefaultWrappedWidth"] = $24a1030e8452f7d6$export$7cd5aab2c4f1fb1e;

});

parcelRegister("34CLe", function(module, exports) {
const $df10a01237b702c1$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
module.exports["wrappedLayouts"] = $df10a01237b702c1$export$405baca3d8bc263d;

});

parcelRegister("8qft0", function(module, exports) {
const $5b70b8fd3b65ebb8$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];
module.exports["nonWrappedLayouts"] = $5b70b8fd3b65ebb8$export$607795ead6e50626;

});

parcelRegister("iqS60", function(module, exports) {
var $d6b49e035a630451$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $d6b49e035a630451$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: "\""
};
var $d6b49e035a630451$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $d6b49e035a630451$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $d6b49e035a630451$var$i = 0; $d6b49e035a630451$var$i < 10; $d6b49e035a630451$var$i++)$d6b49e035a630451$export$e2253033e6e1df16[48 + $d6b49e035a630451$var$i] = $d6b49e035a630451$export$e2253033e6e1df16[96 + $d6b49e035a630451$var$i] = String($d6b49e035a630451$var$i);
// The function keys
for(var $d6b49e035a630451$var$i = 1; $d6b49e035a630451$var$i <= 24; $d6b49e035a630451$var$i++)$d6b49e035a630451$export$e2253033e6e1df16[$d6b49e035a630451$var$i + 111] = "F" + $d6b49e035a630451$var$i;
// And the alphabetic keys
for(var $d6b49e035a630451$var$i = 65; $d6b49e035a630451$var$i <= 90; $d6b49e035a630451$var$i++){
    $d6b49e035a630451$export$e2253033e6e1df16[$d6b49e035a630451$var$i] = String.fromCharCode($d6b49e035a630451$var$i + 32);
    $d6b49e035a630451$export$fba63a578e423eb[$d6b49e035a630451$var$i] = String.fromCharCode($d6b49e035a630451$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $d6b49e035a630451$var$code in $d6b49e035a630451$export$e2253033e6e1df16)if (!$d6b49e035a630451$export$fba63a578e423eb.hasOwnProperty($d6b49e035a630451$var$code)) $d6b49e035a630451$export$fba63a578e423eb[$d6b49e035a630451$var$code] = $d6b49e035a630451$export$e2253033e6e1df16[$d6b49e035a630451$var$code];
function $d6b49e035a630451$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $d6b49e035a630451$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $d6b49e035a630451$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $d6b49e035a630451$export$fba63a578e423eb : $d6b49e035a630451$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}
module.exports["base"] = $d6b49e035a630451$export$e2253033e6e1df16;
module.exports["shift"] = $d6b49e035a630451$export$fba63a578e423eb;
module.exports["keyName"] = $d6b49e035a630451$export$fb33aafd75404f4c;

});

parcelRegister("kmQhR", function(module, exports) {

var $55fM8 = parcelRequire("55fM8");


var $izVFW = parcelRequire("izVFW");

/** Error message constants. */ var $ed3e6bd2c68e4529$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $ed3e6bd2c68e4529$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($ed3e6bd2c68e4529$var$FUNC_ERROR_TEXT);
    if ($izVFW(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $55fM8(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $ed3e6bd2c68e4529$var$throttle;

});

parcelRegister("6wYuL", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 



const $d6a90985447658eb$export$dbe437e0902936cc = 'media-blob-url';
module.exports["mediaBlobUrlIdentifier"] = $d6a90985447658eb$export$dbe437e0902936cc;

});

parcelRegister("aELWC", function(module, exports) {
function $7c22d49b1592b774$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $7c22d49b1592b774$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $7c22d49b1592b774$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $7c22d49b1592b774$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $7c22d49b1592b774$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $7c22d49b1592b774$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $7c22d49b1592b774$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $7c22d49b1592b774$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $7c22d49b1592b774$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $7c22d49b1592b774$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $7c22d49b1592b774$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $7c22d49b1592b774$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $7c22d49b1592b774$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $7c22d49b1592b774$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $7c22d49b1592b774$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $7c22d49b1592b774$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $7c22d49b1592b774$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $7c22d49b1592b774$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $7c22d49b1592b774$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $7c22d49b1592b774$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $7c22d49b1592b774$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $7c22d49b1592b774$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $7c22d49b1592b774$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $7c22d49b1592b774$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $7c22d49b1592b774$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $7c22d49b1592b774$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $7c22d49b1592b774$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $7c22d49b1592b774$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $7c22d49b1592b774$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $7c22d49b1592b774$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $7c22d49b1592b774$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $7c22d49b1592b774$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $7c22d49b1592b774$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $7c22d49b1592b774$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $7c22d49b1592b774$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $7c22d49b1592b774$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $7c22d49b1592b774$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $7c22d49b1592b774$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $7c22d49b1592b774$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $7c22d49b1592b774$var$fromHex_1 = $7c22d49b1592b774$var$fromHex, $7c22d49b1592b774$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $7c22d49b1592b774$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $7c22d49b1592b774$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $7c22d49b1592b774$var$fromRgb_1 = $7c22d49b1592b774$var$fromRgb, $7c22d49b1592b774$var$fromCssRgb_1 = $7c22d49b1592b774$var$fromCssRgb, $7c22d49b1592b774$var$fromHsl_1 = $7c22d49b1592b774$var$fromHsl, $7c22d49b1592b774$var$fromCssHsl_1 = $7c22d49b1592b774$var$fromCssHsl, $7c22d49b1592b774$var$fromHsv_1 = $7c22d49b1592b774$var$fromHsv, $7c22d49b1592b774$var$fromCmyk_1 = $7c22d49b1592b774$var$fromCmyk, $7c22d49b1592b774$var$fromYiq_1 = $7c22d49b1592b774$var$fromYiq, $7c22d49b1592b774$var$fromXYZ_1 = $7c22d49b1592b774$var$fromXYZ, $7c22d49b1592b774$var$fromxyY_1 = $7c22d49b1592b774$var$fromxyY, $7c22d49b1592b774$var$fromLms_1 = $7c22d49b1592b774$var$fromLms, $7c22d49b1592b774$var$fromCieLab_1 = $7c22d49b1592b774$var$fromCieLab, $7c22d49b1592b774$var$fromCieLuv_1 = $7c22d49b1592b774$var$fromCieLuv, $7c22d49b1592b774$var$fromCieLch_1 = $7c22d49b1592b774$var$fromCieLch, $7c22d49b1592b774$var$fromHsluv = $7c22d49b1592b774$var$fromCieLch$1, $7c22d49b1592b774$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $7c22d49b1592b774$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $7c22d49b1592b774$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $7c22d49b1592b774$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $7c22d49b1592b774$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $7c22d49b1592b774$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $7c22d49b1592b774$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $7c22d49b1592b774$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $7c22d49b1592b774$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $7c22d49b1592b774$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $7c22d49b1592b774$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $7c22d49b1592b774$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $7c22d49b1592b774$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $7c22d49b1592b774$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $7c22d49b1592b774$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $7c22d49b1592b774$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $7c22d49b1592b774$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $7c22d49b1592b774$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $7c22d49b1592b774$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $7c22d49b1592b774$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $7c22d49b1592b774$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $7c22d49b1592b774$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $7c22d49b1592b774$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $7c22d49b1592b774$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $7c22d49b1592b774$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $7c22d49b1592b774$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $7c22d49b1592b774$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $7c22d49b1592b774$var$fromHsluv
    }
}, $7c22d49b1592b774$var$adapt_1 = $7c22d49b1592b774$var$adapt, $7c22d49b1592b774$var$adjacent_1 = $7c22d49b1592b774$var$adjacent, $7c22d49b1592b774$var$brightness_1 = $7c22d49b1592b774$var$brightness, $7c22d49b1592b774$var$complementary_1 = $7c22d49b1592b774$var$complementary, $7c22d49b1592b774$var$contrast_1 = $7c22d49b1592b774$var$contrast, $7c22d49b1592b774$var$contrastRatio_1 = $7c22d49b1592b774$var$contrastRatio, $7c22d49b1592b774$var$convert_1 = $7c22d49b1592b774$var$convert, $7c22d49b1592b774$var$difference_1 = $7c22d49b1592b774$var$difference, $7c22d49b1592b774$var$fade_1 = $7c22d49b1592b774$var$fade, $7c22d49b1592b774$var$greyscale_1 = $7c22d49b1592b774$var$greyscale, $7c22d49b1592b774$var$hue_1 = $7c22d49b1592b774$var$hue, $7c22d49b1592b774$var$invert_1 = $7c22d49b1592b774$var$invert, $7c22d49b1592b774$var$invertLightness_1 = $7c22d49b1592b774$var$invertLightness, $7c22d49b1592b774$var$mid_1 = $7c22d49b1592b774$var$mid, $7c22d49b1592b774$var$multiply_1 = $7c22d49b1592b774$var$multiply, $7c22d49b1592b774$var$saturation_1 = $7c22d49b1592b774$var$saturation, $7c22d49b1592b774$var$sepia_1 = $7c22d49b1592b774$var$sepia, $7c22d49b1592b774$var$shade_1 = $7c22d49b1592b774$var$shade, $7c22d49b1592b774$var$temperature_1 = $7c22d49b1592b774$var$temperature, $7c22d49b1592b774$var$tetrad_1 = $7c22d49b1592b774$var$tetrad, $7c22d49b1592b774$var$triad_1 = $7c22d49b1592b774$var$triad, $7c22d49b1592b774$var$index$2 = {
    adapt: $7c22d49b1592b774$var$adapt_1,
    adjacent: $7c22d49b1592b774$var$adjacent_1,
    brightness: $7c22d49b1592b774$var$brightness_1,
    complementary: $7c22d49b1592b774$var$complementary_1,
    contrast: $7c22d49b1592b774$var$contrast_1,
    contrastRatio: $7c22d49b1592b774$var$contrastRatio_1,
    convert: $7c22d49b1592b774$var$convert_1,
    difference: $7c22d49b1592b774$var$difference_1,
    fade: $7c22d49b1592b774$var$fade_1,
    greyscale: $7c22d49b1592b774$var$greyscale_1,
    hue: $7c22d49b1592b774$var$hue_1,
    invert: $7c22d49b1592b774$var$invert_1,
    invertLightness: $7c22d49b1592b774$var$invertLightness_1,
    mid: $7c22d49b1592b774$var$mid_1,
    multiply: $7c22d49b1592b774$var$multiply_1,
    saturation: $7c22d49b1592b774$var$saturation_1,
    sepia: $7c22d49b1592b774$var$sepia_1,
    shade: $7c22d49b1592b774$var$shade_1,
    temperature: $7c22d49b1592b774$var$temperature_1,
    tetrad: $7c22d49b1592b774$var$tetrad_1,
    triad: $7c22d49b1592b774$var$triad_1
}, $7c22d49b1592b774$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $7c22d49b1592b774$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $7c22d49b1592b774$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($7c22d49b1592b774$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $7c22d49b1592b774$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($7c22d49b1592b774$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $7c22d49b1592b774$var$api_1 = $7c22d49b1592b774$var$api, $7c22d49b1592b774$var$helpers = {
    getIlluminant: function(r) {
        return $7c22d49b1592b774$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $7c22d49b1592b774$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $7c22d49b1592b774$var$index)if ($7c22d49b1592b774$var$index.hasOwnProperty(e) && $7c22d49b1592b774$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $7c22d49b1592b774$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $7c22d49b1592b774$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $7c22d49b1592b774$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $7c22d49b1592b774$var$constants, s));
            default:
                return null;
        }
    }
}, $7c22d49b1592b774$var$helpers_1 = $7c22d49b1592b774$var$helpers, $7c22d49b1592b774$var$dependencies = {
    conversions: $7c22d49b1592b774$var$index,
    operations: $7c22d49b1592b774$var$index$2,
    helpers: $7c22d49b1592b774$var$helpers_1
}, $7c22d49b1592b774$var$entry = $7c22d49b1592b774$var$api_1($7c22d49b1592b774$var$dependencies, $7c22d49b1592b774$var$constants);
var $7c22d49b1592b774$export$2e2bcd8739ae039 = $7c22d49b1592b774$var$entry;
module.exports["default"] = $7c22d49b1592b774$export$2e2bcd8739ae039;

});

parcelRegister("5d6Y9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a310062cb7336e4c0e920ee15f52e421>>
 * @codegenCommand yarn build tokens
 */ const $d177a4da6300d858$var$tokens = [
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for for backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#28311B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for for backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Lime1000"
        },
        "name": "color.background.accent.lime.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.lime.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.lime.subtlest."
        },
        "value": "#37471F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.lime.subtlest."
            },
            "value": "Lime900"
        },
        "name": "color.background.accent.lime.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.lime.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.lime.subtlest."
        },
        "value": "#3F5224",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.lime.subtlest."
            },
            "value": "Lime850"
        },
        "name": "color.background.accent.lime.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.lime.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for for backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#37471F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for for backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Lime900"
        },
        "name": "color.background.accent.lime.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.lime.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.lime.subtler."
        },
        "value": "#3F5224",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.lime.subtler."
            },
            "value": "Lime850"
        },
        "name": "color.background.accent.lime.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.lime.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.lime.subtler."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.lime.subtler."
            },
            "value": "Lime800"
        },
        "name": "color.background.accent.lime.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.lime.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for vibrant for backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for vibrant for backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Lime800"
        },
        "name": "color.background.accent.lime.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.lime.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.lime.subtle."
        },
        "value": "#3F5224",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.lime.subtle."
            },
            "value": "Lime850"
        },
        "name": "color.background.accent.lime.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.lime.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.lime.subtle."
        },
        "value": "#37471F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.lime.subtle."
            },
            "value": "Lime900"
        },
        "name": "color.background.accent.lime.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.lime.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for for backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#94C748",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for for backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Lime400"
        },
        "name": "color.background.accent.lime.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.lime.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.lime.bolder."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.lime.bolder."
            },
            "value": "Lime300"
        },
        "name": "color.background.accent.lime.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.lime.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.lime.bolder."
        },
        "value": "#BDE97C",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.lime.bolder."
            },
            "value": "Lime250"
        },
        "name": "color.background.accent.lime.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.lime.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for red backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#42221F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for red backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Red1000"
        },
        "name": "color.background.accent.red.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.red.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.red.subtlest."
        },
        "value": "#5D1F1A",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.red.subtlest."
            },
            "value": "Red900"
        },
        "name": "color.background.accent.red.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.red.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.red.subtlest."
        },
        "value": "#872821",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.red.subtlest."
            },
            "value": "Red850"
        },
        "name": "color.background.accent.red.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.red.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for red backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#5D1F1A",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for red backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Red900"
        },
        "name": "color.background.accent.red.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.red.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.red.subtler."
        },
        "value": "#872821",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.red.subtler."
            },
            "value": "Red850"
        },
        "name": "color.background.accent.red.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.red.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.red.subtler."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.red.subtler."
            },
            "value": "Red800"
        },
        "name": "color.background.accent.red.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.red.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant red backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant red backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Red800"
        },
        "name": "color.background.accent.red.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.red.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.red.subtle."
        },
        "value": "#872821",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.red.subtle."
            },
            "value": "Red850"
        },
        "name": "color.background.accent.red.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.red.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.red.subtle."
        },
        "value": "#5D1F1A",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.red.subtle."
            },
            "value": "Red900"
        },
        "name": "color.background.accent.red.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.red.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for red backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#F87168",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for red backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Red400"
        },
        "name": "color.background.accent.red.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.red.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.red.bolder."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.red.bolder."
            },
            "value": "Red300"
        },
        "name": "color.background.accent.red.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.red.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.red.bolder."
        },
        "value": "#FFB8B2",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.red.bolder."
            },
            "value": "Red250"
        },
        "name": "color.background.accent.red.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.red.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for orange backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#3A2C1F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for orange backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Orange1000"
        },
        "name": "color.background.accent.orange.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.orange.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.orange.subtlest."
        },
        "value": "#693200",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.orange.subtlest."
            },
            "value": "Orange900"
        },
        "name": "color.background.accent.orange.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.orange.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.orange.subtlest."
        },
        "value": "#7A3B00",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.orange.subtlest."
            },
            "value": "Orange850"
        },
        "name": "color.background.accent.orange.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.orange.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for orange backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#693200",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for orange backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Orange900"
        },
        "name": "color.background.accent.orange.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.orange.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.orange.subtler."
        },
        "value": "#7A3B00",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.orange.subtler."
            },
            "value": "Orange850"
        },
        "name": "color.background.accent.orange.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.orange.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.orange.subtler."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.orange.subtler."
            },
            "value": "Orange800"
        },
        "name": "color.background.accent.orange.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.orange.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant orange backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant orange backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Orange800"
        },
        "name": "color.background.accent.orange.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.orange.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.orange.subtle."
        },
        "value": "#7A3B00",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.orange.subtle."
            },
            "value": "Orange850"
        },
        "name": "color.background.accent.orange.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.orange.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.orange.subtle."
        },
        "value": "#693200",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.orange.subtle."
            },
            "value": "Orange900"
        },
        "name": "color.background.accent.orange.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.orange.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for orange backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for orange backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Orange400"
        },
        "name": "color.background.accent.orange.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.orange.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.orange.bolder."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.orange.bolder."
            },
            "value": "Orange300"
        },
        "name": "color.background.accent.orange.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.orange.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.orange.bolder."
        },
        "value": "#FBD779",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.orange.bolder."
            },
            "value": "Orange250"
        },
        "name": "color.background.accent.orange.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.orange.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for yellow backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#332E1B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for yellow backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Yellow1000"
        },
        "name": "color.background.accent.yellow.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.yellow.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.yellow.subtlest."
        },
        "value": "#533F04",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.yellow.subtlest."
            },
            "value": "Yellow900"
        },
        "name": "color.background.accent.yellow.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.yellow.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.yellow.subtlest."
        },
        "value": "#614A05",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.yellow.subtlest."
            },
            "value": "Yellow850"
        },
        "name": "color.background.accent.yellow.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.yellow.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for yellow backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#533F04",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for yellow backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Yellow900"
        },
        "name": "color.background.accent.yellow.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.yellow.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.yellow.subtler."
        },
        "value": "#614A05",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.yellow.subtler."
            },
            "value": "Yellow850"
        },
        "name": "color.background.accent.yellow.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.yellow.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.yellow.subtler."
        },
        "value": "#7F5F01",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.yellow.subtler."
            },
            "value": "Yellow800"
        },
        "name": "color.background.accent.yellow.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.yellow.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant yellow backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#7F5F01",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant yellow backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Yellow800"
        },
        "name": "color.background.accent.yellow.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.yellow.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.yellow.subtle."
        },
        "value": "#614A05",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.yellow.subtle."
            },
            "value": "Yellow850"
        },
        "name": "color.background.accent.yellow.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.yellow.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.yellow.subtle."
        },
        "value": "#533F04",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.yellow.subtle."
            },
            "value": "Yellow900"
        },
        "name": "color.background.accent.yellow.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.yellow.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for yellow backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#DDB30E",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for yellow backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Yellow400"
        },
        "name": "color.background.accent.yellow.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.yellow.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.yellow.bolder."
        },
        "value": "#EED12B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.yellow.bolder."
            },
            "value": "Yellow300"
        },
        "name": "color.background.accent.yellow.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.yellow.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.yellow.bolder."
        },
        "value": "#EFDD4E",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.yellow.bolder."
            },
            "value": "Yellow250"
        },
        "name": "color.background.accent.yellow.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.yellow.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for green backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#1C3329",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for green backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Green1000"
        },
        "name": "color.background.accent.green.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.green.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.green.subtlest."
        },
        "value": "#164B35",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.green.subtlest."
            },
            "value": "Green900"
        },
        "name": "color.background.accent.green.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.green.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.green.subtlest."
        },
        "value": "#19573D",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.green.subtlest."
            },
            "value": "Green850"
        },
        "name": "color.background.accent.green.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.green.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for green backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#164B35",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for green backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Green900"
        },
        "name": "color.background.accent.green.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.green.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.green.subtler."
        },
        "value": "#19573D",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.green.subtler."
            },
            "value": "Green850"
        },
        "name": "color.background.accent.green.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.green.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.green.subtler."
        },
        "value": "#216E4E",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.green.subtler."
            },
            "value": "Green800"
        },
        "name": "color.background.accent.green.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.green.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant green backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#216E4E",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant green backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Green800"
        },
        "name": "color.background.accent.green.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.green.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.green.subtle."
        },
        "value": "#19573D",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.green.subtle."
            },
            "value": "Green850"
        },
        "name": "color.background.accent.green.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.green.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.green.subtle."
        },
        "value": "#164B35",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.green.subtle."
            },
            "value": "Green900"
        },
        "name": "color.background.accent.green.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.green.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for green backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#4BCE97",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for green backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Green400"
        },
        "name": "color.background.accent.green.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.green.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.green.bolder."
        },
        "value": "#7EE2B8",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.green.bolder."
            },
            "value": "Green300"
        },
        "name": "color.background.accent.green.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.green.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.green.bolder."
        },
        "value": "#97EDC9",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.green.bolder."
            },
            "value": "Green250"
        },
        "name": "color.background.accent.green.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.green.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for teal backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#1E3137",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for teal backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Teal1000"
        },
        "name": "color.background.accent.teal.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.teal.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.teal.subtlest."
        },
        "value": "#164555",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.teal.subtlest."
            },
            "value": "Teal900"
        },
        "name": "color.background.accent.teal.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.teal.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.teal.subtlest."
        },
        "value": "#1A5265",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.teal.subtlest."
            },
            "value": "Teal850"
        },
        "name": "color.background.accent.teal.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.teal.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for teal backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#164555",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for teal backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Teal900"
        },
        "name": "color.background.accent.teal.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.teal.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.teal.subtler."
        },
        "value": "#1A5265",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.teal.subtler."
            },
            "value": "Teal850"
        },
        "name": "color.background.accent.teal.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.teal.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.teal.subtler."
        },
        "value": "#206A83",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.teal.subtler."
            },
            "value": "Teal800"
        },
        "name": "color.background.accent.teal.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.teal.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant teal backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#206A83",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant teal backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Teal800"
        },
        "name": "color.background.accent.teal.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.teal.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.teal.subtle."
        },
        "value": "#1A5265",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.teal.subtle."
            },
            "value": "Teal850"
        },
        "name": "color.background.accent.teal.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.teal.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.teal.subtle."
        },
        "value": "#164555",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.teal.subtle."
            },
            "value": "Teal900"
        },
        "name": "color.background.accent.teal.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.teal.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for teal backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#6CC3E0",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for teal backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Teal400"
        },
        "name": "color.background.accent.teal.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.teal.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.teal.bolder."
        },
        "value": "#9DD9EE",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.teal.bolder."
            },
            "value": "Teal300"
        },
        "name": "color.background.accent.teal.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.teal.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.teal.bolder."
        },
        "value": "#B1E4F7",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.teal.bolder."
            },
            "value": "Teal250"
        },
        "name": "color.background.accent.teal.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.teal.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for blue backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#1C2B42",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for blue backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Blue1000"
        },
        "name": "color.background.accent.blue.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.blue.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.blue.subtlest."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.blue.subtlest."
            },
            "value": "Blue900"
        },
        "name": "color.background.accent.blue.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.blue.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.blue.subtlest."
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.blue.subtlest."
            },
            "value": "Blue850"
        },
        "name": "color.background.accent.blue.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.blue.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for blue backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for blue backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Blue900"
        },
        "name": "color.background.accent.blue.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.blue.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.blue.subtler."
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.blue.subtler."
            },
            "value": "Blue850"
        },
        "name": "color.background.accent.blue.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.blue.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.blue.subtler."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.blue.subtler."
            },
            "value": "Blue800"
        },
        "name": "color.background.accent.blue.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.blue.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant blue backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant blue backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Blue800"
        },
        "name": "color.background.accent.blue.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.blue.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.blue.subtle."
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.blue.subtle."
            },
            "value": "Blue850"
        },
        "name": "color.background.accent.blue.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.blue.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.blue.subtle."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.blue.subtle."
            },
            "value": "Blue900"
        },
        "name": "color.background.accent.blue.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.blue.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for blue backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for blue backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Blue400"
        },
        "name": "color.background.accent.blue.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.blue.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.blue.bolder."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.blue.bolder."
            },
            "value": "Blue300"
        },
        "name": "color.background.accent.blue.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.blue.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.blue.bolder."
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.blue.bolder."
            },
            "value": "Blue250"
        },
        "name": "color.background.accent.blue.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.blue.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for purple backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#35243F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for purple backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Purple1000"
        },
        "name": "color.background.accent.purple.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.purple.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.purple.subtlest."
        },
        "value": "#48245D",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.purple.subtlest."
            },
            "value": "Purple900"
        },
        "name": "color.background.accent.purple.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.purple.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.purple.subtlest."
        },
        "value": "#673286",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.purple.subtlest."
            },
            "value": "Purple850"
        },
        "name": "color.background.accent.purple.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.purple.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for purple backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#48245D",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for purple backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Purple900"
        },
        "name": "color.background.accent.purple.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.purple.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.purple.subtler."
        },
        "value": "#673286",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.purple.subtler."
            },
            "value": "Purple850"
        },
        "name": "color.background.accent.purple.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.purple.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.purple.subtler."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.purple.subtler."
            },
            "value": "Purple800"
        },
        "name": "color.background.accent.purple.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.purple.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant purple backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant purple backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Purple800"
        },
        "name": "color.background.accent.purple.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.purple.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.purple.subtle."
        },
        "value": "#673286",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.purple.subtle."
            },
            "value": "Purple850"
        },
        "name": "color.background.accent.purple.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.purple.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.purple.subtle."
        },
        "value": "#48245D",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.purple.subtle."
            },
            "value": "Purple900"
        },
        "name": "color.background.accent.purple.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.purple.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for purple backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#C97CF4",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for purple backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Purple400"
        },
        "name": "color.background.accent.purple.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.purple.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.purple.bolder."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.purple.bolder."
            },
            "value": "Purple300"
        },
        "name": "color.background.accent.purple.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.purple.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.purple.bolder."
        },
        "value": "#E3BDFA",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.purple.bolder."
            },
            "value": "Purple250"
        },
        "name": "color.background.accent.purple.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.purple.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for magenta backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#3D2232",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for magenta backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Magenta1000"
        },
        "name": "color.background.accent.magenta.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.magenta.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.magenta.subtlest."
        },
        "value": "#50253F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.magenta.subtlest."
            },
            "value": "Magenta900"
        },
        "name": "color.background.accent.magenta.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.magenta.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.magenta.subtlest."
        },
        "value": "#77325B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.magenta.subtlest."
            },
            "value": "Magenta850"
        },
        "name": "color.background.accent.magenta.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.magenta.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for magenta backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#50253F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for magenta backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Magenta900"
        },
        "name": "color.background.accent.magenta.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.magenta.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.magenta.subtler."
        },
        "value": "#77325B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.magenta.subtler."
            },
            "value": "Magenta850"
        },
        "name": "color.background.accent.magenta.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.magenta.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.magenta.subtler."
        },
        "value": "#943D73",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.magenta.subtler."
            },
            "value": "Magenta800"
        },
        "name": "color.background.accent.magenta.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.magenta.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant magenta backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#943D73",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant magenta backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Magenta800"
        },
        "name": "color.background.accent.magenta.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.magenta.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.magenta.subtle."
        },
        "value": "#77325B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.magenta.subtle."
            },
            "value": "Magenta850"
        },
        "name": "color.background.accent.magenta.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.magenta.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.magenta.subtle."
        },
        "value": "#50253F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.magenta.subtle."
            },
            "value": "Magenta900"
        },
        "name": "color.background.accent.magenta.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.magenta.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for magenta backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#E774BB",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for magenta backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Magenta400"
        },
        "name": "color.background.accent.magenta.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.magenta.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.magenta.bolder."
        },
        "value": "#F797D2",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.magenta.bolder."
            },
            "value": "Magenta300"
        },
        "name": "color.background.accent.magenta.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.magenta.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.magenta.bolder."
        },
        "value": "#FCB6E1",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.magenta.bolder."
            },
            "value": "Magenta250"
        },
        "name": "color.background.accent.magenta.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.magenta.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for gray backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#303134",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for gray backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "DarkNeutral300"
        },
        "name": "color.background.accent.gray.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.gray.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.gray.subtlest."
        },
        "value": "#3D3F43",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.gray.subtlest."
            },
            "value": "DarkNeutral350"
        },
        "name": "color.background.accent.gray.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.gray.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.gray.subtlest."
        },
        "value": "#4B4D51",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.gray.subtlest."
            },
            "value": "DarkNeutral400"
        },
        "name": "color.background.accent.gray.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.gray.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for gray backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#4B4D51",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for gray backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "DarkNeutral400"
        },
        "name": "color.background.accent.gray.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.gray.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.gray.subtler."
        },
        "value": "#63666B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.gray.subtler."
            },
            "value": "DarkNeutral500"
        },
        "name": "color.background.accent.gray.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.gray.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.gray.subtler."
        },
        "value": "#7E8188",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.gray.subtler."
            },
            "value": "DarkNeutral600"
        },
        "name": "color.background.accent.gray.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.gray.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant gray backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#63666B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant gray backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "DarkNeutral500"
        },
        "name": "color.background.accent.gray.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.gray.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.gray.subtle."
        },
        "value": "#4B4D51",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.gray.subtle."
            },
            "value": "DarkNeutral400"
        },
        "name": "color.background.accent.gray.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.gray.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.gray.subtle."
        },
        "value": "#3D3F43",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.gray.subtle."
            },
            "value": "DarkNeutral350"
        },
        "name": "color.background.accent.gray.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.gray.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for gray backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#96999E",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for gray backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "DarkNeutral700"
        },
        "name": "color.background.accent.gray.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.gray.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.gray.bolder."
        },
        "value": "#A9ABAF",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.gray.bolder."
            },
            "value": "DarkNeutral800"
        },
        "name": "color.background.accent.gray.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.gray.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.gray.subtlest."
        },
        "value": "#BFC1C4",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.gray.subtlest."
            },
            "value": "DarkNeutral900"
        },
        "name": "color.background.accent.gray.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.gray.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for highlighted added code lines."
        },
        "value": "#1C3329",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for highlighted added code lines."
            },
            "value": "Green1000"
        },
        "name": "color.background.code.added.highlight",
        "path": [
            "color",
            "background",
            "code",
            "added",
            "highlight"
        ],
        "cleanName": "color.background.code.added.highlight"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for added code lines."
        },
        "value": "#164B35B2",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for added code lines."
            },
            "value": "Green900A70"
        },
        "name": "color.background.code.added.line",
        "path": [
            "color",
            "background",
            "code",
            "added",
            "line"
        ],
        "cleanName": "color.background.code.added.line"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for the default background of code blocks and code diffs."
        },
        "value": "#1F1F21",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for the default background of code blocks and code diffs."
            },
            "value": "DarkNeutral100"
        },
        "name": "color.background.code.default",
        "path": [
            "color",
            "background",
            "code",
            "default"
        ],
        "cleanName": "color.background.code.default"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for the background of code gutters."
        },
        "value": "#242528",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for the background of code gutters."
            },
            "value": "DarkNeutral200"
        },
        "name": "color.background.code.gutter",
        "path": [
            "color",
            "background",
            "code",
            "gutter"
        ],
        "cleanName": "color.background.code.gutter"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for highlighted unchanged code lines."
        },
        "value": "#242528",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for highlighted unchanged code lines."
            },
            "value": "DarkNeutral200"
        },
        "name": "color.background.code.highlight",
        "path": [
            "color",
            "background",
            "code",
            "highlight"
        ],
        "cleanName": "color.background.code.highlight"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for highlighted removed code lines."
        },
        "value": "#42221F",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for highlighted removed code lines."
            },
            "value": "Red1000"
        },
        "name": "color.background.code.removed.highlight",
        "path": [
            "color",
            "background",
            "code",
            "removed",
            "highlight"
        ],
        "cleanName": "color.background.code.removed.highlight"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for removed code lines."
        },
        "value": "#5D1F1AB2",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for removed code lines."
            },
            "value": "Red900A70"
        },
        "name": "color.background.code.removed.line",
        "path": [
            "color",
            "background",
            "code",
            "removed",
            "line"
        ],
        "cleanName": "color.background.code.removed.line"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for backgrounds of elements in a disabled state."
        },
        "value": "#E3E4F21F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for backgrounds of elements in a disabled state."
            },
            "value": "DarkNeutral300A"
        },
        "name": "color.background.disabled",
        "path": [
            "color",
            "background",
            "disabled"
        ],
        "cleanName": "color.background.disabled"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for background of form UI elements, such as text fields, checkboxes, and radio buttons."
        },
        "value": "#242528",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for background of form UI elements, such as text fields, checkboxes, and radio buttons."
            },
            "value": "DarkNeutral200"
        },
        "name": "color.background.input.[default]",
        "path": [
            "color",
            "background",
            "input",
            "[default]"
        ],
        "cleanName": "color.background.input"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.input"
        },
        "value": "#2B2C2F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.input"
            },
            "value": "DarkNeutral250"
        },
        "name": "color.background.input.hovered",
        "path": [
            "color",
            "background",
            "input",
            "hovered"
        ],
        "cleanName": "color.background.input.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.input"
        },
        "value": "#242528",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.input"
            },
            "value": "DarkNeutral200"
        },
        "name": "color.background.input.pressed",
        "path": [
            "color",
            "background",
            "input",
            "pressed"
        ],
        "cleanName": "color.background.input.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.3",
            "description": "Use for backgrounds of elements on a bold background, such as in the buttons on spotlight cards."
        },
        "value": "#FFFFFF29",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.3",
                "description": "Use for backgrounds of elements on a bold background, such as in the buttons on spotlight cards."
            },
            "value": "#FFFFFF29"
        },
        "name": "color.background.inverse.subtle.[default]",
        "path": [
            "color",
            "background",
            "inverse",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.inverse.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.3",
            "description": "Use for the hovered state of color.background.inverse.subtle"
        },
        "value": "#FFFFFF3D",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.3",
                "description": "Use for the hovered state of color.background.inverse.subtle"
            },
            "value": "#FFFFFF3D"
        },
        "name": "color.background.inverse.subtle.hovered",
        "path": [
            "color",
            "background",
            "inverse",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.inverse.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.3",
            "description": "Use for the pressed state of color.background.inverse.subtle"
        },
        "value": "#FFFFFF52",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.3",
                "description": "Use for the pressed state of color.background.inverse.subtle"
            },
            "value": "#FFFFFF52"
        },
        "name": "color.background.inverse.subtle.pressed",
        "path": [
            "color",
            "background",
            "inverse",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.inverse.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "The default background for neutral elements, such as default buttons."
        },
        "value": "#CECED912",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "The default background for neutral elements, such as default buttons."
            },
            "value": "DarkNeutral200A"
        },
        "name": "color.background.neutral.[default].[default]",
        "path": [
            "color",
            "background",
            "neutral",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.neutral"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.neutral"
        },
        "value": "#E3E4F21F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.neutral"
            },
            "value": "DarkNeutral300A"
        },
        "name": "color.background.neutral.[default].hovered",
        "path": [
            "color",
            "background",
            "neutral",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.neutral.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.neutral"
        },
        "value": "#E5E9F640",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.neutral"
            },
            "value": "DarkNeutral400A"
        },
        "name": "color.background.neutral.[default].pressed",
        "path": [
            "color",
            "background",
            "neutral",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.neutral.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the background of elements that appear to have no background in a resting state, such as subtle buttons and menu items."
        },
        "value": "#00000000",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the background of elements that appear to have no background in a resting state, such as subtle buttons and menu items."
            },
            "value": "transparent"
        },
        "name": "color.background.neutral.subtle.[default]",
        "path": [
            "color",
            "background",
            "neutral",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.neutral.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.neutral.subtle"
        },
        "value": "#CECED912",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.neutral.subtle"
            },
            "value": "DarkNeutral200A"
        },
        "name": "color.background.neutral.subtle.hovered",
        "path": [
            "color",
            "background",
            "neutral",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.neutral.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.neutral.subtle"
        },
        "value": "#E3E4F21F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.neutral.subtle"
            },
            "value": "DarkNeutral300A"
        },
        "name": "color.background.neutral.subtle.pressed",
        "path": [
            "color",
            "background",
            "neutral",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.neutral.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for neutral UI elements, such as announcement banners."
        },
        "value": "#CECFD2",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for neutral UI elements, such as announcement banners."
            },
            "value": "DarkNeutral1000"
        },
        "name": "color.background.neutral.bold.[default]",
        "path": [
            "color",
            "background",
            "neutral",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.neutral.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.neutral.bold"
        },
        "value": "#BFC1C4",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.neutral.bold"
            },
            "value": "DarkNeutral900"
        },
        "name": "color.background.neutral.bold.hovered",
        "path": [
            "color",
            "background",
            "neutral",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.neutral.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.neutral.bold"
        },
        "value": "#A9ABAF",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.neutral.bold"
            },
            "value": "DarkNeutral800"
        },
        "name": "color.background.neutral.bold.pressed",
        "path": [
            "color",
            "background",
            "neutral",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.neutral.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of an element that communicates selection, such as a selected navigation item, or the opened state of a dropdown trigger. Use color.background.selected.hovered or color.background.selected.pressed when interacting with a selected element. Selection is distinct from keyboard focus and hover alone."
        },
        "value": "#1C2B42",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of an element that communicates selection, such as a selected navigation item, or the opened state of a dropdown trigger. Use color.background.selected.hovered or color.background.selected.pressed when interacting with a selected element. Selection is distinct from keyboard focus and hover alone."
            },
            "value": "Blue1000"
        },
        "name": "color.background.selected.[default].[default]",
        "path": [
            "color",
            "background",
            "selected",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of an element that is selected and hovered. This preserves selection while showing pointer hover; do not use for an unselected element or keyboard focus alone."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of an element that is selected and hovered. This preserves selection while showing pointer hover; do not use for an unselected element or keyboard focus alone."
            },
            "value": "Blue900"
        },
        "name": "color.background.selected.[default].hovered",
        "path": [
            "color",
            "background",
            "selected",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.selected.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of an element that is selected and being pressed. Return to color.background.selected or color.background.selected.hovered when the press ends and the element remains selected. Do not use for an unselected element or keyboard focus alone."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of an element that is selected and being pressed. Return to color.background.selected or color.background.selected.hovered when the press ends and the element remains selected. Do not use for an unselected element or keyboard focus alone."
            },
            "value": "Blue800"
        },
        "name": "color.background.selected.[default].pressed",
        "path": [
            "color",
            "background",
            "selected",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.selected.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the bold background of selected controls, such as checked checkboxes and selected radio buttons. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for primary actions or keyboard focus alone."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the bold background of selected controls, such as checked checkboxes and selected radio buttons. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for primary actions or keyboard focus alone."
            },
            "value": "Blue400"
        },
        "name": "color.background.selected.bold.[default]",
        "path": [
            "color",
            "background",
            "selected",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.selected.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of a selected control that uses color.background.selected.bold while it is hovered, such as a checked checkbox. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for an unselected control or keyboard focus alone."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of a selected control that uses color.background.selected.bold while it is hovered, such as a checked checkbox. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for an unselected control or keyboard focus alone."
            },
            "value": "Blue300"
        },
        "name": "color.background.selected.bold.hovered",
        "path": [
            "color",
            "background",
            "selected",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.selected.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of a selected control that uses color.background.selected.bold while it is being pressed, such as a checked checkbox. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for an unselected control or keyboard focus alone."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of a selected control that uses color.background.selected.bold while it is being pressed, such as a checked checkbox. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for an unselected control or keyboard focus alone."
            },
            "value": "Blue200"
        },
        "name": "color.background.selected.bold.pressed",
        "path": [
            "color",
            "background",
            "selected",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.selected.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Use for the background of elements used to reinforce our brand, but with less emphasis."
        },
        "value": "#1C2B42",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Use for the background of elements used to reinforce our brand, but with less emphasis."
            },
            "value": "Blue1000"
        },
        "name": "color.background.brand.subtlest.[default]",
        "path": [
            "color",
            "background",
            "brand",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.brand.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Hovered state of color.background.brand.subtlest."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Hovered state of color.background.brand.subtlest."
            },
            "value": "Blue900"
        },
        "name": "color.background.brand.subtlest.hovered",
        "path": [
            "color",
            "background",
            "brand",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.brand.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Pressed state of color.background.brand.subtlest"
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Pressed state of color.background.brand.subtlest"
            },
            "value": "Blue850"
        },
        "name": "color.background.brand.subtlest.pressed",
        "path": [
            "color",
            "background",
            "brand",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.brand.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the background of elements used to reinforce our brand, but with more emphasis."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the background of elements used to reinforce our brand, but with more emphasis."
            },
            "value": "Blue400"
        },
        "name": "color.background.brand.bold.[default]",
        "path": [
            "color",
            "background",
            "brand",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.brand.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.brand.bold."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.brand.bold."
            },
            "value": "Blue300"
        },
        "name": "color.background.brand.bold.hovered",
        "path": [
            "color",
            "background",
            "brand",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.brand.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.brand.bold."
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.brand.bold."
            },
            "value": "Blue250"
        },
        "name": "color.background.brand.bold.pressed",
        "path": [
            "color",
            "background",
            "brand",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.brand.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Use for the background of elements used to reinforce our brand, that need to stand out a lot."
        },
        "value": "#E9F2FE",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Use for the background of elements used to reinforce our brand, that need to stand out a lot."
            },
            "value": "Blue100"
        },
        "name": "color.background.brand.boldest.[default]",
        "path": [
            "color",
            "background",
            "brand",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.background.brand.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Hovered state of color.background.brand.boldest."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Hovered state of color.background.brand.boldest."
            },
            "value": "Blue200"
        },
        "name": "color.background.brand.boldest.hovered",
        "path": [
            "color",
            "background",
            "brand",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.background.brand.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Pressed state of color.background.brand.boldest."
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Pressed state of color.background.brand.boldest."
            },
            "value": "Blue250"
        },
        "name": "color.background.brand.boldest.pressed",
        "path": [
            "color",
            "background",
            "brand",
            "boldest",
            "pressed"
        ],
        "cleanName": "color.background.brand.boldest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating critical information, such in error section messages."
        },
        "value": "#42221F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating critical information, such in error section messages."
            },
            "value": "Red1000"
        },
        "name": "color.background.danger.[default].[default]",
        "path": [
            "color",
            "background",
            "danger",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.danger"
        },
        "value": "#5D1F1A",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.danger"
            },
            "value": "Red900"
        },
        "name": "color.background.danger.[default].hovered",
        "path": [
            "color",
            "background",
            "danger",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.danger.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.danger"
        },
        "value": "#872821",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.danger"
            },
            "value": "Red850"
        },
        "name": "color.background.danger.[default].pressed",
        "path": [
            "color",
            "background",
            "danger",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.danger.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of danger lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#5D1F1A",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of danger lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Red900"
        },
        "name": "color.background.danger.subtler.[default]",
        "path": [
            "color",
            "background",
            "danger",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.danger.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.danger.subtler"
        },
        "value": "#872821",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.danger.subtler"
            },
            "value": "Red850"
        },
        "name": "color.background.danger.subtler.hovered",
        "path": [
            "color",
            "background",
            "danger",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.danger.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.danger.subtler"
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.danger.subtler"
            },
            "value": "Red800"
        },
        "name": "color.background.danger.subtler.pressed",
        "path": [
            "color",
            "background",
            "danger",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.danger.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating critical danger information (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.danger.bold or color.background.danger.subtler for interactive states."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating critical danger information (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.danger.bold or color.background.danger.subtler for interactive states."
            },
            "value": "Red800"
        },
        "name": "color.background.danger.subtle.[default]",
        "path": [
            "color",
            "background",
            "danger",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.danger.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for communicating critical information, such as in danger buttons and error banners."
        },
        "value": "#F87168",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for communicating critical information, such as in danger buttons and error banners."
            },
            "value": "Red400"
        },
        "name": "color.background.danger.bold.[default]",
        "path": [
            "color",
            "background",
            "danger",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.danger.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.danger.bold"
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.danger.bold"
            },
            "value": "Red300"
        },
        "name": "color.background.danger.bold.hovered",
        "path": [
            "color",
            "background",
            "danger",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.danger.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.danger.bold"
        },
        "value": "#FFB8B2",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.danger.bold"
            },
            "value": "Red250"
        },
        "name": "color.background.danger.bold.pressed",
        "path": [
            "color",
            "background",
            "danger",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.danger.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating caution, such as in warning section messages."
        },
        "value": "#3A2C1F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating caution, such as in warning section messages."
            },
            "value": "Orange1000"
        },
        "name": "color.background.warning.[default].[default]",
        "path": [
            "color",
            "background",
            "warning",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.warning"
        },
        "value": "#693200",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.warning"
            },
            "value": "Orange900"
        },
        "name": "color.background.warning.[default].hovered",
        "path": [
            "color",
            "background",
            "warning",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.warning.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.warning"
        },
        "value": "#7A3B00",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.warning"
            },
            "value": "Orange850"
        },
        "name": "color.background.warning.[default].pressed",
        "path": [
            "color",
            "background",
            "warning",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.warning.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of warning lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#693200",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of warning lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Orange900"
        },
        "name": "color.background.warning.subtler.[default]",
        "path": [
            "color",
            "background",
            "warning",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.warning.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.warning.subtler"
        },
        "value": "#7A3B00",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.warning.subtler"
            },
            "value": "Orange850"
        },
        "name": "color.background.warning.subtler.hovered",
        "path": [
            "color",
            "background",
            "warning",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.warning.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.warning.subtler"
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.warning.subtler"
            },
            "value": "Orange800"
        },
        "name": "color.background.warning.subtler.pressed",
        "path": [
            "color",
            "background",
            "warning",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.warning.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating caution (e.g. status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.warning.bold or color.background.warning.subtler for interactive states."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating caution (e.g. status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.warning.bold or color.background.warning.subtler for interactive states."
            },
            "value": "Orange800"
        },
        "name": "color.background.warning.subtle.[default]",
        "path": [
            "color",
            "background",
            "warning",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.warning.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for communicating caution, such as in warning buttons and warning banners."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for communicating caution, such as in warning buttons and warning banners."
            },
            "value": "Orange300"
        },
        "name": "color.background.warning.bold.[default]",
        "path": [
            "color",
            "background",
            "warning",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.warning.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.warning.bold"
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.warning.bold"
            },
            "value": "Orange400"
        },
        "name": "color.background.warning.bold.hovered",
        "path": [
            "color",
            "background",
            "warning",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.warning.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.warning.bold"
        },
        "value": "#F68909",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.warning.bold"
            },
            "value": "Orange500"
        },
        "name": "color.background.warning.bold.pressed",
        "path": [
            "color",
            "background",
            "warning",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.warning.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating a favorable outcome, such as in success section messages."
        },
        "value": "#28311B",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating a favorable outcome, such as in success section messages."
            },
            "value": "Lime1000"
        },
        "name": "color.background.success.[default].[default]",
        "path": [
            "color",
            "background",
            "success",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.success"
        },
        "value": "#37471F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.success"
            },
            "value": "Lime900"
        },
        "name": "color.background.success.[default].hovered",
        "path": [
            "color",
            "background",
            "success",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.success.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.success"
        },
        "value": "#3F5224",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.success"
            },
            "value": "Lime850"
        },
        "name": "color.background.success.[default].pressed",
        "path": [
            "color",
            "background",
            "success",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.success.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of success lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#37471F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of success lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Lime900"
        },
        "name": "color.background.success.subtler.[default]",
        "path": [
            "color",
            "background",
            "success",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.success.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.success.subtler"
        },
        "value": "#3F5224",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.success.subtler"
            },
            "value": "Lime850"
        },
        "name": "color.background.success.subtler.hovered",
        "path": [
            "color",
            "background",
            "success",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.success.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.success.subtler"
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.success.subtler"
            },
            "value": "Lime800"
        },
        "name": "color.background.success.subtler.pressed",
        "path": [
            "color",
            "background",
            "success",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.success.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating success (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.success.bold or color.background.success.subtler for interactive states."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating success (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.success.bold or color.background.success.subtler for interactive states."
            },
            "value": "Lime800"
        },
        "name": "color.background.success.subtle.[default]",
        "path": [
            "color",
            "background",
            "success",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.success.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for communicating a favorable outcome, such as in checked toggles."
        },
        "value": "#94C748",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for communicating a favorable outcome, such as in checked toggles."
            },
            "value": "Lime400"
        },
        "name": "color.background.success.bold.[default]",
        "path": [
            "color",
            "background",
            "success",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.success.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.success.bold"
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.success.bold"
            },
            "value": "Lime300"
        },
        "name": "color.background.success.bold.hovered",
        "path": [
            "color",
            "background",
            "success",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.success.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.success.bold"
        },
        "value": "#BDE97C",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.success.bold"
            },
            "value": "Lime250"
        },
        "name": "color.background.success.bold.pressed",
        "path": [
            "color",
            "background",
            "success",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.success.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating change or something new, such as in discovery section messages."
        },
        "value": "#35243F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating change or something new, such as in discovery section messages."
            },
            "value": "Purple1000"
        },
        "name": "color.background.discovery.[default].[default]",
        "path": [
            "color",
            "background",
            "discovery",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hover state for color.background.discovery"
        },
        "value": "#48245D",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hover state for color.background.discovery"
            },
            "value": "Purple900"
        },
        "name": "color.background.discovery.[default].hovered",
        "path": [
            "color",
            "background",
            "discovery",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.discovery.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.discovery"
        },
        "value": "#673286",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.discovery"
            },
            "value": "Purple850"
        },
        "name": "color.background.discovery.[default].pressed",
        "path": [
            "color",
            "background",
            "discovery",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.discovery.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of discovery lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#48245D",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of discovery lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Purple900"
        },
        "name": "color.background.discovery.subtler.[default]",
        "path": [
            "color",
            "background",
            "discovery",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.discovery.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.discovery.subtler"
        },
        "value": "#673286",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.discovery.subtler"
            },
            "value": "Purple850"
        },
        "name": "color.background.discovery.subtler.hovered",
        "path": [
            "color",
            "background",
            "discovery",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.discovery.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.discovery.subtler"
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.discovery.subtler"
            },
            "value": "Purple800"
        },
        "name": "color.background.discovery.subtler.pressed",
        "path": [
            "color",
            "background",
            "discovery",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.discovery.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating discovery (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.discovery.bold or color.background.discovery.subtler for interactive states."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating discovery (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.discovery.bold or color.background.discovery.subtler for interactive states."
            },
            "value": "Purple800"
        },
        "name": "color.background.discovery.subtle.[default]",
        "path": [
            "color",
            "background",
            "discovery",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.discovery.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option communicating change or something new, such as in onboarding spotlights."
        },
        "value": "#C97CF4",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option communicating change or something new, such as in onboarding spotlights."
            },
            "value": "Purple400"
        },
        "name": "color.background.discovery.bold.[default]",
        "path": [
            "color",
            "background",
            "discovery",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.discovery.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.discovery.bold"
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.discovery.bold"
            },
            "value": "Purple300"
        },
        "name": "color.background.discovery.bold.hovered",
        "path": [
            "color",
            "background",
            "discovery",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.discovery.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.discovery.bold"
        },
        "value": "#E3BDFA",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.discovery.bold"
            },
            "value": "Purple250"
        },
        "name": "color.background.discovery.bold.pressed",
        "path": [
            "color",
            "background",
            "discovery",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.discovery.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating information or something in-progress, such as in information section messages."
        },
        "value": "#1C2B42",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating information or something in-progress, such as in information section messages."
            },
            "value": "Blue1000"
        },
        "name": "color.background.information.[default].[default]",
        "path": [
            "color",
            "background",
            "information",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.information"
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.information"
            },
            "value": "Blue900"
        },
        "name": "color.background.information.[default].hovered",
        "path": [
            "color",
            "background",
            "information",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.information.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.information"
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.information"
            },
            "value": "Blue850"
        },
        "name": "color.background.information.[default].pressed",
        "path": [
            "color",
            "background",
            "information",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.information.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of information lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of information lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Blue900"
        },
        "name": "color.background.information.subtler.[default]",
        "path": [
            "color",
            "background",
            "information",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.information.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.information.subtler"
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.information.subtler"
            },
            "value": "Blue850"
        },
        "name": "color.background.information.subtler.hovered",
        "path": [
            "color",
            "background",
            "information",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.information.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.information.subtler"
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.information.subtler"
            },
            "value": "Blue800"
        },
        "name": "color.background.information.subtler.pressed",
        "path": [
            "color",
            "background",
            "information",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.information.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating information (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.information.bold or color.background.information.subtler for interactive states."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating information (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.information.bold or color.background.information.subtler for interactive states."
            },
            "value": "Blue800"
        },
        "name": "color.background.information.subtle.[default]",
        "path": [
            "color",
            "background",
            "information",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.information.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for communicating information or something in-progress."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for communicating information or something in-progress."
            },
            "value": "Blue400"
        },
        "name": "color.background.information.bold.[default]",
        "path": [
            "color",
            "background",
            "information",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.information.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.information.bold"
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.information.bold"
            },
            "value": "Blue300"
        },
        "name": "color.background.information.bold.hovered",
        "path": [
            "color",
            "background",
            "information",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.information.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.information.bold"
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.information.bold"
            },
            "value": "Blue250"
        },
        "name": "color.background.information.bold.pressed",
        "path": [
            "color",
            "background",
            "information",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.information.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use to visually group or separate UI elements, such as flat cards or side panel dividers."
        },
        "value": "#E3E4F21F",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use to visually group or separate UI elements, such as flat cards or side panel dividers."
            },
            "value": "DarkNeutral300A"
        },
        "name": "color.border.[default]",
        "path": [
            "color",
            "border",
            "[default]"
        ],
        "cleanName": "color.border"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for lime borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for lime borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Lime500"
        },
        "name": "color.border.accent.lime.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "lime",
            "[default]"
        ],
        "cleanName": "color.border.accent.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative lime borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative lime borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Lime800"
        },
        "name": "color.border.accent.lime.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "lime",
            "subtle"
        ],
        "cleanName": "color.border.accent.lime.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for red borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#F15B50",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for red borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Red500"
        },
        "name": "color.border.accent.red.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "red",
            "[default]"
        ],
        "cleanName": "color.border.accent.red"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative red borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative red borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Red800"
        },
        "name": "color.border.accent.red.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "red",
            "subtle"
        ],
        "cleanName": "color.border.accent.red.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for orange borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#F68909",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for orange borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Orange500"
        },
        "name": "color.border.accent.orange.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "orange",
            "[default]"
        ],
        "cleanName": "color.border.accent.orange"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative orange borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative orange borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Orange800"
        },
        "name": "color.border.accent.orange.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "orange",
            "subtle"
        ],
        "cleanName": "color.border.accent.orange.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for yellow borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#CF9F02",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for yellow borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Yellow500"
        },
        "name": "color.border.accent.yellow.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "yellow",
            "[default]"
        ],
        "cleanName": "color.border.accent.yellow"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative yellow borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#7F5F01",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative yellow borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Yellow800"
        },
        "name": "color.border.accent.yellow.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "yellow",
            "subtle"
        ],
        "cleanName": "color.border.accent.yellow.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for green borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#2ABB7F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for green borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Green500"
        },
        "name": "color.border.accent.green.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "green",
            "[default]"
        ],
        "cleanName": "color.border.accent.green"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative green borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#216E4E",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative green borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Green800"
        },
        "name": "color.border.accent.green.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "green",
            "subtle"
        ],
        "cleanName": "color.border.accent.green.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for teal borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#42B2D7",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for teal borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Teal500"
        },
        "name": "color.border.accent.teal.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "teal",
            "[default]"
        ],
        "cleanName": "color.border.accent.teal"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative teal borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#206A83",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative teal borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Teal800"
        },
        "name": "color.border.accent.teal.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "teal",
            "subtle"
        ],
        "cleanName": "color.border.accent.teal.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for blue borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for blue borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Blue500"
        },
        "name": "color.border.accent.blue.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "blue",
            "[default]"
        ],
        "cleanName": "color.border.accent.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative blue borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative blue borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Blue800"
        },
        "name": "color.border.accent.blue.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "blue",
            "subtle"
        ],
        "cleanName": "color.border.accent.blue.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for purple borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for purple borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Purple500"
        },
        "name": "color.border.accent.purple.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "purple",
            "[default]"
        ],
        "cleanName": "color.border.accent.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative purple borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative purple borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Purple800"
        },
        "name": "color.border.accent.purple.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "purple",
            "subtle"
        ],
        "cleanName": "color.border.accent.purple.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for magenta borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#DA62AC",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for magenta borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Magenta500"
        },
        "name": "color.border.accent.magenta.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "magenta",
            "[default]"
        ],
        "cleanName": "color.border.accent.magenta"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative magenta borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#943D73",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative magenta borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Magenta800"
        },
        "name": "color.border.accent.magenta.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "magenta",
            "subtle"
        ],
        "cleanName": "color.border.accent.magenta.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.5",
            "description": "Use for borders on non-bold gray accent backgrounds."
        },
        "value": "#7E8188",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.5",
                "description": "Use for borders on non-bold gray accent backgrounds."
            },
            "value": "DarkNeutral600"
        },
        "name": "color.border.accent.gray.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "gray",
            "[default]"
        ],
        "cleanName": "color.border.accent.gray"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative gray borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#4B4D51",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative gray borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "DarkNeutral400"
        },
        "name": "color.border.accent.gray.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "gray",
            "subtle"
        ],
        "cleanName": "color.border.accent.gray.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for code block and code diff borders."
        },
        "value": "#E3E4F21F",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for code block and code diff borders."
            },
            "value": "DarkNeutral300A"
        },
        "name": "color.border.code",
        "path": [
            "color",
            "border",
            "code"
        ],
        "cleanName": "color.border.code"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders of elements in a disabled state."
        },
        "value": "#CECED912",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders of elements in a disabled state."
            },
            "value": "DarkNeutral200A"
        },
        "name": "color.border.disabled",
        "path": [
            "color",
            "border",
            "disabled"
        ],
        "cleanName": "color.border.disabled"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the focus ring or border of an element that currently has keyboard or input focus. Do not use to indicate selection or hover alone. When an element is both selected and focused, keep its selected treatment and add a separate focus indicator."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the focus ring or border of an element that currently has keyboard or input focus. Do not use to indicate selection or hover alone. When an element is both selected and focused, keep its selected treatment and add a separate focus indicator."
            },
            "value": "Blue300"
        },
        "name": "color.border.focused",
        "path": [
            "color",
            "border",
            "focused"
        ],
        "cleanName": "color.border.focused"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders of form UI elements, such as text fields, checkboxes, and radio buttons."
        },
        "value": "#7E8188",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders of form UI elements, such as text fields, checkboxes, and radio buttons."
            },
            "value": "DarkNeutral600"
        },
        "name": "color.border.input.[default]",
        "path": [
            "color",
            "border",
            "input",
            "[default]"
        ],
        "cleanName": "color.border.input"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.12.0",
            "description": "Use for the border of search inputs."
        },
        "value": "#E3E4F21F",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.12.0",
                "description": "Use for the border of search inputs."
            },
            "value": "DarkNeutral300A"
        },
        "name": "color.border.input.search",
        "path": [
            "color",
            "border",
            "input",
            "search"
        ],
        "cleanName": "color.border.input.search"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders on bold backgrounds."
        },
        "value": "#18191A",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders on bold backgrounds."
            },
            "value": "DarkNeutral0"
        },
        "name": "color.border.inverse",
        "path": [
            "color",
            "border",
            "inverse"
        ],
        "cleanName": "color.border.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for borders or visual indicators that communicate selection, such as the active tab or a selected menu item, or the opened state of a dropdown trigger. Do not use as a keyboard focus indicator; use color.border.focused for focus and preserve the selected treatment when both states apply."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for borders or visual indicators that communicate selection, such as the active tab or a selected menu item, or the opened state of a dropdown trigger. Do not use as a keyboard focus indicator; use color.border.focused for focus and preserve the selected treatment when both states apply."
            },
            "value": "Blue400"
        },
        "name": "color.border.selected",
        "path": [
            "color",
            "border",
            "selected"
        ],
        "cleanName": "color.border.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders or visual indicators of elements that reinforce our brand, such as logos or primary buttons."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders or visual indicators of elements that reinforce our brand, such as logos or primary buttons."
            },
            "value": "Blue400"
        },
        "name": "color.border.brand",
        "path": [
            "color",
            "border",
            "brand"
        ],
        "cleanName": "color.border.brand"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating critical information, such as the borders on invalid text fields."
        },
        "value": "#F15B50",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating critical information, such as the borders on invalid text fields."
            },
            "value": "Red500"
        },
        "name": "color.border.danger.[default]",
        "path": [
            "color",
            "border",
            "danger",
            "[default]"
        ],
        "cleanName": "color.border.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative danger borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative danger borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Red800"
        },
        "name": "color.border.danger.subtle",
        "path": [
            "color",
            "border",
            "danger",
            "subtle"
        ],
        "cleanName": "color.border.danger.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating caution."
        },
        "value": "#F68909",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating caution."
            },
            "value": "Orange500"
        },
        "name": "color.border.warning.[default]",
        "path": [
            "color",
            "border",
            "warning",
            "[default]"
        ],
        "cleanName": "color.border.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative warning borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative warning borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Orange800"
        },
        "name": "color.border.warning.subtle",
        "path": [
            "color",
            "border",
            "warning",
            "subtle"
        ],
        "cleanName": "color.border.warning.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating a favorable outcome, such as the borders on validated text fields."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating a favorable outcome, such as the borders on validated text fields."
            },
            "value": "Lime500"
        },
        "name": "color.border.success.[default]",
        "path": [
            "color",
            "border",
            "success",
            "[default]"
        ],
        "cleanName": "color.border.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative success borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative success borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Lime800"
        },
        "name": "color.border.success.subtle",
        "path": [
            "color",
            "border",
            "success",
            "subtle"
        ],
        "cleanName": "color.border.success.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating change or something new, such as the borders in onboarding spotlights."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating change or something new, such as the borders in onboarding spotlights."
            },
            "value": "Purple500"
        },
        "name": "color.border.discovery.[default]",
        "path": [
            "color",
            "border",
            "discovery",
            "[default]"
        ],
        "cleanName": "color.border.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative discovery borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative discovery borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Purple800"
        },
        "name": "color.border.discovery.subtle",
        "path": [
            "color",
            "border",
            "discovery",
            "subtle"
        ],
        "cleanName": "color.border.discovery.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating information or something in-progress."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating information or something in-progress."
            },
            "value": "Blue500"
        },
        "name": "color.border.information.[default]",
        "path": [
            "color",
            "border",
            "information",
            "[default]"
        ],
        "cleanName": "color.border.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative information borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative information borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Blue800"
        },
        "name": "color.border.information.subtle",
        "path": [
            "color",
            "border",
            "information",
            "subtle"
        ],
        "cleanName": "color.border.information.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.8",
            "description": "A neutral border option that passes min 3:1 contrast ratios."
        },
        "value": "#7E8188",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.8",
                "description": "A neutral border option that passes min 3:1 contrast ratios."
            },
            "value": "DarkNeutral600"
        },
        "name": "color.border.bold",
        "path": [
            "color",
            "border",
            "bold"
        ],
        "cleanName": "color.border.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for primary text, such as body copy, sentence case headers, and buttons."
        },
        "value": "#CECFD2",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for primary text, such as body copy, sentence case headers, and buttons."
            },
            "value": "DarkNeutral1000"
        },
        "name": "color.text.[default]",
        "path": [
            "color",
            "text",
            "[default]"
        ],
        "cleanName": "color.text"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Use for lime text on subtlest and subtler lime accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Use for lime text on subtlest and subtler lime accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Lime300"
        },
        "name": "color.text.accent.lime.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "lime",
            "[default]"
        ],
        "cleanName": "color.text.accent.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Use for lime text on subtle lime accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#D3F1A7",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Use for lime text on subtle lime accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Lime200"
        },
        "name": "color.text.accent.lime.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "lime",
            "bolder"
        ],
        "cleanName": "color.text.accent.lime.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for red text on subtlest and subtler red accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for red text on subtlest and subtler red accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Red300"
        },
        "name": "color.text.accent.red.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "red",
            "[default]"
        ],
        "cleanName": "color.text.accent.red"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for red text on subtle red accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#FFD5D2",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for red text on subtle red accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Red200"
        },
        "name": "color.text.accent.red.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "red",
            "bolder"
        ],
        "cleanName": "color.text.accent.red.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for orange text on subtlest and subtler orange accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for orange text on subtlest and subtler orange accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Orange300"
        },
        "name": "color.text.accent.orange.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "orange",
            "[default]"
        ],
        "cleanName": "color.text.accent.orange"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for orange text on subtle orange accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#FCE4A6",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for orange text on subtle orange accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Orange200"
        },
        "name": "color.text.accent.orange.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "orange",
            "bolder"
        ],
        "cleanName": "color.text.accent.orange.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for yellow text on subtlest and subtler yellow accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#EED12B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for yellow text on subtlest and subtler yellow accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Yellow300"
        },
        "name": "color.text.accent.yellow.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "yellow",
            "[default]"
        ],
        "cleanName": "color.text.accent.yellow"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for yellow text on subtle yellow accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#F5E989",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for yellow text on subtle yellow accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Yellow200"
        },
        "name": "color.text.accent.yellow.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "yellow",
            "bolder"
        ],
        "cleanName": "color.text.accent.yellow.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for green text on subtlest and subtler green accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#7EE2B8",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for green text on subtlest and subtler green accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Green300"
        },
        "name": "color.text.accent.green.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "green",
            "[default]"
        ],
        "cleanName": "color.text.accent.green"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for green text on subtle green accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#BAF3DB",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for green text on subtle green accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Green200"
        },
        "name": "color.text.accent.green.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "green",
            "bolder"
        ],
        "cleanName": "color.text.accent.green.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for teal text on subtlest and subtler teal accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#9DD9EE",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for teal text on subtlest and subtler teal accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Teal300"
        },
        "name": "color.text.accent.teal.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "teal",
            "[default]"
        ],
        "cleanName": "color.text.accent.teal"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for teal text on subtle teal accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#C6EDFB",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for teal text on subtle teal accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Teal200"
        },
        "name": "color.text.accent.teal.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "teal",
            "bolder"
        ],
        "cleanName": "color.text.accent.teal.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for blue text on subtlest and subtler blue accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for blue text on subtlest and subtler blue accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Blue300"
        },
        "name": "color.text.accent.blue.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "blue",
            "[default]"
        ],
        "cleanName": "color.text.accent.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for blue text on subtle blue accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for blue text on subtle blue accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Blue200"
        },
        "name": "color.text.accent.blue.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "blue",
            "bolder"
        ],
        "cleanName": "color.text.accent.blue.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for purple text on subtlest and subtler purple accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for purple text on subtlest and subtler purple accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Purple300"
        },
        "name": "color.text.accent.purple.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "purple",
            "[default]"
        ],
        "cleanName": "color.text.accent.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for purple text on subtle purple accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#EED7FC",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for purple text on subtle purple accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Purple200"
        },
        "name": "color.text.accent.purple.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "purple",
            "bolder"
        ],
        "cleanName": "color.text.accent.purple.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for magenta text on subtlest and subtler magenta accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#F797D2",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for magenta text on subtlest and subtler magenta accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Magenta300"
        },
        "name": "color.text.accent.magenta.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "magenta",
            "[default]"
        ],
        "cleanName": "color.text.accent.magenta"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for magenta text on subtle magenta accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#FDD0EC",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for magenta text on subtle magenta accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Magenta200"
        },
        "name": "color.text.accent.magenta.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "magenta",
            "bolder"
        ],
        "cleanName": "color.text.accent.magenta.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.5",
            "description": "Use for text on non-bold gray accent backgrounds, such as colored tags."
        },
        "value": "#A9ABAF",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.5",
                "description": "Use for text on non-bold gray accent backgrounds, such as colored tags."
            },
            "value": "DarkNeutral800"
        },
        "name": "color.text.accent.gray.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "gray",
            "[default]"
        ],
        "cleanName": "color.text.accent.gray"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.5",
            "description": "Use for text and icons on gray subtle accent backgrounds."
        },
        "value": "#E2E3E4",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.5",
                "description": "Use for text and icons on gray subtle accent backgrounds."
            },
            "value": "DarkNeutral1100"
        },
        "name": "color.text.accent.gray.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "gray",
            "bolder"
        ],
        "cleanName": "color.text.accent.gray.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for an additional syntax-highlighting text color."
        },
        "value": "#F797D2",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for an additional syntax-highlighting text color."
            },
            "value": "Magenta300"
        },
        "name": "color.text.code.accent.1",
        "path": [
            "color",
            "text",
            "code",
            "accent",
            "1"
        ],
        "cleanName": "color.text.code.accent.1"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for an additional syntax-highlighting text color."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for an additional syntax-highlighting text color."
            },
            "value": "Blue300"
        },
        "name": "color.text.code.accent.2",
        "path": [
            "color",
            "text",
            "code",
            "accent",
            "2"
        ],
        "cleanName": "color.text.code.accent.2"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for comments in syntax-highlighted code."
        },
        "value": "#A9ABAF",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for comments in syntax-highlighted code."
            },
            "value": "DarkNeutral800"
        },
        "name": "color.text.code.comments",
        "path": [
            "color",
            "text",
            "code",
            "comments"
        ],
        "cleanName": "color.text.code.comments"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for default text in code blocks and code diffs."
        },
        "value": "#A9ABAF",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for default text in code blocks and code diffs."
            },
            "value": "DarkNeutral800"
        },
        "name": "color.text.code.default",
        "path": [
            "color",
            "text",
            "code",
            "default"
        ],
        "cleanName": "color.text.code.default"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for functions in syntax-highlighted code."
        },
        "value": "#7EE2B8",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for functions in syntax-highlighted code."
            },
            "value": "Green300"
        },
        "name": "color.text.code.functions",
        "path": [
            "color",
            "text",
            "code",
            "functions"
        ],
        "cleanName": "color.text.code.functions"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for line numbers and other code gutter text."
        },
        "value": "#96999E",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for line numbers and other code gutter text."
            },
            "value": "DarkNeutral700"
        },
        "name": "color.text.code.gutter",
        "path": [
            "color",
            "text",
            "code",
            "gutter"
        ],
        "cleanName": "color.text.code.gutter"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for language keywords in syntax-highlighted code."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for language keywords in syntax-highlighted code."
            },
            "value": "Red300"
        },
        "name": "color.text.code.keywords",
        "path": [
            "color",
            "text",
            "code",
            "keywords"
        ],
        "cleanName": "color.text.code.keywords"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for numeric values in syntax-highlighted code."
        },
        "value": "#EED12B",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for numeric values in syntax-highlighted code."
            },
            "value": "Yellow300"
        },
        "name": "color.text.code.numbers",
        "path": [
            "color",
            "text",
            "code",
            "numbers"
        ],
        "cleanName": "color.text.code.numbers"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for operators and punctuation in syntax-highlighted code."
        },
        "value": "#CECFD2",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for operators and punctuation in syntax-highlighted code."
            },
            "value": "DarkNeutral1000"
        },
        "name": "color.text.code.operators",
        "path": [
            "color",
            "text",
            "code",
            "operators"
        ],
        "cleanName": "color.text.code.operators"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for string values in syntax-highlighted code."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for string values in syntax-highlighted code."
            },
            "value": "Lime300"
        },
        "name": "color.text.code.strings",
        "path": [
            "color",
            "text",
            "code",
            "strings"
        ],
        "cleanName": "color.text.code.strings"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for tags in syntax-highlighted code."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for tags in syntax-highlighted code."
            },
            "value": "Orange400"
        },
        "name": "color.text.code.tags",
        "path": [
            "color",
            "text",
            "code",
            "tags"
        ],
        "cleanName": "color.text.code.tags"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for text in a disabled state."
        },
        "value": "#E5E9F640",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for text in a disabled state."
            },
            "value": "DarkNeutral400A"
        },
        "name": "color.text.disabled",
        "path": [
            "color",
            "text",
            "disabled"
        ],
        "cleanName": "color.text.disabled"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for text on bold backgrounds."
        },
        "value": "#1F1F21",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for text on bold backgrounds."
            },
            "value": "DarkNeutral100"
        },
        "name": "color.text.inverse",
        "path": [
            "color",
            "text",
            "inverse"
        ],
        "cleanName": "color.text.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for text that communicates selection, such as the active tab or a selected navigation item, or the opened state of a dropdown trigger. On bold selected backgrounds, use color.text.inverse instead. Do not use for unselected links, brand emphasis, or hover alone. Keep the selected text treatment when the element also has focus."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for text that communicates selection, such as the active tab or a selected navigation item, or the opened state of a dropdown trigger. On bold selected backgrounds, use color.text.inverse instead. Do not use for unselected links, brand emphasis, or hover alone. Keep the selected text treatment when the element also has focus."
            },
            "value": "Blue400"
        },
        "name": "color.text.selected",
        "path": [
            "color",
            "text",
            "selected"
        ],
        "cleanName": "color.text.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for text that reinforces our brand."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for text that reinforces our brand."
            },
            "value": "Blue400"
        },
        "name": "color.text.brand",
        "path": [
            "color",
            "text",
            "brand"
        ],
        "cleanName": "color.text.brand"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for critical text, such as input field error messaging."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for critical text, such as input field error messaging."
            },
            "value": "Red300"
        },
        "name": "color.text.danger.[default]",
        "path": [
            "color",
            "text",
            "danger",
            "[default]"
        ],
        "cleanName": "color.text.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of danger semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#FFD5D2",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of danger semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Red200"
        },
        "name": "color.text.danger.bolder",
        "path": [
            "color",
            "text",
            "danger",
            "bolder"
        ],
        "cleanName": "color.text.danger.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for text to emphasize caution, such as in moved lozenges."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for text to emphasize caution, such as in moved lozenges."
            },
            "value": "Orange300"
        },
        "name": "color.text.warning.[default]",
        "path": [
            "color",
            "text",
            "warning",
            "[default]"
        ],
        "cleanName": "color.text.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for text when on bold warning backgrounds."
        },
        "value": "#1F1F21",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for text when on bold warning backgrounds."
            },
            "value": "DarkNeutral100"
        },
        "name": "color.text.warning.inverse",
        "path": [
            "color",
            "text",
            "warning",
            "inverse"
        ],
        "cleanName": "color.text.warning.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of warning semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#FCE4A6",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of warning semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Orange200"
        },
        "name": "color.text.warning.bolder",
        "path": [
            "color",
            "text",
            "warning",
            "bolder"
        ],
        "cleanName": "color.text.warning.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for text to communicate a favorable outcome, such as input field success messaging."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for text to communicate a favorable outcome, such as input field success messaging."
            },
            "value": "Lime300"
        },
        "name": "color.text.success.[default]",
        "path": [
            "color",
            "text",
            "success",
            "[default]"
        ],
        "cleanName": "color.text.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of success semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#D3F1A7",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of success semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Lime200"
        },
        "name": "color.text.success.bolder",
        "path": [
            "color",
            "text",
            "success",
            "bolder"
        ],
        "cleanName": "color.text.success.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for text to emphasize change or something new, such as in new lozenges."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for text to emphasize change or something new, such as in new lozenges."
            },
            "value": "Purple300"
        },
        "name": "color.text.discovery.[default]",
        "path": [
            "color",
            "text",
            "discovery",
            "[default]"
        ],
        "cleanName": "color.text.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of discovery semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#EED7FC",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of discovery semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Purple200"
        },
        "name": "color.text.discovery.bolder",
        "path": [
            "color",
            "text",
            "discovery",
            "bolder"
        ],
        "cleanName": "color.text.discovery.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for informative text or to communicate something is in progress, such as in-progress lozenges."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for informative text or to communicate something is in progress, such as in-progress lozenges."
            },
            "value": "Blue300"
        },
        "name": "color.text.information.[default]",
        "path": [
            "color",
            "text",
            "information",
            "[default]"
        ],
        "cleanName": "color.text.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of information semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of information semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Blue200"
        },
        "name": "color.text.information.bolder",
        "path": [
            "color",
            "text",
            "information",
            "bolder"
        ],
        "cleanName": "color.text.information.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for tertiary text, such as meta-data, breadcrumbs, input field placeholder and helper text."
        },
        "value": "#96999E",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for tertiary text, such as meta-data, breadcrumbs, input field placeholder and helper text."
            },
            "value": "DarkNeutral700"
        },
        "name": "color.text.subtlest",
        "path": [
            "color",
            "text",
            "subtlest"
        ],
        "cleanName": "color.text.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for secondary text, such as navigation, subtle button links, input field labels, and all caps subheadings."
        },
        "value": "#A9ABAF",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for secondary text, such as navigation, subtle button links, input field labels, and all caps subheadings."
            },
            "value": "DarkNeutral800"
        },
        "name": "color.text.subtle",
        "path": [
            "color",
            "text",
            "subtle"
        ],
        "cleanName": "color.text.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icon-only buttons, or icons paired with color.text"
        },
        "value": "#CECFD2",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icon-only buttons, or icons paired with color.text"
            },
            "value": "DarkNeutral1000"
        },
        "name": "color.icon.[default]",
        "path": [
            "color",
            "icon",
            "[default]"
        ],
        "cleanName": "color.icon"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for lime icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for lime icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Lime500"
        },
        "name": "color.icon.accent.lime",
        "path": [
            "color",
            "icon",
            "accent",
            "lime"
        ],
        "cleanName": "color.icon.accent.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for red icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#E2483D",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for red icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Red600"
        },
        "name": "color.icon.accent.red",
        "path": [
            "color",
            "icon",
            "accent",
            "red"
        ],
        "cleanName": "color.icon.accent.red"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for orange icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#F68909",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for orange icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Orange500"
        },
        "name": "color.icon.accent.orange",
        "path": [
            "color",
            "icon",
            "accent",
            "orange"
        ],
        "cleanName": "color.icon.accent.orange"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for yellow icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#EED12B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for yellow icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Yellow300"
        },
        "name": "color.icon.accent.yellow",
        "path": [
            "color",
            "icon",
            "accent",
            "yellow"
        ],
        "cleanName": "color.icon.accent.yellow"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for green icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#2ABB7F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for green icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Green500"
        },
        "name": "color.icon.accent.green",
        "path": [
            "color",
            "icon",
            "accent",
            "green"
        ],
        "cleanName": "color.icon.accent.green"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for teal icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#42B2D7",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for teal icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Teal500"
        },
        "name": "color.icon.accent.teal",
        "path": [
            "color",
            "icon",
            "accent",
            "teal"
        ],
        "cleanName": "color.icon.accent.teal"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for blue icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for blue icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Blue500"
        },
        "name": "color.icon.accent.blue",
        "path": [
            "color",
            "icon",
            "accent",
            "blue"
        ],
        "cleanName": "color.icon.accent.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for purple icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for purple icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Purple500"
        },
        "name": "color.icon.accent.purple",
        "path": [
            "color",
            "icon",
            "accent",
            "purple"
        ],
        "cleanName": "color.icon.accent.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for magenta icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#DA62AC",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for magenta icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Magenta500"
        },
        "name": "color.icon.accent.magenta",
        "path": [
            "color",
            "icon",
            "accent",
            "magenta"
        ],
        "cleanName": "color.icon.accent.magenta"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.5",
            "description": "Use for icons on non-bold gray accent backgrounds, such as file type icons."
        },
        "value": "#7E8188",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.5",
                "description": "Use for icons on non-bold gray accent backgrounds, such as file type icons."
            },
            "value": "DarkNeutral600"
        },
        "name": "color.icon.accent.gray",
        "path": [
            "color",
            "icon",
            "accent",
            "gray"
        ],
        "cleanName": "color.icon.accent.gray"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons in a disabled state."
        },
        "value": "#E5E9F640",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons in a disabled state."
            },
            "value": "DarkNeutral400A"
        },
        "name": "color.icon.disabled",
        "path": [
            "color",
            "icon",
            "disabled"
        ],
        "cleanName": "color.icon.disabled"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons on bold backgrounds."
        },
        "value": "#1F1F21",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons on bold backgrounds."
            },
            "value": "DarkNeutral100"
        },
        "name": "color.icon.inverse",
        "path": [
            "color",
            "icon",
            "inverse"
        ],
        "cleanName": "color.icon.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for icons that communicate selection, such as icons in selected navigation items, or the opened state of a dropdown trigger. On bold selected backgrounds, use color.icon.inverse instead. Do not use for brand emphasis or hover alone. Keep the selected icon treatment when the element also has focus."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for icons that communicate selection, such as icons in selected navigation items, or the opened state of a dropdown trigger. On bold selected backgrounds, use color.icon.inverse instead. Do not use for brand emphasis or hover alone. Keep the selected icon treatment when the element also has focus."
            },
            "value": "Blue400"
        },
        "name": "color.icon.selected",
        "path": [
            "color",
            "icon",
            "selected"
        ],
        "cleanName": "color.icon.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons that reinforce our brand."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons that reinforce our brand."
            },
            "value": "Blue400"
        },
        "name": "color.icon.brand",
        "path": [
            "color",
            "icon",
            "brand"
        ],
        "cleanName": "color.icon.brand"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating critical information, such as those used in error handing."
        },
        "value": "#F15B50",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating critical information, such as those used in error handing."
            },
            "value": "Red500"
        },
        "name": "color.icon.danger",
        "path": [
            "color",
            "icon",
            "danger"
        ],
        "cleanName": "color.icon.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating caution, such as those used in warning section messages."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating caution, such as those used in warning section messages."
            },
            "value": "Orange300"
        },
        "name": "color.icon.warning.[default]",
        "path": [
            "color",
            "icon",
            "warning",
            "[default]"
        ],
        "cleanName": "color.icon.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons when on bold warning backgrounds."
        },
        "value": "#1F1F21",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons when on bold warning backgrounds."
            },
            "value": "DarkNeutral100"
        },
        "name": "color.icon.warning.inverse",
        "path": [
            "color",
            "icon",
            "warning",
            "inverse"
        ],
        "cleanName": "color.icon.warning.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating a favorable outcome, such as those used in success section messaged."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating a favorable outcome, such as those used in success section messaged."
            },
            "value": "Lime500"
        },
        "name": "color.icon.success",
        "path": [
            "color",
            "icon",
            "success"
        ],
        "cleanName": "color.icon.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating change or something new, such as discovery section messages."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating change or something new, such as discovery section messages."
            },
            "value": "Purple500"
        },
        "name": "color.icon.discovery",
        "path": [
            "color",
            "icon",
            "discovery"
        ],
        "cleanName": "color.icon.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating information or something in-progress, such as information section messages."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating information or something in-progress, such as information section messages."
            },
            "value": "Blue500"
        },
        "name": "color.icon.information",
        "path": [
            "color",
            "icon",
            "information"
        ],
        "cleanName": "color.icon.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.54.0",
            "description": "Use for icons paired with color.text.subtlest"
        },
        "value": "#96999E",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.54.0",
                "description": "Use for icons paired with color.text.subtlest"
            },
            "value": "DarkNeutral700"
        },
        "name": "color.icon.subtlest",
        "path": [
            "color",
            "icon",
            "subtlest"
        ],
        "cleanName": "color.icon.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons paired with color.text.subtle"
        },
        "value": "#A9ABAF",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons paired with color.text.subtle"
            },
            "value": "DarkNeutral800"
        },
        "name": "color.icon.subtle",
        "path": [
            "color",
            "icon",
            "subtle"
        ],
        "cleanName": "color.icon.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for links in a default or hovered state. Add an underline for hovered states."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for links in a default or hovered state. Add an underline for hovered states."
            },
            "value": "Blue400"
        },
        "name": "color.link.[default]",
        "path": [
            "color",
            "link",
            "[default]"
        ],
        "cleanName": "color.link"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for links in a pressed state."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for links in a pressed state."
            },
            "value": "Blue300"
        },
        "name": "color.link.pressed",
        "path": [
            "color",
            "link",
            "pressed"
        ],
        "cleanName": "color.link.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.23.0",
            "description": "Use for visited links."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.23.0",
                "description": "Use for visited links."
            },
            "value": "Purple300"
        },
        "name": "color.link.visited.[default]",
        "path": [
            "color",
            "link",
            "visited",
            "[default]"
        ],
        "cleanName": "color.link.visited"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.43.0",
            "description": "Use for visited links in a pressed state."
        },
        "value": "#EED7FC",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.43.0",
                "description": "Use for visited links in a pressed state."
            },
            "value": "Purple200"
        },
        "name": "color.link.visited.pressed",
        "path": [
            "color",
            "link",
            "visited",
            "pressed"
        ],
        "cleanName": "color.link.visited.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as a background overlay for elements in a hovered state when their background color cannot change, such as avatars."
        },
        "value": "#ffffff33",
        "filePath": "schema/themes/atlassian-dark/color/interaction.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as a background overlay for elements in a hovered state when their background color cannot change, such as avatars."
            },
            "value": "#ffffff33"
        },
        "name": "color.interaction.hovered",
        "path": [
            "color",
            "interaction",
            "hovered"
        ],
        "cleanName": "color.interaction.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as a background overlay for elements in a pressed state when their background color cannot change, such as avatars."
        },
        "value": "#ffffff5c",
        "filePath": "schema/themes/atlassian-dark/color/interaction.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as a background overlay for elements in a pressed state when their background color cannot change, such as avatars."
            },
            "value": "#ffffff5c"
        },
        "name": "color.interaction.pressed",
        "path": [
            "color",
            "interaction",
            "pressed"
        ],
        "cleanName": "color.interaction.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.0",
            "description": "Use for skeleton loading states"
        },
        "value": "#CECED912",
        "filePath": "schema/themes/atlassian-dark/color/skeleton.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.0",
                "description": "Use for skeleton loading states"
            },
            "value": "DarkNeutral200A"
        },
        "name": "color.skeleton.[default]",
        "path": [
            "color",
            "skeleton",
            "[default]"
        ],
        "cleanName": "color.skeleton"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.0",
            "description": "Use for the pulse or shimmer effect in skeleton loading states"
        },
        "value": "#BDBDBD0A",
        "filePath": "schema/themes/atlassian-dark/color/skeleton.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.0",
                "description": "Use for the pulse or shimmer effect in skeleton loading states"
            },
            "value": "DarkNeutral100A"
        },
        "name": "color.skeleton.subtle",
        "path": [
            "color",
            "skeleton",
            "subtle"
        ],
        "cleanName": "color.skeleton.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for the screen overlay that appears with modal dialogs"
        },
        "value": "#10121499",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for the screen overlay that appears with modal dialogs"
            },
            "value": "#10121499"
        },
        "name": "color.blanket.[default]",
        "path": [
            "color",
            "blanket",
            "[default]"
        ],
        "cleanName": "color.blanket"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as a translucent blanket to communicate selection when changing the background of the selected content is not possible, such as selected Editor blocks. The content beneath remains visible. Do not use to indicate keyboard focus or hover alone."
        },
        "value": "#1D7AFC14",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as a translucent blanket to communicate selection when changing the background of the selected content is not possible, such as selected Editor blocks. The content beneath remains visible. Do not use to indicate keyboard focus or hover alone."
            },
            "value": "#1D7AFC14"
        },
        "name": "color.blanket.selected",
        "path": [
            "color",
            "blanket",
            "selected"
        ],
        "cleanName": "color.blanket.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as an overlay to communicate danger states when a simple background color change isn't possible, such as deletion of Editor block elements"
        },
        "value": "#E3493514",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as an overlay to communicate danger states when a simple background color change isn't possible, such as deletion of Editor block elements"
            },
            "value": "#E3493514"
        },
        "name": "color.blanket.danger",
        "path": [
            "color",
            "blanket",
            "danger"
        ],
        "cleanName": "color.blanket.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Blue500"
        },
        "name": "color.chart.categorical.1.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "1",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.1"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.1."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.1."
            },
            "value": "Blue400"
        },
        "name": "color.chart.categorical.1.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "1",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.1.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#94C748",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Lime400"
        },
        "name": "color.chart.categorical.2.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "2",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.2"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.2."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.2."
            },
            "value": "Lime300"
        },
        "name": "color.chart.categorical.2.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "2",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.2.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#C97CF4",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Purple400"
        },
        "name": "color.chart.categorical.3.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "3",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.3"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.3."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.3."
            },
            "value": "Purple300"
        },
        "name": "color.chart.categorical.3.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "3",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.3.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Orange400"
        },
        "name": "color.chart.categorical.4.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "4",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.4"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.4."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.4."
            },
            "value": "Orange300"
        },
        "name": "color.chart.categorical.4.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "4",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.4.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Blue800"
        },
        "name": "color.chart.categorical.5.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "5",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.5"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.5."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.5."
            },
            "value": "Blue700"
        },
        "name": "color.chart.categorical.5.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "5",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.5.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#964AC0",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Purple700"
        },
        "name": "color.chart.categorical.6.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "6",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.6"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.6."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.6."
            },
            "value": "Purple600"
        },
        "name": "color.chart.categorical.6.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "6",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.6.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#42B2D7",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Teal500"
        },
        "name": "color.chart.categorical.7.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "7",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.7"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.7."
        },
        "value": "#6CC3E0",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.7."
            },
            "value": "Teal400"
        },
        "name": "color.chart.categorical.7.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "7",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.7.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#E06C00",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Orange600"
        },
        "name": "color.chart.categorical.8.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "8",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.8"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.8."
        },
        "value": "#FBD779",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.8."
            },
            "value": "Orange250"
        },
        "name": "color.chart.categorical.8.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "8",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.8.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "For data visualisation only."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "For data visualisation only."
            },
            "value": "Lime500"
        },
        "name": "color.chart.lime.bold.[default]",
        "path": [
            "color",
            "chart",
            "lime",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.lime.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Hovered state of color.chart.lime.bold."
        },
        "value": "#94C748",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Hovered state of color.chart.lime.bold."
            },
            "value": "Lime400"
        },
        "name": "color.chart.lime.bold.hovered",
        "path": [
            "color",
            "chart",
            "lime",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.lime.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "For data visualisation only."
        },
        "value": "#94C748",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "For data visualisation only."
            },
            "value": "Lime400"
        },
        "name": "color.chart.lime.bolder.[default]",
        "path": [
            "color",
            "chart",
            "lime",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.lime.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Hovered state of color.chart.lime.bolder."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Hovered state of color.chart.lime.bolder."
            },
            "value": "Lime300"
        },
        "name": "color.chart.lime.bolder.hovered",
        "path": [
            "color",
            "chart",
            "lime",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.lime.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "For data visualisation only."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "For data visualisation only."
            },
            "value": "Lime300"
        },
        "name": "color.chart.lime.boldest.[default]",
        "path": [
            "color",
            "chart",
            "lime",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.lime.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Hovered state of color.chart.lime.boldest."
        },
        "value": "#D3F1A7",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Hovered state of color.chart.lime.boldest."
            },
            "value": "Lime200"
        },
        "name": "color.chart.lime.boldest.hovered",
        "path": [
            "color",
            "chart",
            "lime",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.lime.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A secondary color for data visualisation or to communicate 'to-do' statues."
        },
        "value": "#7E8188",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A secondary color for data visualisation or to communicate 'to-do' statues."
            },
            "value": "DarkNeutral600"
        },
        "name": "color.chart.neutral.[default]",
        "path": [
            "color",
            "chart",
            "neutral",
            "[default]"
        ],
        "cleanName": "color.chart.neutral"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.neutral."
        },
        "value": "#96999E",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.neutral."
            },
            "value": "DarkNeutral700"
        },
        "name": "color.chart.neutral.hovered",
        "path": [
            "color",
            "chart",
            "neutral",
            "hovered"
        ],
        "cleanName": "color.chart.neutral.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#E2483D",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Red600"
        },
        "name": "color.chart.red.bold.[default]",
        "path": [
            "color",
            "chart",
            "red",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.red.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.red.bold."
        },
        "value": "#F15B50",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.red.bold."
            },
            "value": "Red500"
        },
        "name": "color.chart.red.bold.hovered",
        "path": [
            "color",
            "chart",
            "red",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.red.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#F15B50",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Red500"
        },
        "name": "color.chart.red.bolder.[default]",
        "path": [
            "color",
            "chart",
            "red",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.red.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.red.bolder."
        },
        "value": "#F87168",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.red.bolder."
            },
            "value": "Red400"
        },
        "name": "color.chart.red.bolder.hovered",
        "path": [
            "color",
            "chart",
            "red",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.red.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Red300"
        },
        "name": "color.chart.red.boldest.[default]",
        "path": [
            "color",
            "chart",
            "red",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.red.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.red.boldest."
        },
        "value": "#FFD5D2",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.red.boldest."
            },
            "value": "Red200"
        },
        "name": "color.chart.red.boldest.hovered",
        "path": [
            "color",
            "chart",
            "red",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.red.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#F68909",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Orange500"
        },
        "name": "color.chart.orange.bold.[default]",
        "path": [
            "color",
            "chart",
            "orange",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.orange.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.orange.bold."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.orange.bold."
            },
            "value": "Orange400"
        },
        "name": "color.chart.orange.bold.hovered",
        "path": [
            "color",
            "chart",
            "orange",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.orange.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Orange400"
        },
        "name": "color.chart.orange.bolder.[default]",
        "path": [
            "color",
            "chart",
            "orange",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.orange.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.orange.bolder."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.orange.bolder."
            },
            "value": "Orange300"
        },
        "name": "color.chart.orange.bolder.hovered",
        "path": [
            "color",
            "chart",
            "orange",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.orange.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#FBD779",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Orange250"
        },
        "name": "color.chart.orange.boldest.[default]",
        "path": [
            "color",
            "chart",
            "orange",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.orange.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.orange.boldest."
        },
        "value": "#FCE4A6",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.orange.boldest."
            },
            "value": "Orange200"
        },
        "name": "color.chart.orange.boldest.hovered",
        "path": [
            "color",
            "chart",
            "orange",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.orange.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#CF9F02",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Yellow500"
        },
        "name": "color.chart.yellow.bold.[default]",
        "path": [
            "color",
            "chart",
            "yellow",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.yellow.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.yellow.bold."
        },
        "value": "#DDB30E",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.yellow.bold."
            },
            "value": "Yellow400"
        },
        "name": "color.chart.yellow.bold.hovered",
        "path": [
            "color",
            "chart",
            "yellow",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.yellow.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#DDB30E",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Yellow400"
        },
        "name": "color.chart.yellow.bolder.[default]",
        "path": [
            "color",
            "chart",
            "yellow",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.yellow.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.yellow.bolder."
        },
        "value": "#EED12B",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.yellow.bolder."
            },
            "value": "Yellow300"
        },
        "name": "color.chart.yellow.bolder.hovered",
        "path": [
            "color",
            "chart",
            "yellow",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.yellow.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#EED12B",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Yellow300"
        },
        "name": "color.chart.yellow.boldest.[default]",
        "path": [
            "color",
            "chart",
            "yellow",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.yellow.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.yellow.boldest."
        },
        "value": "#F5E989",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.yellow.boldest."
            },
            "value": "Yellow200"
        },
        "name": "color.chart.yellow.boldest.hovered",
        "path": [
            "color",
            "chart",
            "yellow",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.yellow.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#2ABB7F",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Green500"
        },
        "name": "color.chart.green.bold.[default]",
        "path": [
            "color",
            "chart",
            "green",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.green.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.green.bold."
        },
        "value": "#4BCE97",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.green.bold."
            },
            "value": "Green400"
        },
        "name": "color.chart.green.bold.hovered",
        "path": [
            "color",
            "chart",
            "green",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.green.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#4BCE97",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Green400"
        },
        "name": "color.chart.green.bolder.[default]",
        "path": [
            "color",
            "chart",
            "green",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.green.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.green.bolder."
        },
        "value": "#7EE2B8",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.green.bolder."
            },
            "value": "Green300"
        },
        "name": "color.chart.green.bolder.hovered",
        "path": [
            "color",
            "chart",
            "green",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.green.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#7EE2B8",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Green300"
        },
        "name": "color.chart.green.boldest.[default]",
        "path": [
            "color",
            "chart",
            "green",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.green.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.green.boldest."
        },
        "value": "#BAF3DB",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.green.boldest."
            },
            "value": "Green200"
        },
        "name": "color.chart.green.boldest.hovered",
        "path": [
            "color",
            "chart",
            "green",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.green.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#42B2D7",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Teal500"
        },
        "name": "color.chart.teal.bold.[default]",
        "path": [
            "color",
            "chart",
            "teal",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.teal.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.teal.bold."
        },
        "value": "#6CC3E0",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.teal.bold."
            },
            "value": "Teal400"
        },
        "name": "color.chart.teal.bold.hovered",
        "path": [
            "color",
            "chart",
            "teal",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.teal.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#6CC3E0",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Teal400"
        },
        "name": "color.chart.teal.bolder.[default]",
        "path": [
            "color",
            "chart",
            "teal",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.teal.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.teal.bolder."
        },
        "value": "#9DD9EE",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.teal.bolder."
            },
            "value": "Teal300"
        },
        "name": "color.chart.teal.bolder.hovered",
        "path": [
            "color",
            "chart",
            "teal",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.teal.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#9DD9EE",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Teal300"
        },
        "name": "color.chart.teal.boldest.[default]",
        "path": [
            "color",
            "chart",
            "teal",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.teal.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.teal.boldest."
        },
        "value": "#C6EDFB",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.teal.boldest."
            },
            "value": "Teal200"
        },
        "name": "color.chart.teal.boldest.hovered",
        "path": [
            "color",
            "chart",
            "teal",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.teal.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Blue600"
        },
        "name": "color.chart.blue.bold.[default]",
        "path": [
            "color",
            "chart",
            "blue",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.blue.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.blue.bold."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.blue.bold."
            },
            "value": "Blue500"
        },
        "name": "color.chart.blue.bold.hovered",
        "path": [
            "color",
            "chart",
            "blue",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.blue.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Blue500"
        },
        "name": "color.chart.blue.bolder.[default]",
        "path": [
            "color",
            "chart",
            "blue",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.blue.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.blue.bolder."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.blue.bolder."
            },
            "value": "Blue400"
        },
        "name": "color.chart.blue.bolder.hovered",
        "path": [
            "color",
            "chart",
            "blue",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.blue.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Blue300"
        },
        "name": "color.chart.blue.boldest.[default]",
        "path": [
            "color",
            "chart",
            "blue",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.blue.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.blue.boldest."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.blue.boldest."
            },
            "value": "Blue200"
        },
        "name": "color.chart.blue.boldest.hovered",
        "path": [
            "color",
            "chart",
            "blue",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.blue.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Purple600"
        },
        "name": "color.chart.purple.bold.[default]",
        "path": [
            "color",
            "chart",
            "purple",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.purple.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.purple.bold."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.purple.bold."
            },
            "value": "Purple500"
        },
        "name": "color.chart.purple.bold.hovered",
        "path": [
            "color",
            "chart",
            "purple",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.purple.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Purple500"
        },
        "name": "color.chart.purple.bolder.[default]",
        "path": [
            "color",
            "chart",
            "purple",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.purple.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.purple.bolder."
        },
        "value": "#C97CF4",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.purple.bolder."
            },
            "value": "Purple400"
        },
        "name": "color.chart.purple.bolder.hovered",
        "path": [
            "color",
            "chart",
            "purple",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.purple.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Purple300"
        },
        "name": "color.chart.purple.boldest.[default]",
        "path": [
            "color",
            "chart",
            "purple",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.purple.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.purple.boldest."
        },
        "value": "#EED7FC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.purple.boldest."
            },
            "value": "Purple200"
        },
        "name": "color.chart.purple.boldest.hovered",
        "path": [
            "color",
            "chart",
            "purple",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.purple.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#CD519D",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Magenta600"
        },
        "name": "color.chart.magenta.bold.[default]",
        "path": [
            "color",
            "chart",
            "magenta",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.magenta.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.magenta.bold."
        },
        "value": "#DA62AC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.magenta.bold."
            },
            "value": "Magenta500"
        },
        "name": "color.chart.magenta.bold.hovered",
        "path": [
            "color",
            "chart",
            "magenta",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.magenta.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#DA62AC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Magenta500"
        },
        "name": "color.chart.magenta.bolder.[default]",
        "path": [
            "color",
            "chart",
            "magenta",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.magenta.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.magenta.bolder."
        },
        "value": "#E774BB",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.magenta.bolder."
            },
            "value": "Magenta400"
        },
        "name": "color.chart.magenta.bolder.hovered",
        "path": [
            "color",
            "chart",
            "magenta",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.magenta.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#F797D2",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Magenta300"
        },
        "name": "color.chart.magenta.boldest.[default]",
        "path": [
            "color",
            "chart",
            "magenta",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.magenta.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.magenta.boldest."
        },
        "value": "#FDD0EC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.magenta.boldest."
            },
            "value": "Magenta200"
        },
        "name": "color.chart.magenta.boldest.hovered",
        "path": [
            "color",
            "chart",
            "magenta",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.magenta.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#7E8188",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "DarkNeutral600"
        },
        "name": "color.chart.gray.bold.[default]",
        "path": [
            "color",
            "chart",
            "gray",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.gray.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.gray.bold."
        },
        "value": "#96999E",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.gray.bold."
            },
            "value": "DarkNeutral700"
        },
        "name": "color.chart.gray.bold.hovered",
        "path": [
            "color",
            "chart",
            "gray",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.gray.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#96999E",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "DarkNeutral700"
        },
        "name": "color.chart.gray.bolder.[default]",
        "path": [
            "color",
            "chart",
            "gray",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.gray.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.gray.bolder."
        },
        "value": "#A9ABAF",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.gray.bolder."
            },
            "value": "DarkNeutral800"
        },
        "name": "color.chart.gray.bolder.hovered",
        "path": [
            "color",
            "chart",
            "gray",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.gray.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#A9ABAF",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "DarkNeutral800"
        },
        "name": "color.chart.gray.boldest.[default]",
        "path": [
            "color",
            "chart",
            "gray",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.gray.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.gray.boldest."
        },
        "value": "#BFC1C4",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.gray.boldest."
            },
            "value": "DarkNeutral900"
        },
        "name": "color.chart.gray.boldest.hovered",
        "path": [
            "color",
            "chart",
            "gray",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.gray.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Our primary color for data visualisation. Use when only one color is required."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Our primary color for data visualisation. Use when only one color is required."
            },
            "value": "Blue500"
        },
        "name": "color.chart.brand.[default]",
        "path": [
            "color",
            "chart",
            "brand",
            "[default]"
        ],
        "cleanName": "color.chart.brand"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.brand."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.brand."
            },
            "value": "Blue400"
        },
        "name": "color.chart.brand.hovered",
        "path": [
            "color",
            "chart",
            "brand",
            "hovered"
        ],
        "cleanName": "color.chart.brand.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating negative information, such as 'off track'."
        },
        "value": "#E2483D",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating negative information, such as 'off track'."
            },
            "value": "Red600"
        },
        "name": "color.chart.danger.[default].[default]",
        "path": [
            "color",
            "chart",
            "danger",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.danger."
        },
        "value": "#F15B50",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.danger."
            },
            "value": "Red500"
        },
        "name": "color.chart.danger.[default].hovered",
        "path": [
            "color",
            "chart",
            "danger",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.danger.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.danger."
        },
        "value": "#FFB8B2",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.danger."
            },
            "value": "Red250"
        },
        "name": "color.chart.danger.bold.[default]",
        "path": [
            "color",
            "chart",
            "danger",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.danger.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.danger.bold."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.danger.bold."
            },
            "value": "Red300"
        },
        "name": "color.chart.danger.bold.hovered",
        "path": [
            "color",
            "chart",
            "danger",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.danger.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating caution, such as 'at risk' statuses."
        },
        "value": "#F68909",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating caution, such as 'at risk' statuses."
            },
            "value": "Orange500"
        },
        "name": "color.chart.warning.[default].[default]",
        "path": [
            "color",
            "chart",
            "warning",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.warning."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.warning."
            },
            "value": "Orange400"
        },
        "name": "color.chart.warning.[default].hovered",
        "path": [
            "color",
            "chart",
            "warning",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.warning.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.warning."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.warning."
            },
            "value": "Orange300"
        },
        "name": "color.chart.warning.bold.[default]",
        "path": [
            "color",
            "chart",
            "warning",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.warning.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.warning.bold."
        },
        "value": "#FCE4A6",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.warning.bold."
            },
            "value": "Orange200"
        },
        "name": "color.chart.warning.bold.hovered",
        "path": [
            "color",
            "chart",
            "warning",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.warning.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating positive information, such as 'on track'."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating positive information, such as 'on track'."
            },
            "value": "Lime500"
        },
        "name": "color.chart.success.[default].[default]",
        "path": [
            "color",
            "chart",
            "success",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.success."
        },
        "value": "#94C748",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.success."
            },
            "value": "Lime400"
        },
        "name": "color.chart.success.[default].hovered",
        "path": [
            "color",
            "chart",
            "success",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.success.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.success."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.success."
            },
            "value": "Lime300"
        },
        "name": "color.chart.success.bold.[default]",
        "path": [
            "color",
            "chart",
            "success",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.success.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.success.bold."
        },
        "value": "#D3F1A7",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.success.bold."
            },
            "value": "Lime200"
        },
        "name": "color.chart.success.bold.hovered",
        "path": [
            "color",
            "chart",
            "success",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.success.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating 'new' statuses."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating 'new' statuses."
            },
            "value": "Purple500"
        },
        "name": "color.chart.discovery.[default].[default]",
        "path": [
            "color",
            "chart",
            "discovery",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.discovery."
        },
        "value": "#C97CF4",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.discovery."
            },
            "value": "Purple400"
        },
        "name": "color.chart.discovery.[default].hovered",
        "path": [
            "color",
            "chart",
            "discovery",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.discovery.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.discovery."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.discovery."
            },
            "value": "Purple300"
        },
        "name": "color.chart.discovery.bold.[default]",
        "path": [
            "color",
            "chart",
            "discovery",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.discovery.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.discovery.bold."
        },
        "value": "#EED7FC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.discovery.bold."
            },
            "value": "Purple200"
        },
        "name": "color.chart.discovery.bold.hovered",
        "path": [
            "color",
            "chart",
            "discovery",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.discovery.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating low priority or in-progress statuses."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating low priority or in-progress statuses."
            },
            "value": "Blue500"
        },
        "name": "color.chart.information.[default].[default]",
        "path": [
            "color",
            "chart",
            "information",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.information."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.information."
            },
            "value": "Blue400"
        },
        "name": "color.chart.information.[default].hovered",
        "path": [
            "color",
            "chart",
            "information",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.information.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.information."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.information."
            },
            "value": "Blue300"
        },
        "name": "color.chart.information.bold.[default]",
        "path": [
            "color",
            "chart",
            "information",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.information.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.information.bold."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.information.bold."
            },
            "value": "Blue200"
        },
        "name": "color.chart.information.bold.hovered",
        "path": [
            "color",
            "chart",
            "information",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.information.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.2.0",
            "description": "Background color for Rovo brand emphasis."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.2.0",
                "description": "Background color for Rovo brand emphasis."
            },
            "value": "DarkNeutral1200"
        },
        "name": "color.rovo.background.brand.bold.[default]",
        "path": [
            "color",
            "rovo",
            "background",
            "brand",
            "bold",
            "[default]"
        ],
        "cleanName": "color.rovo.background.brand.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.2.0",
            "description": "Hovered state of color.rovo.background.brand.bold."
        },
        "value": "#E2E3E4",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.2.0",
                "description": "Hovered state of color.rovo.background.brand.bold."
            },
            "value": "DarkNeutral1100"
        },
        "name": "color.rovo.background.brand.bold.hovered",
        "path": [
            "color",
            "rovo",
            "background",
            "brand",
            "bold",
            "hovered"
        ],
        "cleanName": "color.rovo.background.brand.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.2.0",
            "description": "Pressed state of color.rovo.background.brand.bold."
        },
        "value": "#CECFD2",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.2.0",
                "description": "Pressed state of color.rovo.background.brand.bold."
            },
            "value": "DarkNeutral1000"
        },
        "name": "color.rovo.background.brand.bold.pressed",
        "path": [
            "color",
            "rovo",
            "background",
            "brand",
            "bold",
            "pressed"
        ],
        "cleanName": "color.rovo.background.brand.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo lime borders."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo lime borders."
            },
            "value": "Lime500"
        },
        "name": "color.rovo.border.lime",
        "path": [
            "color",
            "rovo",
            "border",
            "lime"
        ],
        "cleanName": "color.rovo.border.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo saffron borders."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo saffron borders."
            },
            "value": "Orange400"
        },
        "name": "color.rovo.border.saffron",
        "path": [
            "color",
            "rovo",
            "border",
            "saffron"
        ],
        "cleanName": "color.rovo.border.saffron"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo blue borders."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo blue borders."
            },
            "value": "Blue600"
        },
        "name": "color.rovo.border.blue",
        "path": [
            "color",
            "rovo",
            "border",
            "blue"
        ],
        "cleanName": "color.rovo.border.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo purple borders."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo purple borders."
            },
            "value": "Purple500"
        },
        "name": "color.rovo.border.purple",
        "path": [
            "color",
            "rovo",
            "border",
            "purple"
        ],
        "cleanName": "color.rovo.border.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo lime icons."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo lime icons."
            },
            "value": "Lime500"
        },
        "name": "color.rovo.icon.lime",
        "path": [
            "color",
            "rovo",
            "icon",
            "lime"
        ],
        "cleanName": "color.rovo.icon.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo saffron icons."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo saffron icons."
            },
            "value": "Orange400"
        },
        "name": "color.rovo.icon.saffron",
        "path": [
            "color",
            "rovo",
            "icon",
            "saffron"
        ],
        "cleanName": "color.rovo.icon.saffron"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo blue icons."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo blue icons."
            },
            "value": "Blue600"
        },
        "name": "color.rovo.icon.blue",
        "path": [
            "color",
            "rovo",
            "icon",
            "blue"
        ],
        "cleanName": "color.rovo.icon.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo purple icons."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo purple icons."
            },
            "value": "Purple500"
        },
        "name": "color.rovo.icon.purple",
        "path": [
            "color",
            "rovo",
            "icon",
            "purple"
        ],
        "cleanName": "color.rovo.icon.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as the primary background for the UI."
        },
        "value": "#1F1F21",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as the primary background for the UI."
            },
            "value": "DarkNeutral100"
        },
        "name": "elevation.surface.[default].[default]",
        "path": [
            "elevation",
            "surface",
            "[default]",
            "[default]"
        ],
        "cleanName": "elevation.surface"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Hovered state of elevation.surface"
        },
        "value": "#242528",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Hovered state of elevation.surface"
            },
            "value": "DarkNeutral200"
        },
        "name": "elevation.surface.[default].hovered",
        "path": [
            "elevation",
            "surface",
            "[default]",
            "hovered"
        ],
        "cleanName": "elevation.surface.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Pressed state of elevation.surface"
        },
        "value": "#2B2C2F",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Pressed state of elevation.surface"
            },
            "value": "DarkNeutral250"
        },
        "name": "elevation.surface.[default].pressed",
        "path": [
            "elevation",
            "surface",
            "[default]",
            "pressed"
        ],
        "cleanName": "elevation.surface.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.3.0",
            "description": "Use as a neutral container surface background."
        },
        "value": "#BDBDBD0A",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.3.0",
                "description": "Use as a neutral container surface background."
            },
            "value": "DarkNeutral100A"
        },
        "name": "elevation.surface.container.[default]",
        "path": [
            "elevation",
            "surface",
            "container",
            "[default]"
        ],
        "cleanName": "elevation.surface.container"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "14.1.0",
            "description": "Hovered state of elevation.surface.container"
        },
        "value": "#CECED912",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "14.1.0",
                "description": "Hovered state of elevation.surface.container"
            },
            "value": "DarkNeutral200A"
        },
        "name": "elevation.surface.container.hovered",
        "path": [
            "elevation",
            "surface",
            "container",
            "hovered"
        ],
        "cleanName": "elevation.surface.container.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "14.1.0",
            "description": "Pressed state of elevation.surface.container"
        },
        "value": "#D9DAE71A",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "14.1.0",
                "description": "Pressed state of elevation.surface.container"
            },
            "value": "DarkNeutral250A"
        },
        "name": "elevation.surface.container.pressed",
        "path": [
            "elevation",
            "surface",
            "container",
            "pressed"
        ],
        "cleanName": "elevation.surface.container.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the background of elements that sit on top of they UI, such as modals, dialogs, dropdown menus, floating toolbars, and floating single-action buttons. Also use for the background of raised cards in a dragged state. Combine with elevation.shadow.overlay."
        },
        "value": "#2B2C2F",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the background of elements that sit on top of they UI, such as modals, dialogs, dropdown menus, floating toolbars, and floating single-action buttons. Also use for the background of raised cards in a dragged state. Combine with elevation.shadow.overlay."
            },
            "value": "DarkNeutral250"
        },
        "name": "elevation.surface.overlay.[default]",
        "path": [
            "elevation",
            "surface",
            "overlay",
            "[default]"
        ],
        "cleanName": "elevation.surface.overlay"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Hovered state of elevation.surface.overlay"
        },
        "value": "#303134",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Hovered state of elevation.surface.overlay"
            },
            "value": "DarkNeutral300"
        },
        "name": "elevation.surface.overlay.hovered",
        "path": [
            "elevation",
            "surface",
            "overlay",
            "hovered"
        ],
        "cleanName": "elevation.surface.overlay.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Pressed state of elevation.surface.overlay"
        },
        "value": "#3D3F43",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Pressed state of elevation.surface.overlay"
            },
            "value": "DarkNeutral350"
        },
        "name": "elevation.surface.overlay.pressed",
        "path": [
            "elevation",
            "surface",
            "overlay",
            "pressed"
        ],
        "cleanName": "elevation.surface.overlay.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the background of cards that can be moved, such as Jira cards on a Kanban board. Combine with elevation.shadow.raised."
        },
        "value": "#242528",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the background of cards that can be moved, such as Jira cards on a Kanban board. Combine with elevation.shadow.raised."
            },
            "value": "DarkNeutral200"
        },
        "name": "elevation.surface.raised.[default]",
        "path": [
            "elevation",
            "surface",
            "raised",
            "[default]"
        ],
        "cleanName": "elevation.surface.raised"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Hovered state of elevation.surface.raised"
        },
        "value": "#2B2C2F",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Hovered state of elevation.surface.raised"
            },
            "value": "DarkNeutral250"
        },
        "name": "elevation.surface.raised.hovered",
        "path": [
            "elevation",
            "surface",
            "raised",
            "hovered"
        ],
        "cleanName": "elevation.surface.raised.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Pressed state of elevation.surface.raised"
        },
        "value": "#303134",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Pressed state of elevation.surface.raised"
            },
            "value": "DarkNeutral300"
        },
        "name": "elevation.surface.raised.pressed",
        "path": [
            "elevation",
            "surface",
            "raised",
            "pressed"
        ],
        "cleanName": "elevation.surface.raised.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A secondary background for the UI commonly used for grouping items, such as Jira cards in columns."
        },
        "value": "#18191A",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A secondary background for the UI commonly used for grouping items, such as Jira cards in columns."
            },
            "value": "DarkNeutral0"
        },
        "name": "elevation.surface.sunken",
        "path": [
            "elevation",
            "surface",
            "sunken"
        ],
        "cleanName": "elevation.surface.sunken"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.3.0",
            "description": "Use for Rovo overlay surface backgrounds."
        },
        "value": "#242528",
        "filePath": "schema/themes/atlassian-dark/elevation/rovo/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.3.0",
                "description": "Use for Rovo overlay surface backgrounds."
            },
            "value": "DarkNeutral200"
        },
        "name": "elevation.rovo.surface.overlay.[default]",
        "path": [
            "elevation",
            "rovo",
            "surface",
            "overlay",
            "[default]"
        ],
        "cleanName": "elevation.rovo.surface.overlay"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.3.0",
            "description": "Hovered state of elevation.rovo.surface.overlay."
        },
        "value": "#2B2C2F",
        "filePath": "schema/themes/atlassian-dark/elevation/rovo/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.3.0",
                "description": "Hovered state of elevation.rovo.surface.overlay."
            },
            "value": "DarkNeutral250"
        },
        "name": "elevation.rovo.surface.overlay.hovered",
        "path": [
            "elevation",
            "rovo",
            "surface",
            "overlay",
            "hovered"
        ],
        "cleanName": "elevation.rovo.surface.overlay.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.3.0",
            "description": "Pressed state of elevation.rovo.surface.overlay."
        },
        "value": "#303134",
        "filePath": "schema/themes/atlassian-dark/elevation/rovo/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.3.0",
                "description": "Pressed state of elevation.rovo.surface.overlay."
            },
            "value": "DarkNeutral300"
        },
        "name": "elevation.rovo.surface.overlay.pressed",
        "path": [
            "elevation",
            "rovo",
            "surface",
            "overlay",
            "pressed"
        ],
        "cleanName": "elevation.rovo.surface.overlay.pressed"
    },
    {
        "attributes": {
            "group": "shadow",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use to create a shadow when content scrolls under other content."
        },
        "value": [
            {
                "radius": 12,
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "color": "#01040475",
                "opacity": 0.56
            },
            {
                "radius": 1,
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "color": "#01040475",
                "opacity": 0.5
            }
        ],
        "filePath": "schema/themes/atlassian-dark/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "shadow",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use to create a shadow when content scrolls under other content."
            },
            "value": [
                {
                    "radius": 12,
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "color": "DarkNeutral-100A",
                    "opacity": 0.56
                },
                {
                    "radius": 1,
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "color": "DarkNeutral-100A",
                    "opacity": 0.5
                }
            ]
        },
        "name": "elevation.shadow.overflow.[default]",
        "path": [
            "elevation",
            "shadow",
            "overflow",
            "[default]"
        ],
        "cleanName": "elevation.shadow.overflow"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.32",
            "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.spread to replicate the overflow shadow."
        },
        "value": "#01040480",
        "filePath": "schema/themes/atlassian-dark/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.32",
                "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.spread to replicate the overflow shadow."
            },
            "value": "#01040480"
        },
        "name": "elevation.shadow.overflow.perimeter",
        "path": [
            "elevation",
            "shadow",
            "overflow",
            "perimeter"
        ],
        "cleanName": "elevation.shadow.overflow.perimeter"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.32",
            "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.perimeter to replicate the overflow shadow."
        },
        "value": "#0104048f",
        "filePath": "schema/themes/atlassian-dark/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.32",
                "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.perimeter to replicate the overflow shadow."
            },
            "value": "#0104048f"
        },
        "name": "elevation.shadow.overflow.spread",
        "path": [
            "elevation",
            "shadow",
            "overflow",
            "spread"
        ],
        "cleanName": "elevation.shadow.overflow.spread"
    },
    {
        "attributes": {
            "group": "shadow",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the box shadow of elements that sit on top of the UI, such as modals, dropdown menus, flags, and inline dialogs. Combine with elevation.surface.overlay\n\nAlso use for the box shadow of raised cards in a dragged state."
        },
        "value": [
            {
                "radius": 0,
                "spread": 1,
                "color": "#BDBDBD",
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "opacity": 0.12
            },
            {
                "radius": 12,
                "offset": {
                    "x": 0,
                    "y": 8
                },
                "color": "#01040475",
                "opacity": 0.36
            },
            {
                "radius": 1,
                "spread": 1,
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "color": "#01040475",
                "opacity": 0.5
            }
        ],
        "filePath": "schema/themes/atlassian-dark/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "shadow",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the box shadow of elements that sit on top of the UI, such as modals, dropdown menus, flags, and inline dialogs. Combine with elevation.surface.overlay\n\nAlso use for the box shadow of raised cards in a dragged state."
            },
            "value": [
                {
                    "radius": 0,
                    "spread": 1,
                    "color": "#BDBDBD",
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "opacity": 0.12
                },
                {
                    "radius": 12,
                    "offset": {
                        "x": 0,
                        "y": 8
                    },
                    "color": "DarkNeutral-100A",
                    "opacity": 0.36
                },
                {
                    "radius": 1,
                    "spread": 1,
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "color": "DarkNeutral-100A",
                    "opacity": 0.5
                }
            ]
        },
        "name": "elevation.shadow.overlay",
        "path": [
            "elevation",
            "shadow",
            "overlay"
        ],
        "cleanName": "elevation.shadow.overlay"
    },
    {
        "attributes": {
            "group": "shadow",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the box shadow of raised card elements, such as Jira cards on a Kanban board. Combine with elevation.surface.raised"
        },
        "value": [
            {
                "radius": 0,
                "spread": 1,
                "color": "#000000",
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "opacity": 0
            },
            {
                "radius": 1,
                "offset": {
                    "x": 0,
                    "y": 1
                },
                "color": "#01040475",
                "opacity": 0.5
            },
            {
                "radius": 1,
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "color": "#01040475",
                "opacity": 0.5
            }
        ],
        "filePath": "schema/themes/atlassian-dark/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "shadow",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the box shadow of raised card elements, such as Jira cards on a Kanban board. Combine with elevation.surface.raised"
            },
            "value": [
                {
                    "radius": 0,
                    "spread": 1,
                    "color": "#000000",
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "opacity": 0
                },
                {
                    "radius": 1,
                    "offset": {
                        "x": 0,
                        "y": 1
                    },
                    "color": "DarkNeutral-100A",
                    "opacity": 0.5
                },
                {
                    "radius": 1,
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "color": "DarkNeutral-100A",
                    "opacity": 0.5
                }
            ]
        },
        "name": "elevation.shadow.raised",
        "path": [
            "elevation",
            "shadow",
            "raised"
        ],
        "cleanName": "elevation.shadow.raised"
    },
    {
        "attributes": {
            "group": "opacity",
            "state": "active",
            "introduced": "0.10.13",
            "description": "Apply to images when in a disabled state."
        },
        "value": 0.4,
        "filePath": "schema/themes/atlassian-dark/opacity/opacity.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "opacity",
                "state": "active",
                "introduced": "0.10.13",
                "description": "Apply to images when in a disabled state."
            },
            "value": "Opacity40"
        },
        "name": "opacity.disabled",
        "path": [
            "opacity",
            "disabled"
        ],
        "cleanName": "opacity.disabled"
    },
    {
        "attributes": {
            "group": "opacity",
            "state": "active",
            "introduced": "0.10.13",
            "description": "Apply to content that sits under a loading spinner."
        },
        "value": 0.2,
        "filePath": "schema/themes/atlassian-dark/opacity/opacity.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "opacity",
                "state": "active",
                "introduced": "0.10.13",
                "description": "Apply to content that sits under a loading spinner."
            },
            "value": "Opacity20"
        },
        "name": "opacity.loading",
        "path": [
            "opacity",
            "loading"
        ],
        "cleanName": "opacity.loading"
    },
    {
        "attributes": {
            "group": "raw",
            "state": "active",
            "introduced": "0.1.1",
            "description": "Transparent token used for backwards compatibility between new and old theming solutions"
        },
        "value": "transparent",
        "filePath": "schema/themes/atlassian-dark/utility/utility.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "raw",
                "state": "active",
                "introduced": "0.1.1",
                "description": "Transparent token used for backwards compatibility between new and old theming solutions"
            },
            "value": "transparent"
        },
        "name": "utility.UNSAFE.transparent",
        "path": [
            "utility",
            "UNSAFE",
            "transparent"
        ],
        "cleanName": "utility.UNSAFE.transparent"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.14.0",
            "description": "A dynamic token that represents the current surface color set by a parent element. It defaults to the 'elevation.surface' token value."
        },
        "value": "#1F1F21",
        "filePath": "schema/themes/atlassian-dark/utility/utility.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.14.0",
                "description": "A dynamic token that represents the current surface color set by a parent element. It defaults to the 'elevation.surface' token value."
            },
            "value": "DarkNeutral100"
        },
        "name": "utility.elevation.surface.current",
        "path": [
            "utility",
            "elevation",
            "surface",
            "current"
        ],
        "cleanName": "utility.elevation.surface.current"
    }
];
var $d177a4da6300d858$export$2e2bcd8739ae039 = $d177a4da6300d858$var$tokens;
module.exports["default"] = $d177a4da6300d858$export$2e2bcd8739ae039;

});

parcelRegister("2Jj9T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fe28fde9f84f65da4f55e608e01a49f>>
 * @codegenCommand yarn build tokens
 */ const $71f646414e8eb43c$var$tokens = [
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for for backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#EFFFD6",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for for backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Lime100"
        },
        "name": "color.background.accent.lime.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.lime.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.lime.subtlest."
        },
        "value": "#D3F1A7",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.lime.subtlest."
            },
            "value": "Lime200"
        },
        "name": "color.background.accent.lime.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.lime.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.lime.subtlest."
        },
        "value": "#BDE97C",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.lime.subtlest."
            },
            "value": "Lime250"
        },
        "name": "color.background.accent.lime.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.lime.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for for backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#D3F1A7",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for for backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Lime200"
        },
        "name": "color.background.accent.lime.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.lime.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.lime.subtler."
        },
        "value": "#BDE97C",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.lime.subtler."
            },
            "value": "Lime250"
        },
        "name": "color.background.accent.lime.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.lime.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.lime.subtler."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.lime.subtler."
            },
            "value": "Lime300"
        },
        "name": "color.background.accent.lime.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.lime.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for vibrant for backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#94C748",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for vibrant for backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Lime400"
        },
        "name": "color.background.accent.lime.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.lime.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.lime.subtle."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.lime.subtle."
            },
            "value": "Lime300"
        },
        "name": "color.background.accent.lime.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.lime.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.lime.subtle."
        },
        "value": "#BDE97C",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.lime.subtle."
            },
            "value": "Lime250"
        },
        "name": "color.background.accent.lime.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.lime.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for for backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#5B7F24",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for for backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Lime700"
        },
        "name": "color.background.accent.lime.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.lime.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.lime.bolder."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.lime.bolder."
            },
            "value": "Lime800"
        },
        "name": "color.background.accent.lime.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.lime.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.lime.bolder."
        },
        "value": "#3F5224",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.lime.bolder."
            },
            "value": "Lime850"
        },
        "name": "color.background.accent.lime.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.lime.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for red backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#FFECEB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for red backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Red100"
        },
        "name": "color.background.accent.red.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.red.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.red.subtlest."
        },
        "value": "#FFD5D2",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.red.subtlest."
            },
            "value": "Red200"
        },
        "name": "color.background.accent.red.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.red.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.red.subtlest."
        },
        "value": "#FFB8B2",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.red.subtlest."
            },
            "value": "Red250"
        },
        "name": "color.background.accent.red.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.red.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for red backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#FFD5D2",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for red backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Red200"
        },
        "name": "color.background.accent.red.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.red.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.red.subtler."
        },
        "value": "#FFB8B2",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.red.subtler."
            },
            "value": "Red250"
        },
        "name": "color.background.accent.red.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.red.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.red.subtler."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.red.subtler."
            },
            "value": "Red300"
        },
        "name": "color.background.accent.red.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.red.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant red backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#F87168",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant red backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Red400"
        },
        "name": "color.background.accent.red.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.red.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.red.subtle."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.red.subtle."
            },
            "value": "Red300"
        },
        "name": "color.background.accent.red.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.red.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.red.subtle."
        },
        "value": "#FFB8B2",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.red.subtle."
            },
            "value": "Red250"
        },
        "name": "color.background.accent.red.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.red.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for red backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#C9372C",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for red backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Red700"
        },
        "name": "color.background.accent.red.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.red.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.red.bolder."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.red.bolder."
            },
            "value": "Red800"
        },
        "name": "color.background.accent.red.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.red.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.red.bolder."
        },
        "value": "#872821",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.red.bolder."
            },
            "value": "Red850"
        },
        "name": "color.background.accent.red.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.red.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for orange backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#FFF5DB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for orange backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Orange100"
        },
        "name": "color.background.accent.orange.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.orange.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.orange.subtlest."
        },
        "value": "#FCE4A6",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.orange.subtlest."
            },
            "value": "Orange200"
        },
        "name": "color.background.accent.orange.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.orange.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.orange.subtlest."
        },
        "value": "#FBD779",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.orange.subtlest."
            },
            "value": "Orange250"
        },
        "name": "color.background.accent.orange.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.orange.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for orange backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#FCE4A6",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for orange backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Orange200"
        },
        "name": "color.background.accent.orange.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.orange.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.orange.subtler."
        },
        "value": "#FBD779",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.orange.subtler."
            },
            "value": "Orange250"
        },
        "name": "color.background.accent.orange.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.orange.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.orange.subtler."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.orange.subtler."
            },
            "value": "Orange300"
        },
        "name": "color.background.accent.orange.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.orange.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant orange backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant orange backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Orange400"
        },
        "name": "color.background.accent.orange.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.orange.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.orange.subtle."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.orange.subtle."
            },
            "value": "Orange300"
        },
        "name": "color.background.accent.orange.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.orange.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.orange.subtle."
        },
        "value": "#FBD779",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.orange.subtle."
            },
            "value": "Orange250"
        },
        "name": "color.background.accent.orange.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.orange.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for orange backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#BD5B00",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for orange backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Orange700"
        },
        "name": "color.background.accent.orange.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.orange.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.orange.bolder."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.orange.bolder."
            },
            "value": "Orange800"
        },
        "name": "color.background.accent.orange.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.orange.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.orange.bolder."
        },
        "value": "#7A3B00",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.orange.bolder."
            },
            "value": "Orange850"
        },
        "name": "color.background.accent.orange.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.orange.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for yellow backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#FEF7C8",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for yellow backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Yellow100"
        },
        "name": "color.background.accent.yellow.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.yellow.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.yellow.subtlest."
        },
        "value": "#F5E989",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.yellow.subtlest."
            },
            "value": "Yellow200"
        },
        "name": "color.background.accent.yellow.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.yellow.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.yellow.subtlest."
        },
        "value": "#EFDD4E",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.yellow.subtlest."
            },
            "value": "Yellow250"
        },
        "name": "color.background.accent.yellow.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.yellow.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for yellow backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#F5E989",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for yellow backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Yellow200"
        },
        "name": "color.background.accent.yellow.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.yellow.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.yellow.subtler."
        },
        "value": "#EFDD4E",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.yellow.subtler."
            },
            "value": "Yellow250"
        },
        "name": "color.background.accent.yellow.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.yellow.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.yellow.subtler."
        },
        "value": "#EED12B",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.yellow.subtler."
            },
            "value": "Yellow300"
        },
        "name": "color.background.accent.yellow.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.yellow.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant yellow backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#EED12B",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant yellow backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Yellow300"
        },
        "name": "color.background.accent.yellow.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.yellow.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.yellow.subtle."
        },
        "value": "#DDB30E",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.yellow.subtle."
            },
            "value": "Yellow400"
        },
        "name": "color.background.accent.yellow.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.yellow.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.yellow.subtle."
        },
        "value": "#EFDD4E",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.yellow.subtle."
            },
            "value": "Yellow250"
        },
        "name": "color.background.accent.yellow.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.yellow.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for yellow backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#946F00",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for yellow backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Yellow700"
        },
        "name": "color.background.accent.yellow.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.yellow.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.yellow.bolder."
        },
        "value": "#7F5F01",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.yellow.bolder."
            },
            "value": "Yellow800"
        },
        "name": "color.background.accent.yellow.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.yellow.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.yellow.bolder."
        },
        "value": "#614A05",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.yellow.bolder."
            },
            "value": "Yellow850"
        },
        "name": "color.background.accent.yellow.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.yellow.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for green backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#DCFFF1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for green backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Green100"
        },
        "name": "color.background.accent.green.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.green.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.green.subtlest."
        },
        "value": "#BAF3DB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.green.subtlest."
            },
            "value": "Green200"
        },
        "name": "color.background.accent.green.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.green.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.green.subtlest."
        },
        "value": "#97EDC9",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.green.subtlest."
            },
            "value": "Green250"
        },
        "name": "color.background.accent.green.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.green.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for green backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#BAF3DB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for green backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Green200"
        },
        "name": "color.background.accent.green.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.green.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.green.subtler."
        },
        "value": "#97EDC9",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.green.subtler."
            },
            "value": "Green250"
        },
        "name": "color.background.accent.green.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.green.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.green.subtler."
        },
        "value": "#7EE2B8",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.green.subtler."
            },
            "value": "Green300"
        },
        "name": "color.background.accent.green.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.green.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant green backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#4BCE97",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant green backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Green400"
        },
        "name": "color.background.accent.green.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.green.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.green.subtle."
        },
        "value": "#7EE2B8",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.green.subtle."
            },
            "value": "Green300"
        },
        "name": "color.background.accent.green.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.green.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.green.subtle."
        },
        "value": "#97EDC9",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.green.subtle."
            },
            "value": "Green250"
        },
        "name": "color.background.accent.green.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.green.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for green backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#1F845A",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for green backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Green700"
        },
        "name": "color.background.accent.green.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.green.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.green.bolder."
        },
        "value": "#216E4E",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.green.bolder."
            },
            "value": "Green800"
        },
        "name": "color.background.accent.green.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.green.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.green.bolder."
        },
        "value": "#19573D",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.green.bolder."
            },
            "value": "Green850"
        },
        "name": "color.background.accent.green.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.green.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for teal backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#E7F9FF",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for teal backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Teal100"
        },
        "name": "color.background.accent.teal.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.teal.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.teal.subtlest."
        },
        "value": "#C6EDFB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.teal.subtlest."
            },
            "value": "Teal200"
        },
        "name": "color.background.accent.teal.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.teal.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.teal.subtlest."
        },
        "value": "#B1E4F7",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.teal.subtlest."
            },
            "value": "Teal250"
        },
        "name": "color.background.accent.teal.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.teal.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for teal backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#C6EDFB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for teal backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Teal200"
        },
        "name": "color.background.accent.teal.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.teal.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.teal.subtler."
        },
        "value": "#B1E4F7",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.teal.subtler."
            },
            "value": "Teal250"
        },
        "name": "color.background.accent.teal.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.teal.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.teal.subtler."
        },
        "value": "#9DD9EE",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.teal.subtler."
            },
            "value": "Teal300"
        },
        "name": "color.background.accent.teal.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.teal.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant teal backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#6CC3E0",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant teal backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Teal400"
        },
        "name": "color.background.accent.teal.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.teal.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.teal.subtle."
        },
        "value": "#9DD9EE",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.teal.subtle."
            },
            "value": "Teal300"
        },
        "name": "color.background.accent.teal.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.teal.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.teal.subtle."
        },
        "value": "#B1E4F7",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.teal.subtle."
            },
            "value": "Teal250"
        },
        "name": "color.background.accent.teal.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.teal.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for teal backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#227D9B",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for teal backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Teal700"
        },
        "name": "color.background.accent.teal.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.teal.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.teal.bolder."
        },
        "value": "#206A83",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.teal.bolder."
            },
            "value": "Teal800"
        },
        "name": "color.background.accent.teal.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.teal.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.teal.bolder."
        },
        "value": "#1A5265",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.teal.bolder."
            },
            "value": "Teal850"
        },
        "name": "color.background.accent.teal.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.teal.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for blue backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#E9F2FE",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for blue backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Blue100"
        },
        "name": "color.background.accent.blue.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.blue.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.blue.subtlest."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.blue.subtlest."
            },
            "value": "Blue200"
        },
        "name": "color.background.accent.blue.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.blue.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.blue.subtlest."
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.blue.subtlest."
            },
            "value": "Blue250"
        },
        "name": "color.background.accent.blue.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.blue.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for blue backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for blue backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Blue200"
        },
        "name": "color.background.accent.blue.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.blue.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.blue.subtler."
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.blue.subtler."
            },
            "value": "Blue250"
        },
        "name": "color.background.accent.blue.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.blue.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.blue.subtler."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.blue.subtler."
            },
            "value": "Blue300"
        },
        "name": "color.background.accent.blue.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.blue.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant blue backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant blue backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Blue400"
        },
        "name": "color.background.accent.blue.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.blue.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.blue.subtle."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.blue.subtle."
            },
            "value": "Blue300"
        },
        "name": "color.background.accent.blue.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.blue.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.blue.subtle."
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.blue.subtle."
            },
            "value": "Blue250"
        },
        "name": "color.background.accent.blue.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.blue.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for blue backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for blue backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Blue700"
        },
        "name": "color.background.accent.blue.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.blue.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.blue.bolder."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.blue.bolder."
            },
            "value": "Blue800"
        },
        "name": "color.background.accent.blue.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.blue.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.blue.bolder."
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.blue.bolder."
            },
            "value": "Blue850"
        },
        "name": "color.background.accent.blue.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.blue.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for purple backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#F8EEFE",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for purple backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Purple100"
        },
        "name": "color.background.accent.purple.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.purple.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.purple.subtlest."
        },
        "value": "#EED7FC",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.purple.subtlest."
            },
            "value": "Purple200"
        },
        "name": "color.background.accent.purple.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.purple.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.purple.subtlest."
        },
        "value": "#E3BDFA",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.purple.subtlest."
            },
            "value": "Purple250"
        },
        "name": "color.background.accent.purple.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.purple.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for purple backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#EED7FC",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for purple backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Purple200"
        },
        "name": "color.background.accent.purple.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.purple.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.purple.subtler."
        },
        "value": "#E3BDFA",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.purple.subtler."
            },
            "value": "Purple250"
        },
        "name": "color.background.accent.purple.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.purple.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.purple.subtler."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.purple.subtler."
            },
            "value": "Purple300"
        },
        "name": "color.background.accent.purple.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.purple.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant purple backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#C97CF4",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant purple backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Purple400"
        },
        "name": "color.background.accent.purple.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.purple.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.purple.subtle."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.purple.subtle."
            },
            "value": "Purple300"
        },
        "name": "color.background.accent.purple.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.purple.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.purple.subtle."
        },
        "value": "#E3BDFA",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.purple.subtle."
            },
            "value": "Purple250"
        },
        "name": "color.background.accent.purple.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.purple.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for purple backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#964AC0",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for purple backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Purple700"
        },
        "name": "color.background.accent.purple.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.purple.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.purple.bolder."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.purple.bolder."
            },
            "value": "Purple800"
        },
        "name": "color.background.accent.purple.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.purple.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.purple.bolder."
        },
        "value": "#673286",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.purple.bolder."
            },
            "value": "Purple850"
        },
        "name": "color.background.accent.purple.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.purple.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for magenta backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#FFECF8",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for magenta backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Magenta100"
        },
        "name": "color.background.accent.magenta.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.magenta.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.magenta.subtlest."
        },
        "value": "#FDD0EC",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.magenta.subtlest."
            },
            "value": "Magenta200"
        },
        "name": "color.background.accent.magenta.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.magenta.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.magenta.subtlest."
        },
        "value": "#FCB6E1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.magenta.subtlest."
            },
            "value": "Magenta250"
        },
        "name": "color.background.accent.magenta.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.magenta.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for magenta backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#FDD0EC",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for magenta backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Magenta200"
        },
        "name": "color.background.accent.magenta.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.magenta.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.magenta.subtler."
        },
        "value": "#FCB6E1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.magenta.subtler."
            },
            "value": "Magenta250"
        },
        "name": "color.background.accent.magenta.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.magenta.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.magenta.subtler."
        },
        "value": "#F797D2",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.magenta.subtler."
            },
            "value": "Magenta300"
        },
        "name": "color.background.accent.magenta.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.magenta.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant magenta backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#E774BB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant magenta backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Magenta400"
        },
        "name": "color.background.accent.magenta.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.magenta.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.magenta.subtle."
        },
        "value": "#F797D2",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.magenta.subtle."
            },
            "value": "Magenta300"
        },
        "name": "color.background.accent.magenta.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.magenta.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.magenta.subtle."
        },
        "value": "#FCB6E1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.magenta.subtle."
            },
            "value": "Magenta250"
        },
        "name": "color.background.accent.magenta.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.magenta.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for magenta backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#AE4787",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for magenta backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Magenta700"
        },
        "name": "color.background.accent.magenta.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.magenta.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.magenta.bolder."
        },
        "value": "#943D73",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.magenta.bolder."
            },
            "value": "Magenta800"
        },
        "name": "color.background.accent.magenta.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.magenta.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.magenta.bolder."
        },
        "value": "#77325B",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.magenta.bolder."
            },
            "value": "Magenta850"
        },
        "name": "color.background.accent.magenta.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.magenta.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for gray backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#F0F1F2",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for gray backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Neutral200"
        },
        "name": "color.background.accent.gray.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.gray.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.gray.subtlest."
        },
        "value": "#DDDEE1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.gray.subtlest."
            },
            "value": "Neutral300"
        },
        "name": "color.background.accent.gray.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.gray.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.gray.subtlest."
        },
        "value": "#B7B9BE",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.gray.subtlest."
            },
            "value": "Neutral400"
        },
        "name": "color.background.accent.gray.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.gray.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for gray backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#DDDEE1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for gray backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Neutral300"
        },
        "name": "color.background.accent.gray.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.gray.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.gray.subtler."
        },
        "value": "#B7B9BE",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.gray.subtler."
            },
            "value": "Neutral400"
        },
        "name": "color.background.accent.gray.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.gray.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.gray.subtler."
        },
        "value": "#8C8F97",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.gray.subtler."
            },
            "value": "Neutral500"
        },
        "name": "color.background.accent.gray.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.gray.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant gray backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#8C8F97",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant gray backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Neutral500"
        },
        "name": "color.background.accent.gray.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.gray.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.gray.subtle."
        },
        "value": "#B7B9BE",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.gray.subtle."
            },
            "value": "Neutral400"
        },
        "name": "color.background.accent.gray.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.gray.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.gray.subtle."
        },
        "value": "#DDDEE1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.gray.subtle."
            },
            "value": "Neutral300"
        },
        "name": "color.background.accent.gray.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.gray.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for gray backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#6B6E76",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for gray backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Neutral700"
        },
        "name": "color.background.accent.gray.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.gray.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.gray.bolder."
        },
        "value": "#505258",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.gray.bolder."
            },
            "value": "Neutral800"
        },
        "name": "color.background.accent.gray.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.gray.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.gray.subtlest."
        },
        "value": "#3B3D42",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.gray.subtlest."
            },
            "value": "Neutral900"
        },
        "name": "color.background.accent.gray.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.gray.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for highlighted added code lines."
        },
        "value": "#DCFFF1",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for highlighted added code lines."
            },
            "value": "Green100"
        },
        "name": "color.background.code.added.highlight",
        "path": [
            "color",
            "background",
            "code",
            "added",
            "highlight"
        ],
        "cleanName": "color.background.code.added.highlight"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for added code lines."
        },
        "value": "#BAF3DB66",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for added code lines."
            },
            "value": "Green200A40"
        },
        "name": "color.background.code.added.line",
        "path": [
            "color",
            "background",
            "code",
            "added",
            "line"
        ],
        "cleanName": "color.background.code.added.line"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for the default background of code blocks and code diffs."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for the default background of code blocks and code diffs."
            },
            "value": "Neutral0"
        },
        "name": "color.background.code.default",
        "path": [
            "color",
            "background",
            "code",
            "default"
        ],
        "cleanName": "color.background.code.default"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for the background of code gutters."
        },
        "value": "#F0F1F2",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for the background of code gutters."
            },
            "value": "Neutral200"
        },
        "name": "color.background.code.gutter",
        "path": [
            "color",
            "background",
            "code",
            "gutter"
        ],
        "cleanName": "color.background.code.gutter"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for highlighted unchanged code lines."
        },
        "value": "#F0F1F2",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for highlighted unchanged code lines."
            },
            "value": "Neutral200"
        },
        "name": "color.background.code.highlight",
        "path": [
            "color",
            "background",
            "code",
            "highlight"
        ],
        "cleanName": "color.background.code.highlight"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for highlighted removed code lines."
        },
        "value": "#FFECEB",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for highlighted removed code lines."
            },
            "value": "Red100"
        },
        "name": "color.background.code.removed.highlight",
        "path": [
            "color",
            "background",
            "code",
            "removed",
            "highlight"
        ],
        "cleanName": "color.background.code.removed.highlight"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for removed code lines."
        },
        "value": "#FFD5D266",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for removed code lines."
            },
            "value": "Red200A40"
        },
        "name": "color.background.code.removed.line",
        "path": [
            "color",
            "background",
            "code",
            "removed",
            "line"
        ],
        "cleanName": "color.background.code.removed.line"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for backgrounds of elements in a disabled state."
        },
        "value": "#0515240F",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for backgrounds of elements in a disabled state."
            },
            "value": "Neutral200A"
        },
        "name": "color.background.disabled",
        "path": [
            "color",
            "background",
            "disabled"
        ],
        "cleanName": "color.background.disabled"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for background of form UI elements, such as text fields, checkboxes, and radio buttons."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for background of form UI elements, such as text fields, checkboxes, and radio buttons."
            },
            "value": "Neutral0"
        },
        "name": "color.background.input.[default]",
        "path": [
            "color",
            "background",
            "input",
            "[default]"
        ],
        "cleanName": "color.background.input"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.input"
        },
        "value": "#F8F8F8",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.input"
            },
            "value": "Neutral100"
        },
        "name": "color.background.input.hovered",
        "path": [
            "color",
            "background",
            "input",
            "hovered"
        ],
        "cleanName": "color.background.input.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.input"
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.input"
            },
            "value": "Neutral0"
        },
        "name": "color.background.input.pressed",
        "path": [
            "color",
            "background",
            "input",
            "pressed"
        ],
        "cleanName": "color.background.input.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.3",
            "description": "Use for backgrounds of elements on a bold background, such as in the buttons on spotlight cards."
        },
        "value": "#00000029",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.3",
                "description": "Use for backgrounds of elements on a bold background, such as in the buttons on spotlight cards."
            },
            "value": "#00000029"
        },
        "name": "color.background.inverse.subtle.[default]",
        "path": [
            "color",
            "background",
            "inverse",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.inverse.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.3",
            "description": "Use for the hovered state of color.background.inverse.subtle"
        },
        "value": "#0000003D",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.3",
                "description": "Use for the hovered state of color.background.inverse.subtle"
            },
            "value": "#0000003D"
        },
        "name": "color.background.inverse.subtle.hovered",
        "path": [
            "color",
            "background",
            "inverse",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.inverse.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.3",
            "description": "Use for the pressed state of color.background.inverse.subtle"
        },
        "value": "#00000052",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.3",
                "description": "Use for the pressed state of color.background.inverse.subtle"
            },
            "value": "#00000052"
        },
        "name": "color.background.inverse.subtle.pressed",
        "path": [
            "color",
            "background",
            "inverse",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.inverse.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "The default background for neutral elements, such as default buttons."
        },
        "value": "#0515240F",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "The default background for neutral elements, such as default buttons."
            },
            "value": "Neutral200A"
        },
        "name": "color.background.neutral.[default].[default]",
        "path": [
            "color",
            "background",
            "neutral",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.neutral"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.neutral"
        },
        "value": "#0B120E24",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.neutral"
            },
            "value": "Neutral300A"
        },
        "name": "color.background.neutral.[default].hovered",
        "path": [
            "color",
            "background",
            "neutral",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.neutral.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.neutral"
        },
        "value": "#080F214A",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.neutral"
            },
            "value": "Neutral400A"
        },
        "name": "color.background.neutral.[default].pressed",
        "path": [
            "color",
            "background",
            "neutral",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.neutral.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the background of elements that appear to have no background in a resting state, such as subtle buttons and menu items."
        },
        "value": "#00000000",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the background of elements that appear to have no background in a resting state, such as subtle buttons and menu items."
            },
            "value": "transparent"
        },
        "name": "color.background.neutral.subtle.[default]",
        "path": [
            "color",
            "background",
            "neutral",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.neutral.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.neutral.subtle"
        },
        "value": "#0515240F",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.neutral.subtle"
            },
            "value": "Neutral200A"
        },
        "name": "color.background.neutral.subtle.hovered",
        "path": [
            "color",
            "background",
            "neutral",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.neutral.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.neutral.subtle"
        },
        "value": "#0B120E24",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.neutral.subtle"
            },
            "value": "Neutral300A"
        },
        "name": "color.background.neutral.subtle.pressed",
        "path": [
            "color",
            "background",
            "neutral",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.neutral.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for neutral UI elements, such as announcement banners."
        },
        "value": "#292A2E",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for neutral UI elements, such as announcement banners."
            },
            "value": "Neutral1000"
        },
        "name": "color.background.neutral.bold.[default]",
        "path": [
            "color",
            "background",
            "neutral",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.neutral.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.neutral.bold"
        },
        "value": "#3B3D42",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.neutral.bold"
            },
            "value": "Neutral900"
        },
        "name": "color.background.neutral.bold.hovered",
        "path": [
            "color",
            "background",
            "neutral",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.neutral.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.neutral.bold"
        },
        "value": "#505258",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.neutral.bold"
            },
            "value": "Neutral800"
        },
        "name": "color.background.neutral.bold.pressed",
        "path": [
            "color",
            "background",
            "neutral",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.neutral.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of an element that communicates selection, such as a selected navigation item, or the opened state of a dropdown trigger. Use color.background.selected.hovered or color.background.selected.pressed when interacting with a selected element. Selection is distinct from keyboard focus and hover alone."
        },
        "value": "#E9F2FE",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of an element that communicates selection, such as a selected navigation item, or the opened state of a dropdown trigger. Use color.background.selected.hovered or color.background.selected.pressed when interacting with a selected element. Selection is distinct from keyboard focus and hover alone."
            },
            "value": "Blue100"
        },
        "name": "color.background.selected.[default].[default]",
        "path": [
            "color",
            "background",
            "selected",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of an element that is selected and hovered. This preserves selection while showing pointer hover; do not use for an unselected element or keyboard focus alone."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of an element that is selected and hovered. This preserves selection while showing pointer hover; do not use for an unselected element or keyboard focus alone."
            },
            "value": "Blue200"
        },
        "name": "color.background.selected.[default].hovered",
        "path": [
            "color",
            "background",
            "selected",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.selected.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of an element that is selected and being pressed. Return to color.background.selected or color.background.selected.hovered when the press ends and the element remains selected. Do not use for an unselected element or keyboard focus alone."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of an element that is selected and being pressed. Return to color.background.selected or color.background.selected.hovered when the press ends and the element remains selected. Do not use for an unselected element or keyboard focus alone."
            },
            "value": "Blue300"
        },
        "name": "color.background.selected.[default].pressed",
        "path": [
            "color",
            "background",
            "selected",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.selected.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the bold background of selected controls, such as checked checkboxes and selected radio buttons. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for primary actions or keyboard focus alone."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the bold background of selected controls, such as checked checkboxes and selected radio buttons. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for primary actions or keyboard focus alone."
            },
            "value": "Blue700"
        },
        "name": "color.background.selected.bold.[default]",
        "path": [
            "color",
            "background",
            "selected",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.selected.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of a selected control that uses color.background.selected.bold while it is hovered, such as a checked checkbox. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for an unselected control or keyboard focus alone."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of a selected control that uses color.background.selected.bold while it is hovered, such as a checked checkbox. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for an unselected control or keyboard focus alone."
            },
            "value": "Blue800"
        },
        "name": "color.background.selected.bold.hovered",
        "path": [
            "color",
            "background",
            "selected",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.selected.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of a selected control that uses color.background.selected.bold while it is being pressed, such as a checked checkbox. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for an unselected control or keyboard focus alone."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of a selected control that uses color.background.selected.bold while it is being pressed, such as a checked checkbox. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for an unselected control or keyboard focus alone."
            },
            "value": "Blue900"
        },
        "name": "color.background.selected.bold.pressed",
        "path": [
            "color",
            "background",
            "selected",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.selected.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Use for the background of elements used to reinforce our brand, but with less emphasis."
        },
        "value": "#E9F2FE",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Use for the background of elements used to reinforce our brand, but with less emphasis."
            },
            "value": "Blue100"
        },
        "name": "color.background.brand.subtlest.[default]",
        "path": [
            "color",
            "background",
            "brand",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.brand.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Hovered state of color.background.brand.subtlest."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Hovered state of color.background.brand.subtlest."
            },
            "value": "Blue200"
        },
        "name": "color.background.brand.subtlest.hovered",
        "path": [
            "color",
            "background",
            "brand",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.brand.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Pressed state of color.background.brand.subtlest"
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Pressed state of color.background.brand.subtlest"
            },
            "value": "Blue250"
        },
        "name": "color.background.brand.subtlest.pressed",
        "path": [
            "color",
            "background",
            "brand",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.brand.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the background of elements used to reinforce our brand, but with more emphasis."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the background of elements used to reinforce our brand, but with more emphasis."
            },
            "value": "Blue700"
        },
        "name": "color.background.brand.bold.[default]",
        "path": [
            "color",
            "background",
            "brand",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.brand.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.brand.bold."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.brand.bold."
            },
            "value": "Blue800"
        },
        "name": "color.background.brand.bold.hovered",
        "path": [
            "color",
            "background",
            "brand",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.brand.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.brand.bold."
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.brand.bold."
            },
            "value": "Blue850"
        },
        "name": "color.background.brand.bold.pressed",
        "path": [
            "color",
            "background",
            "brand",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.brand.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Use for the background of elements used to reinforce our brand, that need to stand out a lot."
        },
        "value": "#1C2B42",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Use for the background of elements used to reinforce our brand, that need to stand out a lot."
            },
            "value": "Blue1000"
        },
        "name": "color.background.brand.boldest.[default]",
        "path": [
            "color",
            "background",
            "brand",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.background.brand.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Hovered state of color.background.brand.boldest."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Hovered state of color.background.brand.boldest."
            },
            "value": "Blue900"
        },
        "name": "color.background.brand.boldest.hovered",
        "path": [
            "color",
            "background",
            "brand",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.background.brand.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Pressed state of color.background.brand.boldest."
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Pressed state of color.background.brand.boldest."
            },
            "value": "Blue850"
        },
        "name": "color.background.brand.boldest.pressed",
        "path": [
            "color",
            "background",
            "brand",
            "boldest",
            "pressed"
        ],
        "cleanName": "color.background.brand.boldest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating critical information, such in error section messages."
        },
        "value": "#FFECEB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating critical information, such in error section messages."
            },
            "value": "Red100"
        },
        "name": "color.background.danger.[default].[default]",
        "path": [
            "color",
            "background",
            "danger",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.danger"
        },
        "value": "#FFD5D2",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.danger"
            },
            "value": "Red200"
        },
        "name": "color.background.danger.[default].hovered",
        "path": [
            "color",
            "background",
            "danger",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.danger.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.danger"
        },
        "value": "#FFB8B2",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.danger"
            },
            "value": "Red250"
        },
        "name": "color.background.danger.[default].pressed",
        "path": [
            "color",
            "background",
            "danger",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.danger.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of danger lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#FFD5D2",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of danger lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Red200"
        },
        "name": "color.background.danger.subtler.[default]",
        "path": [
            "color",
            "background",
            "danger",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.danger.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.danger.subtler"
        },
        "value": "#FFB8B2",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.danger.subtler"
            },
            "value": "Red250"
        },
        "name": "color.background.danger.subtler.hovered",
        "path": [
            "color",
            "background",
            "danger",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.danger.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.danger.subtler"
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.danger.subtler"
            },
            "value": "Red300"
        },
        "name": "color.background.danger.subtler.pressed",
        "path": [
            "color",
            "background",
            "danger",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.danger.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating critical danger information (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.danger.bold or color.background.danger.subtler for interactive states."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating critical danger information (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.danger.bold or color.background.danger.subtler for interactive states."
            },
            "value": "Red300"
        },
        "name": "color.background.danger.subtle.[default]",
        "path": [
            "color",
            "background",
            "danger",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.danger.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for communicating critical information, such as in danger buttons and error banners."
        },
        "value": "#C9372C",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for communicating critical information, such as in danger buttons and error banners."
            },
            "value": "Red700"
        },
        "name": "color.background.danger.bold.[default]",
        "path": [
            "color",
            "background",
            "danger",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.danger.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.danger.bold"
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.danger.bold"
            },
            "value": "Red800"
        },
        "name": "color.background.danger.bold.hovered",
        "path": [
            "color",
            "background",
            "danger",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.danger.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.danger.bold"
        },
        "value": "#872821",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.danger.bold"
            },
            "value": "Red850"
        },
        "name": "color.background.danger.bold.pressed",
        "path": [
            "color",
            "background",
            "danger",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.danger.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating caution, such as in warning section messages."
        },
        "value": "#FFF5DB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating caution, such as in warning section messages."
            },
            "value": "Orange100"
        },
        "name": "color.background.warning.[default].[default]",
        "path": [
            "color",
            "background",
            "warning",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.warning"
        },
        "value": "#FCE4A6",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.warning"
            },
            "value": "Orange200"
        },
        "name": "color.background.warning.[default].hovered",
        "path": [
            "color",
            "background",
            "warning",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.warning.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.warning"
        },
        "value": "#FBD779",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.warning"
            },
            "value": "Orange250"
        },
        "name": "color.background.warning.[default].pressed",
        "path": [
            "color",
            "background",
            "warning",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.warning.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of warning lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#FCE4A6",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of warning lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Orange200"
        },
        "name": "color.background.warning.subtler.[default]",
        "path": [
            "color",
            "background",
            "warning",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.warning.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.warning.subtler"
        },
        "value": "#FBD779",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.warning.subtler"
            },
            "value": "Orange250"
        },
        "name": "color.background.warning.subtler.hovered",
        "path": [
            "color",
            "background",
            "warning",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.warning.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.warning.subtler"
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.warning.subtler"
            },
            "value": "Orange300"
        },
        "name": "color.background.warning.subtler.pressed",
        "path": [
            "color",
            "background",
            "warning",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.warning.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating caution (e.g. status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.warning.bold or color.background.warning.subtler for interactive states."
        },
        "value": "#FBD779",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating caution (e.g. status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.warning.bold or color.background.warning.subtler for interactive states."
            },
            "value": "Orange250"
        },
        "name": "color.background.warning.subtle.[default]",
        "path": [
            "color",
            "background",
            "warning",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.warning.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for communicating caution, such as in warning buttons and warning banners."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for communicating caution, such as in warning buttons and warning banners."
            },
            "value": "Orange300"
        },
        "name": "color.background.warning.bold.[default]",
        "path": [
            "color",
            "background",
            "warning",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.warning.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.warning.bold"
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.warning.bold"
            },
            "value": "Orange400"
        },
        "name": "color.background.warning.bold.hovered",
        "path": [
            "color",
            "background",
            "warning",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.warning.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.warning.bold"
        },
        "value": "#F68909",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.warning.bold"
            },
            "value": "Orange500"
        },
        "name": "color.background.warning.bold.pressed",
        "path": [
            "color",
            "background",
            "warning",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.warning.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating a favorable outcome, such as in success section messages."
        },
        "value": "#EFFFD6",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating a favorable outcome, such as in success section messages."
            },
            "value": "Lime100"
        },
        "name": "color.background.success.[default].[default]",
        "path": [
            "color",
            "background",
            "success",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.success"
        },
        "value": "#D3F1A7",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.success"
            },
            "value": "Lime200"
        },
        "name": "color.background.success.[default].hovered",
        "path": [
            "color",
            "background",
            "success",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.success.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.success"
        },
        "value": "#BDE97C",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.success"
            },
            "value": "Lime250"
        },
        "name": "color.background.success.[default].pressed",
        "path": [
            "color",
            "background",
            "success",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.success.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of success lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#D3F1A7",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of success lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Lime200"
        },
        "name": "color.background.success.subtler.[default]",
        "path": [
            "color",
            "background",
            "success",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.success.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.success.subtler"
        },
        "value": "#BDE97C",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.success.subtler"
            },
            "value": "Lime250"
        },
        "name": "color.background.success.subtler.hovered",
        "path": [
            "color",
            "background",
            "success",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.success.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.success.subtler"
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.success.subtler"
            },
            "value": "Lime300"
        },
        "name": "color.background.success.subtler.pressed",
        "path": [
            "color",
            "background",
            "success",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.success.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating success (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.success.bold or color.background.success.subtler for interactive states."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating success (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.success.bold or color.background.success.subtler for interactive states."
            },
            "value": "Lime300"
        },
        "name": "color.background.success.subtle.[default]",
        "path": [
            "color",
            "background",
            "success",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.success.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for communicating a favorable outcome, such as in checked toggles."
        },
        "value": "#5B7F24",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for communicating a favorable outcome, such as in checked toggles."
            },
            "value": "Lime700"
        },
        "name": "color.background.success.bold.[default]",
        "path": [
            "color",
            "background",
            "success",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.success.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.success.bold"
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.success.bold"
            },
            "value": "Lime800"
        },
        "name": "color.background.success.bold.hovered",
        "path": [
            "color",
            "background",
            "success",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.success.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.success.bold"
        },
        "value": "#3F5224",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.success.bold"
            },
            "value": "Lime850"
        },
        "name": "color.background.success.bold.pressed",
        "path": [
            "color",
            "background",
            "success",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.success.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating change or something new, such as in discovery section messages."
        },
        "value": "#F8EEFE",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating change or something new, such as in discovery section messages."
            },
            "value": "Purple100"
        },
        "name": "color.background.discovery.[default].[default]",
        "path": [
            "color",
            "background",
            "discovery",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hover state for color.background.discovery"
        },
        "value": "#EED7FC",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hover state for color.background.discovery"
            },
            "value": "Purple200"
        },
        "name": "color.background.discovery.[default].hovered",
        "path": [
            "color",
            "background",
            "discovery",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.discovery.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.discovery"
        },
        "value": "#E3BDFA",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.discovery"
            },
            "value": "Purple250"
        },
        "name": "color.background.discovery.[default].pressed",
        "path": [
            "color",
            "background",
            "discovery",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.discovery.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of discovery lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#EED7FC",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of discovery lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Purple200"
        },
        "name": "color.background.discovery.subtler.[default]",
        "path": [
            "color",
            "background",
            "discovery",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.discovery.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.discovery.subtler"
        },
        "value": "#E3BDFA",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.discovery.subtler"
            },
            "value": "Purple250"
        },
        "name": "color.background.discovery.subtler.hovered",
        "path": [
            "color",
            "background",
            "discovery",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.discovery.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.discovery.subtler"
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.discovery.subtler"
            },
            "value": "Purple300"
        },
        "name": "color.background.discovery.subtler.pressed",
        "path": [
            "color",
            "background",
            "discovery",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.discovery.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating discovery (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.discovery.bold or color.background.discovery.subtler for interactive states."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating discovery (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.discovery.bold or color.background.discovery.subtler for interactive states."
            },
            "value": "Purple300"
        },
        "name": "color.background.discovery.subtle.[default]",
        "path": [
            "color",
            "background",
            "discovery",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.discovery.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option communicating change or something new, such as in onboarding spotlights."
        },
        "value": "#964AC0",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option communicating change or something new, such as in onboarding spotlights."
            },
            "value": "Purple700"
        },
        "name": "color.background.discovery.bold.[default]",
        "path": [
            "color",
            "background",
            "discovery",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.discovery.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.discovery.bold"
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.discovery.bold"
            },
            "value": "Purple800"
        },
        "name": "color.background.discovery.bold.hovered",
        "path": [
            "color",
            "background",
            "discovery",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.discovery.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.discovery.bold"
        },
        "value": "#673286",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.discovery.bold"
            },
            "value": "Purple850"
        },
        "name": "color.background.discovery.bold.pressed",
        "path": [
            "color",
            "background",
            "discovery",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.discovery.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating information or something in-progress, such as in information section messages."
        },
        "value": "#E9F2FE",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating information or something in-progress, such as in information section messages."
            },
            "value": "Blue100"
        },
        "name": "color.background.information.[default].[default]",
        "path": [
            "color",
            "background",
            "information",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.information"
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.information"
            },
            "value": "Blue200"
        },
        "name": "color.background.information.[default].hovered",
        "path": [
            "color",
            "background",
            "information",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.information.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.information"
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.information"
            },
            "value": "Blue250"
        },
        "name": "color.background.information.[default].pressed",
        "path": [
            "color",
            "background",
            "information",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.information.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of information lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of information lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Blue200"
        },
        "name": "color.background.information.subtler.[default]",
        "path": [
            "color",
            "background",
            "information",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.information.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.information.subtler"
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.information.subtler"
            },
            "value": "Blue250"
        },
        "name": "color.background.information.subtler.hovered",
        "path": [
            "color",
            "background",
            "information",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.information.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.information.subtler"
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.information.subtler"
            },
            "value": "Blue300"
        },
        "name": "color.background.information.subtler.pressed",
        "path": [
            "color",
            "background",
            "information",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.information.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating information (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.information.bold or color.background.information.subtler for interactive states."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating information (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.information.bold or color.background.information.subtler for interactive states."
            },
            "value": "Blue300"
        },
        "name": "color.background.information.subtle.[default]",
        "path": [
            "color",
            "background",
            "information",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.information.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for communicating information or something in-progress."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for communicating information or something in-progress."
            },
            "value": "Blue700"
        },
        "name": "color.background.information.bold.[default]",
        "path": [
            "color",
            "background",
            "information",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.information.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.information.bold"
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.information.bold"
            },
            "value": "Blue800"
        },
        "name": "color.background.information.bold.hovered",
        "path": [
            "color",
            "background",
            "information",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.information.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.information.bold"
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.information.bold"
            },
            "value": "Blue850"
        },
        "name": "color.background.information.bold.pressed",
        "path": [
            "color",
            "background",
            "information",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.information.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use to visually group or separate UI elements, such as flat cards or side panel dividers."
        },
        "value": "#0B120E24",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use to visually group or separate UI elements, such as flat cards or side panel dividers."
            },
            "value": "Neutral300A"
        },
        "name": "color.border.[default]",
        "path": [
            "color",
            "border",
            "[default]"
        ],
        "cleanName": "color.border"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for lime borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#6A9A23",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for lime borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Lime600"
        },
        "name": "color.border.accent.lime.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "lime",
            "[default]"
        ],
        "cleanName": "color.border.accent.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative lime borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative lime borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Lime300"
        },
        "name": "color.border.accent.lime.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "lime",
            "subtle"
        ],
        "cleanName": "color.border.accent.lime.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for red borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#E2483D",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for red borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Red600"
        },
        "name": "color.border.accent.red.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "red",
            "[default]"
        ],
        "cleanName": "color.border.accent.red"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative red borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative red borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Red300"
        },
        "name": "color.border.accent.red.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "red",
            "subtle"
        ],
        "cleanName": "color.border.accent.red.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for orange borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#E06C00",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for orange borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Orange600"
        },
        "name": "color.border.accent.orange.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "orange",
            "[default]"
        ],
        "cleanName": "color.border.accent.orange"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative orange borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative orange borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Orange300"
        },
        "name": "color.border.accent.orange.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "orange",
            "subtle"
        ],
        "cleanName": "color.border.accent.orange.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for yellow borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#B38600",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for yellow borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Yellow600"
        },
        "name": "color.border.accent.yellow.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "yellow",
            "[default]"
        ],
        "cleanName": "color.border.accent.yellow"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative yellow borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#EED12B",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative yellow borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Yellow300"
        },
        "name": "color.border.accent.yellow.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "yellow",
            "subtle"
        ],
        "cleanName": "color.border.accent.yellow.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for green borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#22A06B",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for green borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Green600"
        },
        "name": "color.border.accent.green.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "green",
            "[default]"
        ],
        "cleanName": "color.border.accent.green"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative green borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#7EE2B8",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative green borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Green300"
        },
        "name": "color.border.accent.green.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "green",
            "subtle"
        ],
        "cleanName": "color.border.accent.green.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for teal borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#2898BD",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for teal borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Teal600"
        },
        "name": "color.border.accent.teal.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "teal",
            "[default]"
        ],
        "cleanName": "color.border.accent.teal"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative teal borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#9DD9EE",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative teal borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Teal300"
        },
        "name": "color.border.accent.teal.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "teal",
            "subtle"
        ],
        "cleanName": "color.border.accent.teal.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for blue borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for blue borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Blue600"
        },
        "name": "color.border.accent.blue.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "blue",
            "[default]"
        ],
        "cleanName": "color.border.accent.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative blue borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative blue borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Blue300"
        },
        "name": "color.border.accent.blue.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "blue",
            "subtle"
        ],
        "cleanName": "color.border.accent.blue.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for purple borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for purple borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Purple600"
        },
        "name": "color.border.accent.purple.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "purple",
            "[default]"
        ],
        "cleanName": "color.border.accent.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative purple borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative purple borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Purple300"
        },
        "name": "color.border.accent.purple.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "purple",
            "subtle"
        ],
        "cleanName": "color.border.accent.purple.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for magenta borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#CD519D",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for magenta borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Magenta600"
        },
        "name": "color.border.accent.magenta.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "magenta",
            "[default]"
        ],
        "cleanName": "color.border.accent.magenta"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative magenta borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#F797D2",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative magenta borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Magenta300"
        },
        "name": "color.border.accent.magenta.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "magenta",
            "subtle"
        ],
        "cleanName": "color.border.accent.magenta.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.5",
            "description": "Use for borders on non-bold gray accent backgrounds."
        },
        "value": "#7D818A",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.5",
                "description": "Use for borders on non-bold gray accent backgrounds."
            },
            "value": "Neutral600"
        },
        "name": "color.border.accent.gray.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "gray",
            "[default]"
        ],
        "cleanName": "color.border.accent.gray"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative gray borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#B7B9BE",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative gray borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Neutral400"
        },
        "name": "color.border.accent.gray.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "gray",
            "subtle"
        ],
        "cleanName": "color.border.accent.gray.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for code block and code diff borders."
        },
        "value": "#0B120E24",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for code block and code diff borders."
            },
            "value": "Neutral300A"
        },
        "name": "color.border.code",
        "path": [
            "color",
            "border",
            "code"
        ],
        "cleanName": "color.border.code"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders of elements in a disabled state."
        },
        "value": "#0515240F",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders of elements in a disabled state."
            },
            "value": "Neutral200A"
        },
        "name": "color.border.disabled",
        "path": [
            "color",
            "border",
            "disabled"
        ],
        "cleanName": "color.border.disabled"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the focus ring or border of an element that currently has keyboard or input focus. Do not use to indicate selection or hover alone. When an element is both selected and focused, keep its selected treatment and add a separate focus indicator."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the focus ring or border of an element that currently has keyboard or input focus. Do not use to indicate selection or hover alone. When an element is both selected and focused, keep its selected treatment and add a separate focus indicator."
            },
            "value": "Blue500"
        },
        "name": "color.border.focused",
        "path": [
            "color",
            "border",
            "focused"
        ],
        "cleanName": "color.border.focused"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders of form UI elements, such as text fields, checkboxes, and radio buttons."
        },
        "value": "#8C8F97",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders of form UI elements, such as text fields, checkboxes, and radio buttons."
            },
            "value": "Neutral500"
        },
        "name": "color.border.input.[default]",
        "path": [
            "color",
            "border",
            "input",
            "[default]"
        ],
        "cleanName": "color.border.input"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.12.0",
            "description": "Use for the border of search inputs."
        },
        "value": "#0B120E24",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.12.0",
                "description": "Use for the border of search inputs."
            },
            "value": "Neutral300A"
        },
        "name": "color.border.input.search",
        "path": [
            "color",
            "border",
            "input",
            "search"
        ],
        "cleanName": "color.border.input.search"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders on bold backgrounds."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders on bold backgrounds."
            },
            "value": "Neutral0"
        },
        "name": "color.border.inverse",
        "path": [
            "color",
            "border",
            "inverse"
        ],
        "cleanName": "color.border.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for borders or visual indicators that communicate selection, such as the active tab or a selected menu item, or the opened state of a dropdown trigger. Do not use as a keyboard focus indicator; use color.border.focused for focus and preserve the selected treatment when both states apply."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for borders or visual indicators that communicate selection, such as the active tab or a selected menu item, or the opened state of a dropdown trigger. Do not use as a keyboard focus indicator; use color.border.focused for focus and preserve the selected treatment when both states apply."
            },
            "value": "Blue700"
        },
        "name": "color.border.selected",
        "path": [
            "color",
            "border",
            "selected"
        ],
        "cleanName": "color.border.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders or visual indicators of elements that reinforce our brand, such as logos or primary buttons."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders or visual indicators of elements that reinforce our brand, such as logos or primary buttons."
            },
            "value": "Blue700"
        },
        "name": "color.border.brand",
        "path": [
            "color",
            "border",
            "brand"
        ],
        "cleanName": "color.border.brand"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating critical information, such as the borders on invalid text fields."
        },
        "value": "#E2483D",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating critical information, such as the borders on invalid text fields."
            },
            "value": "Red600"
        },
        "name": "color.border.danger.[default]",
        "path": [
            "color",
            "border",
            "danger",
            "[default]"
        ],
        "cleanName": "color.border.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative danger borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative danger borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Red300"
        },
        "name": "color.border.danger.subtle",
        "path": [
            "color",
            "border",
            "danger",
            "subtle"
        ],
        "cleanName": "color.border.danger.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating caution."
        },
        "value": "#E06C00",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating caution."
            },
            "value": "Orange600"
        },
        "name": "color.border.warning.[default]",
        "path": [
            "color",
            "border",
            "warning",
            "[default]"
        ],
        "cleanName": "color.border.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative warning borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative warning borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Orange300"
        },
        "name": "color.border.warning.subtle",
        "path": [
            "color",
            "border",
            "warning",
            "subtle"
        ],
        "cleanName": "color.border.warning.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating a favorable outcome, such as the borders on validated text fields."
        },
        "value": "#6A9A23",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating a favorable outcome, such as the borders on validated text fields."
            },
            "value": "Lime600"
        },
        "name": "color.border.success.[default]",
        "path": [
            "color",
            "border",
            "success",
            "[default]"
        ],
        "cleanName": "color.border.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative success borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative success borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Lime300"
        },
        "name": "color.border.success.subtle",
        "path": [
            "color",
            "border",
            "success",
            "subtle"
        ],
        "cleanName": "color.border.success.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating change or something new, such as the borders in onboarding spotlights."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating change or something new, such as the borders in onboarding spotlights."
            },
            "value": "Purple600"
        },
        "name": "color.border.discovery.[default]",
        "path": [
            "color",
            "border",
            "discovery",
            "[default]"
        ],
        "cleanName": "color.border.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative discovery borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative discovery borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Purple300"
        },
        "name": "color.border.discovery.subtle",
        "path": [
            "color",
            "border",
            "discovery",
            "subtle"
        ],
        "cleanName": "color.border.discovery.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating information or something in-progress."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating information or something in-progress."
            },
            "value": "Blue600"
        },
        "name": "color.border.information.[default]",
        "path": [
            "color",
            "border",
            "information",
            "[default]"
        ],
        "cleanName": "color.border.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative information borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative information borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Blue300"
        },
        "name": "color.border.information.subtle",
        "path": [
            "color",
            "border",
            "information",
            "subtle"
        ],
        "cleanName": "color.border.information.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.8",
            "description": "A neutral border option that passes min 3:1 contrast ratios."
        },
        "value": "#7D818A",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.8",
                "description": "A neutral border option that passes min 3:1 contrast ratios."
            },
            "value": "Neutral600"
        },
        "name": "color.border.bold",
        "path": [
            "color",
            "border",
            "bold"
        ],
        "cleanName": "color.border.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for primary text, such as body copy, sentence case headers, and buttons."
        },
        "value": "#292A2E",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for primary text, such as body copy, sentence case headers, and buttons."
            },
            "value": "Neutral1000"
        },
        "name": "color.text.[default]",
        "path": [
            "color",
            "text",
            "[default]"
        ],
        "cleanName": "color.text"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Use for lime text on subtlest and subtler lime accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Use for lime text on subtlest and subtler lime accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Lime800"
        },
        "name": "color.text.accent.lime.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "lime",
            "[default]"
        ],
        "cleanName": "color.text.accent.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Use for lime text on subtle lime accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#37471F",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Use for lime text on subtle lime accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Lime900"
        },
        "name": "color.text.accent.lime.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "lime",
            "bolder"
        ],
        "cleanName": "color.text.accent.lime.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for red text on subtlest and subtler red accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for red text on subtlest and subtler red accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Red800"
        },
        "name": "color.text.accent.red.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "red",
            "[default]"
        ],
        "cleanName": "color.text.accent.red"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for red text on subtle red accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#5D1F1A",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for red text on subtle red accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Red900"
        },
        "name": "color.text.accent.red.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "red",
            "bolder"
        ],
        "cleanName": "color.text.accent.red.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for orange text on subtlest and subtler orange accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for orange text on subtlest and subtler orange accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Orange800"
        },
        "name": "color.text.accent.orange.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "orange",
            "[default]"
        ],
        "cleanName": "color.text.accent.orange"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for orange text on subtle orange accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#693200",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for orange text on subtle orange accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Orange900"
        },
        "name": "color.text.accent.orange.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "orange",
            "bolder"
        ],
        "cleanName": "color.text.accent.orange.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for yellow text on subtlest and subtler yellow accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#7F5F01",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for yellow text on subtlest and subtler yellow accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Yellow800"
        },
        "name": "color.text.accent.yellow.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "yellow",
            "[default]"
        ],
        "cleanName": "color.text.accent.yellow"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for yellow text on subtle yellow accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#533F04",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for yellow text on subtle yellow accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Yellow900"
        },
        "name": "color.text.accent.yellow.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "yellow",
            "bolder"
        ],
        "cleanName": "color.text.accent.yellow.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for green text on subtlest and subtler green accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#216E4E",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for green text on subtlest and subtler green accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Green800"
        },
        "name": "color.text.accent.green.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "green",
            "[default]"
        ],
        "cleanName": "color.text.accent.green"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for green text on subtle green accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#164B35",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for green text on subtle green accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Green900"
        },
        "name": "color.text.accent.green.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "green",
            "bolder"
        ],
        "cleanName": "color.text.accent.green.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for teal text on subtlest and subtler teal accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#206A83",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for teal text on subtlest and subtler teal accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Teal800"
        },
        "name": "color.text.accent.teal.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "teal",
            "[default]"
        ],
        "cleanName": "color.text.accent.teal"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for teal text on subtle teal accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#164555",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for teal text on subtle teal accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Teal900"
        },
        "name": "color.text.accent.teal.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "teal",
            "bolder"
        ],
        "cleanName": "color.text.accent.teal.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for blue text on subtlest and subtler blue accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for blue text on subtlest and subtler blue accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Blue800"
        },
        "name": "color.text.accent.blue.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "blue",
            "[default]"
        ],
        "cleanName": "color.text.accent.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for blue text on subtle blue accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for blue text on subtle blue accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Blue900"
        },
        "name": "color.text.accent.blue.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "blue",
            "bolder"
        ],
        "cleanName": "color.text.accent.blue.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for purple text on subtlest and subtler purple accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for purple text on subtlest and subtler purple accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Purple800"
        },
        "name": "color.text.accent.purple.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "purple",
            "[default]"
        ],
        "cleanName": "color.text.accent.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for purple text on subtle purple accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#48245D",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for purple text on subtle purple accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Purple900"
        },
        "name": "color.text.accent.purple.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "purple",
            "bolder"
        ],
        "cleanName": "color.text.accent.purple.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for magenta text on subtlest and subtler magenta accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#943D73",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for magenta text on subtlest and subtler magenta accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Magenta800"
        },
        "name": "color.text.accent.magenta.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "magenta",
            "[default]"
        ],
        "cleanName": "color.text.accent.magenta"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for magenta text on subtle magenta accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#50253F",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for magenta text on subtle magenta accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Magenta900"
        },
        "name": "color.text.accent.magenta.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "magenta",
            "bolder"
        ],
        "cleanName": "color.text.accent.magenta.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.5",
            "description": "Use for text on non-bold gray accent backgrounds, such as colored tags."
        },
        "value": "#505258",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.5",
                "description": "Use for text on non-bold gray accent backgrounds, such as colored tags."
            },
            "value": "Neutral800"
        },
        "name": "color.text.accent.gray.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "gray",
            "[default]"
        ],
        "cleanName": "color.text.accent.gray"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.5",
            "description": "Use for text and icons on gray subtle accent backgrounds."
        },
        "value": "#1E1F21",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.5",
                "description": "Use for text and icons on gray subtle accent backgrounds."
            },
            "value": "Neutral1100"
        },
        "name": "color.text.accent.gray.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "gray",
            "bolder"
        ],
        "cleanName": "color.text.accent.gray.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for an additional syntax-highlighting text color."
        },
        "value": "#943D73",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for an additional syntax-highlighting text color."
            },
            "value": "Magenta800"
        },
        "name": "color.text.code.accent.1",
        "path": [
            "color",
            "text",
            "code",
            "accent",
            "1"
        ],
        "cleanName": "color.text.code.accent.1"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for an additional syntax-highlighting text color."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for an additional syntax-highlighting text color."
            },
            "value": "Blue800"
        },
        "name": "color.text.code.accent.2",
        "path": [
            "color",
            "text",
            "code",
            "accent",
            "2"
        ],
        "cleanName": "color.text.code.accent.2"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for comments in syntax-highlighted code."
        },
        "value": "#505258",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for comments in syntax-highlighted code."
            },
            "value": "Neutral800"
        },
        "name": "color.text.code.comments",
        "path": [
            "color",
            "text",
            "code",
            "comments"
        ],
        "cleanName": "color.text.code.comments"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for default text in code blocks and code diffs."
        },
        "value": "#505258",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for default text in code blocks and code diffs."
            },
            "value": "Neutral800"
        },
        "name": "color.text.code.default",
        "path": [
            "color",
            "text",
            "code",
            "default"
        ],
        "cleanName": "color.text.code.default"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for functions in syntax-highlighted code."
        },
        "value": "#216E4E",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for functions in syntax-highlighted code."
            },
            "value": "Green800"
        },
        "name": "color.text.code.functions",
        "path": [
            "color",
            "text",
            "code",
            "functions"
        ],
        "cleanName": "color.text.code.functions"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for line numbers and other code gutter text."
        },
        "value": "#6B6E76",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for line numbers and other code gutter text."
            },
            "value": "Neutral700"
        },
        "name": "color.text.code.gutter",
        "path": [
            "color",
            "text",
            "code",
            "gutter"
        ],
        "cleanName": "color.text.code.gutter"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for language keywords in syntax-highlighted code."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for language keywords in syntax-highlighted code."
            },
            "value": "Red800"
        },
        "name": "color.text.code.keywords",
        "path": [
            "color",
            "text",
            "code",
            "keywords"
        ],
        "cleanName": "color.text.code.keywords"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for numeric values in syntax-highlighted code."
        },
        "value": "#7F5F01",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for numeric values in syntax-highlighted code."
            },
            "value": "Yellow800"
        },
        "name": "color.text.code.numbers",
        "path": [
            "color",
            "text",
            "code",
            "numbers"
        ],
        "cleanName": "color.text.code.numbers"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for operators and punctuation in syntax-highlighted code."
        },
        "value": "#292A2E",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for operators and punctuation in syntax-highlighted code."
            },
            "value": "Neutral1000"
        },
        "name": "color.text.code.operators",
        "path": [
            "color",
            "text",
            "code",
            "operators"
        ],
        "cleanName": "color.text.code.operators"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for string values in syntax-highlighted code."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for string values in syntax-highlighted code."
            },
            "value": "Lime800"
        },
        "name": "color.text.code.strings",
        "path": [
            "color",
            "text",
            "code",
            "strings"
        ],
        "cleanName": "color.text.code.strings"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for tags in syntax-highlighted code."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for tags in syntax-highlighted code."
            },
            "value": "Orange800"
        },
        "name": "color.text.code.tags",
        "path": [
            "color",
            "text",
            "code",
            "tags"
        ],
        "cleanName": "color.text.code.tags"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for text in a disabled state."
        },
        "value": "#080F214A",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for text in a disabled state."
            },
            "value": "Neutral400A"
        },
        "name": "color.text.disabled",
        "path": [
            "color",
            "text",
            "disabled"
        ],
        "cleanName": "color.text.disabled"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for text on bold backgrounds."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for text on bold backgrounds."
            },
            "value": "Neutral0"
        },
        "name": "color.text.inverse",
        "path": [
            "color",
            "text",
            "inverse"
        ],
        "cleanName": "color.text.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for text that communicates selection, such as the active tab or a selected navigation item, or the opened state of a dropdown trigger. On bold selected backgrounds, use color.text.inverse instead. Do not use for unselected links, brand emphasis, or hover alone. Keep the selected text treatment when the element also has focus."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for text that communicates selection, such as the active tab or a selected navigation item, or the opened state of a dropdown trigger. On bold selected backgrounds, use color.text.inverse instead. Do not use for unselected links, brand emphasis, or hover alone. Keep the selected text treatment when the element also has focus."
            },
            "value": "Blue700"
        },
        "name": "color.text.selected",
        "path": [
            "color",
            "text",
            "selected"
        ],
        "cleanName": "color.text.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for text that reinforces our brand."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for text that reinforces our brand."
            },
            "value": "Blue700"
        },
        "name": "color.text.brand",
        "path": [
            "color",
            "text",
            "brand"
        ],
        "cleanName": "color.text.brand"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for critical text, such as input field error messaging."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for critical text, such as input field error messaging."
            },
            "value": "Red800"
        },
        "name": "color.text.danger.[default]",
        "path": [
            "color",
            "text",
            "danger",
            "[default]"
        ],
        "cleanName": "color.text.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of danger semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#5D1F1A",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of danger semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Red900"
        },
        "name": "color.text.danger.bolder",
        "path": [
            "color",
            "text",
            "danger",
            "bolder"
        ],
        "cleanName": "color.text.danger.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for text to emphasize caution, such as in moved lozenges."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for text to emphasize caution, such as in moved lozenges."
            },
            "value": "Orange800"
        },
        "name": "color.text.warning.[default]",
        "path": [
            "color",
            "text",
            "warning",
            "[default]"
        ],
        "cleanName": "color.text.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for text when on bold warning backgrounds."
        },
        "value": "#292A2E",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for text when on bold warning backgrounds."
            },
            "value": "Neutral1000"
        },
        "name": "color.text.warning.inverse",
        "path": [
            "color",
            "text",
            "warning",
            "inverse"
        ],
        "cleanName": "color.text.warning.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of warning semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#693200",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of warning semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Orange900"
        },
        "name": "color.text.warning.bolder",
        "path": [
            "color",
            "text",
            "warning",
            "bolder"
        ],
        "cleanName": "color.text.warning.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for text to communicate a favorable outcome, such as input field success messaging."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for text to communicate a favorable outcome, such as input field success messaging."
            },
            "value": "Lime800"
        },
        "name": "color.text.success.[default]",
        "path": [
            "color",
            "text",
            "success",
            "[default]"
        ],
        "cleanName": "color.text.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of success semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#37471F",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of success semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Lime900"
        },
        "name": "color.text.success.bolder",
        "path": [
            "color",
            "text",
            "success",
            "bolder"
        ],
        "cleanName": "color.text.success.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for text to emphasize change or something new, such as in new lozenges."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for text to emphasize change or something new, such as in new lozenges."
            },
            "value": "Purple800"
        },
        "name": "color.text.discovery.[default]",
        "path": [
            "color",
            "text",
            "discovery",
            "[default]"
        ],
        "cleanName": "color.text.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of discovery semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#48245D",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of discovery semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Purple900"
        },
        "name": "color.text.discovery.bolder",
        "path": [
            "color",
            "text",
            "discovery",
            "bolder"
        ],
        "cleanName": "color.text.discovery.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for informative text or to communicate something is in progress, such as in-progress lozenges."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for informative text or to communicate something is in progress, such as in-progress lozenges."
            },
            "value": "Blue800"
        },
        "name": "color.text.information.[default]",
        "path": [
            "color",
            "text",
            "information",
            "[default]"
        ],
        "cleanName": "color.text.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of information semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of information semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Blue900"
        },
        "name": "color.text.information.bolder",
        "path": [
            "color",
            "text",
            "information",
            "bolder"
        ],
        "cleanName": "color.text.information.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for tertiary text, such as meta-data, breadcrumbs, input field placeholder and helper text."
        },
        "value": "#6B6E76",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for tertiary text, such as meta-data, breadcrumbs, input field placeholder and helper text."
            },
            "value": "Neutral700"
        },
        "name": "color.text.subtlest",
        "path": [
            "color",
            "text",
            "subtlest"
        ],
        "cleanName": "color.text.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for secondary text, such as navigation, subtle button links, input field labels, and all caps subheadings."
        },
        "value": "#505258",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for secondary text, such as navigation, subtle button links, input field labels, and all caps subheadings."
            },
            "value": "Neutral800"
        },
        "name": "color.text.subtle",
        "path": [
            "color",
            "text",
            "subtle"
        ],
        "cleanName": "color.text.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icon-only buttons, or icons paired with color.text"
        },
        "value": "#292A2E",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icon-only buttons, or icons paired with color.text"
            },
            "value": "Neutral1000"
        },
        "name": "color.icon.[default]",
        "path": [
            "color",
            "icon",
            "[default]"
        ],
        "cleanName": "color.icon"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for lime icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#6A9A23",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for lime icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Lime600"
        },
        "name": "color.icon.accent.lime",
        "path": [
            "color",
            "icon",
            "accent",
            "lime"
        ],
        "cleanName": "color.icon.accent.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for red icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#C9372C",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for red icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Red700"
        },
        "name": "color.icon.accent.red",
        "path": [
            "color",
            "icon",
            "accent",
            "red"
        ],
        "cleanName": "color.icon.accent.red"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for orange icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#E06C00",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for orange icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Orange600"
        },
        "name": "color.icon.accent.orange",
        "path": [
            "color",
            "icon",
            "accent",
            "orange"
        ],
        "cleanName": "color.icon.accent.orange"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for yellow icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#B38600",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for yellow icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Yellow600"
        },
        "name": "color.icon.accent.yellow",
        "path": [
            "color",
            "icon",
            "accent",
            "yellow"
        ],
        "cleanName": "color.icon.accent.yellow"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for green icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#22A06B",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for green icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Green600"
        },
        "name": "color.icon.accent.green",
        "path": [
            "color",
            "icon",
            "accent",
            "green"
        ],
        "cleanName": "color.icon.accent.green"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for teal icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#2898BD",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for teal icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Teal600"
        },
        "name": "color.icon.accent.teal",
        "path": [
            "color",
            "icon",
            "accent",
            "teal"
        ],
        "cleanName": "color.icon.accent.teal"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for blue icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for blue icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Blue600"
        },
        "name": "color.icon.accent.blue",
        "path": [
            "color",
            "icon",
            "accent",
            "blue"
        ],
        "cleanName": "color.icon.accent.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for purple icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for purple icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Purple600"
        },
        "name": "color.icon.accent.purple",
        "path": [
            "color",
            "icon",
            "accent",
            "purple"
        ],
        "cleanName": "color.icon.accent.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for magenta icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#CD519D",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for magenta icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Magenta600"
        },
        "name": "color.icon.accent.magenta",
        "path": [
            "color",
            "icon",
            "accent",
            "magenta"
        ],
        "cleanName": "color.icon.accent.magenta"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.5",
            "description": "Use for icons on non-bold gray accent backgrounds, such as file type icons."
        },
        "value": "#7D818A",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.5",
                "description": "Use for icons on non-bold gray accent backgrounds, such as file type icons."
            },
            "value": "Neutral600"
        },
        "name": "color.icon.accent.gray",
        "path": [
            "color",
            "icon",
            "accent",
            "gray"
        ],
        "cleanName": "color.icon.accent.gray"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons in a disabled state."
        },
        "value": "#080F214A",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons in a disabled state."
            },
            "value": "Neutral400A"
        },
        "name": "color.icon.disabled",
        "path": [
            "color",
            "icon",
            "disabled"
        ],
        "cleanName": "color.icon.disabled"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons on bold backgrounds."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons on bold backgrounds."
            },
            "value": "Neutral0"
        },
        "name": "color.icon.inverse",
        "path": [
            "color",
            "icon",
            "inverse"
        ],
        "cleanName": "color.icon.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for icons that communicate selection, such as icons in selected navigation items, or the opened state of a dropdown trigger. On bold selected backgrounds, use color.icon.inverse instead. Do not use for brand emphasis or hover alone. Keep the selected icon treatment when the element also has focus."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for icons that communicate selection, such as icons in selected navigation items, or the opened state of a dropdown trigger. On bold selected backgrounds, use color.icon.inverse instead. Do not use for brand emphasis or hover alone. Keep the selected icon treatment when the element also has focus."
            },
            "value": "Blue700"
        },
        "name": "color.icon.selected",
        "path": [
            "color",
            "icon",
            "selected"
        ],
        "cleanName": "color.icon.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons that reinforce our brand."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons that reinforce our brand."
            },
            "value": "Blue700"
        },
        "name": "color.icon.brand",
        "path": [
            "color",
            "icon",
            "brand"
        ],
        "cleanName": "color.icon.brand"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating critical information, such as those used in error handing."
        },
        "value": "#C9372C",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating critical information, such as those used in error handing."
            },
            "value": "Red700"
        },
        "name": "color.icon.danger",
        "path": [
            "color",
            "icon",
            "danger"
        ],
        "cleanName": "color.icon.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating caution, such as those used in warning section messages."
        },
        "value": "#E06C00",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating caution, such as those used in warning section messages."
            },
            "value": "Orange600"
        },
        "name": "color.icon.warning.[default]",
        "path": [
            "color",
            "icon",
            "warning",
            "[default]"
        ],
        "cleanName": "color.icon.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons when on bold warning backgrounds."
        },
        "value": "#292A2E",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons when on bold warning backgrounds."
            },
            "value": "Neutral1000"
        },
        "name": "color.icon.warning.inverse",
        "path": [
            "color",
            "icon",
            "warning",
            "inverse"
        ],
        "cleanName": "color.icon.warning.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating a favorable outcome, such as those used in success section messaged."
        },
        "value": "#6A9A23",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating a favorable outcome, such as those used in success section messaged."
            },
            "value": "Lime600"
        },
        "name": "color.icon.success",
        "path": [
            "color",
            "icon",
            "success"
        ],
        "cleanName": "color.icon.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating change or something new, such as discovery section messages."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating change or something new, such as discovery section messages."
            },
            "value": "Purple600"
        },
        "name": "color.icon.discovery",
        "path": [
            "color",
            "icon",
            "discovery"
        ],
        "cleanName": "color.icon.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating information or something in-progress, such as information section messages."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating information or something in-progress, such as information section messages."
            },
            "value": "Blue600"
        },
        "name": "color.icon.information",
        "path": [
            "color",
            "icon",
            "information"
        ],
        "cleanName": "color.icon.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.54.0",
            "description": "Use for icons paired with color.text.subtlest"
        },
        "value": "#6B6E76",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.54.0",
                "description": "Use for icons paired with color.text.subtlest"
            },
            "value": "Neutral700"
        },
        "name": "color.icon.subtlest",
        "path": [
            "color",
            "icon",
            "subtlest"
        ],
        "cleanName": "color.icon.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons paired with color.text.subtle"
        },
        "value": "#505258",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons paired with color.text.subtle"
            },
            "value": "Neutral800"
        },
        "name": "color.icon.subtle",
        "path": [
            "color",
            "icon",
            "subtle"
        ],
        "cleanName": "color.icon.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for links in a default or hovered state. Add an underline for hovered states."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for links in a default or hovered state. Add an underline for hovered states."
            },
            "value": "Blue700"
        },
        "name": "color.link.[default]",
        "path": [
            "color",
            "link",
            "[default]"
        ],
        "cleanName": "color.link"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for links in a pressed state."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for links in a pressed state."
            },
            "value": "Blue800"
        },
        "name": "color.link.pressed",
        "path": [
            "color",
            "link",
            "pressed"
        ],
        "cleanName": "color.link.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.23.0",
            "description": "Use for visited links."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.23.0",
                "description": "Use for visited links."
            },
            "value": "Purple800"
        },
        "name": "color.link.visited.[default]",
        "path": [
            "color",
            "link",
            "visited",
            "[default]"
        ],
        "cleanName": "color.link.visited"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.43.0",
            "description": "Use for visited links in a pressed state."
        },
        "value": "#48245D",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.43.0",
                "description": "Use for visited links in a pressed state."
            },
            "value": "Purple900"
        },
        "name": "color.link.visited.pressed",
        "path": [
            "color",
            "link",
            "visited",
            "pressed"
        ],
        "cleanName": "color.link.visited.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as a background overlay for elements in a hovered state when their background color cannot change, such as avatars."
        },
        "value": "#00000029",
        "filePath": "schema/themes/atlassian-light/color/interaction.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as a background overlay for elements in a hovered state when their background color cannot change, such as avatars."
            },
            "value": "#00000029"
        },
        "name": "color.interaction.hovered",
        "path": [
            "color",
            "interaction",
            "hovered"
        ],
        "cleanName": "color.interaction.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as a background overlay for elements in a pressed state when their background color cannot change, such as avatars."
        },
        "value": "#00000052",
        "filePath": "schema/themes/atlassian-light/color/interaction.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as a background overlay for elements in a pressed state when their background color cannot change, such as avatars."
            },
            "value": "#00000052"
        },
        "name": "color.interaction.pressed",
        "path": [
            "color",
            "interaction",
            "pressed"
        ],
        "cleanName": "color.interaction.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.0",
            "description": "Use for skeleton loading states"
        },
        "value": "#0515240F",
        "filePath": "schema/themes/atlassian-light/color/skeleton.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.0",
                "description": "Use for skeleton loading states"
            },
            "value": "Neutral200A"
        },
        "name": "color.skeleton.[default]",
        "path": [
            "color",
            "skeleton",
            "[default]"
        ],
        "cleanName": "color.skeleton"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.0",
            "description": "Use for the pulse or shimmer effect in skeleton loading states"
        },
        "value": "#17171708",
        "filePath": "schema/themes/atlassian-light/color/skeleton.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.0",
                "description": "Use for the pulse or shimmer effect in skeleton loading states"
            },
            "value": "Neutral100A"
        },
        "name": "color.skeleton.subtle",
        "path": [
            "color",
            "skeleton",
            "subtle"
        ],
        "cleanName": "color.skeleton.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for the screen overlay that appears with modal dialogs"
        },
        "value": "#050C1F75",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for the screen overlay that appears with modal dialogs"
            },
            "value": "Neutral500A"
        },
        "name": "color.blanket.[default]",
        "path": [
            "color",
            "blanket",
            "[default]"
        ],
        "cleanName": "color.blanket"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as a translucent blanket to communicate selection when changing the background of the selected content is not possible, such as selected Editor blocks. The content beneath remains visible. Do not use to indicate keyboard focus or hover alone."
        },
        "value": "#388BFF14",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as a translucent blanket to communicate selection when changing the background of the selected content is not possible, such as selected Editor blocks. The content beneath remains visible. Do not use to indicate keyboard focus or hover alone."
            },
            "value": "#388BFF14"
        },
        "name": "color.blanket.selected",
        "path": [
            "color",
            "blanket",
            "selected"
        ],
        "cleanName": "color.blanket.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as an overlay to communicate danger states when a simple background color change isn't possible, such as deletion of Editor block elements"
        },
        "value": "#EF5C4814",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as an overlay to communicate danger states when a simple background color change isn't possible, such as deletion of Editor block elements"
            },
            "value": "#EF5C4814"
        },
        "name": "color.blanket.danger",
        "path": [
            "color",
            "blanket",
            "danger"
        ],
        "cleanName": "color.blanket.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Blue600"
        },
        "name": "color.chart.categorical.1.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "1",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.1"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.1."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.1."
            },
            "value": "Blue700"
        },
        "name": "color.chart.categorical.1.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "1",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.1.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Lime500"
        },
        "name": "color.chart.categorical.2.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "2",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.2"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.2."
        },
        "value": "#6A9A23",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.2."
            },
            "value": "Lime600"
        },
        "name": "color.chart.categorical.2.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "2",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.2.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Purple500"
        },
        "name": "color.chart.categorical.3.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "3",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.3"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.3."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.3."
            },
            "value": "Purple600"
        },
        "name": "color.chart.categorical.3.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "3",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.3.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#F68909",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Orange500"
        },
        "name": "color.chart.categorical.4.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "4",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.4"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.4."
        },
        "value": "#E06C00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.4."
            },
            "value": "Orange600"
        },
        "name": "color.chart.categorical.4.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "4",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.4.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Blue800"
        },
        "name": "color.chart.categorical.5.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "5",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.5"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.5."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.5."
            },
            "value": "Blue900"
        },
        "name": "color.chart.categorical.5.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "5",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.5.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#964AC0",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Purple700"
        },
        "name": "color.chart.categorical.6.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "6",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.6"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.6."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.6."
            },
            "value": "Purple800"
        },
        "name": "color.chart.categorical.6.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "6",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.6.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#42B2D7",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Teal500"
        },
        "name": "color.chart.categorical.7.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "7",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.7"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.7."
        },
        "value": "#2898BD",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.7."
            },
            "value": "Teal600"
        },
        "name": "color.chart.categorical.7.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "7",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.7.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#BD5B00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Orange700"
        },
        "name": "color.chart.categorical.8.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "8",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.8"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.8."
        },
        "value": "#7A3B00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.8."
            },
            "value": "Orange850"
        },
        "name": "color.chart.categorical.8.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "8",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.8.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "For data visualisation only."
        },
        "value": "#6A9A23",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "For data visualisation only."
            },
            "value": "Lime600"
        },
        "name": "color.chart.lime.bold.[default]",
        "path": [
            "color",
            "chart",
            "lime",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.lime.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Hovered state of color.chart.lime.bold."
        },
        "value": "#5B7F24",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Hovered state of color.chart.lime.bold."
            },
            "value": "Lime700"
        },
        "name": "color.chart.lime.bold.hovered",
        "path": [
            "color",
            "chart",
            "lime",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.lime.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "For data visualisation only."
        },
        "value": "#5B7F24",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "For data visualisation only."
            },
            "value": "Lime700"
        },
        "name": "color.chart.lime.bolder.[default]",
        "path": [
            "color",
            "chart",
            "lime",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.lime.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Hovered state of color.chart.lime.bolder."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Hovered state of color.chart.lime.bolder."
            },
            "value": "Lime800"
        },
        "name": "color.chart.lime.bolder.hovered",
        "path": [
            "color",
            "chart",
            "lime",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.lime.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "For data visualisation only."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "For data visualisation only."
            },
            "value": "Lime800"
        },
        "name": "color.chart.lime.boldest.[default]",
        "path": [
            "color",
            "chart",
            "lime",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.lime.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Hovered state of color.chart.lime.boldest."
        },
        "value": "#37471F",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Hovered state of color.chart.lime.boldest."
            },
            "value": "Lime900"
        },
        "name": "color.chart.lime.boldest.hovered",
        "path": [
            "color",
            "chart",
            "lime",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.lime.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A secondary color for data visualisation or to communicate 'to-do' statues."
        },
        "value": "#8C8F97",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A secondary color for data visualisation or to communicate 'to-do' statues."
            },
            "value": "Neutral500"
        },
        "name": "color.chart.neutral.[default]",
        "path": [
            "color",
            "chart",
            "neutral",
            "[default]"
        ],
        "cleanName": "color.chart.neutral"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.neutral."
        },
        "value": "#7D818A",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.neutral."
            },
            "value": "Neutral600"
        },
        "name": "color.chart.neutral.hovered",
        "path": [
            "color",
            "chart",
            "neutral",
            "hovered"
        ],
        "cleanName": "color.chart.neutral.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#F15B50",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Red500"
        },
        "name": "color.chart.red.bold.[default]",
        "path": [
            "color",
            "chart",
            "red",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.red.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.red.bold."
        },
        "value": "#E2483D",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.red.bold."
            },
            "value": "Red600"
        },
        "name": "color.chart.red.bold.hovered",
        "path": [
            "color",
            "chart",
            "red",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.red.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#E2483D",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Red600"
        },
        "name": "color.chart.red.bolder.[default]",
        "path": [
            "color",
            "chart",
            "red",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.red.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.red.bolder."
        },
        "value": "#C9372C",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.red.bolder."
            },
            "value": "Red700"
        },
        "name": "color.chart.red.bolder.hovered",
        "path": [
            "color",
            "chart",
            "red",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.red.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Red800"
        },
        "name": "color.chart.red.boldest.[default]",
        "path": [
            "color",
            "chart",
            "red",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.red.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.red.boldest."
        },
        "value": "#5D1F1A",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.red.boldest."
            },
            "value": "Red900"
        },
        "name": "color.chart.red.boldest.hovered",
        "path": [
            "color",
            "chart",
            "red",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.red.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#E06C00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Orange600"
        },
        "name": "color.chart.orange.bold.[default]",
        "path": [
            "color",
            "chart",
            "orange",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.orange.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.orange.bold."
        },
        "value": "#BD5B00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.orange.bold."
            },
            "value": "Orange700"
        },
        "name": "color.chart.orange.bold.hovered",
        "path": [
            "color",
            "chart",
            "orange",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.orange.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#BD5B00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Orange700"
        },
        "name": "color.chart.orange.bolder.[default]",
        "path": [
            "color",
            "chart",
            "orange",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.orange.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.orange.bolder."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.orange.bolder."
            },
            "value": "Orange800"
        },
        "name": "color.chart.orange.bolder.hovered",
        "path": [
            "color",
            "chart",
            "orange",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.orange.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#7A3B00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Orange850"
        },
        "name": "color.chart.orange.boldest.[default]",
        "path": [
            "color",
            "chart",
            "orange",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.orange.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.orange.boldest."
        },
        "value": "#693200",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.orange.boldest."
            },
            "value": "Orange900"
        },
        "name": "color.chart.orange.boldest.hovered",
        "path": [
            "color",
            "chart",
            "orange",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.orange.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#B38600",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Yellow600"
        },
        "name": "color.chart.yellow.bold.[default]",
        "path": [
            "color",
            "chart",
            "yellow",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.yellow.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.yellow.bold."
        },
        "value": "#946F00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.yellow.bold."
            },
            "value": "Yellow700"
        },
        "name": "color.chart.yellow.bold.hovered",
        "path": [
            "color",
            "chart",
            "yellow",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.yellow.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#946F00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Yellow700"
        },
        "name": "color.chart.yellow.bolder.[default]",
        "path": [
            "color",
            "chart",
            "yellow",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.yellow.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.yellow.bolder."
        },
        "value": "#7F5F01",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.yellow.bolder."
            },
            "value": "Yellow800"
        },
        "name": "color.chart.yellow.bolder.hovered",
        "path": [
            "color",
            "chart",
            "yellow",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.yellow.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#7F5F01",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Yellow800"
        },
        "name": "color.chart.yellow.boldest.[default]",
        "path": [
            "color",
            "chart",
            "yellow",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.yellow.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.yellow.boldest."
        },
        "value": "#533F04",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.yellow.boldest."
            },
            "value": "Yellow900"
        },
        "name": "color.chart.yellow.boldest.hovered",
        "path": [
            "color",
            "chart",
            "yellow",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.yellow.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#22A06B",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Green600"
        },
        "name": "color.chart.green.bold.[default]",
        "path": [
            "color",
            "chart",
            "green",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.green.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.green.bold."
        },
        "value": "#1F845A",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.green.bold."
            },
            "value": "Green700"
        },
        "name": "color.chart.green.bold.hovered",
        "path": [
            "color",
            "chart",
            "green",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.green.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#1F845A",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Green700"
        },
        "name": "color.chart.green.bolder.[default]",
        "path": [
            "color",
            "chart",
            "green",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.green.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.green.bolder."
        },
        "value": "#216E4E",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.green.bolder."
            },
            "value": "Green800"
        },
        "name": "color.chart.green.bolder.hovered",
        "path": [
            "color",
            "chart",
            "green",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.green.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#216E4E",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Green800"
        },
        "name": "color.chart.green.boldest.[default]",
        "path": [
            "color",
            "chart",
            "green",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.green.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.green.boldest."
        },
        "value": "#164B35",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.green.boldest."
            },
            "value": "Green900"
        },
        "name": "color.chart.green.boldest.hovered",
        "path": [
            "color",
            "chart",
            "green",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.green.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#2898BD",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Teal600"
        },
        "name": "color.chart.teal.bold.[default]",
        "path": [
            "color",
            "chart",
            "teal",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.teal.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.teal.bold."
        },
        "value": "#227D9B",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.teal.bold."
            },
            "value": "Teal700"
        },
        "name": "color.chart.teal.bold.hovered",
        "path": [
            "color",
            "chart",
            "teal",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.teal.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#227D9B",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Teal700"
        },
        "name": "color.chart.teal.bolder.[default]",
        "path": [
            "color",
            "chart",
            "teal",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.teal.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.teal.bolder."
        },
        "value": "#206A83",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.teal.bolder."
            },
            "value": "Teal800"
        },
        "name": "color.chart.teal.bolder.hovered",
        "path": [
            "color",
            "chart",
            "teal",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.teal.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#206A83",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Teal800"
        },
        "name": "color.chart.teal.boldest.[default]",
        "path": [
            "color",
            "chart",
            "teal",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.teal.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.teal.boldest."
        },
        "value": "#164555",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.teal.boldest."
            },
            "value": "Teal900"
        },
        "name": "color.chart.teal.boldest.hovered",
        "path": [
            "color",
            "chart",
            "teal",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.teal.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Blue500"
        },
        "name": "color.chart.blue.bold.[default]",
        "path": [
            "color",
            "chart",
            "blue",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.blue.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.blue.bold."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.blue.bold."
            },
            "value": "Blue600"
        },
        "name": "color.chart.blue.bold.hovered",
        "path": [
            "color",
            "chart",
            "blue",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.blue.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Blue600"
        },
        "name": "color.chart.blue.bolder.[default]",
        "path": [
            "color",
            "chart",
            "blue",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.blue.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.blue.bolder."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.blue.bolder."
            },
            "value": "Blue700"
        },
        "name": "color.chart.blue.bolder.hovered",
        "path": [
            "color",
            "chart",
            "blue",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.blue.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Blue800"
        },
        "name": "color.chart.blue.boldest.[default]",
        "path": [
            "color",
            "chart",
            "blue",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.blue.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.blue.boldest."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.blue.boldest."
            },
            "value": "Blue900"
        },
        "name": "color.chart.blue.boldest.hovered",
        "path": [
            "color",
            "chart",
            "blue",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.blue.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Purple500"
        },
        "name": "color.chart.purple.bold.[default]",
        "path": [
            "color",
            "chart",
            "purple",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.purple.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.purple.bold."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.purple.bold."
            },
            "value": "Purple600"
        },
        "name": "color.chart.purple.bold.hovered",
        "path": [
            "color",
            "chart",
            "purple",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.purple.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Purple600"
        },
        "name": "color.chart.purple.bolder.[default]",
        "path": [
            "color",
            "chart",
            "purple",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.purple.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.purple.bolder."
        },
        "value": "#964AC0",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.purple.bolder."
            },
            "value": "Purple700"
        },
        "name": "color.chart.purple.bolder.hovered",
        "path": [
            "color",
            "chart",
            "purple",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.purple.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Purple800"
        },
        "name": "color.chart.purple.boldest.[default]",
        "path": [
            "color",
            "chart",
            "purple",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.purple.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.purple.boldest."
        },
        "value": "#48245D",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.purple.boldest."
            },
            "value": "Purple900"
        },
        "name": "color.chart.purple.boldest.hovered",
        "path": [
            "color",
            "chart",
            "purple",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.purple.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#DA62AC",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Magenta500"
        },
        "name": "color.chart.magenta.bold.[default]",
        "path": [
            "color",
            "chart",
            "magenta",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.magenta.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.magenta.bold."
        },
        "value": "#CD519D",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.magenta.bold."
            },
            "value": "Magenta600"
        },
        "name": "color.chart.magenta.bold.hovered",
        "path": [
            "color",
            "chart",
            "magenta",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.magenta.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#CD519D",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Magenta600"
        },
        "name": "color.chart.magenta.bolder.[default]",
        "path": [
            "color",
            "chart",
            "magenta",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.magenta.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.magenta.bolder."
        },
        "value": "#AE4787",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.magenta.bolder."
            },
            "value": "Magenta700"
        },
        "name": "color.chart.magenta.bolder.hovered",
        "path": [
            "color",
            "chart",
            "magenta",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.magenta.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#943D73",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Magenta800"
        },
        "name": "color.chart.magenta.boldest.[default]",
        "path": [
            "color",
            "chart",
            "magenta",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.magenta.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.magenta.boldest."
        },
        "value": "#50253F",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.magenta.boldest."
            },
            "value": "Magenta900"
        },
        "name": "color.chart.magenta.boldest.hovered",
        "path": [
            "color",
            "chart",
            "magenta",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.magenta.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#8C8F97",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Neutral500"
        },
        "name": "color.chart.gray.bold.[default]",
        "path": [
            "color",
            "chart",
            "gray",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.gray.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.gray.bold."
        },
        "value": "#7D818A",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.gray.bold."
            },
            "value": "Neutral600"
        },
        "name": "color.chart.gray.bold.hovered",
        "path": [
            "color",
            "chart",
            "gray",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.gray.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#7D818A",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Neutral600"
        },
        "name": "color.chart.gray.bolder.[default]",
        "path": [
            "color",
            "chart",
            "gray",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.gray.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.gray.bolder."
        },
        "value": "#6B6E76",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.gray.bolder."
            },
            "value": "Neutral700"
        },
        "name": "color.chart.gray.bolder.hovered",
        "path": [
            "color",
            "chart",
            "gray",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.gray.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#505258",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Neutral800"
        },
        "name": "color.chart.gray.boldest.[default]",
        "path": [
            "color",
            "chart",
            "gray",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.gray.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.gray.boldest."
        },
        "value": "#3B3D42",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.gray.boldest."
            },
            "value": "Neutral900"
        },
        "name": "color.chart.gray.boldest.hovered",
        "path": [
            "color",
            "chart",
            "gray",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.gray.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Our primary color for data visualisation. Use when only one color is required."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Our primary color for data visualisation. Use when only one color is required."
            },
            "value": "Blue600"
        },
        "name": "color.chart.brand.[default]",
        "path": [
            "color",
            "chart",
            "brand",
            "[default]"
        ],
        "cleanName": "color.chart.brand"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.brand."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.brand."
            },
            "value": "Blue700"
        },
        "name": "color.chart.brand.hovered",
        "path": [
            "color",
            "chart",
            "brand",
            "hovered"
        ],
        "cleanName": "color.chart.brand.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating negative information, such as 'off track'."
        },
        "value": "#E2483D",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating negative information, such as 'off track'."
            },
            "value": "Red600"
        },
        "name": "color.chart.danger.[default].[default]",
        "path": [
            "color",
            "chart",
            "danger",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.danger."
        },
        "value": "#C9372C",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.danger."
            },
            "value": "Red700"
        },
        "name": "color.chart.danger.[default].hovered",
        "path": [
            "color",
            "chart",
            "danger",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.danger.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.danger."
        },
        "value": "#872821",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.danger."
            },
            "value": "Red850"
        },
        "name": "color.chart.danger.bold.[default]",
        "path": [
            "color",
            "chart",
            "danger",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.danger.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.danger.bold."
        },
        "value": "#5D1F1A",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.danger.bold."
            },
            "value": "Red900"
        },
        "name": "color.chart.danger.bold.hovered",
        "path": [
            "color",
            "chart",
            "danger",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.danger.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating caution, such as 'at risk' statuses."
        },
        "value": "#F68909",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating caution, such as 'at risk' statuses."
            },
            "value": "Orange500"
        },
        "name": "color.chart.warning.[default].[default]",
        "path": [
            "color",
            "chart",
            "warning",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.warning."
        },
        "value": "#E06C00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.warning."
            },
            "value": "Orange600"
        },
        "name": "color.chart.warning.[default].hovered",
        "path": [
            "color",
            "chart",
            "warning",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.warning.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.warning."
        },
        "value": "#BD5B00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.warning."
            },
            "value": "Orange700"
        },
        "name": "color.chart.warning.bold.[default]",
        "path": [
            "color",
            "chart",
            "warning",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.warning.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.warning.bold."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.warning.bold."
            },
            "value": "Orange800"
        },
        "name": "color.chart.warning.bold.hovered",
        "path": [
            "color",
            "chart",
            "warning",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.warning.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating positive information, such as 'on track'."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating positive information, such as 'on track'."
            },
            "value": "Lime500"
        },
        "name": "color.chart.success.[default].[default]",
        "path": [
            "color",
            "chart",
            "success",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.success."
        },
        "value": "#6A9A23",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.success."
            },
            "value": "Lime600"
        },
        "name": "color.chart.success.[default].hovered",
        "path": [
            "color",
            "chart",
            "success",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.success.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.success."
        },
        "value": "#5B7F24",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.success."
            },
            "value": "Lime700"
        },
        "name": "color.chart.success.bold.[default]",
        "path": [
            "color",
            "chart",
            "success",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.success.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.success.bold."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.success.bold."
            },
            "value": "Lime800"
        },
        "name": "color.chart.success.bold.hovered",
        "path": [
            "color",
            "chart",
            "success",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.success.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating 'new' statuses."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating 'new' statuses."
            },
            "value": "Purple500"
        },
        "name": "color.chart.discovery.[default].[default]",
        "path": [
            "color",
            "chart",
            "discovery",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.discovery."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.discovery."
            },
            "value": "Purple600"
        },
        "name": "color.chart.discovery.[default].hovered",
        "path": [
            "color",
            "chart",
            "discovery",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.discovery.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.discovery."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.discovery."
            },
            "value": "Purple800"
        },
        "name": "color.chart.discovery.bold.[default]",
        "path": [
            "color",
            "chart",
            "discovery",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.discovery.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.discovery.bold."
        },
        "value": "#964AC0",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.discovery.bold."
            },
            "value": "Purple700"
        },
        "name": "color.chart.discovery.bold.hovered",
        "path": [
            "color",
            "chart",
            "discovery",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.discovery.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating low priority or in-progress statuses."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating low priority or in-progress statuses."
            },
            "value": "Blue600"
        },
        "name": "color.chart.information.[default].[default]",
        "path": [
            "color",
            "chart",
            "information",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.information."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.information."
            },
            "value": "Blue700"
        },
        "name": "color.chart.information.[default].hovered",
        "path": [
            "color",
            "chart",
            "information",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.information.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.information."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.information."
            },
            "value": "Blue800"
        },
        "name": "color.chart.information.bold.[default]",
        "path": [
            "color",
            "chart",
            "information",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.information.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.information.bold."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.information.bold."
            },
            "value": "Blue900"
        },
        "name": "color.chart.information.bold.hovered",
        "path": [
            "color",
            "chart",
            "information",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.information.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.2.0",
            "description": "Background color for Rovo brand emphasis."
        },
        "value": "#000000",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.2.0",
                "description": "Background color for Rovo brand emphasis."
            },
            "value": "Neutral1200"
        },
        "name": "color.rovo.background.brand.bold.[default]",
        "path": [
            "color",
            "rovo",
            "background",
            "brand",
            "bold",
            "[default]"
        ],
        "cleanName": "color.rovo.background.brand.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.2.0",
            "description": "Hovered state of color.rovo.background.brand.bold."
        },
        "value": "#1E1F21",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.2.0",
                "description": "Hovered state of color.rovo.background.brand.bold."
            },
            "value": "Neutral1100"
        },
        "name": "color.rovo.background.brand.bold.hovered",
        "path": [
            "color",
            "rovo",
            "background",
            "brand",
            "bold",
            "hovered"
        ],
        "cleanName": "color.rovo.background.brand.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.2.0",
            "description": "Pressed state of color.rovo.background.brand.bold."
        },
        "value": "#292A2E",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.2.0",
                "description": "Pressed state of color.rovo.background.brand.bold."
            },
            "value": "Neutral1000"
        },
        "name": "color.rovo.background.brand.bold.pressed",
        "path": [
            "color",
            "rovo",
            "background",
            "brand",
            "bold",
            "pressed"
        ],
        "cleanName": "color.rovo.background.brand.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo lime borders."
        },
        "value": "#6A9A23",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo lime borders."
            },
            "value": "Lime600"
        },
        "name": "color.rovo.border.lime",
        "path": [
            "color",
            "rovo",
            "border",
            "lime"
        ],
        "cleanName": "color.rovo.border.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo saffron borders."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo saffron borders."
            },
            "value": "Orange400"
        },
        "name": "color.rovo.border.saffron",
        "path": [
            "color",
            "rovo",
            "border",
            "saffron"
        ],
        "cleanName": "color.rovo.border.saffron"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo blue borders."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo blue borders."
            },
            "value": "Blue700"
        },
        "name": "color.rovo.border.blue",
        "path": [
            "color",
            "rovo",
            "border",
            "blue"
        ],
        "cleanName": "color.rovo.border.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo purple borders."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo purple borders."
            },
            "value": "Purple600"
        },
        "name": "color.rovo.border.purple",
        "path": [
            "color",
            "rovo",
            "border",
            "purple"
        ],
        "cleanName": "color.rovo.border.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo lime icons."
        },
        "value": "#6A9A23",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo lime icons."
            },
            "value": "Lime600"
        },
        "name": "color.rovo.icon.lime",
        "path": [
            "color",
            "rovo",
            "icon",
            "lime"
        ],
        "cleanName": "color.rovo.icon.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo saffron icons."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo saffron icons."
            },
            "value": "Orange400"
        },
        "name": "color.rovo.icon.saffron",
        "path": [
            "color",
            "rovo",
            "icon",
            "saffron"
        ],
        "cleanName": "color.rovo.icon.saffron"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo blue icons."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo blue icons."
            },
            "value": "Blue700"
        },
        "name": "color.rovo.icon.blue",
        "path": [
            "color",
            "rovo",
            "icon",
            "blue"
        ],
        "cleanName": "color.rovo.icon.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo purple icons."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo purple icons."
            },
            "value": "Purple600"
        },
        "name": "color.rovo.icon.purple",
        "path": [
            "color",
            "rovo",
            "icon",
            "purple"
        ],
        "cleanName": "color.rovo.icon.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as the primary background for the UI."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as the primary background for the UI."
            },
            "value": "Neutral0"
        },
        "name": "elevation.surface.[default].[default]",
        "path": [
            "elevation",
            "surface",
            "[default]",
            "[default]"
        ],
        "cleanName": "elevation.surface"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Hovered state of elevation.surface"
        },
        "value": "#F0F1F2",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Hovered state of elevation.surface"
            },
            "value": "Neutral200"
        },
        "name": "elevation.surface.[default].hovered",
        "path": [
            "elevation",
            "surface",
            "[default]",
            "hovered"
        ],
        "cleanName": "elevation.surface.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Pressed state of elevation.surface"
        },
        "value": "#DDDEE1",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Pressed state of elevation.surface"
            },
            "value": "Neutral300"
        },
        "name": "elevation.surface.[default].pressed",
        "path": [
            "elevation",
            "surface",
            "[default]",
            "pressed"
        ],
        "cleanName": "elevation.surface.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.3.0",
            "description": "Use as a neutral container surface background."
        },
        "value": "#17171708",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.3.0",
                "description": "Use as a neutral container surface background."
            },
            "value": "Neutral100A"
        },
        "name": "elevation.surface.container.[default]",
        "path": [
            "elevation",
            "surface",
            "container",
            "[default]"
        ],
        "cleanName": "elevation.surface.container"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "14.1.0",
            "description": "Hovered state of elevation.surface.container"
        },
        "value": "#0515240F",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "14.1.0",
                "description": "Hovered state of elevation.surface.container"
            },
            "value": "Neutral200A"
        },
        "name": "elevation.surface.container.hovered",
        "path": [
            "elevation",
            "surface",
            "container",
            "hovered"
        ],
        "cleanName": "elevation.surface.container.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "14.1.0",
            "description": "Pressed state of elevation.surface.container"
        },
        "value": "#0B120E24",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "14.1.0",
                "description": "Pressed state of elevation.surface.container"
            },
            "value": "Neutral300A"
        },
        "name": "elevation.surface.container.pressed",
        "path": [
            "elevation",
            "surface",
            "container",
            "pressed"
        ],
        "cleanName": "elevation.surface.container.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the background of elements that sit on top of they UI, such as modals, dialogs, dropdown menus, floating toolbars, and floating single-action buttons. Also use for the background of raised cards in a dragged state. Combine with elevation.shadow.overlay."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the background of elements that sit on top of they UI, such as modals, dialogs, dropdown menus, floating toolbars, and floating single-action buttons. Also use for the background of raised cards in a dragged state. Combine with elevation.shadow.overlay."
            },
            "value": "Neutral0"
        },
        "name": "elevation.surface.overlay.[default]",
        "path": [
            "elevation",
            "surface",
            "overlay",
            "[default]"
        ],
        "cleanName": "elevation.surface.overlay"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Hovered state of elevation.surface.overlay"
        },
        "value": "#F0F1F2",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Hovered state of elevation.surface.overlay"
            },
            "value": "Neutral200"
        },
        "name": "elevation.surface.overlay.hovered",
        "path": [
            "elevation",
            "surface",
            "overlay",
            "hovered"
        ],
        "cleanName": "elevation.surface.overlay.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Pressed state of elevation.surface.overlay"
        },
        "value": "#DDDEE1",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Pressed state of elevation.surface.overlay"
            },
            "value": "Neutral300"
        },
        "name": "elevation.surface.overlay.pressed",
        "path": [
            "elevation",
            "surface",
            "overlay",
            "pressed"
        ],
        "cleanName": "elevation.surface.overlay.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the background of cards that can be moved, such as Jira cards on a Kanban board. Combine with elevation.shadow.raised."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the background of cards that can be moved, such as Jira cards on a Kanban board. Combine with elevation.shadow.raised."
            },
            "value": "Neutral0"
        },
        "name": "elevation.surface.raised.[default]",
        "path": [
            "elevation",
            "surface",
            "raised",
            "[default]"
        ],
        "cleanName": "elevation.surface.raised"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Hovered state of elevation.surface.raised"
        },
        "value": "#F0F1F2",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Hovered state of elevation.surface.raised"
            },
            "value": "Neutral200"
        },
        "name": "elevation.surface.raised.hovered",
        "path": [
            "elevation",
            "surface",
            "raised",
            "hovered"
        ],
        "cleanName": "elevation.surface.raised.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Pressed state of elevation.surface.raised"
        },
        "value": "#DDDEE1",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Pressed state of elevation.surface.raised"
            },
            "value": "Neutral300"
        },
        "name": "elevation.surface.raised.pressed",
        "path": [
            "elevation",
            "surface",
            "raised",
            "pressed"
        ],
        "cleanName": "elevation.surface.raised.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A secondary background for the UI commonly used for grouping items, such as Jira cards in columns."
        },
        "value": "#F8F8F8",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A secondary background for the UI commonly used for grouping items, such as Jira cards in columns."
            },
            "value": "Neutral100"
        },
        "name": "elevation.surface.sunken",
        "path": [
            "elevation",
            "surface",
            "sunken"
        ],
        "cleanName": "elevation.surface.sunken"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.3.0",
            "description": "Use for Rovo overlay surface backgrounds."
        },
        "value": "#F8F8F8",
        "filePath": "schema/themes/atlassian-light/elevation/rovo/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.3.0",
                "description": "Use for Rovo overlay surface backgrounds."
            },
            "value": "Neutral100"
        },
        "name": "elevation.rovo.surface.overlay.[default]",
        "path": [
            "elevation",
            "rovo",
            "surface",
            "overlay",
            "[default]"
        ],
        "cleanName": "elevation.rovo.surface.overlay"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.3.0",
            "description": "Hovered state of elevation.rovo.surface.overlay."
        },
        "value": "#F0F1F2",
        "filePath": "schema/themes/atlassian-light/elevation/rovo/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.3.0",
                "description": "Hovered state of elevation.rovo.surface.overlay."
            },
            "value": "Neutral200"
        },
        "name": "elevation.rovo.surface.overlay.hovered",
        "path": [
            "elevation",
            "rovo",
            "surface",
            "overlay",
            "hovered"
        ],
        "cleanName": "elevation.rovo.surface.overlay.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.3.0",
            "description": "Pressed state of elevation.rovo.surface.overlay."
        },
        "value": "#DDDEE1",
        "filePath": "schema/themes/atlassian-light/elevation/rovo/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.3.0",
                "description": "Pressed state of elevation.rovo.surface.overlay."
            },
            "value": "Neutral300"
        },
        "name": "elevation.rovo.surface.overlay.pressed",
        "path": [
            "elevation",
            "rovo",
            "surface",
            "overlay",
            "pressed"
        ],
        "cleanName": "elevation.rovo.surface.overlay.pressed"
    },
    {
        "attributes": {
            "group": "shadow",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use to create a shadow when content scrolls under other content."
        },
        "value": [
            {
                "radius": 8,
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "color": "#1E1F21",
                "opacity": 0.16
            },
            {
                "radius": 1,
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "color": "#1E1F21",
                "opacity": 0.12
            }
        ],
        "filePath": "schema/themes/atlassian-light/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "shadow",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use to create a shadow when content scrolls under other content."
            },
            "value": [
                {
                    "radius": 8,
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "color": "Neutral1100",
                    "opacity": 0.16
                },
                {
                    "radius": 1,
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "color": "Neutral1100",
                    "opacity": 0.12
                }
            ]
        },
        "name": "elevation.shadow.overflow.[default]",
        "path": [
            "elevation",
            "shadow",
            "overflow",
            "[default]"
        ],
        "cleanName": "elevation.shadow.overflow"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.32",
            "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.spread to replicate the overflow shadow."
        },
        "value": "#1E1F211f",
        "filePath": "schema/themes/atlassian-light/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.32",
                "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.spread to replicate the overflow shadow."
            },
            "value": "#1E1F211f"
        },
        "name": "elevation.shadow.overflow.perimeter",
        "path": [
            "elevation",
            "shadow",
            "overflow",
            "perimeter"
        ],
        "cleanName": "elevation.shadow.overflow.perimeter"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.32",
            "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.perimeter to replicate the overflow shadow."
        },
        "value": "#1E1F2129",
        "filePath": "schema/themes/atlassian-light/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.32",
                "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.perimeter to replicate the overflow shadow."
            },
            "value": "#1E1F2129"
        },
        "name": "elevation.shadow.overflow.spread",
        "path": [
            "elevation",
            "shadow",
            "overflow",
            "spread"
        ],
        "cleanName": "elevation.shadow.overflow.spread"
    },
    {
        "attributes": {
            "group": "shadow",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the box shadow of elements that sit on top of the UI, such as modals, dropdown menus, flags, and inline dialogs. Combine with elevation.surface.overlay\n\nAlso use for the box shadow of raised cards in a dragged state."
        },
        "value": [
            {
                "radius": 12,
                "offset": {
                    "x": 0,
                    "y": 8
                },
                "color": "#1E1F21",
                "opacity": 0.15
            },
            {
                "radius": 1,
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "color": "#1E1F21",
                "opacity": 0.31
            }
        ],
        "filePath": "schema/themes/atlassian-light/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "shadow",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the box shadow of elements that sit on top of the UI, such as modals, dropdown menus, flags, and inline dialogs. Combine with elevation.surface.overlay\n\nAlso use for the box shadow of raised cards in a dragged state."
            },
            "value": [
                {
                    "radius": 12,
                    "offset": {
                        "x": 0,
                        "y": 8
                    },
                    "color": "Neutral1100",
                    "opacity": 0.15
                },
                {
                    "radius": 1,
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "color": "Neutral1100",
                    "opacity": 0.31
                }
            ]
        },
        "name": "elevation.shadow.overlay",
        "path": [
            "elevation",
            "shadow",
            "overlay"
        ],
        "cleanName": "elevation.shadow.overlay"
    },
    {
        "attributes": {
            "group": "shadow",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the box shadow of raised card elements, such as Jira cards on a Kanban board. Combine with elevation.surface.raised"
        },
        "value": [
            {
                "radius": 1,
                "offset": {
                    "x": 0,
                    "y": 1
                },
                "color": "#1E1F21",
                "opacity": 0.25
            },
            {
                "radius": 1,
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "color": "#1E1F21",
                "opacity": 0.31
            }
        ],
        "filePath": "schema/themes/atlassian-light/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "shadow",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the box shadow of raised card elements, such as Jira cards on a Kanban board. Combine with elevation.surface.raised"
            },
            "value": [
                {
                    "radius": 1,
                    "offset": {
                        "x": 0,
                        "y": 1
                    },
                    "color": "Neutral1100",
                    "opacity": 0.25
                },
                {
                    "radius": 1,
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "color": "Neutral1100",
                    "opacity": 0.31
                }
            ]
        },
        "name": "elevation.shadow.raised",
        "path": [
            "elevation",
            "shadow",
            "raised"
        ],
        "cleanName": "elevation.shadow.raised"
    },
    {
        "attributes": {
            "group": "opacity",
            "state": "active",
            "introduced": "0.10.13",
            "description": "Apply to images when in a disabled state."
        },
        "value": 0.4,
        "filePath": "schema/themes/atlassian-light/opacity/opacity.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "opacity",
                "state": "active",
                "introduced": "0.10.13",
                "description": "Apply to images when in a disabled state."
            },
            "value": "Opacity40"
        },
        "name": "opacity.disabled",
        "path": [
            "opacity",
            "disabled"
        ],
        "cleanName": "opacity.disabled"
    },
    {
        "attributes": {
            "group": "opacity",
            "state": "active",
            "introduced": "0.10.13",
            "description": "Apply to content that sits under a loading spinner."
        },
        "value": 0.2,
        "filePath": "schema/themes/atlassian-light/opacity/opacity.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "opacity",
                "state": "active",
                "introduced": "0.10.13",
                "description": "Apply to content that sits under a loading spinner."
            },
            "value": "Opacity20"
        },
        "name": "opacity.loading",
        "path": [
            "opacity",
            "loading"
        ],
        "cleanName": "opacity.loading"
    },
    {
        "attributes": {
            "group": "raw",
            "state": "active",
            "introduced": "0.1.1",
            "description": "Transparent token used for backwards compatibility between new and old theming solutions"
        },
        "value": "transparent",
        "filePath": "schema/themes/atlassian-light/utility/utility.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "raw",
                "state": "active",
                "introduced": "0.1.1",
                "description": "Transparent token used for backwards compatibility between new and old theming solutions"
            },
            "value": "transparent"
        },
        "name": "utility.UNSAFE.transparent",
        "path": [
            "utility",
            "UNSAFE",
            "transparent"
        ],
        "cleanName": "utility.UNSAFE.transparent"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.14.0",
            "description": "A dynamic token that represents the current surface color set by a parent element. It defaults to the 'elevation.surface' token value."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/utility/utility.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.14.0",
                "description": "A dynamic token that represents the current surface color set by a parent element. It defaults to the 'elevation.surface' token value."
            },
            "value": "Neutral0"
        },
        "name": "utility.elevation.surface.current",
        "path": [
            "utility",
            "elevation",
            "surface",
            "current"
        ],
        "cleanName": "utility.elevation.surface.current"
    }
];
var $71f646414e8eb43c$export$2e2bcd8739ae039 = $71f646414e8eb43c$var$tokens;
module.exports["default"] = $71f646414e8eb43c$export$2e2bcd8739ae039;

});

parcelRegister("1HhPq", function(module, exports) {
const $d746f4d35b6be9d0$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;
module.exports["isEmpty"] = $d746f4d35b6be9d0$export$dd1bc94b04021eeb;

});

parcelRegister("79LXc", function(module, exports) {

var $4EPzQ = parcelRequire("4EPzQ");


var $c8QR9 = parcelRequire("c8QR9");

const $e6b881450bf521b8$export$46a7f65963d82cf5 = (doc)=>{
    const pageElementCounts = {
        elements: {},
        textFormats: {},
        macros: {},
        unexpectedElements: {}
    };
    (0, $4EPzQ.reduce)(doc, (acc, node)=>{
        if (node.type === 'text') {
            if (node.marks) node.marks.forEach((mark)=>{
                const markType = mark.type;
                acc.textFormats[markType] = (acc.textFormats[markType] ?? 0) + 1;
            });
            acc.elements[node.type] = (acc.elements[node.type] ?? 0) + 1;
        } else if (node.type === 'extension' || node.type === 'inlineExtension' || node.type === 'bodiedExtension' || node.type === 'multiBodiedExtension' || node.type === 'extensionFrame') {
            if ('attrs' in node && node.attrs && 'extensionKey' in node.attrs && node.attrs.extensionKey) {
                let extensionKey = node.attrs.extensionKey;
                // If there is a nested table extension
                if ((0, $c8QR9.isNestedTableExtension)(node)) {
                    if ('parameters' in node.attrs && node.attrs.parameters && 'adf' in node.attrs.parameters) {
                        // Check to see if the ADF contains a nested table
                        const adfString = node.attrs.parameters.adf;
                        const adf = JSON.parse(adfString);
                        if (adfString.includes('{"type":"table"')) {
                            if ($e6b881450bf521b8$var$getHasNestedTable(adf)) acc.unexpectedElements['tablesNestedMoreThanOnce'] = (acc.unexpectedElements['tablesNestedMoreThanOnce'] ?? 0) + 1;
                        }
                    }
                }
                // If macros extensionKey has <UUID>/<UUID>/static/ prepended to it, remove the prefix
                if (extensionKey.includes('/static/')) {
                    const extensionKeyParts = extensionKey.split('/');
                    extensionKey = extensionKeyParts[extensionKeyParts.length - 1];
                }
                acc.macros[extensionKey] = (acc.macros[extensionKey] ?? 0) + 1;
            }
        } else acc.elements[node.type] = (acc.elements[node.type] ?? 0) + 1;
        return acc;
    }, pageElementCounts);
    return pageElementCounts;
};
/**
 * Return true is the JSON document contains a table nested within a table
 */ const $e6b881450bf521b8$var$getHasNestedTable = (node)=>{
    return (0, $4EPzQ.reduce)(node, (hasNestedTable, node)=>{
        if (hasNestedTable) return hasNestedTable;
        if (node.type === 'table') {
            // The first node that we pass into the reduce function is a table node, and we need to ignore it
            let foundFirstTable = false;
            return (0, $4EPzQ.reduce)(node, (hasNestedTable, node)=>{
                if (hasNestedTable) return hasNestedTable;
                if (node.type === 'table' && foundFirstTable) return true;
                else if (node.type === 'table') foundFirstTable = true;
                return hasNestedTable;
            }, false);
        }
        return hasNestedTable;
    }, false);
};
module.exports["getPageElementCounts"] = $e6b881450bf521b8$export$46a7f65963d82cf5;

});

parcelRegister("jbOus", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ /* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ 
var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");


var $gqUuL = parcelRequire("gqUuL");

var $b2605b01b89d7d87$export$54cb529986e2487b = /*#__PURE__*/ function(PROVIDER_ERROR_CODE) {
    PROVIDER_ERROR_CODE["NO_PERMISSION_ERROR"] = "NO_PERMISSION_ERROR";
    PROVIDER_ERROR_CODE["INVALID_USER_TOKEN"] = "INVALID_USER_TOKEN";
    PROVIDER_ERROR_CODE["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    PROVIDER_ERROR_CODE["LOCKED"] = "LOCKED";
    PROVIDER_ERROR_CODE["DOCUMENT_BLOCKED"] = "DOCUMENT_BLOCKED";
    PROVIDER_ERROR_CODE["FAIL_TO_SAVE"] = "FAIL_TO_SAVE";
    PROVIDER_ERROR_CODE["DOCUMENT_RESTORE_ERROR"] = "DOCUMENT_RESTORE_ERROR";
    PROVIDER_ERROR_CODE["INITIALISATION_ERROR"] = "INITIALISATION_ERROR";
    PROVIDER_ERROR_CODE["NETWORK_ISSUE"] = "NETWORK_ISSUE";
    PROVIDER_ERROR_CODE["INVALID_PROVIDER_CONFIGURATION"] = "INVALID_PROVIDER_CONFIGURATION";
    PROVIDER_ERROR_CODE["INTERNAL_SERVICE_ERROR"] = "INTERNAL_SERVICE_ERROR";
    PROVIDER_ERROR_CODE["DOCUMENT_UPDATE_ERROR"] = "DOCUMENT_UPDATE_ERROR";
    return PROVIDER_ERROR_CODE;
}({});
var $b2605b01b89d7d87$export$258d16488300d83f = /*#__PURE__*/ function(DisconnectReason) {
    DisconnectReason["CLIENT_DISCONNECT"] = "CLIENT_DISCONNECT";
    DisconnectReason["SERVER_DISCONNECT"] = "SERVER_DISCONNECT";
    DisconnectReason["SOCKET_CLOSED"] = "SOCKET_CLOSED";
    DisconnectReason["SOCKET_ERROR"] = "SOCKET_ERROR";
    DisconnectReason["SOCKET_TIMEOUT"] = "SOCKET_TIMEOUT";
    DisconnectReason["UNKNOWN_DISCONNECT"] = "UNKNOWN_DISCONNECT";
    return DisconnectReason;
}({});
const $b2605b01b89d7d87$var$telepointerColorStyle = (backgroundColor, textColor, index)=>{
    const { colorMode: colorMode } = (0, $gqUuL.getGlobalTheme)();
    const backgroundStyle = colorMode === 'dark' ? `linear-gradient(to bottom, ${backgroundColor} -800000%, transparent 200000%)` : `linear-gradient(to bottom, ${backgroundColor} -850000%, transparent 150000%)`;
    return `
    &.color-${index} {
      background: ${backgroundStyle};
      &::after {
        background-color: ${backgroundColor};
        color: ${textColor};
        border-color: ${backgroundColor};
      }
    }
  `;
};
const $b2605b01b89d7d87$export$75f1e2b0ae2c8197 = 'telepointer-dim';
const $b2605b01b89d7d87$export$44ee82a2b1106d13 = 'telepointer-pulse-animate';
const $b2605b01b89d7d87$export$15875d5e8ce4fd42 = 'telepointer-pulse-during-tr';
const $b2605b01b89d7d87$export$cea3f62f94f5fdf0 = 7500; // Keeping it longer so it'll be easier to spot during transactions
const $b2605b01b89d7d87$export$74788e2dc4d9be50 = 'data-telepointer-sessionid';
const $b2605b01b89d7d87$export$c94087d6ea5127ad = /*#__PURE__*/ (0, $lOiVq.css)("@keyframes pulseIn{0%,100%{transform:scaleX(0);opacity:0;}10%{transform:scaleX(1.4);opacity:1;}15%,85%{transform:scaleX(1);opacity:1;}}@keyframes pulseOut{0%,90%,100%{transform:scaleX(1);opacity:1;}10%,80%{transform:scaleX(0);opacity:0;}}@keyframes pulseInDuringTr{0%,95%{transform:scaleX(1);opacity:1;}100%{transform:scaleX(0);opacity:0;}}@keyframes pulseOutDuringTr{100%{transform:scaleX(1);opacity:1;}0%,90%{transform:scaleX(0);opacity:0;}}.ProseMirror .telepointer{position:relative;transition:opacity 200ms;", (0, $7Y8M5.participantColors).map((participantColor, index)=>$b2605b01b89d7d87$var$telepointerColorStyle(participantColor.backgroundColor, participantColor.textColor, index)), ";&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-selection-badge{.telepointer-initial,.telepointer-fullname{position:absolute;display:block;user-select:none;white-space:pre;top:-14px;left:0px;font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px);padding-right:var(--ds-space-050, 4px);border-radius:0 2px 2px 0;}.telepointer-initial{opacity:1;transition:opacity 0.15s ease-out;}.telepointer-fullname{opacity:0;transform:scaleX(0);transform-origin:top left;transition:transform 0.15s ease-out,opacity 0.15s ease-out;}}&.", $b2605b01b89d7d87$export$44ee82a2b1106d13, "{.telepointer-initial{animation:pulseOut 2.5s ease-in-out;}.telepointer-fullname{animation:pulseIn 2.5s ease-in-out;}}&.", $b2605b01b89d7d87$export$15875d5e8ce4fd42, "{.telepointer-initial{animation:pulseOutDuringTr ", $b2605b01b89d7d87$export$cea3f62f94f5fdf0, "ms ease-in-out;}.telepointer-fullname{animation:pulseInDuringTr ", $b2605b01b89d7d87$export$cea3f62f94f5fdf0, "ms ease-in-out;}}&:hover{.telepointer-initial{opacity:0;transition-delay:150ms;}.telepointer-fullname{transform:scaleX(1);opacity:1;z-index:1;}}&.", $b2605b01b89d7d87$export$75f1e2b0ae2c8197, "{opacity:0.2;}}");
const $b2605b01b89d7d87$var$tintKey = 'collab:isDirtyTransaction';
const $b2605b01b89d7d87$export$c500b1bc696a0abc = (tr)=>{
    return Boolean(tr.getMeta($b2605b01b89d7d87$var$tintKey));
};
const $b2605b01b89d7d87$export$f25182515d14d793 = (tr)=>{
    tr.setMeta($b2605b01b89d7d87$var$tintKey, true);
};
module.exports["PROVIDER_ERROR_CODE"] = $b2605b01b89d7d87$export$54cb529986e2487b;
module.exports["DisconnectReason"] = $b2605b01b89d7d87$export$258d16488300d83f;
module.exports["TELEPOINTER_DIM_CLASS"] = $b2605b01b89d7d87$export$75f1e2b0ae2c8197;
module.exports["TELEPOINTER_PULSE_CLASS"] = $b2605b01b89d7d87$export$44ee82a2b1106d13;
module.exports["TELEPOINTER_PULSE_DURING_TR_CLASS"] = $b2605b01b89d7d87$export$15875d5e8ce4fd42;
module.exports["TELEPOINTER_PULSE_DURING_TR_DURATION_MS"] = $b2605b01b89d7d87$export$cea3f62f94f5fdf0;
module.exports["TELEPOINTER_DATA_SESSION_ID_ATTR"] = $b2605b01b89d7d87$export$74788e2dc4d9be50;
module.exports["isDirtyTransaction"] = $b2605b01b89d7d87$export$c500b1bc696a0abc;
module.exports["tintDirtyTransaction"] = $b2605b01b89d7d87$export$f25182515d14d793;

});

parcelRegister("b2jdX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $ee6c0aefb76f2192$var$ToolbarUIContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    onDropdownOpenChanged: ()=>{},
    preventDefaultOnMouseDown: false,
    isDisabled: false,
    disabledWithoutInteractionLogic: false,
    popupsMountPoint: undefined,
    fireAnalyticsEvent: undefined,
    keyboardNavigation: undefined
});
const $ee6c0aefb76f2192$export$e7063f2520f6adf8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($ee6c0aefb76f2192$var$ToolbarUIContext);
    if (!context) throw new Error("useToolbarUI must be used within ToolbarUIContext");
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)($ee6c0aefb76f2192$var$ToolbarUIContext);
    if (!context) throw new Error('useToolbarUI must be used within ToolbarUIContext');
    return context;
};
const $ee6c0aefb76f2192$export$ae8c3f290017c42a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { children: children, onDropdownOpenChanged: onDropdownOpenChanged, preventDefaultOnMouseDown: preventDefaultOnMouseDown, isDisabled: isDisabled, disabledWithoutInteractionLogic: disabledWithoutInteractionLogic, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, fireAnalyticsEvent: fireAnalyticsEvent, keyboardNavigation: keyboardNavigation } = t0;
    let t1;
    if ($[0] !== disabledWithoutInteractionLogic || $[1] !== fireAnalyticsEvent || $[2] !== isDisabled || $[3] !== keyboardNavigation || $[4] !== onDropdownOpenChanged || $[5] !== popupsBoundariesElement || $[6] !== popupsMountPoint || $[7] !== popupsScrollableElement || $[8] !== preventDefaultOnMouseDown) {
        t1 = {
            onDropdownOpenChanged: onDropdownOpenChanged,
            preventDefaultOnMouseDown: preventDefaultOnMouseDown,
            isDisabled: isDisabled,
            disabledWithoutInteractionLogic: disabledWithoutInteractionLogic,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            fireAnalyticsEvent: fireAnalyticsEvent,
            keyboardNavigation: keyboardNavigation
        };
        $[0] = disabledWithoutInteractionLogic;
        $[1] = fireAnalyticsEvent;
        $[2] = isDisabled;
        $[3] = keyboardNavigation;
        $[4] = onDropdownOpenChanged;
        $[5] = popupsBoundariesElement;
        $[6] = popupsMountPoint;
        $[7] = popupsScrollableElement;
        $[8] = preventDefaultOnMouseDown;
        $[9] = t1;
    } else t1 = $[9];
    let t2;
    if ($[10] !== children || $[11] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($ee6c0aefb76f2192$var$ToolbarUIContext.Provider, {
            value: t1,
            children: children
        });
        $[10] = children;
        $[11] = t1;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
} : ({ children: children, onDropdownOpenChanged: onDropdownOpenChanged, preventDefaultOnMouseDown: preventDefaultOnMouseDown, isDisabled: isDisabled, disabledWithoutInteractionLogic: disabledWithoutInteractionLogic, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, fireAnalyticsEvent: fireAnalyticsEvent, keyboardNavigation: keyboardNavigation })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($ee6c0aefb76f2192$var$ToolbarUIContext.Provider, {
        // eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        value: {
            onDropdownOpenChanged: onDropdownOpenChanged,
            preventDefaultOnMouseDown: preventDefaultOnMouseDown,
            isDisabled: isDisabled,
            disabledWithoutInteractionLogic: disabledWithoutInteractionLogic,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            fireAnalyticsEvent: fireAnalyticsEvent,
            keyboardNavigation: keyboardNavigation
        },
        children: children
    });
};
module.exports["useToolbarUI"] = $ee6c0aefb76f2192$export$e7063f2520f6adf8;
module.exports["ToolbarUIProvider"] = $ee6c0aefb76f2192$export$ae8c3f290017c42a;

});

parcelRegister("5AKbu", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iMnC5 = parcelRequire("iMnC5");

const $acfbcf7b1df25093$var$styles = {
    container: "_2mHwu8FQfX _3iDTPbQ4SZ _3u6cVGo126",
    firstChild: "_311W63gVvo _48FllgdnbC _0eW79tdnbC",
    lastChild: "_311W63gVvo _2KSXSEdnbC _1cA73odnbC"
};
const $acfbcf7b1df25093$export$89cfa2b8585c6d03 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { children: children } = t0;
    let firstChild;
    let items;
    let lastChild;
    let t1;
    if ($[0] !== children) {
        items = (0, $cozmU.Children).toArray(children);
        firstChild = items[0];
        lastChild = items[items.length - 1];
        t1 = items.slice(1, -1);
        $[0] = children;
        $[1] = firstChild;
        $[2] = items;
        $[3] = lastChild;
        $[4] = t1;
    } else {
        firstChild = $[1];
        items = $[2];
        lastChild = $[3];
        t1 = $[4];
    }
    const middleChildren = t1;
    let t2;
    if ($[5] !== children || $[6] !== firstChild || $[7] !== items.length || $[8] !== lastChild || $[9] !== middleChildren) {
        t2 = items.length <= 1 ? children : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    className: (0, $hekY6.default)([
                        $acfbcf7b1df25093$var$styles.firstChild
                    ]),
                    children: firstChild
                }),
                middleChildren,
                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    className: (0, $hekY6.default)([
                        $acfbcf7b1df25093$var$styles.lastChild
                    ]),
                    children: lastChild
                })
            ]
        });
        $[5] = children;
        $[6] = firstChild;
        $[7] = items.length;
        $[8] = lastChild;
        $[9] = middleChildren;
        $[10] = t2;
    } else t2 = $[10];
    let t3;
    if ($[11] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $acfbcf7b1df25093$var$styles.container,
            "data-toolbar-component": "button-group",
            children: t2
        });
        $[11] = t2;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : ({ children: children })=>{
    const items = (0, $cozmU.Children).toArray(children); //  The .at() method is a relatively newer JavaScript API (ES2022) that isn't supported in older browsers
    //  Using items[i] is more compatible with older browsers.
    const firstChild = items[0];
    const lastChild = items[items.length - 1];
    const middleChildren = items.slice(1, -1);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $acfbcf7b1df25093$var$styles.container,
        "data-toolbar-component": "button-group",
        children: items.length <= 1 ? children : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    className: (0, $hekY6.default)([
                        $acfbcf7b1df25093$var$styles.firstChild
                    ]),
                    children: firstChild
                }),
                middleChildren,
                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    className: (0, $hekY6.default)([
                        $acfbcf7b1df25093$var$styles.lastChild
                    ]),
                    children: lastChild
                })
            ]
        })
    });
};
module.exports["ToolbarButtonGroup"] = $acfbcf7b1df25093$export$89cfa2b8585c6d03;

});

parcelRegister("jgJIe", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $9erVg = parcelRequire("9erVg");

const $9fc2092c7b4c22d1$export$3e60ddf10b9269e3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, hasSeparator: hasSeparator, title: title, testId: testId } = t0;
    let t1;
    if ($[0] !== children || $[1] !== hasSeparator || $[2] !== testId || $[3] !== title) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9erVg.default), {
            hasSeparator: hasSeparator,
            title: title,
            "data-toolbar-component": "menu-section",
            testId: testId,
            children: children
        });
        $[0] = children;
        $[1] = hasSeparator;
        $[2] = testId;
        $[3] = title;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ children: children, hasSeparator: hasSeparator, title: title, testId: testId })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9erVg.default), {
        hasSeparator: hasSeparator,
        title: title,
        "data-toolbar-component": "menu-section",
        testId: testId,
        children: children
    });
};
module.exports["ToolbarDropdownItemSection"] = $9fc2092c7b4c22d1$export$3e60ddf10b9269e3;

});

parcelRegister("cE5a1", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

var $3e12f89b0df5e85f$export$90683802e28416b5 = /*#__PURE__*/ function(SeparatorPosition) {
    SeparatorPosition["START"] = "start";
    SeparatorPosition["END"] = "end";
    return SeparatorPosition;
}({});
const $3e12f89b0df5e85f$var$styles = {
    container: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT"
};
const $3e12f89b0df5e85f$var$separator = null;
const $3e12f89b0df5e85f$var$marginInlineOverridden = null;
const $3e12f89b0df5e85f$var$ToolbarSeparator = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-toolbar-component": "separator",
            role: "separator",
            "aria-orientation": "vertical",
            className: (0, $hekY6.default)([
                "_2YLqiK2ADO _0jFU0VSPN1 _39xV02HZdu _0KLXru9r67",
                "_42G2HJFQfX"
            ])
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-toolbar-component": "separator",
        role: "separator",
        "aria-orientation": "vertical",
        className: (0, $hekY6.default)([
            "_2YLqiK2ADO _0jFU0VSPN1 _39xV02HZdu _0KLXru9r67",
            "_42G2HJFQfX"
        ])
    });
};
const $3e12f89b0df5e85f$export$b978f6a1bb31af67 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, testId: testId, hasSeparator: hasSeparator } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($3e12f89b0df5e85f$var$styles.container);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== hasSeparator) {
        t2 = hasSeparator === "start" && /*#__PURE__*/ (0, $8aG6j.jsx)($3e12f89b0df5e85f$var$ToolbarSeparator, {});
        $[1] = hasSeparator;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== hasSeparator) {
        t3 = hasSeparator === "end" && /*#__PURE__*/ (0, $8aG6j.jsx)($3e12f89b0df5e85f$var$ToolbarSeparator, {});
        $[3] = hasSeparator;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== children || $[6] !== t2 || $[7] !== t3 || $[8] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            xcss: t1,
            testId: testId,
            "data-toolbar-component": "section",
            children: [
                t2,
                children,
                t3
            ]
        });
        $[5] = children;
        $[6] = t2;
        $[7] = t3;
        $[8] = testId;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ children: children, testId: testId, hasSeparator: hasSeparator })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3e12f89b0df5e85f$var$styles.container),
        testId: testId,
        "data-toolbar-component": "section",
        children: [
            hasSeparator === "start" && /*#__PURE__*/ (0, $8aG6j.jsx)($3e12f89b0df5e85f$var$ToolbarSeparator, {}),
            children,
            hasSeparator === "end" && /*#__PURE__*/ (0, $8aG6j.jsx)($3e12f89b0df5e85f$var$ToolbarSeparator, {})
        ]
    });
};
module.exports["SeparatorPosition"] = $3e12f89b0df5e85f$export$90683802e28416b5;
module.exports["ToolbarSection"] = $3e12f89b0df5e85f$export$b978f6a1bb31af67;

});

parcelRegister("4Qu9h", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6QC2Y = parcelRequire("6QC2Y");


var $3u5lg = parcelRequire("3u5lg");


var $1KOhB = parcelRequire("1KOhB");

function $5781a3d6f4ca414b$export$feb16861fe41d066(api, plugin, options = {}) {
    const transformer = (0, $cozmU.useCallback)((pluginState)=>{
        const [pluginName, ...properties] = plugin.split('.');
        if (!pluginState || properties?.length === 0) return undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6QC2Y)))(pluginState?.[`${pluginName}State`], properties);
    }, [
        plugin
    ]);
    const pluginNameArray = (0, $cozmU.useMemo)(()=>{
        const [pluginName_0] = plugin.split('.');
        return [
            pluginName_0
        ];
    }, [
        plugin
    ]);
    const initialState = (0, $cozmU.useMemo)(()=>{
        if (options.disabled) return;
        const [pluginName_1] = plugin.split('.');
        return transformer({
            [`${pluginName_1}State`]: api?.[pluginName_1]?.sharedState.currentState()
        });
    }, [
        plugin,
        api,
        options.disabled,
        transformer
    ]);
    return $5781a3d6f4ca414b$var$useSharedPluginStateSelectorInternal(api, pluginNameArray, transformer, initialState, options);
}
const $5781a3d6f4ca414b$var$useSharedPluginStateSelectorInternal = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSharedPluginStateSelectorInternal(api, plugins, transformer, initialState, t0) {
    const $ = (0, $bDgLe.c)(7);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    let t2;
    if ($[2] !== initialState) {
        t2 = ()=>initialState;
        $[2] = initialState;
        $[3] = t2;
    } else t2 = $[3];
    const [selectedPluginState, setSelectedPluginState] = (0, $cozmU.useState)(t2);
    let t3;
    if ($[4] !== selectedPluginState || $[5] !== transformer) {
        t3 = (pluginStates)=>{
            const transformedValue = transformer(pluginStates);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(transformedValue, selectedPluginState)) setSelectedPluginState(()=>transformedValue);
        };
        $[4] = selectedPluginState;
        $[5] = transformer;
        $[6] = t3;
    } else t3 = $[6];
    (0, $1KOhB.usePluginStateEffect)(api, plugins, t3, options);
    return selectedPluginState;
} : function useSharedPluginStateSelectorInternal(api, plugins, transformer, initialState, options = {}) {
    const [selectedPluginState, setSelectedPluginState] = (0, $cozmU.useState)(()=>initialState);
    (0, $1KOhB.usePluginStateEffect)(api, plugins, (pluginStates)=>{
        // `pluginStates`: This is the same type through inference - but typescript doesn't recognise them as they are computed slightly differently
        const transformedValue = transformer(pluginStates);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(transformedValue, selectedPluginState)) setSelectedPluginState(()=>transformedValue);
    }, options);
    return selectedPluginState;
};
module.exports["useSharedPluginStateSelector"] = $5781a3d6f4ca414b$export$feb16861fe41d066;

});

parcelRegister("1KOhB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");

/**
 *
 * Directly map object values
 *
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $31dd9cd4213bf84a$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginState` example: `useSharedPluginState(api, ['width'])`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $31dd9cd4213bf84a$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $cozmU.useMemo)(()=>plugins, []);
}
function $31dd9cd4213bf84a$export$85f3fdc261c569b3(injectionApi, plugins, effect, options = {}) {
    const pluginNames = $31dd9cd4213bf84a$var$useStaticPlugins(plugins);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $cozmU.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    $31dd9cd4213bf84a$var$usePluginStateEffectInternal(namedExternalPlugins, effect, options);
}
function $31dd9cd4213bf84a$var$usePluginStateEffectInternal(externalPlugins, effect, options = {}) {
    const refStates = (0, $cozmU.useRef)();
    const cleanup = (0, $cozmU.useRef)();
    const latestEffect = (0, $cozmU.useRef)(effect);
    // We should store the latest effect in a reference so it is more intuitive to the user
    // and we are not causing a memory leak by having references to old state.
    (0, $cozmU.useLayoutEffect)(()=>{
        if (options.disabled) return;
        latestEffect.current = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(effect);
        return ()=>{
            latestEffect.current = undefined;
        };
    }, [
        effect,
        options.disabled
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (options.disabled) return;
        // Update the reference for this plugin and activate the effect
        refStates.current = $31dd9cd4213bf84a$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
        cleanup.current = latestEffect.current?.(refStates.current);
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState !== nextSharedState && refStates.current) {
                    // Update the reference for this plugin and activate the effect
                    refStates.current[pluginKey] = nextSharedState;
                    cleanup.current = latestEffect.current?.(refStates.current);
                }
            }));
        return ()=>{
            refStates.current = undefined;
            unsubs.forEach((cb)=>cb?.());
            cleanup.current?.();
        };
    // Do not re-run if the `effect` changes - this is not expected with `useEffect` or similar hooks
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPlugins,
        options.disabled
    ]);
}
module.exports["usePluginStateEffect"] = $31dd9cd4213bf84a$export$85f3fdc261c569b3;

});

parcelRegister("2InGJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e944e2355550fd12$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $e944e2355550fd12$export$2e2bcd8739ae039(value, initialValue) {
    const ref = (0, $cozmU.useRef)(initialValue);
    (0, $cozmU.useEffect)(()=>{
        // Setting the value to ref.current inside an effect, or otherwise the behaviour in staging/prod doesn't match with local
        // In local, the double rendering in react dev mode causes the previous value to be the same as next value immediately after
        // In prod and staging, double rendering is not done since that is a react prod build
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("l5rX3", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $eOaGc = parcelRequire("eOaGc");

parcelRequire("5aU9U");


const $f364c08792661dd1$export$9126078e8b0f76e4 = 'atlaskit-analytics';
const $f364c08792661dd1$export$89a6d622be04d823 = 'atlaskit-analytics-invert';
var $f364c08792661dd1$var$HISTORY_ACTIONS = /*#__PURE__*/ function(HISTORY_ACTIONS) {
    HISTORY_ACTIONS["UNDID"] = "undid";
    HISTORY_ACTIONS["REDID"] = "redid";
    return HISTORY_ACTIONS;
}($f364c08792661dd1$var$HISTORY_ACTIONS || {});
/** Creates undo event from a normal analytics event */ function $f364c08792661dd1$var$createUndoEvent(analyticsEvent) {
    return {
        ...analyticsEvent,
        payload: {
            action: "undid",
            actionSubject: analyticsEvent.payload.actionSubject,
            actionSubjectId: analyticsEvent.payload.action,
            attributes: {
                ...analyticsEvent.payload.attributes,
                actionSubjectId: analyticsEvent.payload.actionSubjectId,
                inputMethod: analyticsEvent.payload.attributes?.inputMethod || ''
            },
            eventType: 'track'
        }
    };
}
/** Toggles event action between undo & redo */ const $f364c08792661dd1$var$toggleEventAction = (analyticsEvent)=>({
        ...analyticsEvent,
        payload: {
            ...analyticsEvent.payload,
            action: analyticsEvent.payload.action === "undid" ? "redid" : "undid"
        }
    });
function $f364c08792661dd1$var$isHistoryAnalyticsEvent(event) {
    return event.payload.action === "undid" || event.payload.action === "redid";
}
class $f364c08792661dd1$export$cc33374693c7fb23 extends (0, $eOaGc.Step) {
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        const analyticsEvents = this.analyticsEvents.filter((analyticsEvent)=>this.actionsToIgnore.indexOf(analyticsEvent.payload.action) === -1).map((analyticsEvent)=>{
            if ($f364c08792661dd1$var$isHistoryAnalyticsEvent(analyticsEvent)) return $f364c08792661dd1$var$toggleEventAction(analyticsEvent);
            else return $f364c08792661dd1$var$createUndoEvent(analyticsEvent);
        });
        return new $f364c08792661dd1$export$cc33374693c7fb23(analyticsEvents, []);
    }
    apply(doc) {
        return (0, $eOaGc.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $f364c08792661dd1$export$cc33374693c7fb23(this.analyticsEvents, this.actionsToIgnore, newPos);
    }
    getMap() {
        if (typeof this.pos === 'number') return new (0, $eOaGc.StepMap)([
            this.pos,
            0,
            0
        ]);
        return new (0, $eOaGc.StepMap)([]);
    }
    merge(other) {
        if (other instanceof $f364c08792661dd1$export$cc33374693c7fb23) {
            const otherAnalyticsEvents = other.analyticsEvents;
            return new $f364c08792661dd1$export$cc33374693c7fb23([
                ...otherAnalyticsEvents,
                ...this.analyticsEvents
            ]);
        }
        return null;
    }
    toJSON() {
        return {
            stepType: $f364c08792661dd1$export$9126078e8b0f76e4
        };
    }
    static fromJSON() {
        return new (0, $eOaGc.ReplaceStep)(0, 0, (0, $aPdNQ.Slice).empty);
    }
    constructor(analyticsEvents, actionsToIgnore = [], pos // Used to create the map, prevent splitting history.
    ){
        super();
        this.analyticsEvents = [];
        this.pos = void 0;
        this.actionsToIgnore = [];
        this.analyticsEvents = analyticsEvents;
        this.actionsToIgnore = actionsToIgnore;
        this.pos = pos;
    }
}
/** Register this step with Prosemirror */ (0, $eOaGc.Step).jsonID($f364c08792661dd1$export$9126078e8b0f76e4, $f364c08792661dd1$export$cc33374693c7fb23);
module.exports["AnalyticsStep"] = $f364c08792661dd1$export$cc33374693c7fb23;

});

parcelRegister("5aU9U", function(module, exports) {
$parcel$export(module.exports, "Step", () => (parcelRequire("eOaGc")).Step);

var $eOaGc = parcelRequire("eOaGc");

// Using this avoids infinite recursion, as referencing Step.fromJSON inside Step.fromJSON
// will refer to the reassigned version, not the original version
const $6ff25faa98168f32$var$originalFromJSON = (0, $eOaGc.Step).fromJSON;
(0, $eOaGc.Step).fromJSON = (schema, jsonStep)=>{
    const stepImplementation = $6ff25faa98168f32$var$originalFromJSON(schema, jsonStep);
    return new Proxy(stepImplementation, {
        get (target, prop, receiver) {
            if (prop === 'toJSON') {
                const toJSONfunc = Reflect.get(target, prop, receiver);
                // @ts-expect-error Metadata may or may not exist at this stage, depending on step type,
                // but also additions outside of the type system that others may have done.
                const classMetadata = target.metadata;
                return new Proxy(toJSONfunc, {
                    apply (target, thisArg, argArray) {
                        const originalResult = Reflect.apply(target, thisArg, argArray);
                        const metadata = {
                            ...jsonStep.metadata,
                            ...classMetadata,
                            ...originalResult.metadata
                        };
                        return {
                            ...originalResult,
                            ...Object.keys(metadata).length === 0 ? {} : {
                                metadata: metadata
                            }
                        };
                    }
                });
            }
            return Reflect.get(target, prop, receiver);
        }
    });
};

});

parcelRegister("8hfTK", function(module, exports) {
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $606c3e53108474be$var$isArray(value) {
    return !Array.isArray ? $606c3e53108474be$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $606c3e53108474be$var$INFINITY = 1 / 0;
function $606c3e53108474be$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$606c3e53108474be$var$INFINITY ? '-0' : result;
}
function $606c3e53108474be$var$toString(value) {
    return value == null ? '' : $606c3e53108474be$var$baseToString(value);
}
function $606c3e53108474be$var$isString(value) {
    return typeof value === 'string';
}
function $606c3e53108474be$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $606c3e53108474be$var$isBoolean(value) {
    return value === true || value === false || $606c3e53108474be$var$isObjectLike(value) && $606c3e53108474be$var$getTag(value) == '[object Boolean]';
}
function $606c3e53108474be$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $606c3e53108474be$var$isObjectLike(value) {
    return $606c3e53108474be$var$isObject(value) && value !== null;
}
function $606c3e53108474be$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $606c3e53108474be$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $606c3e53108474be$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $606c3e53108474be$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $606c3e53108474be$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $606c3e53108474be$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $606c3e53108474be$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $606c3e53108474be$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $606c3e53108474be$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $606c3e53108474be$var$hasOwn = Object.prototype.hasOwnProperty;
class $606c3e53108474be$var$KeyStore {
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $606c3e53108474be$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
}
function $606c3e53108474be$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($606c3e53108474be$var$isString(key) || $606c3e53108474be$var$isArray(key)) {
        src = key;
        path = $606c3e53108474be$var$createKeyPath(key);
        id = $606c3e53108474be$var$createKeyId(key);
    } else {
        if (!$606c3e53108474be$var$hasOwn.call(key, 'name')) throw new Error($606c3e53108474be$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($606c3e53108474be$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($606c3e53108474be$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $606c3e53108474be$var$createKeyPath(name);
        id = $606c3e53108474be$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $606c3e53108474be$var$createKeyPath(key) {
    return $606c3e53108474be$var$isArray(key) ? key : key.split('.');
}
function $606c3e53108474be$var$createKeyId(key) {
    return $606c3e53108474be$var$isArray(key) ? key.join('.') : key;
}
function $606c3e53108474be$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$606c3e53108474be$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$606c3e53108474be$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($606c3e53108474be$var$isString(value) || $606c3e53108474be$var$isNumber(value) || $606c3e53108474be$var$isBoolean(value))) list.push($606c3e53108474be$var$toString(value));
            else if ($606c3e53108474be$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $606c3e53108474be$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $606c3e53108474be$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $606c3e53108474be$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $606c3e53108474be$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $606c3e53108474be$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $606c3e53108474be$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $606c3e53108474be$var$Config = {
    ...$606c3e53108474be$var$BasicOptions,
    ...$606c3e53108474be$var$MatchOptions,
    ...$606c3e53108474be$var$FuzzyOptions,
    ...$606c3e53108474be$var$AdvancedOptions
};
const $606c3e53108474be$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $606c3e53108474be$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($606c3e53108474be$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $606c3e53108474be$var$FuseIndex {
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($606c3e53108474be$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($606c3e53108474be$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$606c3e53108474be$var$isDefined(doc) || $606c3e53108474be$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$606c3e53108474be$var$isDefined(value)) return;
            if ($606c3e53108474be$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$606c3e53108474be$var$isDefined(value)) continue;
                    if ($606c3e53108474be$var$isString(value) && !$606c3e53108474be$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($606c3e53108474be$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($606c3e53108474be$var$isString(value) && !$606c3e53108474be$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
    constructor({ getFn: getFn = $606c3e53108474be$var$Config.getFn, fieldNormWeight: fieldNormWeight = $606c3e53108474be$var$Config.fieldNormWeight } = {}){
        this.norm = $606c3e53108474be$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
}
function $606c3e53108474be$var$createIndex(keys, docs, { getFn: getFn = $606c3e53108474be$var$Config.getFn, fieldNormWeight: fieldNormWeight = $606c3e53108474be$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $606c3e53108474be$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($606c3e53108474be$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $606c3e53108474be$var$parseIndex(data, { getFn: getFn = $606c3e53108474be$var$Config.getFn, fieldNormWeight: fieldNormWeight = $606c3e53108474be$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $606c3e53108474be$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $606c3e53108474be$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $606c3e53108474be$var$Config.distance, ignoreLocation: ignoreLocation = $606c3e53108474be$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $606c3e53108474be$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $606c3e53108474be$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $606c3e53108474be$var$MAX_BITS = 32;
function $606c3e53108474be$var$search(text, pattern, patternAlphabet, { location: location = $606c3e53108474be$var$Config.location, distance: distance = $606c3e53108474be$var$Config.distance, threshold: threshold = $606c3e53108474be$var$Config.threshold, findAllMatches: findAllMatches = $606c3e53108474be$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $606c3e53108474be$var$Config.minMatchCharLength, includeMatches: includeMatches = $606c3e53108474be$var$Config.includeMatches, ignoreLocation: ignoreLocation = $606c3e53108474be$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $606c3e53108474be$var$MAX_BITS) throw new Error($606c3e53108474be$var$PATTERN_LENGTH_TOO_LARGE($606c3e53108474be$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $606c3e53108474be$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $606c3e53108474be$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $606c3e53108474be$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $606c3e53108474be$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $606c3e53108474be$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $606c3e53108474be$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $606c3e53108474be$var$BitapSearch {
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $606c3e53108474be$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
    constructor(pattern, { location: location = $606c3e53108474be$var$Config.location, threshold: threshold = $606c3e53108474be$var$Config.threshold, distance: distance = $606c3e53108474be$var$Config.distance, includeMatches: includeMatches = $606c3e53108474be$var$Config.includeMatches, findAllMatches: findAllMatches = $606c3e53108474be$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $606c3e53108474be$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $606c3e53108474be$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $606c3e53108474be$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $606c3e53108474be$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $606c3e53108474be$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $606c3e53108474be$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $606c3e53108474be$var$MAX_BITS), i);
                i += $606c3e53108474be$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $606c3e53108474be$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
}
class $606c3e53108474be$var$BaseMatch {
    static isMultiMatch(pattern) {
        return $606c3e53108474be$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $606c3e53108474be$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
    constructor(pattern){
        this.pattern = pattern;
    }
}
function $606c3e53108474be$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $606c3e53108474be$var$ExactMatch extends $606c3e53108474be$var$BaseMatch {
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: !fire
class $606c3e53108474be$var$InverseExactMatch extends $606c3e53108474be$var$BaseMatch {
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: ^file
class $606c3e53108474be$var$PrefixExactMatch extends $606c3e53108474be$var$BaseMatch {
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: !^fire
class $606c3e53108474be$var$InversePrefixExactMatch extends $606c3e53108474be$var$BaseMatch {
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: .file$
class $606c3e53108474be$var$SuffixExactMatch extends $606c3e53108474be$var$BaseMatch {
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: !.file$
class $606c3e53108474be$var$InverseSuffixExactMatch extends $606c3e53108474be$var$BaseMatch {
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
class $606c3e53108474be$var$FuzzyMatch extends $606c3e53108474be$var$BaseMatch {
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
    constructor(pattern, { location: location = $606c3e53108474be$var$Config.location, threshold: threshold = $606c3e53108474be$var$Config.threshold, distance: distance = $606c3e53108474be$var$Config.distance, includeMatches: includeMatches = $606c3e53108474be$var$Config.includeMatches, findAllMatches: findAllMatches = $606c3e53108474be$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $606c3e53108474be$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $606c3e53108474be$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $606c3e53108474be$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $606c3e53108474be$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
}
// Token: 'file
class $606c3e53108474be$var$IncludeMatch extends $606c3e53108474be$var$BaseMatch {
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// ❗Order is important. DO NOT CHANGE.
const $606c3e53108474be$var$searchers = [
    $606c3e53108474be$var$ExactMatch,
    $606c3e53108474be$var$IncludeMatch,
    $606c3e53108474be$var$PrefixExactMatch,
    $606c3e53108474be$var$InversePrefixExactMatch,
    $606c3e53108474be$var$InverseSuffixExactMatch,
    $606c3e53108474be$var$SuffixExactMatch,
    $606c3e53108474be$var$InverseExactMatch,
    $606c3e53108474be$var$FuzzyMatch
];
const $606c3e53108474be$var$searchersLen = $606c3e53108474be$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $606c3e53108474be$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $606c3e53108474be$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $606c3e53108474be$var$parseQuery(pattern, options = {}) {
    return pattern.split($606c3e53108474be$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($606c3e53108474be$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $606c3e53108474be$var$searchersLen){
                const searcher = $606c3e53108474be$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $606c3e53108474be$var$searchersLen){
                const searcher = $606c3e53108474be$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $606c3e53108474be$var$MultiMatchSet = new Set([
    $606c3e53108474be$var$FuzzyMatch.type,
    $606c3e53108474be$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $606c3e53108474be$var$ExtendedSearch {
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($606c3e53108474be$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $606c3e53108474be$var$Config.isCaseSensitive, includeMatches: includeMatches = $606c3e53108474be$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $606c3e53108474be$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $606c3e53108474be$var$Config.ignoreLocation, findAllMatches: findAllMatches = $606c3e53108474be$var$Config.findAllMatches, location: location = $606c3e53108474be$var$Config.location, threshold: threshold = $606c3e53108474be$var$Config.threshold, distance: distance = $606c3e53108474be$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $606c3e53108474be$var$parseQuery(this.pattern, this.options);
    }
}
const $606c3e53108474be$var$registeredSearchers = [];
function $606c3e53108474be$var$register(...args) {
    $606c3e53108474be$var$registeredSearchers.push(...args);
}
function $606c3e53108474be$var$createSearcher(pattern, options) {
    for(let i = 0, len = $606c3e53108474be$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $606c3e53108474be$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $606c3e53108474be$var$BitapSearch(pattern, options);
}
const $606c3e53108474be$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $606c3e53108474be$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $606c3e53108474be$var$isExpression = (query)=>!!(query[$606c3e53108474be$var$LogicalOperator.AND] || query[$606c3e53108474be$var$LogicalOperator.OR]);
const $606c3e53108474be$var$isPath = (query)=>!!query[$606c3e53108474be$var$KeyType.PATH];
const $606c3e53108474be$var$isLeaf = (query)=>!$606c3e53108474be$var$isArray(query) && $606c3e53108474be$var$isObject(query) && !$606c3e53108474be$var$isExpression(query);
const $606c3e53108474be$var$convertToExplicit = (query)=>({
        [$606c3e53108474be$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $606c3e53108474be$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $606c3e53108474be$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$606c3e53108474be$var$isExpression(query)) return next($606c3e53108474be$var$convertToExplicit(query));
        if ($606c3e53108474be$var$isLeaf(query)) {
            const key = isQueryPath ? query[$606c3e53108474be$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$606c3e53108474be$var$KeyType.PATTERN] : query[key];
            if (!$606c3e53108474be$var$isString(pattern)) throw new Error($606c3e53108474be$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $606c3e53108474be$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $606c3e53108474be$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($606c3e53108474be$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$606c3e53108474be$var$isExpression(query)) query = $606c3e53108474be$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $606c3e53108474be$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $606c3e53108474be$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $606c3e53108474be$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$606c3e53108474be$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$606c3e53108474be$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $606c3e53108474be$var$transformScore(result, data) {
    data.score = result.score;
}
function $606c3e53108474be$var$format(results, docs, { includeMatches: includeMatches = $606c3e53108474be$var$Config.includeMatches, includeScore: includeScore = $606c3e53108474be$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($606c3e53108474be$var$transformMatches);
    if (includeScore) transformers.push($606c3e53108474be$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $606c3e53108474be$export$2e2bcd8739ae039 {
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $606c3e53108474be$var$FuseIndex)) throw new Error($606c3e53108474be$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $606c3e53108474be$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$606c3e53108474be$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $606c3e53108474be$var$isString(query) ? $606c3e53108474be$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $606c3e53108474be$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($606c3e53108474be$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $606c3e53108474be$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $606c3e53108474be$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$606c3e53108474be$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $606c3e53108474be$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $606c3e53108474be$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($606c3e53108474be$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $606c3e53108474be$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$606c3e53108474be$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$606c3e53108474be$var$isDefined(value)) return [];
        let matches = [];
        if ($606c3e53108474be$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$606c3e53108474be$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
    constructor(docs, options = {}, index){
        this.options = {
            ...$606c3e53108474be$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $606c3e53108474be$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
}
$606c3e53108474be$export$2e2bcd8739ae039.version = '6.6.2';
$606c3e53108474be$export$2e2bcd8739ae039.createIndex = $606c3e53108474be$var$createIndex;
$606c3e53108474be$export$2e2bcd8739ae039.parseIndex = $606c3e53108474be$var$parseIndex;
$606c3e53108474be$export$2e2bcd8739ae039.config = $606c3e53108474be$var$Config;
$606c3e53108474be$export$2e2bcd8739ae039.parseQuery = $606c3e53108474be$var$parse;
$606c3e53108474be$var$register($606c3e53108474be$var$ExtendedSearch);
module.exports["default"] = $606c3e53108474be$export$2e2bcd8739ae039;

});

parcelRegister("ivert", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11ff3476759ba85eb0a355499bddb2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d78653211ce9e783$var$_react = $d78653211ce9e783$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d78653211ce9e783$var$_iconNew = $d78653211ce9e783$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $d78653211ce9e783$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Template".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/template
 * Usage guidance:
 * Reserved fore templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d78653211ce9e783$var$TemplateIcon = (props)=>/*#__PURE__*/ $d78653211ce9e783$var$_react.default.createElement($d78653211ce9e783$var$_iconNew.default, Object.assign({
        name: "TemplateIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 6h-7v7.5H13a.5.5 0 0 0 .5-.5zm-11 7a.5.5 0 0 0 .5.5h2V6H2.5zm11-10a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1.5h11zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$d78653211ce9e783$var$TemplateIcon.displayName = 'TemplateIcon';
var $d78653211ce9e783$var$_default = module.exports.default = $d78653211ce9e783$var$TemplateIcon;

});

parcelRegister("4IGja", function(module, exports) {

var $bjg0G = parcelRequire("bjg0G");

const $4cc024e57414859b$export$1ae6a0a4f7784fc4 = (selection)=>(0, $bjg0G.findParentNode)((node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table')(selection);
module.exports["findTable"] = $4cc024e57414859b$export$1ae6a0a4f7784fc4;

});

parcelRegister("dVKvM", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $is1T6 = parcelRequire("is1T6");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");


var $kwf4Z = parcelRequire("kwf4Z");

const $622440dab28238ae$var$styles = {
    toolbarDropdownItem: "_2sNsIgmnOE _2Y7lL48HPE _4c065U1Y8M _3iDTPbQ4SZ _1mT5xdRAKS _0KLXru66of _39xV02N91d _4kiQYAUofl _4ouGXIFpVx _1UtDYzZpcK _37yqvNKxmn _34b3D2Ll21",
    anchor: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _2nTuUYZpcK _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMZpcK",
    enabled: "_1eOmH6o126 _3gzVzLN4oS",
    disabled: "_1UtDYzot27 _0wOv4Qsyl5",
    selected: "_0KLXruY9q9 _1UtDYzjTy9 _1eOmH6sumd _3gzVzLXsxn",
    elemAfterText: "_2XsHFMgVvo"
};
const $622440dab28238ae$var$CustomDropdownMenuItemButton = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(21);
    const { children: children, "data-testid": testId, "aria-haspopup": ariaHasPopup, "aria-disabled": ariaDisabled, "aria-pressed": ariaPressed, "aria-keyshortcuts": ariaKeyshortcuts, onClick: onClick, onBlur: onBlur, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, tabIndex: tabIndex, title: title, "data-extension-item-key": dataExtensionItemKey, itemRole: itemRole } = t0;
    const t1 = itemRole || "menuitem";
    const t2 = testId;
    const t3 = ariaDisabled ? $622440dab28238ae$var$styles.disabled : ariaPressed ? $622440dab28238ae$var$styles.selected : $622440dab28238ae$var$styles.enabled;
    let t4;
    if ($[0] !== t3) {
        t4 = (0, $w6R6I.cx)($622440dab28238ae$var$styles.toolbarDropdownItem, t3);
        $[0] = t3;
        $[1] = t4;
    } else t4 = $[1];
    const t5 = ariaHasPopup ? ariaPressed ? true : false : undefined;
    const t6 = itemRole === "menuitemradio" || itemRole === "menuitemcheckbox" ? ariaPressed : undefined;
    const t7 = (0, $iDrrr.fg)("cc_blocks_changeboarding") ? dataExtensionItemKey : undefined;
    let t8;
    if ($[2] !== ariaDisabled || $[3] !== ariaHasPopup || $[4] !== ariaKeyshortcuts || $[5] !== children || $[6] !== onBlur || $[7] !== onClick || $[8] !== onFocus || $[9] !== onMouseEnter || $[10] !== onMouseLeave || $[11] !== ref || $[12] !== t1 || $[13] !== t2 || $[14] !== t4 || $[15] !== t5 || $[16] !== t6 || $[17] !== t7 || $[18] !== tabIndex || $[19] !== title) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
            role: t1,
            testId: t2,
            xcss: t4,
            onClick: onClick,
            onBlur: onBlur,
            onFocus: onFocus,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            tabIndex: tabIndex,
            "aria-haspopup": ariaHasPopup,
            "aria-expanded": t5,
            "aria-checked": t6,
            "aria-disabled": ariaDisabled,
            "aria-keyshortcuts": ariaKeyshortcuts,
            "data-toolbar-component": "menu-item",
            ref: ref,
            title: title,
            "data-extension-item-key": t7,
            children: children
        });
        $[2] = ariaDisabled;
        $[3] = ariaHasPopup;
        $[4] = ariaKeyshortcuts;
        $[5] = children;
        $[6] = onBlur;
        $[7] = onClick;
        $[8] = onFocus;
        $[9] = onMouseEnter;
        $[10] = onMouseLeave;
        $[11] = ref;
        $[12] = t1;
        $[13] = t2;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
        $[18] = tabIndex;
        $[19] = title;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ children: children, 'data-testid': testId, 'aria-haspopup': ariaHasPopup, 'aria-disabled': ariaDisabled, 'aria-pressed': ariaPressed, 'aria-keyshortcuts': ariaKeyshortcuts, onClick: onClick, onBlur: onBlur, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, tabIndex: tabIndex, title: title, 'data-extension-item-key': dataExtensionItemKey, itemRole: itemRole }, ref)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
        role: itemRole || 'menuitem',
        testId: testId,
        xcss: (0, $w6R6I.cx)($622440dab28238ae$var$styles.toolbarDropdownItem, ariaDisabled ? $622440dab28238ae$var$styles.disabled : ariaPressed ? $622440dab28238ae$var$styles.selected : $622440dab28238ae$var$styles.enabled),
        onClick: onClick,
        onBlur: onBlur,
        onFocus: onFocus,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        tabIndex: tabIndex,
        "aria-haspopup": ariaHasPopup,
        "aria-expanded": ariaHasPopup ? ariaPressed ? true : false : undefined,
        "aria-checked": itemRole === 'menuitemradio' || itemRole === 'menuitemcheckbox' ? ariaPressed : undefined,
        "aria-disabled": ariaDisabled,
        "aria-keyshortcuts": ariaKeyshortcuts,
        "data-toolbar-component": "menu-item",
        ref: ref,
        title: title,
        "data-extension-item-key": (0, $iDrrr.fg)('cc_blocks_changeboarding') ? dataExtensionItemKey : undefined,
        children: children
    }));
const $622440dab28238ae$var$CustomDropdownMenuItemAnchor = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(43);
    let ariaDisabled;
    let ariaHasPopup;
    let ariaKeyshortcuts;
    let ariaPressed;
    let children;
    let dataAttributes;
    let href;
    let itemRole;
    let onBlur;
    let onClick;
    let onFocus;
    let onMouseEnter;
    let onMouseLeave;
    let rel;
    let tabIndex;
    let target;
    let testId;
    let title;
    if ($[0] !== t0) {
        ({ children: children, "data-testid": testId, "aria-haspopup": ariaHasPopup, "aria-disabled": ariaDisabled, "aria-pressed": ariaPressed, "aria-keyshortcuts": ariaKeyshortcuts, onClick: onClick, onBlur: onBlur, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, tabIndex: tabIndex, href: href, target: target, rel: rel, title: title, itemRole: itemRole, ...dataAttributes } = t0);
        $[0] = t0;
        $[1] = ariaDisabled;
        $[2] = ariaHasPopup;
        $[3] = ariaKeyshortcuts;
        $[4] = ariaPressed;
        $[5] = children;
        $[6] = dataAttributes;
        $[7] = href;
        $[8] = itemRole;
        $[9] = onBlur;
        $[10] = onClick;
        $[11] = onFocus;
        $[12] = onMouseEnter;
        $[13] = onMouseLeave;
        $[14] = rel;
        $[15] = tabIndex;
        $[16] = target;
        $[17] = testId;
        $[18] = title;
    } else {
        ariaDisabled = $[1];
        ariaHasPopup = $[2];
        ariaKeyshortcuts = $[3];
        ariaPressed = $[4];
        children = $[5];
        dataAttributes = $[6];
        href = $[7];
        itemRole = $[8];
        onBlur = $[9];
        onClick = $[10];
        onFocus = $[11];
        onMouseEnter = $[12];
        onMouseLeave = $[13];
        rel = $[14];
        tabIndex = $[15];
        target = $[16];
        testId = $[17];
        title = $[18];
    }
    const t1 = itemRole || "menuitem";
    const t2 = testId;
    const t3 = ariaDisabled ? $622440dab28238ae$var$styles.disabled : ariaPressed ? $622440dab28238ae$var$styles.selected : $622440dab28238ae$var$styles.enabled;
    let t4;
    if ($[19] !== t3) {
        t4 = (0, $w6R6I.cx)($622440dab28238ae$var$styles.toolbarDropdownItem, $622440dab28238ae$var$styles.anchor, t3);
        $[19] = t3;
        $[20] = t4;
    } else t4 = $[20];
    const t5 = ariaHasPopup ? ariaPressed ? true : false : undefined;
    const t6 = itemRole === "menuitemradio" || itemRole === "menuitemcheckbox" ? ariaPressed : undefined;
    let t7;
    if ($[21] !== ariaDisabled || $[22] !== ariaHasPopup || $[23] !== ariaKeyshortcuts || $[24] !== children || $[25] !== dataAttributes || $[26] !== href || $[27] !== onBlur || $[28] !== onClick || $[29] !== onFocus || $[30] !== onMouseEnter || $[31] !== onMouseLeave || $[32] !== ref || $[33] !== rel || $[34] !== t1 || $[35] !== t2 || $[36] !== t4 || $[37] !== t5 || $[38] !== t6 || $[39] !== tabIndex || $[40] !== target || $[41] !== title) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
            role: t1,
            testId: t2,
            xcss: t4,
            onClick: onClick,
            onBlur: onBlur,
            onFocus: onFocus,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            tabIndex: tabIndex,
            "aria-haspopup": ariaHasPopup,
            "aria-expanded": t5,
            "aria-checked": t6,
            "aria-disabled": ariaDisabled,
            "aria-keyshortcuts": ariaKeyshortcuts,
            "data-toolbar-component": "menu-item",
            ref: ref,
            href: href,
            target: target,
            rel: rel,
            title: title,
            ...dataAttributes,
            children: children
        });
        $[21] = ariaDisabled;
        $[22] = ariaHasPopup;
        $[23] = ariaKeyshortcuts;
        $[24] = children;
        $[25] = dataAttributes;
        $[26] = href;
        $[27] = onBlur;
        $[28] = onClick;
        $[29] = onFocus;
        $[30] = onMouseEnter;
        $[31] = onMouseLeave;
        $[32] = ref;
        $[33] = rel;
        $[34] = t1;
        $[35] = t2;
        $[36] = t4;
        $[37] = t5;
        $[38] = t6;
        $[39] = tabIndex;
        $[40] = target;
        $[41] = title;
        $[42] = t7;
    } else t7 = $[42];
    return t7;
} : ({ children: children, 'data-testid': testId, 'aria-haspopup': ariaHasPopup, 'aria-disabled': ariaDisabled, 'aria-pressed': ariaPressed, 'aria-keyshortcuts': ariaKeyshortcuts, onClick: onClick, onBlur: onBlur, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, tabIndex: tabIndex, href: href, target: target, rel: rel, title: title, itemRole: itemRole, ...dataAttributes }, ref)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
        role: itemRole || 'menuitem',
        testId: testId,
        xcss: (0, $w6R6I.cx)($622440dab28238ae$var$styles.toolbarDropdownItem, $622440dab28238ae$var$styles.anchor, ariaDisabled ? $622440dab28238ae$var$styles.disabled : ariaPressed ? $622440dab28238ae$var$styles.selected : $622440dab28238ae$var$styles.enabled),
        onClick: onClick,
        onBlur: onBlur,
        onFocus: onFocus,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        tabIndex: tabIndex,
        "aria-haspopup": ariaHasPopup,
        "aria-expanded": ariaHasPopup ? ariaPressed ? true : false : undefined,
        "aria-checked": itemRole === 'menuitemradio' || itemRole === 'menuitemcheckbox' ? ariaPressed : undefined,
        "aria-disabled": ariaDisabled,
        "aria-keyshortcuts": ariaKeyshortcuts,
        "data-toolbar-component": "menu-item",
        ref: ref,
        href: href,
        target: target,
        rel: rel,
        title: title,
        ...dataAttributes,
        children: children
    }));
const $622440dab28238ae$export$abcb00136d206988 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(57);
    let ariaKeyshortcuts;
    let children;
    let dataAttributes;
    let elemAfter;
    let elemAfterText;
    let elemBefore;
    let hasNestedDropdownMenu;
    let href;
    let isDisabled;
    let isSelected;
    let onBlur;
    let onClick;
    let onFocus;
    let onMouseEnter;
    let onMouseLeave;
    let rel;
    let role;
    let t1;
    let target;
    let testId;
    let title;
    let triggerRef;
    if ($[0] !== t0) {
        ({ onClick: onClick, onBlur: onBlur, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, elemBefore: elemBefore, elemAfter: elemAfter, elemAfterText: elemAfterText, isSelected: isSelected, children: children, isDisabled: isDisabled, hasNestedDropdownMenu: hasNestedDropdownMenu, triggerRef: triggerRef, title: title, shouldTitleWrap: t1, testId: testId, ariaKeyshortcuts: ariaKeyshortcuts, href: href, target: target, rel: rel, role: role, ...dataAttributes } = t0);
        $[0] = t0;
        $[1] = ariaKeyshortcuts;
        $[2] = children;
        $[3] = dataAttributes;
        $[4] = elemAfter;
        $[5] = elemAfterText;
        $[6] = elemBefore;
        $[7] = hasNestedDropdownMenu;
        $[8] = href;
        $[9] = isDisabled;
        $[10] = isSelected;
        $[11] = onBlur;
        $[12] = onClick;
        $[13] = onFocus;
        $[14] = onMouseEnter;
        $[15] = onMouseLeave;
        $[16] = rel;
        $[17] = role;
        $[18] = t1;
        $[19] = target;
        $[20] = testId;
        $[21] = title;
        $[22] = triggerRef;
    } else {
        ariaKeyshortcuts = $[1];
        children = $[2];
        dataAttributes = $[3];
        elemAfter = $[4];
        elemAfterText = $[5];
        elemBefore = $[6];
        hasNestedDropdownMenu = $[7];
        href = $[8];
        isDisabled = $[9];
        isSelected = $[10];
        onBlur = $[11];
        onClick = $[12];
        onFocus = $[13];
        onMouseEnter = $[14];
        onMouseLeave = $[15];
        rel = $[16];
        role = $[17];
        t1 = $[18];
        target = $[19];
        testId = $[20];
        title = $[21];
        triggerRef = $[22];
    }
    const shouldTitleWrap = t1 === undefined ? true : t1;
    const parentContext = (0, $kwf4Z.useToolbarDropdownMenu)();
    let t2;
    bb0: {
        if (!/*#__PURE__*/ (0, $cozmU.isValidElement)(elemAfter)) {
            t2 = elemAfter;
            break bb0;
        }
        const elementProps = elemAfter.props;
        if ("isDisabled" in elementProps) {
            t2 = elemAfter;
            break bb0;
        }
        let t3;
        if ($[23] !== elemAfter || $[24] !== elementProps || $[25] !== isDisabled) {
            t3 = /*#__PURE__*/ (0, $cozmU.cloneElement)(elemAfter, {
                ...elementProps,
                isDisabled: isDisabled
            });
            $[23] = elemAfter;
            $[24] = elementProps;
            $[25] = isDisabled;
            $[26] = t3;
        } else t3 = $[26];
        t2 = t3;
    }
    const injectedElemAfter = t2;
    let t3;
    if ($[27] !== hasNestedDropdownMenu || $[28] !== onClick || $[29] !== parentContext) {
        t3 = (e)=>{
            if (!hasNestedDropdownMenu) parentContext?.closeMenu(e);
            onClick?.(e);
        };
        $[27] = hasNestedDropdownMenu;
        $[28] = onClick;
        $[29] = parentContext;
        $[30] = t3;
    } else t3 = $[30];
    const t4 = href ? $622440dab28238ae$var$CustomDropdownMenuItemAnchor : $622440dab28238ae$var$CustomDropdownMenuItemButton;
    let t5;
    if ($[31] !== elemAfterText) {
        t5 = elemAfterText ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            xcss: $622440dab28238ae$var$styles.elemAfterText,
            children: elemAfterText
        }) : null;
        $[31] = elemAfterText;
        $[32] = t5;
    } else t5 = $[32];
    let t6;
    if ($[33] !== ariaKeyshortcuts || $[34] !== children || $[35] !== dataAttributes || $[36] !== elemBefore || $[37] !== hasNestedDropdownMenu || $[38] !== href || $[39] !== injectedElemAfter || $[40] !== isDisabled || $[41] !== isSelected || $[42] !== onBlur || $[43] !== onFocus || $[44] !== onMouseEnter || $[45] !== onMouseLeave || $[46] !== rel || $[47] !== role || $[48] !== shouldTitleWrap || $[49] !== t3 || $[50] !== t4 || $[51] !== t5 || $[52] !== target || $[53] !== testId || $[54] !== title || $[55] !== triggerRef) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $is1T6.default), {
            onClick: t3,
            onBlur: onBlur,
            onFocus: onFocus,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            elemBefore: elemBefore,
            elemAfter: injectedElemAfter,
            isSelected: isSelected,
            isDisabled: isDisabled,
            "aria-haspopup": hasNestedDropdownMenu,
            "aria-pressed": isSelected,
            "aria-keyshortcuts": ariaKeyshortcuts,
            itemRole: role,
            ref: triggerRef,
            href: href,
            target: target,
            rel: rel,
            component: t4,
            testId: testId,
            "data-toolbar-component": "menu-item",
            title: title,
            shouldTitleWrap: shouldTitleWrap,
            ...dataAttributes,
            children: [
                children,
                t5
            ]
        });
        $[33] = ariaKeyshortcuts;
        $[34] = children;
        $[35] = dataAttributes;
        $[36] = elemBefore;
        $[37] = hasNestedDropdownMenu;
        $[38] = href;
        $[39] = injectedElemAfter;
        $[40] = isDisabled;
        $[41] = isSelected;
        $[42] = onBlur;
        $[43] = onFocus;
        $[44] = onMouseEnter;
        $[45] = onMouseLeave;
        $[46] = rel;
        $[47] = role;
        $[48] = shouldTitleWrap;
        $[49] = t3;
        $[50] = t4;
        $[51] = t5;
        $[52] = target;
        $[53] = testId;
        $[54] = title;
        $[55] = triggerRef;
        $[56] = t6;
    } else t6 = $[56];
    return t6;
} : ({ onClick: onClick, onBlur: onBlur, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, elemBefore: elemBefore, elemAfter: elemAfter, elemAfterText: elemAfterText, isSelected: isSelected, children: children, isDisabled: isDisabled, hasNestedDropdownMenu: hasNestedDropdownMenu, triggerRef: triggerRef, title: title, shouldTitleWrap: shouldTitleWrap = true, testId: testId, ariaKeyshortcuts: ariaKeyshortcuts, href: href, target: target, rel: rel, role: role, ...dataAttributes })=>{
    const parentContext = (0, $kwf4Z.useToolbarDropdownMenu)();
    const injectedElemAfter = (()=>{
        if (!/*#__PURE__*/ (0, $cozmU.isValidElement)(elemAfter)) return elemAfter;
        const elementProps = elemAfter.props;
        if ('isDisabled' in elementProps) return elemAfter;
        return /*#__PURE__*/ (0, $cozmU.cloneElement)(elemAfter, {
            ...elementProps,
            isDisabled: isDisabled
        });
    })();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $is1T6.default // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
    ), {
        onClick: (e)=>{
            if (!hasNestedDropdownMenu) parentContext?.closeMenu(e);
            onClick?.(e);
        },
        onBlur: onBlur,
        onFocus: onFocus,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        elemBefore: elemBefore,
        elemAfter: injectedElemAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        "aria-haspopup": hasNestedDropdownMenu,
        "aria-pressed": isSelected,
        "aria-keyshortcuts": ariaKeyshortcuts,
        itemRole: role,
        ref: triggerRef,
        href: href,
        target: target,
        rel: rel,
        component: href ? $622440dab28238ae$var$CustomDropdownMenuItemAnchor : $622440dab28238ae$var$CustomDropdownMenuItemButton,
        testId: testId,
        "data-toolbar-component": "menu-item",
        title: title,
        shouldTitleWrap: shouldTitleWrap,
        ...dataAttributes,
        children: [
            children,
            elemAfterText ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                as: "span",
                xcss: $622440dab28238ae$var$styles.elemAfterText,
                children: elemAfterText
            }) : null
        ]
    });
};
module.exports["ToolbarDropdownItem"] = $622440dab28238ae$export$abcb00136d206988;

});

parcelRegister("kwf4Z", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $b2jdX = parcelRequire("b2jdX");

const $3c95869d73b1b0c1$var$ToolbarDropdownMenuContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $3c95869d73b1b0c1$export$4a532e97cc88ad2f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($3c95869d73b1b0c1$var$ToolbarDropdownMenuContext);
} : ()=>{
    return (0, $cozmU.useContext)($3c95869d73b1b0c1$var$ToolbarDropdownMenuContext);
};
const $3c95869d73b1b0c1$export$7baf0d20f25b94dd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { children: children, isOpen: isOpen, setIsOpen: setIsOpen } = t0;
    const [isOpenInternal, setIsOpenInternal] = (0, $cozmU.useState)(false);
    const { onDropdownOpenChanged: onDropdownOpenChanged } = (0, $b2jdX.useToolbarUI)();
    let t1;
    if ($[0] !== onDropdownOpenChanged || $[1] !== setIsOpen) {
        t1 = (event)=>{
            if (setIsOpen !== undefined) setIsOpen(true);
            else setIsOpenInternal(true);
            onDropdownOpenChanged({
                isOpen: true,
                event: event
            });
        };
        $[0] = onDropdownOpenChanged;
        $[1] = setIsOpen;
        $[2] = t1;
    } else t1 = $[2];
    const openMenu = t1;
    let t2;
    if ($[3] !== onDropdownOpenChanged || $[4] !== setIsOpen) {
        t2 = (event_0)=>{
            if (setIsOpen !== undefined) setIsOpen(false);
            else setIsOpenInternal(false);
            onDropdownOpenChanged({
                isOpen: false,
                event: event_0
            });
        };
        $[3] = onDropdownOpenChanged;
        $[4] = setIsOpen;
        $[5] = t2;
    } else t2 = $[5];
    const closeMenu = t2;
    const t3 = isOpen !== undefined ? isOpen : isOpenInternal;
    let t4;
    if ($[6] !== closeMenu || $[7] !== openMenu || $[8] !== t3) {
        t4 = {
            openMenu: openMenu,
            closeMenu: closeMenu,
            isOpen: t3
        };
        $[6] = closeMenu;
        $[7] = openMenu;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    const contextValue = t4;
    let t5;
    if ($[10] !== children || $[11] !== contextValue) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($3c95869d73b1b0c1$var$ToolbarDropdownMenuContext.Provider, {
            value: contextValue,
            children: children
        });
        $[10] = children;
        $[11] = contextValue;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ children: children, isOpen: isOpen, setIsOpen: setIsOpen })=>{
    const [isOpenInternal, setIsOpenInternal] = (0, $cozmU.useState)(false);
    const { onDropdownOpenChanged: onDropdownOpenChanged } = (0, $b2jdX.useToolbarUI)();
    const openMenu = (event)=>{
        if (setIsOpen !== undefined) setIsOpen(true);
        else setIsOpenInternal(true);
        onDropdownOpenChanged({
            isOpen: true,
            event: event
        });
    };
    const closeMenu = (event_0)=>{
        if (setIsOpen !== undefined) setIsOpen(false);
        else setIsOpenInternal(false);
        onDropdownOpenChanged({
            isOpen: false,
            event: event_0
        });
    };
    const contextValue = {
        openMenu: openMenu,
        closeMenu: closeMenu,
        isOpen: isOpen !== undefined ? isOpen : isOpenInternal
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)($3c95869d73b1b0c1$var$ToolbarDropdownMenuContext.Provider, {
        value: contextValue,
        children: children
    });
};
module.exports["useToolbarDropdownMenu"] = $3c95869d73b1b0c1$export$4a532e97cc88ad2f;
module.exports["ToolbarDropdownMenuProvider"] = $3c95869d73b1b0c1$export$7baf0d20f25b94dd;

});

parcelRegister("lslMH", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lpNn5 = parcelRequire("lpNn5");

const $899690fd1fe39a0e$export$7293ce116b97b92a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { content: content, shortcut: shortcut, children: children, position: t1, delay: delay } = t0;
    const position = t1 === undefined ? "top" : t1;
    let t2;
    if ($[0] !== children || $[1] !== content || $[2] !== delay || $[3] !== position || $[4] !== shortcut) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: content,
            position: position,
            delay: delay,
            shortcut: shortcut,
            isScreenReaderAnnouncementDisabled: true,
            children: children
        });
        $[0] = children;
        $[1] = content;
        $[2] = delay;
        $[3] = position;
        $[4] = shortcut;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ content: content, shortcut: shortcut, children: children, position: position = 'top', delay: delay })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: content,
        position: position,
        delay: delay,
        shortcut: shortcut,
        // the information in toolbar tooltips is already announced by aria-label and aria-keyshortcuts on the item
        // so we need to disable screen reader announcement of tooltip to avoid duplicate announcements
        isScreenReaderAnnouncementDisabled: true,
        children: children
    });
};
module.exports["ToolbarTooltip"] = $899690fd1fe39a0e$export$7293ce116b97b92a;

});

parcelRegister("a6nzD", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $3vgx3 = parcelRequire("3vgx3");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $b2jdX = parcelRequire("b2jdX");


var $6t3CY = parcelRequire("6t3CY");


var $kwf4Z = parcelRequire("kwf4Z");

const $5055fa73eeae6712$var$styles = {
    sectionMargin: "_3SamIHFQfX",
    firstSectionSeparator: "_2WsOzoZqHV",
    scrollContainer: "_0NUa3rsz7G _2WAcuGIZbP",
    renderToParent: "_39xV02W9qI"
};
const $5055fa73eeae6712$var$ToolbarDropdownMenuContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { iconBefore: iconBefore, tooltipComponent: tooltipComponent, children: children, isDisabled: isDisabled, id: id, testId: testId, label: label, onClick: onClick, shouldRenderToParent: shouldRenderToParent } = t0;
    const { onDropdownOpenChanged: onDropdownOpenChanged } = (0, $b2jdX.useToolbarUI)();
    const menuContext = (0, $kwf4Z.useToolbarDropdownMenu)();
    let t1;
    if ($[0] !== menuContext || $[1] !== onDropdownOpenChanged) {
        t1 = (args)=>{
            onDropdownOpenChanged(args);
            if (!args.isOpen) menuContext?.closeMenu(args.event);
        };
        $[0] = menuContext;
        $[1] = onDropdownOpenChanged;
        $[2] = t1;
    } else t1 = $[2];
    const handleOpenChange = t1;
    let t2;
    if ($[3] !== menuContext) {
        t2 = (e)=>{
            if (!menuContext?.isOpen) menuContext?.openMenu(e);
            else menuContext?.closeMenu(e);
        };
        $[3] = menuContext;
        $[4] = t2;
    } else t2 = $[4];
    const handleClick = t2;
    let t3;
    if ($[5] !== handleClick || $[6] !== iconBefore || $[7] !== id || $[8] !== isDisabled || $[9] !== label || $[10] !== menuContext?.isOpen || $[11] !== onClick || $[12] !== testId || $[13] !== tooltipComponent) {
        t3 = (triggerProps)=>{
            const toolbarButton = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
                ref: triggerProps.triggerRef,
                isSelected: triggerProps.isSelected,
                "aria-expanded": triggerProps["aria-expanded"],
                "aria-haspopup": triggerProps["aria-haspopup"],
                "aria-controls": triggerProps["aria-controls"],
                onBlur: triggerProps.onBlur,
                onClick: (e_0)=>{
                    onClick && onClick(e_0, !menuContext?.isOpen);
                    handleClick(e_0);
                    triggerProps.onClick && triggerProps.onClick(e_0);
                },
                onFocus: triggerProps.onFocus,
                id: id,
                testId: testId,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                label: label
            });
            if (tooltipComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(tooltipComponent, {
                children: toolbarButton
            });
            return toolbarButton;
        };
        $[5] = handleClick;
        $[6] = iconBefore;
        $[7] = id;
        $[8] = isDisabled;
        $[9] = label;
        $[10] = menuContext?.isOpen;
        $[11] = onClick;
        $[12] = testId;
        $[13] = tooltipComponent;
        $[14] = t3;
    } else t3 = $[14];
    const t4 = menuContext?.isOpen;
    const t5 = shouldRenderToParent ? true : undefined;
    const t6 = shouldRenderToParent ? "absolute" : undefined;
    let t7;
    if ($[15] !== children || $[16] !== handleOpenChange || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
            trigger: t3,
            onOpenChange: handleOpenChange,
            isOpen: t4,
            shouldRenderToParent: t5,
            strategy: t6,
            children: children
        });
        $[15] = children;
        $[16] = handleOpenChange;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
        $[20] = t6;
        $[21] = t7;
    } else t7 = $[21];
    return t7;
} : ({ iconBefore: iconBefore, tooltipComponent: tooltipComponent, children: children, isDisabled: isDisabled, id: id, testId: testId, label: label, onClick: onClick, shouldRenderToParent: shouldRenderToParent })=>{
    const { onDropdownOpenChanged: onDropdownOpenChanged } = (0, $b2jdX.useToolbarUI)();
    const menuContext = (0, $kwf4Z.useToolbarDropdownMenu)();
    const handleOpenChange = (0, $cozmU.useCallback)((args)=>{
        onDropdownOpenChanged(args);
        if (!args.isOpen) menuContext?.closeMenu(args.event);
    }, [
        menuContext,
        onDropdownOpenChanged
    ]);
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        if (!menuContext?.isOpen) menuContext?.openMenu(e);
        else menuContext?.closeMenu(e);
    }, [
        menuContext
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        trigger: (triggerProps)=>{
            const toolbarButton = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
                ref: triggerProps.triggerRef,
                isSelected: triggerProps.isSelected,
                "aria-expanded": triggerProps['aria-expanded'],
                "aria-haspopup": triggerProps['aria-haspopup'],
                "aria-controls": triggerProps['aria-controls'],
                onBlur: triggerProps.onBlur,
                onClick: (e_0)=>{
                    onClick && onClick(e_0, !menuContext?.isOpen);
                    handleClick(e_0);
                    triggerProps.onClick && triggerProps.onClick(e_0);
                },
                onFocus: triggerProps.onFocus,
                id: id,
                testId: testId,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                label: label
            });
            if (tooltipComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(tooltipComponent, {
                children: toolbarButton
            });
            return toolbarButton;
        },
        onOpenChange: handleOpenChange,
        isOpen: menuContext?.isOpen,
        shouldRenderToParent: shouldRenderToParent ? true : undefined,
        strategy: shouldRenderToParent ? 'absolute' : undefined,
        children: children
    });
};
const $5055fa73eeae6712$export$fffc3e0cfea7888f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { iconBefore: iconBefore, children: children, isDisabled: isDisabled, id: id, testId: testId, label: label, hasSectionMargin: t1, enableMaxHeight: t2, onClick: onClick, tooltipComponent: tooltipComponent, shouldRenderToParent: shouldRenderToParent } = t0;
    const hasSectionMargin = t1 === undefined ? true : t1;
    const enableMaxHeight = t2 === undefined ? false : t2;
    const t3 = hasSectionMargin && $5055fa73eeae6712$var$styles.sectionMargin;
    const t4 = enableMaxHeight && $5055fa73eeae6712$var$styles.scrollContainer;
    let t5;
    if ($[0] !== shouldRenderToParent) {
        t5 = shouldRenderToParent && (0, $iDrrr.fg)("platform_editor_fix_text_styles_width") && $5055fa73eeae6712$var$styles.renderToParent;
        $[0] = shouldRenderToParent;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== t3 || $[3] !== t4 || $[4] !== t5) {
        t6 = (0, $k12R1.cx)(t3, t4, t5, $5055fa73eeae6712$var$styles.firstSectionSeparator);
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== children || $[7] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t6,
            "data-toolbar-component": "menu",
            children: children
        });
        $[6] = children;
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== iconBefore || $[10] !== id || $[11] !== isDisabled || $[12] !== label || $[13] !== onClick || $[14] !== shouldRenderToParent || $[15] !== t7 || $[16] !== testId || $[17] !== tooltipComponent) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)($5055fa73eeae6712$var$ToolbarDropdownMenuContent, {
            iconBefore: iconBefore,
            isDisabled: isDisabled,
            id: id,
            testId: testId,
            label: label,
            onClick: onClick,
            tooltipComponent: tooltipComponent,
            shouldRenderToParent: shouldRenderToParent,
            children: t7
        });
        $[9] = iconBefore;
        $[10] = id;
        $[11] = isDisabled;
        $[12] = label;
        $[13] = onClick;
        $[14] = shouldRenderToParent;
        $[15] = t7;
        $[16] = testId;
        $[17] = tooltipComponent;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
} : ({ iconBefore: iconBefore, children: children, isDisabled: isDisabled, id: id, testId: testId, label: label, hasSectionMargin: hasSectionMargin = true, enableMaxHeight: enableMaxHeight = false, onClick: onClick, tooltipComponent: tooltipComponent, shouldRenderToParent: shouldRenderToParent })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($5055fa73eeae6712$var$ToolbarDropdownMenuContent, {
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        id: id,
        testId: testId,
        label: label,
        onClick: onClick,
        tooltipComponent: tooltipComponent,
        shouldRenderToParent: shouldRenderToParent,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: (0, $k12R1.cx)(hasSectionMargin && $5055fa73eeae6712$var$styles.sectionMargin, enableMaxHeight && $5055fa73eeae6712$var$styles.scrollContainer, shouldRenderToParent && (0, $iDrrr.fg)('platform_editor_fix_text_styles_width') && $5055fa73eeae6712$var$styles.renderToParent, $5055fa73eeae6712$var$styles.firstSectionSeparator),
            "data-toolbar-component": "menu",
            children: children
        })
    });
};
module.exports["ToolbarDropdownMenu"] = $5055fa73eeae6712$export$fffc3e0cfea7888f;

});

parcelRegister("6t3CY", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $hBYtq = parcelRequire("hBYtq");


var $b2jdX = parcelRequire("b2jdX");

const $4267f56118acba47$var$styles = {
    button: "_2mHwu8gVvo _0bjKvDKxmn _2sNsIgmnOE _3iDTPbQ4SZ _0KLXru66of _1ANEUSLRg7 _0hPCNLDIqT _37wbyuDIqT _4kiQYAcM5X _1UtDYzZpcK _2Zuz6Q2ADO _1Znuxb2ADO _34b3D2dnbC _13yjol7dHp _1C8RqERAKS",
    enabled: "_1eOmH6o126 _3gzVzLN4oS",
    disabled: "_1UtDYzot27 _0wOv4Qsyl5",
    selected: "_0KLXruY9q9 _1UtDYzjTy9 _1eOmH6sumd _3gzVzLXsxn"
};
const $4267f56118acba47$export$e5c1a33878e86e9e = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(25);
    const { iconBefore: iconBefore, children: children, onClick: onClick, isSelected: isSelected, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, "aria-controls": ariaControls, "data-ds--level": dataDsLevel, onBlur: onBlur, onFocus: onFocus, testId: testId, id: id, isDisabled: isDisabled, ariaKeyshortcuts: ariaKeyshortcuts, label: label, interactionName: interactionName, ignoreInteractionDisabled: ignoreInteractionDisabled } = t0;
    const { preventDefaultOnMouseDown: preventDefaultOnMouseDown, isDisabled: ctxDisabled, disabledWithoutInteractionLogic: disabledWithoutInteractionLogic } = (0, $b2jdX.useToolbarUI)();
    const disabled = Boolean((ignoreInteractionDisabled ? disabledWithoutInteractionLogic : ctxDisabled) || isDisabled);
    const t1 = disabled ? $4267f56118acba47$var$styles.disabled : isSelected ? $4267f56118acba47$var$styles.selected : $4267f56118acba47$var$styles.enabled;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $w6R6I.cx)($4267f56118acba47$var$styles.button, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = Boolean(ariaHasPopup) ? undefined : isSelected;
    let t4;
    if ($[2] !== preventDefaultOnMouseDown) {
        t4 = (event)=>{
            if (preventDefaultOnMouseDown) event.preventDefault();
        };
        $[2] = preventDefaultOnMouseDown;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== ariaControls || $[5] !== ariaExpanded || $[6] !== ariaHasPopup || $[7] !== ariaKeyshortcuts || $[8] !== children || $[9] !== dataDsLevel || $[10] !== disabled || $[11] !== iconBefore || $[12] !== id || $[13] !== interactionName || $[14] !== isSelected || $[15] !== label || $[16] !== onBlur || $[17] !== onClick || $[18] !== onFocus || $[19] !== ref || $[20] !== t2 || $[21] !== t3 || $[22] !== t4 || $[23] !== testId) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hBYtq.Pressable), {
            ref: ref,
            xcss: t2,
            "aria-pressed": t3,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            "aria-controls": ariaControls,
            "aria-keyshortcuts": ariaKeyshortcuts,
            "aria-label": label,
            "data-ds--level": dataDsLevel,
            onClick: onClick,
            onBlur: onBlur,
            onFocus: onFocus,
            testId: testId,
            id: id,
            isDisabled: disabled,
            onMouseDown: t4,
            "data-toolbar-component": "button",
            "data-selected": isSelected,
            interactionName: interactionName,
            children: [
                iconBefore,
                children
            ]
        });
        $[4] = ariaControls;
        $[5] = ariaExpanded;
        $[6] = ariaHasPopup;
        $[7] = ariaKeyshortcuts;
        $[8] = children;
        $[9] = dataDsLevel;
        $[10] = disabled;
        $[11] = iconBefore;
        $[12] = id;
        $[13] = interactionName;
        $[14] = isSelected;
        $[15] = label;
        $[16] = onBlur;
        $[17] = onClick;
        $[18] = onFocus;
        $[19] = ref;
        $[20] = t2;
        $[21] = t3;
        $[22] = t4;
        $[23] = testId;
        $[24] = t5;
    } else t5 = $[24];
    return t5;
} : ({ iconBefore: iconBefore, children: children, onClick: onClick, isSelected: isSelected, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, 'aria-controls': ariaControls, 'data-ds--level': dataDsLevel, onBlur: onBlur, onFocus: onFocus, testId: testId, id: id, isDisabled: isDisabled, ariaKeyshortcuts: ariaKeyshortcuts, label: label, interactionName: interactionName, ignoreInteractionDisabled: ignoreInteractionDisabled }, ref)=>{
    const { preventDefaultOnMouseDown: preventDefaultOnMouseDown, isDisabled: ctxDisabled, disabledWithoutInteractionLogic: disabledWithoutInteractionLogic } = (0, $b2jdX.useToolbarUI)(); // When ignoreInteractionDisabled=true, only use the disabled state without the interaction check
    const disabled = Boolean((ignoreInteractionDisabled ? disabledWithoutInteractionLogic : ctxDisabled) || isDisabled);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hBYtq.Pressable), {
        ref: ref,
        xcss: (0, $w6R6I.cx)($4267f56118acba47$var$styles.button, disabled ? $4267f56118acba47$var$styles.disabled : isSelected ? $4267f56118acba47$var$styles.selected : $4267f56118acba47$var$styles.enabled),
        "aria-pressed": Boolean(ariaHasPopup) ? undefined // No aria-pressed for dropdown buttons
         : isSelected,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        "aria-controls": ariaControls,
        "aria-keyshortcuts": ariaKeyshortcuts,
        "aria-label": label,
        "data-ds--level": dataDsLevel,
        onClick: onClick,
        onBlur: onBlur,
        onFocus: onFocus,
        testId: testId,
        id: id,
        isDisabled: disabled,
        onMouseDown: (event)=>{
            if (preventDefaultOnMouseDown) event.preventDefault();
        },
        "data-toolbar-component": "button",
        "data-selected": isSelected,
        interactionName: interactionName,
        children: [
            iconBefore,
            children
        ]
    });
});
module.exports["ToolbarButton"] = $4267f56118acba47$export$e5c1a33878e86e9e;

});

parcelRegister("fIopu", function(module, exports) {
$parcel$export(module.exports, "default", () => $b70de66e5258d327$export$2e2bcd8739ae039);

var $4m74k = parcelRequire("4m74k");


var $eYSi7 = parcelRequire("eYSi7");


var $jgqX6 = parcelRequire("jgqX6");


var $bUfyX = parcelRequire("bUfyX");


var $8SGej = parcelRequire("8SGej");


var $dkBOe = parcelRequire("dkBOe");


var $hSjk1 = parcelRequire("hSjk1");


var $jrCh2 = parcelRequire("jrCh2");


var $j90Gh = parcelRequire("j90Gh");


var $3yGK6 = parcelRequire("3yGK6");

var $b70de66e5258d327$var$MINUTES_IN_DAY = 1440;
var $b70de66e5258d327$var$MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var $b70de66e5258d327$var$MINUTES_IN_MONTH = 43200;
var $b70de66e5258d327$var$MINUTES_IN_TWO_MONTHS = 86400;
function $b70de66e5258d327$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale;
    (0, $3yGK6.default)(2, arguments);
    var defaultOptions = (0, $4m74k.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $8SGej.default);
    if (!locale.formatDistance) throw new RangeError('locale must contain formatDistance property');
    var comparison = (0, $eYSi7.default)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError('Invalid time value');
    var localizeOptions = (0, $jrCh2.default)((0, $hSjk1.default)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $dkBOe.default)(dirtyBaseDate);
        dateRight = (0, $dkBOe.default)(dirtyDate);
    } else {
        dateLeft = (0, $dkBOe.default)(dirtyDate);
        dateRight = (0, $dkBOe.default)(dirtyBaseDate);
    }
    var seconds = (0, $bUfyX.default)(dateRight, dateLeft);
    var offsetInSeconds = ((0, $j90Gh.default)(dateRight) - (0, $j90Gh.default)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options !== null && options !== void 0 && options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance('halfAMinute', 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            else return locale.formatDistance('xMinutes', 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            else return locale.formatDistance('xMinutes', minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance('xMinutes', minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance('aboutXHours', 1, localizeOptions);
    else if (minutes < $b70de66e5258d327$var$MINUTES_IN_DAY) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance('aboutXHours', hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < $b70de66e5258d327$var$MINUTES_IN_ALMOST_TWO_DAYS) return locale.formatDistance('xDays', 1, localizeOptions);
    else if (minutes < $b70de66e5258d327$var$MINUTES_IN_MONTH) {
        var days = Math.round(minutes / $b70de66e5258d327$var$MINUTES_IN_DAY);
        return locale.formatDistance('xDays', days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $b70de66e5258d327$var$MINUTES_IN_TWO_MONTHS) {
        months = Math.round(minutes / $b70de66e5258d327$var$MINUTES_IN_MONTH);
        return locale.formatDistance('aboutXMonths', months, localizeOptions);
    }
    months = (0, $jgqX6.default)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / $b70de66e5258d327$var$MINUTES_IN_MONTH);
        return locale.formatDistance('xMonths', nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.floor(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance('aboutXYears', years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance('overXYears', years, localizeOptions);
        else return locale.formatDistance('almostXYears', years + 1, localizeOptions);
    }
}

});

parcelRegister("bUfyX", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ab0ff1e3ce4e116$export$2e2bcd8739ae039);

var $g93kp = parcelRequire("g93kp");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $8ab0ff1e3ce4e116$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $g93kp.default)(dateLeft, dateRight) / 1000;
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("hSjk1", function(module, exports) {
$parcel$export(module.exports, "default", () => $d03677bb2b2eb9e6$export$2e2bcd8739ae039);

var $jrCh2 = parcelRequire("jrCh2");

function $d03677bb2b2eb9e6$export$2e2bcd8739ae039(object) {
    return (0, $jrCh2.default)({}, object);
}

});

parcelRegister("mW7G5", function(module, exports) {
$parcel$export(module.exports, "expVal", () => (parcelRequire("7aoyv")).expVal);
$parcel$export(module.exports, "expValNoExposure", () => (parcelRequire("2vg8D")).expValNoExposure);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /* eslint-disable @atlaskit/editor/no-re-export -- deprecated shims re-exporting the split `expVal`/`expValNoExposure` modules for backwards compatibility (VOLTC-139). */ 
var $cXtTj = parcelRequire("cXtTj");


var $7OZjB = parcelRequire("7OZjB");


var $htnjC = parcelRequire("htnjC");


var $72aLq = parcelRequire("72aLq");


var $7aoyv = parcelRequire("7aoyv");


var $2vg8D = parcelRequire("2vg8D");

function $b932e71e6f49f771$export$48708229abf6ab93({ experimentName: experimentName, experimentParam: experimentParam, defaultValue: defaultValue, fireExperimentExposure: fireExperimentExposure }) {
    const experimentConfig = (0, $htnjC.editorExperimentsConfig)[experimentName];
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if ((0, $72aLq._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $72aLq._overrides)[experimentName];
    // Check for parameter overrides
    const paramOverride = (0, $72aLq._paramOverrides)[experimentName]?.[experimentParam];
    if (paramOverride !== undefined) return paramOverride;
    // If client is not initialized, we return the default value
    if (!(0, $cXtTj.default).initializeCompleted()) return defaultValue;
    if (!(0, $72aLq._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return defaultValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $72aLq._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return defaultValue;
    const resolvedExperimentKey = (0, $htnjC.disallowsProductKeys).includes(experimentName) ? experimentName : experimentKey;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $cXtTj.default).getExperimentValue(resolvedExperimentKey, experimentParam, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $7OZjB.addFeatureFlagAccessed)(`${resolvedExperimentKey}:${experimentParam}`, experimentValue);
    return experimentValue;
}
module.exports["expValInternal"] = $b932e71e6f49f771$export$48708229abf6ab93;

});

parcelRegister("i8Lg4", function(module, exports) {

var $8Z43Z = parcelRequire("8Z43Z");


var $4IGja = parcelRequire("4IGja");

function $8b61887f9f8b02fa$export$d2cf64960b17e12e(selection) {
    let map;
    let totalRowCount = 0;
    let totalColumnCount = 0;
    const table = (0, $4IGja.findTable)(selection);
    if (table) {
        map = (0, $8Z43Z.TableMap).get(table.node);
        totalRowCount = map.height;
        totalColumnCount = map.width;
    }
    return {
        table: table,
        map: map,
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount
    };
}
module.exports["getSelectedTableInfo"] = $8b61887f9f8b02fa$export$d2cf64960b17e12e;

});

parcelRegister("5wPlS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
function $4067c65608db979b$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $4067c65608db979b$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $4067c65608db979b$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $4067c65608db979b$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $4067c65608db979b$export$2e2bcd8739ae039 = $4067c65608db979b$export$4f5d2d50c9deca37;
module.exports["clsx"] = $4067c65608db979b$export$4f5d2d50c9deca37;
module.exports["default"] = $4067c65608db979b$export$2e2bcd8739ae039;

});

parcelRegister("bqYnI", function(module, exports) {

var $1P2f3 = parcelRequire("1P2f3");

function $ecdbda048ec1ade6$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $1P2f3 !== 'undefined' && $1P2f3?.env?.REACT_SSR);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}
module.exports["isSSR"] = $ecdbda048ec1ade6$export$48d7c418edadb60c;

});

parcelRegister("dprMh", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $79e8257d19df66c1$export$73987987fac5266b = (shortName)=>`emoji-placeholder-${shortName}`;
module.exports["emojiPlaceholderTestId"] = $79e8257d19df66c1$export$73987987fac5266b;

});

parcelRegister("9Jo6P", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $f68116e60c972a4f$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch(error, errorInfo) {
        for (const exp of this.props.experiences){
            const { name: name, message: message } = error;
            const infoStack = errorInfo.componentStack && typeof errorInfo.componentStack !== 'undefined' ? errorInfo.componentStack : undefined;
            exp.failure({
                metadata: {
                    source: 'UfoErrorBoundary',
                    reason: 'error',
                    error: {
                        name: name,
                        message: message,
                        infoStack: infoStack
                    }
                }
            });
        }
    }
    render() {
        return this.props.children;
    }
}
module.exports["UfoErrorBoundary"] = $f68116e60c972a4f$export$5ef1c2550074a375;

});

parcelRegister("39tfn", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
const $19771135398ccf69$export$de1ffc44591c1877 = ()=>(parcelRequire("2eLSi"));
module.exports["emojiPickerModuleLoader"] = $19771135398ccf69$export$de1ffc44591c1877;

});

parcelRegister("aGLvf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $e656e5d7e8d89d36$export$9fab6c37a453c65e = (0, $cozmU.createContext)(null);
module.exports["EmojiContext"] = $e656e5d7e8d89d36$export$9fab6c37a453c65e;

});

parcelRegister("7gsaD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $53TEx = parcelRequire("53TEx");

const $76dc57e6fa0afa99$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $cozmU.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $76dc57e6fa0afa99$export$f959821a7419dee1 = (experience, samplingRate, metadata)=>{
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            (0, $53TEx.withSampling)(experience).abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $76dc57e6fa0afa99$var$useConstructor(()=>{
        (0, $53TEx.withSampling)(experience).start({
            samplingRate: samplingRate
        });
        const isMetadataEmpty = Object.keys(experience.metadata).length === 0;
        if (metadata && isMetadataEmpty) experience.addMetadata(metadata);
    });
    return null;
};
module.exports["useSampledUFOComponentExperience"] = $76dc57e6fa0afa99$export$f959821a7419dee1;

});

parcelRegister("7aoyv", function(module, exports) {

var $mW7G5 = parcelRequire("mW7G5");

function $49077a760efbbc32$export$9db1624a8af791a4(experimentName, experimentParam, defaultValue) {
    return (0, $mW7G5.expValInternal)({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: true
    });
}
module.exports["expVal"] = $49077a760efbbc32$export$9db1624a8af791a4;

});

parcelRegister("2vg8D", function(module, exports) {

var $mW7G5 = parcelRequire("mW7G5");

function $77b1b44f5a6ee78c$export$94f132839aec533f(experimentName, experimentParam, defaultValue) {
    return (0, $mW7G5.expValInternal)({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: false
    });
}
module.exports["expValNoExposure"] = $77b1b44f5a6ee78c$export$94f132839aec533f;

});


$parcel$global.rlb("icYyL")
//# sourceMappingURL=simpleHasher.014dc393.js.map
